import { __decorate, __rest, __awaiter } from 'tslib';
import { ɵɵdefineInjectable, Injectable, Component, ɵɵinject, ViewChild, HostListener, ViewEncapsulation, Input, NgModule, EventEmitter, Output, ChangeDetectorRef, ViewChildren, Directive, HostBinding, ContentChildren } from '@angular/core';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { ConfirmationService as ConfirmationService$2 } from 'primeng/api';
import { selectors, actions } from '@lbmx/app-state';
import { TemplateTypes, PerFormPrimengModule, LuiWizardModule, LuiWizardV3Module, LuiWidgetWrapperModule } from '@lbmx/per-form-primeng';
import { ToastrNotificationService, SpinnerService, UtilsModule } from '@lbmx/phoenix-lib-utils';
import { SearchContainerLoaderService, BaseHttpService as BaseHttpService$3, SearchContainerLoaderModule, AdvancedSearchLoaderModule, SearchContainerModule } from '@lbmx/search-container';
import { toolKeys } from '@lbmx/types';
import { HttpMethod as HttpMethod$2, BaseHttpService as BaseHttpService$2 } from '@lbmx/web-core';
import { TranslocoService, TranslocoModule } from '@ngneat/transloco';
import { select, Store } from '@ngrx/store';
import { saveAs } from 'file-saver';
import { DynamicDialogRef as DynamicDialogRef$1, DynamicDialogConfig as DynamicDialogConfig$1, ConfirmationService, DialogService, ProgressSpinnerModule as ProgressSpinnerModule$1, ButtonModule as ButtonModule$1, DialogModule as DialogModule$1, DynamicDialogModule, CheckboxModule as CheckboxModule$1, InputTextModule as InputTextModule$1, InputNumberModule as InputNumberModule$1, ConfirmDialogModule as ConfirmDialogModule$1, RadioButtonModule } from 'primeng-lts';
import { pipe, of, EMPTY, Observable, Subject, BehaviorSubject, forkJoin, combineLatest, merge } from 'rxjs';
import { startWith, tap, catchError, finalize, map, first, filter, switchMap, mergeMap, takeUntil, exhaustMap, delay, throttleTime } from 'rxjs/operators';
import { BaseHttpService as BaseHttpService$1, PopupService, SiteTypeService } from '@lbmx/root-services';
import add from 'date-fns/add';
import differenceInCalendarDays from 'date-fns/differenceInCalendarDays';
import { GenerateFormService, PerFormModule, FormControlRole, UseFormService } from '@lbmx/per-form';
import { DynamicDialogRef, DynamicDialogConfig, ConfirmationService as ConfirmationService$1, DialogService as DialogService$1, ButtonModule as ButtonModule$2, TableModule as TableModule$1, TabMenuModule, DialogModule as DialogModule$2, ProgressSpinnerModule as ProgressSpinnerModule$3 } from 'primeng';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import urlJoin from 'proper-url-join';
import { TemplateTypes as TemplateTypes$1, AnalyticsStatus, AnalyticsModule, ColorType, CdTableModule } from '@lbmx/analytics';
import { CommonModule, DatePipe } from '@angular/common';
import { Action, ActionUiService, queryChange } from '@lbmx/action-ui';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule as ButtonModule$3 } from 'primeng-lts/button';
import { ProgressSpinnerModule as ProgressSpinnerModule$2 } from 'primeng-lts/progressspinner';
import { FlexmonsterPivotModule } from 'ng-flexmonster';
import { InputTextModule } from 'primeng/inputtext';
import { sub, add as add$1 } from 'date-fns';
import { BaseAPIService } from '@lbmx/phoenix-lib-core';
import { AccordionModule } from 'primeng/accordion';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { coerceNumberProperty } from '@angular/cdk/coercion';
import { DataSource } from '@angular/cdk/collections';
import { CdkTableModule } from '@angular/cdk/table';

let MarketplaceService = class MarketplaceService {
    constructor() { }
    setConfig(config) {
        this.config = config;
    }
    getConfig() {
        return this.config;
    }
};
MarketplaceService.ɵprov = ɵɵdefineInjectable({ factory: function MarketplaceService_Factory() { return new MarketplaceService(); }, token: MarketplaceService, providedIn: "root" });
MarketplaceService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], MarketplaceService);
let KpiService = class KpiService {
    constructor() { }
    setConfig(config) {
        this.config = config;
    }
    getConfig() {
        return this.config;
    }
};
KpiService.ɵprov = ɵɵdefineInjectable({ factory: function KpiService_Factory() { return new KpiService(); }, token: KpiService, providedIn: "root" });
KpiService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], KpiService);

let MarketplaceComponent = class MarketplaceComponent {
};
MarketplaceComponent = __decorate([
    Component({
        selector: 'lib-marketplace',
        template: `<lib-toast-notification></lib-toast-notification>
    <lib-working-spinner-component></lib-working-spinner-component
    ><router-outlet></router-outlet>`
    })
], MarketplaceComponent);

const toDropdownOptions = (options, valueKey, labelKey) => {
    return [
        ...options.map((item) => ({
            value: item[valueKey],
            label: item[labelKey],
        })),
    ];
};

const searchContainerPipe = (searchContainerLoaderService, spinner, toast, translocoService) => pipe(startWith(() => spinner.on()), tap(() => {
    searchContainerLoaderService.refreshSearch();
}), catchError(() => of(toast.errorNotify(translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => spinner.off()));
const defaultDashboardState = {
    dashboard: [
        'orderingReceiving.poSentLast30Days',
        'orderingReceiving.poSentMTD',
        'orderingReceiving.poSentYTD',
        'orderingReceiving.unacknowledgedPOLast7Days',
    ],
    gridArea: [[0, 1, 2, 3]],
};
const schemaDefinition = (fields) => ({
    fields,
});
var EventType;
(function (EventType) {
    EventType["PRINT"] = "print";
    EventType["WARNINGS"] = "warnings";
    EventType["ATTACHMENT"] = "attachmentCount";
    EventType["DISABLED"] = "none";
})(EventType || (EventType = {}));
const bulkUpdateConfig = (selection) => ({
    endpoint: 'po/bulk-update',
    httpMethod: 'POST',
    body: {
        ids: [...selection].map((_a) => {
            var { poKey } = _a, _ = __rest(_a, ["poKey"]);
            return poKey;
        }),
        isProcessed: {
            value: true,
        },
    },
});
const printConfig = (sentPo) => ({
    endpoint: `po/${sentPo === null || sentPo === void 0 ? void 0 : sentPo.poKey}/print`,
    httpMethod: 'GET',
    options: {
        responseType: 'blob',
    },
});
const bulkPrintConfig = (posToPrint) => ({
    endpoint: `po/print`,
    httpMethod: 'POST',
    body: posToPrint,
    options: {
        responseType: 'blob',
    },
});
const warningsConfig = (baseUrl, itemSelected) => ({
    endpoint: `${baseUrl}/${itemSelected === null || itemSelected === void 0 ? void 0 : itemSelected.poKey}/warning/form`,
    httpMethod: 'GET',
});
const wizardConfig = (translateService, baseUrl) => [
    ({ title }) => ({
        fetchUrl: `${baseUrl}/sentpo/pull`,
        fetchMethod: 'GET',
        responseField: 'records',
        title: translateService.translate(title),
        form: (options) => ({
            fields: {
                poDateMin: {
                    type: 'calendar',
                    label: translateService.translate('SENT_PURCHASE_ORDER.DATE_FROM'),
                    validations: [
                        {
                            test: dateOrderValidation('poDateMax'),
                            message: translateService.translate('SENT_PURCHASE_ORDER.DATE_FROM_LESS_THAN_VALIDATION'),
                        },
                        {
                            test: dateRangeValidation,
                            message: translateService.translate('SENT_PURCHASE_ORDER.DATE_RANGE_VALIDATION'),
                        },
                    ],
                    componentProperties: {
                        showIcon: true,
                        showButtonBar: true,
                    },
                    required: true,
                },
                poDateMax: {
                    type: 'calendar',
                    label: translateService.translate('SENT_PURCHASE_ORDER.DATE_TO'),
                    validations: [
                        {
                            test: dateOrderValidation('poDateMin'),
                            message: translateService.translate('SENT_PURCHASE_ORDER.DATE_TO_GREATER_THAN_VALIDATION'),
                        },
                        {
                            test: dateRangeValidation,
                            message: translateService.translate('SENT_PURCHASE_ORDER.DATE_RANGE_VALIDATION'),
                        },
                    ],
                    componentProperties: {
                        showIcon: true,
                        showButtonBar: true,
                    },
                    required: true,
                },
                connectionKey: {
                    type: 'dropdown',
                    label: translateService.translate('INVOICE.CONNECTIONS'),
                    options: [
                        {
                            value: null,
                            label: translateService.translate('ADMINISTRATION.CHOOSE_CONNECTOR'),
                        },
                        ...toDropdownOptions(options, 'connectionKey', 'description'),
                    ],
                    required: true,
                },
            },
        }),
        response: ({ screenConfig, response }) => {
            const { form } = screenConfig;
            return form(response);
        },
        buttons: {
            cancel: {
                label: translateService.translate('ACTIONS.CANCEL'),
            },
            next: {
                label: translateService.translate('ACTIONS.NEXT'),
                componentProperties: {
                    style: { 'flex-grow': 1 },
                },
            },
        },
    }),
    ({ screens, title }) => ({
        fetchUrl: `${baseUrl}/sentpo/pull/${screens[0].connectionKey}/filter`,
        fetchMethod: 'POST',
        body: {
            poDateMin: screens[0].poDateMin,
            poDateMax: transformDate(screens[0].poDateMax),
        },
        title: translateService.translate(title),
        response: ({ response }) => {
            return response;
        },
        buttons: {
            cancel: {
                label: translateService.translate('ACTIONS.CANCEL'),
            },
            previous: {
                label: translateService.translate('ACTIONS.PREVIOUS'),
            },
            next: {
                label: translateService.translate('ACTIONS.SUBMIT'),
                componentProperties: {
                    style: { 'flex-grow': 1 },
                },
            },
        },
    }),
    ({ screens, title }) => {
        var _a;
        return ({
            fetchUrl: `${baseUrl}/sentpo/pull/${screens[0].connectionKey}`,
            fetchMethod: 'POST',
            body: {
                poKeys: (_a = screens[1]) === null || _a === void 0 ? void 0 : _a.poKeys,
            },
            title: translateService.translate(title),
            response: ({ response }) => {
                return response;
            },
            buttons: {
                submit: {
                    label: translateService.translate('ACTIONS.OK'),
                    componentProperties: {
                        style: { 'flex-grow': 1 },
                    },
                },
            },
        });
    },
];
const dateRangeValidation = ({ poDateMin, poDateMax }) => {
    let diff = null;
    if (poDateMin && poDateMax) {
        diff = differenceInCalendarDays(poDateMin, transformDate(poDateMax));
    }
    return diff > -32;
};
const ɵ0 = dateRangeValidation;
const dateOrderValidation = (dateToCheck) => ({ [dateToCheck]: ensurePresent, poDateMin, poDateMax }) => {
    let diff = null;
    if (poDateMin && poDateMax) {
        diff = differenceInCalendarDays(poDateMin, transformDate(poDateMax));
    }
    return !!ensurePresent ? diff && diff < 0 : true;
};
const ɵ1 = dateOrderValidation;
const transformDate = (date) => add(date, { days: 1 });
const ɵ2 = transformDate;

var HttpMethod;
(function (HttpMethod) {
    HttpMethod["DELETE"] = "DELETE";
    HttpMethod["GET"] = "GET";
    HttpMethod["POST"] = "POST";
    HttpMethod["PUT"] = "PUT";
})(HttpMethod || (HttpMethod = {}));
let BaseHttpService = class BaseHttpService {
    constructor(http) {
        this.http = http;
        this._baseUrl = '';
    }
    set baseUrl(baseUrl) {
        this._baseUrl = baseUrl;
    }
    get baseUrl() {
        return this._baseUrl;
    }
    fetchWithFqn({ endpoint, httpMethod, body, responseField, }) {
        return this.buildRequest(endpoint, httpMethod, body).pipe(map((response) => responseField && response ? response[responseField] : response));
    }
    fetch({ endpoint, httpMethod, body, responseField, options, }) {
        return this.buildRequest(urlJoin(this._baseUrl, endpoint), httpMethod, body, options).pipe(map((response) => responseField && response ? response[responseField] : response));
    }
    buildRequest(endpoint, httpMethod, body, options) {
        switch (httpMethod) {
            case HttpMethod.GET:
                return this.http.get(endpoint, Object.assign(Object.assign({}, options), { withCredentials: true }));
            case HttpMethod.POST:
                return this.http.post(endpoint, body, Object.assign(Object.assign({}, options), { withCredentials: true }));
            case HttpMethod.PUT:
                return this.http.put(endpoint, body, Object.assign(Object.assign({}, options), { withCredentials: true }));
            case HttpMethod.DELETE:
                return this.http.delete(endpoint, Object.assign(Object.assign({}, options), { withCredentials: true }));
        }
    }
};
BaseHttpService.ctorParameters = () => [
    { type: HttpClient }
];
BaseHttpService.ɵprov = ɵɵdefineInjectable({ factory: function BaseHttpService_Factory() { return new BaseHttpService(ɵɵinject(HttpClient)); }, token: BaseHttpService, providedIn: "root" });
BaseHttpService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], BaseHttpService);

const schemaDefinition$1 = (fields) => ({
    fields,
});

let ExportComponent = class ExportComponent {
    constructor(http, translocoService, toast, formGenerator, ref, dialogConfig, mp) {
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.formGenerator = formGenerator;
        this.ref = ref;
        this.dialogConfig = dialogConfig;
        this.mp = mp;
        this.schemaDefinition = schemaDefinition$1;
    }
    ngOnInit() {
        var _a;
        this.http
            .fetchWithFqn({
            endpoint: `${(_a = this.mp.getConfig()) === null || _a === void 0 ? void 0 : _a.export}/export-options/form`,
            httpMethod: 'GET',
        })
            .pipe(tap(({ fields }) => {
            this.form = this.formGenerator.init(this.schemaDefinition(fields));
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))))
            .subscribe();
    }
};
ExportComponent.ctorParameters = () => [
    { type: BaseHttpService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: GenerateFormService },
    { type: DynamicDialogRef },
    { type: DynamicDialogConfig },
    { type: MarketplaceService }
];
ExportComponent = __decorate([
    Component({
        selector: 'lib-export',
        template: `<lib-export-form
    [form]="form"
    (closeForm)="ref?.close(null)"
    (save)="ref?.close($event)"
  ></lib-export-form>`
    })
], ExportComponent);

let PdfViewerComponent = class PdfViewerComponent {
    constructor(ref, dialogConfig) {
        this.ref = ref;
        this.dialogConfig = dialogConfig;
    }
    ngOnInit() {
        this.setViewer();
    }
    setViewer() {
        const reader = new FileReader();
        reader.readAsArrayBuffer(this.dialogConfig.data.response);
        reader.onloadend = () => {
            const objectUrl = URL.createObjectURL(new Blob([reader.result], { type: 'application/pdf' }));
            // tslint:disable quotemark
            this.pdfFrame.nativeElement.innerHTML =
                "<iframe style='min-height:70vh; min-width: 100%' src='" +
                    encodeURI(objectUrl) +
                    "'></iframe>";
            // tslint:enable quotemark
        };
    }
};
PdfViewerComponent.ctorParameters = () => [
    { type: DynamicDialogRef$1 },
    { type: DynamicDialogConfig$1 }
];
__decorate([
    ViewChild('pdfFrame')
], PdfViewerComponent.prototype, "pdfFrame", void 0);
PdfViewerComponent = __decorate([
    Component({
        selector: 'lib-pdf-viewer',
        template: `<div style="overflow: auto" #pdfFrame></div> `
    })
], PdfViewerComponent);

let PrintOptionsService = class PrintOptionsService {
    constructor(store, http, translocoService, toast) {
        this.store = store;
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
    }
    get(uriFragment, printToolkey) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.store
                .pipe(first(), select(selectors.isAuthorized, {
                printOptions: printToolkey,
            }), filter((permissions) => permissions.printOptions), switchMap(() => this.http
                .fetch({
                endpoint: `${uriFragment}/print-options`,
                httpMethod: 'GET',
            })
                .pipe(catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), map((response) => response === null || response === void 0 ? void 0 : response.record))))
                .toPromise();
        });
    }
};
PrintOptionsService.ctorParameters = () => [
    { type: Store },
    { type: BaseHttpService$1 },
    { type: TranslocoService },
    { type: ToastrNotificationService }
];
PrintOptionsService.ɵprov = ɵɵdefineInjectable({ factory: function PrintOptionsService_Factory() { return new PrintOptionsService(ɵɵinject(Store), ɵɵinject(BaseHttpService$1), ɵɵinject(TranslocoService), ɵɵinject(ToastrNotificationService)); }, token: PrintOptionsService, providedIn: "root" });
PrintOptionsService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], PrintOptionsService);

const schemaDefinition$2 = (transloco) => ({
    fields: {
        selectionType: {
            type: 'dropdown',
            label: transloco.translate('DATA_GENIUS.SELECT_OPTION'),
            required: true,
            options: [
                { label: transloco.translate('DATA_GENIUS.SELECT'), value: null },
                { label: transloco.translate('EXPORT_TYPES.ALL_PAGES'), value: 1 },
                { label: transloco.translate('EXPORT_TYPES.CURRENT_PAGE'), value: 2 },
                { label: transloco.translate('EXPORT_TYPES.SELECTED_ITEMS'), value: 3 },
            ],
        },
    },
});

let DataGeniusSelectionComponent = class DataGeniusSelectionComponent {
    constructor(http, translocoService, toast, formGenerator, ref, dialogConfig, mp) {
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.formGenerator = formGenerator;
        this.ref = ref;
        this.dialogConfig = dialogConfig;
        this.mp = mp;
        this.schemaDefinition = schemaDefinition$2;
    }
    ngOnInit() {
        var _a, _b;
        const selectionCount = (_b = (_a = this.dialogConfig.data) === null || _a === void 0 ? void 0 : _a.selectionCount) !== null && _b !== void 0 ? _b : 0;
        const schema = this.schemaDefinition(this.translocoService);
        const filteredSchema = {
            fields: Object.assign(Object.assign({}, schema.fields), { selectionType: Object.assign(Object.assign({}, schema.fields.selectionType), { options: schema.fields.selectionType.options.filter((option) => !(option.value === 3 && selectionCount === 0)) }) }),
        };
        this.form = this.formGenerator.init(filteredSchema);
    }
};
DataGeniusSelectionComponent.ctorParameters = () => [
    { type: BaseHttpService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: GenerateFormService },
    { type: DynamicDialogRef },
    { type: DynamicDialogConfig },
    { type: MarketplaceService }
];
DataGeniusSelectionComponent = __decorate([
    Component({
        selector: 'lib-data-genius-selection',
        template: `<lib-data-genius-form
    [form]="form"
    (closeForm)="ref?.close(null)"
    (save)="ref?.close($event)"
  ></lib-data-genius-form>`
    })
], DataGeniusSelectionComponent);

let AsnReceivedComponent = class AsnReceivedComponent {
    constructor(confirmationService, dialogService, mp, http, translocoService, toast, spinner, searchContainerLoaderService, store, printOptionsService) {
        this.confirmationService = confirmationService;
        this.dialogService = dialogService;
        this.mp = mp;
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.store = store;
        this.printOptionsService = printOptionsService;
        // Warnings state
        this.showWarningsDialog = false;
        // display log states
        this.showDisplayLog = false;
        this.batchKey = 0;
        this.loggingUrl = '';
        // Action logs
        this.showActionLogs = false;
        this.templateTypes = TemplateTypes;
        // kpi dashboard states
        this.dashBoardStateKey = 'receivedASNDashboardState';
        this.dashBoardVisibilityStateKey = 'receivedASNDashboardVisibilityState';
        this.categoryFilter = ['orderingReceiving'];
        this.showCategories = false;
        this.defaultDashboardState = {
            dashboard: ['orderingReceiving.newASNUnprocessed'],
            gridArea: [[0]],
        };
        // print states
        this.showPrintOptionsDialog = false;
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        this.asnsToPrint = [];
        // search container loader states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'receivedASNSearch';
        this.i18nSearchField = 'ASN_RECEIVED.SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {
            printOptions: (selection) => {
                this.showPrintOptionsDialog = true;
            },
            print: (selection) => {
                var _a;
                this.asnsToPrint = [...selection].map((_a) => {
                    var { asnKey } = _a, _ = __rest(_a, ["asnKey"]);
                    return asnKey;
                });
                if (((_a = Object.keys(this.selectedPrintOptions || {})) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.bulkPrint();
                }
                else {
                    this.triggeredByPrint = true;
                    this.showPrintOptionsDialog = true;
                }
            },
            markProcessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('ASN_RECEIVED.PROCESSED_MESSAGE'),
                    header: this.translocoService.translate('ASN_RECEIVED.PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'asn/mark-processed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { asnKey } = _a, _ = __rest(_a, ["asnKey"]);
                                return asnKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnprocessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('ASN_RECEIVED.UNPROCESSED_MESSAGE'),
                    header: this.translocoService.translate('ASN_RECEIVED.PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'asn/mark-unprocessed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { asnKey } = _a, _ = __rest(_a, ["asnKey"]);
                                return asnKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markRead: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('ASN_RECEIVED.READ_MESSAGE'),
                    header: this.translocoService.translate('ASN_RECEIVED.READ_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'asn/mark-read',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { asnKey } = _a, _ = __rest(_a, ["asnKey"]);
                                return asnKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnread: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('ASN_RECEIVED.UNREAD_MESSAGE'),
                    header: this.translocoService.translate('ASN_RECEIVED.UNREAD_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'asn/mark-unread',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { asnKey } = _a, _ = __rest(_a, ["asnKey"]);
                                return asnKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            export: (selection) => {
                this.selections = selection;
                this.openExport();
            },
            displayLog: (selection) => {
                var _a;
                this.batchKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.asnKey;
                this.loggingUrl = `${this.mp.getConfig().receivedAsn}/asnhistory/${this.batchKey}/form`;
                this.showDisplayLog = true;
            },
            runDataGenius: (selection) => {
                this.selections = selection;
                this.openDataGenius();
            },
            actionLogs: (selection) => {
                var _a;
                const asnKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.asnKey;
                this.actionLogsWizard = {
                    endpoint: `/${asnKey}/actionlogs/form`,
                    httpMethod: HttpMethod$2.GET,
                };
                this.showActionLogs = true;
            },
            warnings: (selection) => {
                const asnKeys = [...selection].map((_a) => {
                    var { asnKey } = _a, _ = __rest(_a, ["asnKey"]);
                    return asnKey;
                });
                this.warningsDialogWizard = {
                    endpoint: `receivedasn/asn/warning/form`,
                    httpMethod: HttpMethod$2.POST,
                    body: {
                        keys: asnKeys,
                    },
                };
                this.showWarningsDialog = true;
            },
        };
        this.baseUrl = `${this.mp.getConfig().receivedAsn}/asn`;
        this.apiBaseUrl = `${this.mp.getConfig().apiBaseUrl}`;
        this.email = '';
        http.baseUrl = mp.getConfig().receivedAsn;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.push(this.store
                .pipe(select(selectors.isAuthorized, {
                edit: toolKeys.MP_ASN_VIEW,
                print: toolKeys.MP_RECEIVED_ASN_PRINT,
            }), tap((authorizedButtons) => {
                this.columnActions = {
                    shipmentId: authorizedButtons.print
                        ? {
                            link: () => ({ path: './' }),
                            event: (receivedAsn) => ({
                                data: { receivedAsn },
                                eventType: EventType.PRINT,
                            }),
                        }
                        : {},
                    warnings: {
                        link: () => {
                            return { path: './' };
                        },
                        event: (receivedAsn) => ({
                            data: { receivedAsn },
                            eventType: EventType.WARNINGS,
                        }),
                        icon: 'exclamation-triangle',
                        styleClass: 'warnings-icon',
                    },
                };
            }))
                .subscribe(), this.store
                .pipe(select(selectors.userProfile), tap((user) => {
                this.email = user.sub;
            }))
                .subscribe());
            this.selectedPrintOptions = yield this.printOptionsService.get('asn', toolKeys.MP_RECEIVED_ASN_PRINT);
        });
    }
    searchContainerEvent({ data, eventType }) {
        const { receivedAsn } = data;
        switch (eventType) {
            case EventType.PRINT:
                this.print(receivedAsn);
                break;
            case EventType.WARNINGS:
                this.selectedAsnKey = receivedAsn === null || receivedAsn === void 0 ? void 0 : receivedAsn.asnKey;
                this.warningsDialogWizard = {
                    endpoint: `receivedasn/asn/warning/form`,
                    httpMethod: HttpMethod$2.POST,
                    body: {
                        keys: [this.selectedAsnKey],
                    },
                };
                this.showWarningsDialog = true;
                break;
            default:
                break;
        }
    }
    closeWarningsDialog() {
        this.searchContainerLoaderService.refreshSearch();
        this.showWarningsDialog = false;
    }
    submitWarningsDialog(event) {
        this.showWarningsDialog = false;
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.searchContainerLoaderService.refreshSearch();
    }
    print(receivedAsn) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `asn/${receivedAsn === null || receivedAsn === void 0 ? void 0 : receivedAsn.asnKey}/print`,
            httpMethod: 'GET',
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
            .subscribe();
    }
    // if triggered from bulk print then it also prints the selected documents
    updatePrintOptions(selectedPrintOptions) {
        this.selectedPrintOptions = selectedPrintOptions;
        if (this.triggeredByPrint) {
            this.bulkPrint();
        }
        this.closePrintOptionsDialog();
    }
    bulkPrint() {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `asn/print`,
            httpMethod: 'POST',
            body: this.asnsToPrint,
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            var _a;
            ((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) === 1
                ? saveAs(response, 'MergedDocuments')
                : this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.asnsToPrint = [];
            this.triggeredByPrint = false;
            this.spinner.off();
        }))
            .subscribe();
    }
    closePrintOptionsDialog() {
        this.showPrintOptionsDialog = false;
    }
    openPdfViewer(data) {
        const ref = this.dialogService.open(PdfViewerComponent, {
            data: {
                response: data,
            },
            styleClass: 'pdf-viewer',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
    }
    openExport() {
        const ref = this.dialogService.open(ExportComponent, {
            data: {
                endpoint: `${this.baseUrl}/export/form`,
            },
            showHeader: false,
            styleClass: 'export-dialog',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
        const refSubscription = ref.onClose
            .pipe(mergeMap((exportOptions) => exportOptions ? this.submitExport(exportOptions) : EMPTY), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
            .subscribe();
        this.subscriptions = [...this.subscriptions, refSubscription];
    }
    submitExport(exportOptions) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.spinner.on();
        return this.http
            .fetchWithFqn({
            endpoint: `${this.mp.getConfig().receivedAsn}/asn/export`,
            httpMethod: 'POST',
            body: Object.assign(Object.assign({}, exportOptions), { email: this.email, toolkeys: '', keys: [...this.selections].map((_a) => {
                    var { asnKey } = _a, _ = __rest(_a, ["asnKey"]);
                    return asnKey;
                }), page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows }, sort: {
                    field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                    order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                }, search: {
                    filters: this.searchContainerLoaderService.filters,
                    term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
                } }),
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()));
    }
    ngOnDestroy() {
        this.dynamicDialogRefs.forEach((ref) => ref.destroy());
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
    closeDisplayLog() {
        this.showDisplayLog = false;
    }
    closeActionLogs() {
        this.showActionLogs = false;
    }
    submitActionLogs(options) {
        this.showActionLogs = false;
        this.searchContainerLoaderService.refreshSearch();
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
    openDataGenius() {
        const ref = this.dialogService.open(DataGeniusSelectionComponent, {
            showHeader: false,
            styleClass: 'export-dialog',
            data: {
                selectionCount: this.selections.length,
            },
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
        const refSubscription = ref.onClose
            .pipe(mergeMap((dgOptions) => dgOptions ? this.submitDataGenius(dgOptions) : EMPTY), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
            .subscribe();
        this.subscriptions = [...this.subscriptions, refSubscription];
    }
    submitDataGenius(dgOptions) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.spinner.on();
        return this.http
            .fetchWithFqn({
            endpoint: `${this.mp.getConfig().receivedAsn}/asn/rundatagenius`,
            httpMethod: 'POST',
            body: Object.assign(Object.assign({}, dgOptions), { keys: [...this.selections].map((_a) => {
                    var { asnKey } = _a, _ = __rest(_a, ["asnKey"]);
                    return asnKey;
                }), page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows }, sort: {
                    field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                    order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                }, search: {
                    filters: this.searchContainerLoaderService.filters,
                    term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
                } }),
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()));
    }
};
AsnReceivedComponent.ctorParameters = () => [
    { type: ConfirmationService },
    { type: DialogService },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: Store },
    { type: PrintOptionsService }
];
AsnReceivedComponent = __decorate([
    Component({
        selector: 'lib-asn-received-beta',
        template: "<div class=\"view-invoices\">\r\n  <div class=\"dashboard\">\r\n    <lib-dashboard-container\r\n      [dashBoardStateKey]=\"dashBoardStateKey\"\r\n      [dashBoardVisibilityStateKey]=\"dashBoardVisibilityStateKey\"\r\n      [dashBoardHeader]=\"'ASN_RECEIVED.ASN_RECEIVED'\"\r\n      [categoryFilter]=\"categoryFilter\"\r\n      [showCategories]=\"showCategories\"\r\n      [defaultDashboardState]=\"defaultDashboardState\"\r\n    ></lib-dashboard-container>\r\n  </div>\r\n\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"baseUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showPrintOptionsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-print-options-container\r\n    [baseUrl]=\"baseUrl\"\r\n    [selectedPrintOptions]=\"selectedPrintOptions\"\r\n    (closeDialog)=\"closePrintOptionsDialog()\"\r\n    (updatePrintOptions)=\"updatePrintOptions($event)\"\r\n  ></lib-print-options-container>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showWarningsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"apiBaseUrl\"\r\n    [wizardConfig]=\"warningsDialogWizard\"\r\n    (submit)=\"submitWarningsDialog($event)\"\r\n    (cancel)=\"closeWarningsDialog()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeWarningsDialog()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showDisplayLog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-logging\r\n    [baseUrl]=\"loggingUrl\"\r\n    [batchKey]=\"batchKey\"\r\n    (closeLogDialog)=\"closeDisplayLog()\"\r\n  >\r\n  </lib-logging>\r\n</p-dialog>\r\n<p-dialog\r\n  *ngIf=\"showActionLogs\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"baseUrl\"\r\n    [wizardConfig]=\"actionLogsWizard\"\r\n    (submit)=\"submitActionLogs($event)\"\r\n    (cancel)=\"closeActionLogs()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n      <div>\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeActionLogs()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, DialogService]
    })
], AsnReceivedComponent);

const ɵ0$1 = { breadcrumb: 'BREADCRUMB.ASNS_RECEIVED' };
const routes = [
    {
        path: 'asns-received',
        component: AsnReceivedComponent,
        data: ɵ0$1,
    },
];

let CdaWizardService = class CdaWizardService {
    reset() {
        // empty
    }
};
CdaWizardService.ɵprov = ɵɵdefineInjectable({ factory: function CdaWizardService_Factory() { return new CdaWizardService(); }, token: CdaWizardService, providedIn: "root" });
CdaWizardService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], CdaWizardService);

class ComponentCanDeactivate {
    unloadNotification($event) {
        if (!this.canDeactivate()) {
            $event.returnValue = true;
        }
    }
}
__decorate([
    HostListener('window:beforeunload', ['$event'])
], ComponentCanDeactivate.prototype, "unloadNotification", null);

let CdaWizardComponent = class CdaWizardComponent extends ComponentCanDeactivate {
    constructor(confirmationService, translocoService, router, cdaWizardSrv) {
        super();
        this.confirmationService = confirmationService;
        this.translocoService = translocoService;
        this.router = router;
        this.cdaWizardSrv = cdaWizardSrv;
        this.templateTypes = TemplateTypes$1;
        this.cancelButtonClicked = false;
        this.wizardConfig = cdaWizardSrv.wizardConfig;
        this.baseUrl = cdaWizardSrv.baseUrl;
    }
    ngOnInit() {
        if (this.wizardConfig === undefined) {
            this.router.navigate([this.cdaWizardSrv.redirectUrl]);
        }
    }
    submitNew(event) {
        this.cancelButtonClicked = true;
        this.cdaWizardSrv.reset();
        this.router.navigate([this.cdaWizardSrv.redirectUrl]);
    }
    redirect() {
        this.confirmationService.confirm({
            header: this.translocoService.translate('ACTIONS.CANCEL'),
            message: this.translocoService.translate('COMMON.CONFIRM_LEAVE'),
            acceptLabel: this.translocoService.translate('ACTIONS.YES'),
            rejectLabel: this.translocoService.translate('ACTIONS.NO'),
            accept: () => {
                this.cancelButtonClicked = true;
                this.cdaWizardSrv.reset();
                this.router.navigate([this.cdaWizardSrv.redirectUrl]);
            },
        });
    }
    canDeactivate(nextState) {
        // when the cancel dialog is open, we don't want the alert to show and just nav away
        if (this.cancelButtonClicked) {
            return true;
        }
        return false;
    }
};
CdaWizardComponent.ctorParameters = () => [
    { type: ConfirmationService },
    { type: TranslocoService },
    { type: Router },
    { type: CdaWizardService }
];
CdaWizardComponent = __decorate([
    Component({
        selector: 'lib-flip-to-cda',
        template: "<lui-wizard-v3\r\n  [baseUrl]=\"baseUrl\"\r\n  [wizardConfig]=\"wizardConfig\"\r\n  (submit)=\"submitNew($event)\"\r\n  (cancel)=\"redirect()\"\r\n>\r\n  <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n    <div\r\n      class=\"error\"\r\n      style=\"\r\n        min-height: 30vh;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n      \"\r\n    >\r\n      <div>\r\n        <span>\r\n          <i class=\"pi pi-times-circle\"></i>\r\n          {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n        </span>\r\n      </div>\r\n    </div>\r\n    <button pButton (click)=\"redirect()\" class=\"ds secondary\">\r\n      {{ 'ACTIONS.CANCEL' | transloco }}\r\n    </button>\r\n  </ng-template>\r\n</lui-wizard-v3>\r\n\r\n<p-confirmDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n",
        providers: [ConfirmationService]
    })
], CdaWizardComponent);

let CanDeactivateGuard = class CanDeactivateGuard {
    constructor(transloco) {
        this.transloco = transloco;
    }
    canDeactivate(component, currentRoute, currentState, nextState) {
        if (component.canDeactivate(nextState)) {
            return true;
        }
        else {
            return new Observable((obs) => {
                obs.next(window.confirm(this.transloco.translate('ACTIONS.LEAVING_PAGE_CONFIRMATION') +
                    this.transloco.translate('ACTIONS.UNSAVED_CHANGES_WILL_BE_LOST')));
                obs.complete();
            });
        }
    }
};
CanDeactivateGuard.ctorParameters = () => [
    { type: TranslocoService }
];
CanDeactivateGuard = __decorate([
    Injectable()
], CanDeactivateGuard);

const ɵ0$2 = () => {
    return 'receivedinvoice/invoice/fliptocda';
}, ɵ1$1 = () => {
    return 'sentcda/form/cda/entry';
}, ɵ2$1 = (asnKey) => {
    return `sentasn/form/asn/${asnKey}/copy`;
}, ɵ3 = () => {
    return 'sentasn/form/asn/entry';
}, ɵ4 = () => {
    return 'sentAsn/ui/draft/new';
}, ɵ5 = (asnKey) => {
    return `sentAsn/ui/draft/${asnKey}/edit`;
}, ɵ6 = (asnKey) => {
    return `sentasn/ui/draft/${asnKey}/copy`;
}, ɵ7 = () => {
    return `sentasn/ui/draft/promote`;
}, ɵ8 = () => {
    return `draft/delete`;
}, ɵ9 = () => {
    return `draft/restore`;
}, ɵ10 = (baseUrl, statementKey) => {
    return `/payment/${statementKey}/print`;
}, ɵ11 = (cdaKey) => {
    return `sentcda/cdahistory/${cdaKey}/form`;
}, ɵ12 = () => {
    return '/wizard/upload';
}, ɵ13 = (draftInvoiceKey) => {
    return `sentinvoice/compliance/edit/${draftInvoiceKey}`;
}, ɵ14 = () => {
    return `/export/form`;
}, ɵ15 = (baseUrl) => {
    return `${baseUrl}/invoice/export`;
}, ɵ16 = (baseUrl) => {
    return `${baseUrl}/statement/export`;
}, ɵ17 = () => {
    return '/wizard/pay/setup';
}, ɵ18 = (baseUrl, batchKey) => {
    return `${baseUrl}/statementhistory/${batchKey}/form`;
}, ɵ19 = (statementKey) => {
    return `wizard/notify/${statementKey}`;
};
const apiUrls = {
    flipToCdaConfig: ɵ0$2,
    newCdaConfig: ɵ1$1,
    copyAsnConfig: ɵ2$1,
    entryAsnConfig: ɵ3,
    draftNewAsnConfig: ɵ4,
    draftEditAsnConfig: ɵ5,
    draftCopyAsnConfig: ɵ6,
    draftPromoteAsnConfig: ɵ7,
    draftDeleteAsnUrl: ɵ8,
    draftRestoreAsnUrl: ɵ9,
    printStatement: ɵ10,
    sentCdaDisplayLogConfig: ɵ11,
    uploadInvoiceWizard: ɵ12,
    editComplianceInvoiceUrl: ɵ13,
    exportWizardUrl: ɵ14,
    submitExport: ɵ15,
    submitStatementExport: ɵ16,
    newStatementsWizard: ɵ17,
    displayLogStatements: ɵ18,
    notifyWizard: ɵ19,
};
const ɵ20 = () => {
    return '/MarketplaceModule/order-fulfillment/asn-entry';
}, ɵ21 = () => {
    return '/MarketplaceModule/order-fulfillment/asn-copy';
}, ɵ22 = () => {
    return '/MarketplaceModule/order-fulfillment/asns-sent';
}, ɵ23 = () => {
    return '/MarketplaceModule/accounts-payable/invoices';
}, ɵ24 = () => {
    return '/MarketplaceModule/accounts-payable/direct-invoices';
}, ɵ25 = () => {
    return '/MarketplaceModule/accounts-payable/cda-flip';
}, ɵ26 = () => {
    return '/MarketplaceModule/accounts-payable/di-cda-flip';
}, ɵ27 = () => {
    return '/MarketplaceModule/accounts-payable/cda-sent';
}, ɵ28 = () => {
    return '/MarketplaceModule/accounts-payable/new-cda';
}, ɵ29 = () => {
    return '/MarketplaceModule/accounts-receivable/invoices';
}, ɵ30 = () => {
    return '/MarketplaceModule/order-fulfillment/draft-asn';
}, ɵ31 = (statementKey) => {
    return `/pay-module/statement-invoices/${statementKey}`;
}, ɵ32 = () => {
    return '/MarketplaceModule/compliance/invoice-matching';
}, ɵ33 = () => {
    return '/MarketplaceModule/compliance/edit-invoice';
};
const moduleUrls = {
    asnEntry: ɵ20,
    asnCopy: ɵ21,
    sentAsn: ɵ22,
    receivedInvoice: ɵ23,
    directInvoice: ɵ24,
    flipToCDA: ɵ25,
    flipToDirectInvoice_CDA: ɵ26,
    sentCda: ɵ27,
    newCda: ɵ28,
    sentInvoice: ɵ29,
    draftASN: ɵ30,
    manageDetails: ɵ31,
    invoiceReconcilliation: ɵ32,
    editComplianceInvoice: ɵ33,
};

let PayService = class PayService {
    constructor() {
        this.invoiceKeys = [];
        this.paymentReferenceNumber = '';
        this.bankAccountName = '';
        this.search = null;
        this.data = [
            { options: '' },
            {
                paymentReferenceNumber: '',
                paymentDate: '',
                paymentMethodType: '',
                accountBankingInfoKeys: null,
                selectedKeys: [],
            },
        ];
        this.accountBankingInfoKeys = null;
        this.ready = false;
        this.wizardData = [
            { options: '' },
            {
                paymentReferenceNumber: '',
                paymentDate: '',
                paymentMethodType: '',
                accountBankingInfoKeys: null,
                selectedKeys: [],
            },
        ];
        this.redirectUrl = '/MarketplaceModule/accounts-payable/invoices';
    }
    payInit(data) {
        var _a, _b, _c, _d, _e;
        this.wizardData = data;
        this.data = this.transformData(data);
        this.paymentReferenceNumber = (_a = data[1].paymentReferenceNumber) !== null && _a !== void 0 ? _a : '';
        this.paymentDate = (_c = new Date((_b = data[1]) === null || _b === void 0 ? void 0 : _b.paymentDate).toISOString()) !== null && _c !== void 0 ? _c : '';
        this.bankAccountName = (_e = (_d = data[1]) === null || _d === void 0 ? void 0 : _d.bankAccountName) !== null && _e !== void 0 ? _e : '';
        this.accountBankingInfoKeys = this.data[1].accountBankingInfoKeys;
        this.paymentMethodType = data[1].paymentMethodType;
        this.ready = true;
        this.selectedKeys = data[1].selectedKeys;
    }
    reset() {
        this.invoiceKeys = [];
        this.paymentReferenceNumber = '';
        this.bankAccount = null;
        this.bankAccountName = '';
        this.paymentDate = '';
        this.search = null;
        this.selectedKeys = [];
        this.data = [
            { options: '' },
            {
                paymentReferenceNumber: '',
                paymentDate: '',
                paymentMethodType: '',
                accountBankingInfoKeys: null,
                selectedKeys: [],
            },
        ];
        this.accountBankingInfoKeys = null;
        this.paymentMethodType = '';
        this.ready = false;
    }
    transformData(wizardData) {
        const payStep2Data = Object.entries(wizardData[1]).reduce((total, [key, value]) => {
            var _a;
            if (key.includes('locationBankingInfo')) {
                const newKey = key.split('|')[1];
                const newAccountBankingInfoKeys = (_a = total.accountBankingInfoKeys) !== null && _a !== void 0 ? _a : {};
                return Object.assign(Object.assign({}, total), { accountBankingInfoKeys: Object.assign(Object.assign({}, newAccountBankingInfoKeys), { [newKey]: value }) });
            }
            return Object.assign(Object.assign({}, total), { [key]: value });
        }, {
            paymentReferenceNumber: '',
            paymentDate: '',
            paymentMethodType: '',
            accountBankingInfoKeys: null,
            selectedKeys: [],
        });
        return [wizardData[0], payStep2Data];
    }
};
PayService.ɵprov = ɵɵdefineInjectable({ factory: function PayService_Factory() { return new PayService(); }, token: PayService, providedIn: "root" });
PayService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], PayService);

const payWizardConfig = (translateService, baseUrl) => [
    ({ title }) => ({
        fetchUrl: `http://localhost:61466/auth/getProfile`,
        fetchMethod: 'GET',
        responseField: 'records',
        title: translateService.translate(title),
        form: (_) => ({
            fields: {
                paymentReferenceNumber: {
                    type: 'text',
                    label: 'Payment Reference Number',
                    required: true,
                },
                paymentDay: {
                    type: 'calendar',
                    label: 'Payment Date',
                    componentProperties: {
                        minDate: new Date(),
                    },
                },
            },
        }),
        response: ({ screenConfig, response }) => {
            const { form } = screenConfig;
            return form(response);
        },
        buttons: {
            cancel: {
                label: translateService.translate('ACTIONS.CANCEL'),
            },
            next: {
                label: translateService.translate('ACTIONS.NEXT'),
                componentProperties: {
                    style: { 'flex-grow': 1 },
                },
            },
        },
    }),
    ({ title }) => ({
        fetchUrl: `http://localhost:61466/auth/getProfile`,
        fetchMethod: 'GET',
        responseField: 'records',
        title: translateService.translate(title),
        form: (_) => ({
            fields: {
                paymentReferenceNumber: {
                    type: 'text',
                    label: 'Payment Reference Number',
                    required: true,
                },
                paymentDay: {
                    type: 'calendar',
                    label: 'Payment Date',
                    componentProperties: {
                        minDate: new Date(),
                    },
                },
            },
        }),
        response: ({ screenConfig, response }) => {
            const { form } = screenConfig;
            return form(response);
        },
        buttons: {
            cancel: {
                label: translateService.translate('ACTIONS.CANCEL'),
            },
            next: {
                label: translateService.translate('ACTIONS.NEXT'),
                componentProperties: {
                    style: { 'flex-grow': 1 },
                },
            },
        },
    }),
];
const searchFilters = (term = '', pagination, advancedSearch) => {
    const page = pagination !== null && pagination !== undefined ? pagination : {};
    const search = {
        search: {
            term,
            filters: advancedSearch,
        },
        sort: {},
        page: {
            limit: page.rows ? page.rows : 25,
            offset: page.first ? page.first : 0,
        },
    };
    Object.assign(search, page.sortField && {
        sort: { field: page.sortField, order: page.sortOrder },
    });
    return search;
};

let ReceivedInvoiceComponent = class ReceivedInvoiceComponent {
    constructor(confirmationService, dialogService, mp, http, translocoService, toast, spinner, searchContainerLoaderService, store, payService, router, route, flipToCdaSrv, printOptionsService, popupService) {
        this.confirmationService = confirmationService;
        this.dialogService = dialogService;
        this.mp = mp;
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.store = store;
        this.payService = payService;
        this.router = router;
        this.route = route;
        this.flipToCdaSrv = flipToCdaSrv;
        this.printOptionsService = printOptionsService;
        this.popupService = popupService;
        // Warnings state
        this.showWarningsDialog = false;
        // Warnings List states
        this.showWarningsListDialog = false;
        this.warningSelections = [];
        this.warningsConfirmationLabels = {
            header: 'Clear Warnings',
            message: 'Are you sure you want to clear the selected warnings?',
            acceptLabel: 'Yes',
            rejectLabel: 'No',
        };
        this.showEditDialog = false;
        // = {
        //   endpoint: '/invoice/pay/form/step/1',
        //   httpMethod: HttpMethod.POST,
        //   body: { magma: 'good' },
        // };
        // kpi dashboard states
        this.dashBoardStateKey = 'invoicesDashboardState';
        this.dashBoardVisibilityStateKey = 'invoicesDashboardVisibilityState';
        this.categoryFilter = ['accountsPayable'];
        this.showCategories = false;
        this.defaultDashboardState = {
            dashboard: [
                'accountsPayable.newInvoicesUnprocessed',
                'accountsPayable.invoiceWarnings',
                'accountsPayable.invoicesOnHoldCurrent',
                'accountsPayable.newCreditsUnprocessed',
                'accountsPayable.selectKPI',
            ],
            gridArea: [[0, 1, 2, 3, 4]],
        };
        // display log states
        this.showDisplayLog = false;
        this.batchKey = 0;
        this.loggingUrl = '';
        // print states
        this.showPrintOptionsDialog = false;
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        this.isDirectInvoice = false;
        this.InvoicesToPrint = [];
        // On Hold states
        this.showOnHoldDialog = false;
        this.invoicesOnHold = [];
        this.templateTypes = TemplateTypes;
        // Action logs
        this.showActionLogs = false;
        // Accounting Export states
        this.showAccountingExport = false;
        this.controller = 'invoice';
        // search container loader states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'receivedInvoiceSearch';
        this.i18nSearchField = 'INVOICE.SENT_INVOICES_SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {
            pay: (selection) => {
                const search = Object.assign({}, searchFilters(this.searchContainerLoaderService.term, this.searchContainerLoaderService.pagination, this.searchContainerLoaderService.filters));
                this.payService.search = search;
                this.payService.selectedKeys = [...selection].map((_a) => {
                    var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                    return invoiceKey;
                });
                this.router.navigate(['../payment-details'], { relativeTo: this.route });
            },
            printOptions: (selection) => {
                this.showPrintOptionsDialog = true;
            },
            print: (selection) => {
                var _a;
                this.InvoicesToPrint = [...selection].map((_a) => {
                    var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                    return invoiceKey;
                });
                if (((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) > 0) {
                    this.bulkPrint();
                }
                else {
                    this.triggeredByPrint = true;
                    this.showPrintOptionsDialog = true;
                }
            },
            onHold: (selection) => {
                this.invoicesOnHold = [...selection].map((_a) => {
                    var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                    return invoiceKey;
                });
                this.onHoldWizardConfig = {
                    endpoint: `${this.controller}/on-hold/form`,
                    httpMethod: HttpMethod.POST,
                    body: {
                        invoiceKeys: [...selection].map((_a) => {
                            var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                            return invoiceKey;
                        }),
                    },
                };
                this.showOnHoldDialog = true;
            },
            markProcessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('INVOICE.PROCESSED_MESSAGE'),
                    header: this.translocoService.translate('INVOICE.PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'mark-processed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                                return invoiceKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnprocessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('INVOICE.UNPROCESSED_MESSAGE'),
                    header: this.translocoService.translate('INVOICE.PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'mark-unprocessed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                                return invoiceKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markRead: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('INVOICE.READ_MESSAGE'),
                    header: this.translocoService.translate('INVOICE.READ_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'mark-read',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                                return invoiceKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnread: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('INVOICE.UNREAD_MESSAGE'),
                    header: this.translocoService.translate('INVOICE.UNREAD_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'mark-unread',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                                return invoiceKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            delete: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('VALIDATION_MESSAGE.DELETE_CONFIRMATION_MESSAGE'),
                    header: this.translocoService.translate('VALIDATION_MESSAGE.DELETE_CONFIRMATION_HEADER'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'delete',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                                return invoiceKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError((err) => {
                            var _a;
                            ((_a = err === null || err === void 0 ? void 0 : err.error) === null || _a === void 0 ? void 0 : _a.errorCode) === 5
                                ? this.confirmationService.confirm({
                                    message: this.translocoService.translate('INVOICE.SOME_NOT_DELETED'),
                                    header: this.translocoService.translate('VALIDATION_MESSAGE.DELETE_CONFIRMATION_HEADER'),
                                    acceptVisible: false,
                                    rejectVisible: true,
                                    rejectLabel: this.translocoService.translate('ACTIONS.CLOSE'),
                                    reject: () => {
                                        this.searchContainerLoaderService.refreshSearch();
                                    },
                                })
                                : this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR'));
                            return of({});
                        }), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            restore: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('VALIDATION_MESSAGE.RESTORE_CONFIRMATION_MESSAGE'),
                    header: this.translocoService.translate('VALIDATION_MESSAGE.RESTORE_CONFIRMATION_HEADER'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'restore',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                                return invoiceKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            export: (selection) => {
                this.selections = selection;
                this.openExport();
            },
            edit: (selection) => {
                var _a;
                const invoiceKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.invoiceKey;
                this.wizardConfig = {
                    endpoint: `receivedinvoice/form/${this.controller}/${invoiceKey}/edit`,
                    httpMethod: HttpMethod.GET,
                };
                this.selections = selection;
                this.showEditDialog = true;
            },
            displayLog: (selection) => {
                var _a;
                this.batchKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.invoiceKey;
                this.loggingUrl = `${this.mp.getConfig().receivedInvoice}/invoicehistory/${this.batchKey}/form`;
                this.showDisplayLog = true;
            },
            warnings: (selection) => {
                this.warningSelections = [...selection].map((_a) => {
                    var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                    return invoiceKey;
                });
                this.warningsDialogWizard = {
                    endpoint: `receivedinvoice/${this.controller}/warning/form`,
                    httpMethod: HttpMethod.POST,
                    body: {
                        keys: this.warningSelections,
                    },
                };
                this.showWarningsDialog = true;
            },
            removeHold: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('VALIDATION_MESSAGE.REMOVE_HOLD_MESSAGE'),
                    header: this.translocoService.translate('VALIDATION_MESSAGE.REMOVE_HOLD_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'remove-hold',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                                return invoiceKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            claim: (selection) => {
                this.warningSelections = [...selection].map((_a) => {
                    var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                    return invoiceKey;
                });
                this.flipToCdaSrv.wizardConfig = {
                    endpoint: apiUrls.flipToCdaConfig(),
                    httpMethod: HttpMethod.POST,
                    body: {
                        key: this.warningSelections[0],
                    },
                };
                this.flipToCdaSrv.baseUrl = this.apiBaseUrl;
                if (this.isDirectInvoice) {
                    this.router.navigate([moduleUrls.flipToDirectInvoice_CDA()]);
                    this.flipToCdaSrv.redirectUrl = moduleUrls.directInvoice();
                }
                else {
                    this.router.navigate([moduleUrls.flipToCDA()]);
                    this.flipToCdaSrv.redirectUrl = moduleUrls.receivedInvoice();
                }
            },
            runDataGenius: (selection) => {
                this.selections = selection;
                this.openDataGenius();
            },
            actionLogs: (selection) => {
                var _a;
                const invoiceKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.invoiceKey;
                this.actionLogsWizard = {
                    endpoint: `/${this.controller}/${invoiceKey}/actionlogs/form`,
                    httpMethod: HttpMethod.GET,
                };
                this.showActionLogs = true;
            },
            accountingExport: (selection) => {
                this.accountExportConfig = {
                    endpoint: `connector/ui/receivedinvoice/export/unacknowledged`,
                    httpMethod: HttpMethod.POST,
                };
                this.selections = selection;
                this.showAccountingExport = true;
            },
        };
        this.baseUrl = `${this.mp.getConfig().receivedInvoice}/invoice`;
        this.directInvoiceUrl = `${this.mp.getConfig().receivedInvoice}/directinvoice`;
        this.wizardUrl = `${this.mp.getConfig().receivedInvoice}`;
        this.apiBaseUrl = `${this.mp.getConfig().apiBaseUrl}`;
        this.warningsBaseUrl = `${this.mp.getConfig().receivedInvoice}/invoice`;
        this.warningsUrl = `/warning/form`;
        this.warningsSubmitUrl = `/warning/clear`;
        this.columnActions = {};
        this.defaultState = {
            page: 0,
            title: 'INVOICE.ACCOUNTING_IMPORT',
            screens: {},
        };
        this.email = '';
        this.route.data
            .pipe(tap((data) => {
            this.isDirectInvoice = data.directInvoice;
            this.baseUrl = `${this.mp.getConfig().apiBaseUrl}/${data.url}`;
            if (data.directInvoice) {
                this.controller = 'directinvoice';
            }
        }))
            .subscribe();
        http.baseUrl = this.baseUrl;
        this.wizardBaseUrl = mp.getConfig().receivedInvoice;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.push(this.store
                .pipe(select(selectors.isAuthorized, {
                edit: toolKeys.MP_INVOICE_VIEW,
                print: toolKeys.MP_RECEIVED_INVOICE_PRINT,
                directInvoicePrint: toolKeys.MP_DIRECT_INVOICE_PRINT,
            }), tap((authorizedButtons) => {
                this.columnActions = {
                    invoiceNumber: authorizedButtons.print ||
                        authorizedButtons.directInvoicePrint
                        ? {
                            link: () => ({ path: './' }),
                            event: (receivedInvoice) => ({
                                data: { receivedInvoice },
                                eventType: EventType.PRINT,
                            }),
                        }
                        : {},
                    warnings: {
                        link: () => {
                            return { path: './' };
                        },
                        event: (receivedInvoice) => ({
                            data: { receivedInvoice },
                            eventType: EventType.WARNINGS,
                        }),
                        icon: 'exclamation-triangle',
                        styleClass: 'warnings-icon',
                    },
                    attachmentCount: authorizedButtons.print ||
                        authorizedButtons.directInvoicePrint
                        ? {
                            link: () => {
                                return { path: './' };
                            },
                            event: (receivedInvoice) => ({
                                data: { receivedInvoice },
                                eventType: EventType.ATTACHMENT,
                            }),
                            icon: 'paperclip',
                            styleClass: 'column-icon',
                        }
                        : {
                            link: () => {
                                return { path: './' };
                            },
                            event: (receivedInvoice) => ({
                                data: { receivedInvoice },
                                eventType: EventType.DISABLED,
                            }),
                            icon: 'paperclip',
                            styleClass: 'column-icon disabled',
                        },
                };
            }))
                .subscribe(), this.store
                .pipe(select(selectors.userProfile), tap((user) => {
                this.email = user.sub;
            }))
                .subscribe());
            this.selectedPrintOptions = yield this.printOptionsService.get('', toolKeys.MP_RECEIVED_INVOICE_PRINT);
        });
    }
    searchContainerEvent({ data, eventType }) {
        const { receivedInvoice } = data;
        switch (eventType) {
            case EventType.PRINT:
                this.print(receivedInvoice);
                break;
            case EventType.WARNINGS:
                const key = receivedInvoice === null || receivedInvoice === void 0 ? void 0 : receivedInvoice.invoiceKey;
                this.warningsDialogWizard = {
                    endpoint: `receivedinvoice/${this.controller}/warning/form`,
                    httpMethod: HttpMethod.POST,
                    body: {
                        keys: [key],
                    },
                };
                this.showWarningsDialog = true;
                break;
            case EventType.ATTACHMENT:
                const invoiceKey = receivedInvoice === null || receivedInvoice === void 0 ? void 0 : receivedInvoice.invoiceKey;
                this.popupService.openWizard({
                    endpoint: `/receivedInvoice/ui/${this.controller}/${invoiceKey}/attachments`,
                    httpMethod: HttpMethod.POST,
                    body: {},
                });
                break;
            default:
                break;
        }
    }
    closeWarningsDialog() {
        this.searchContainerLoaderService.refreshSearch();
        this.showWarningsDialog = false;
    }
    submitWarningsDialog(event) {
        this.showWarningsDialog = false;
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.searchContainerLoaderService.refreshSearch();
    }
    // single print
    print(receivedInvoice) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `${receivedInvoice === null || receivedInvoice === void 0 ? void 0 : receivedInvoice.invoiceKey}/print`,
            httpMethod: 'GET',
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
            .subscribe();
    }
    // if triggered from bulk print then it also prints the selected documents
    updatePrintOptions(selectedPrintOptions) {
        this.selectedPrintOptions = selectedPrintOptions;
        if (this.triggeredByPrint) {
            this.bulkPrint();
        }
        this.closePrintOptionsDialog();
    }
    bulkPrint() {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `print`,
            httpMethod: 'POST',
            body: this.InvoicesToPrint,
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            var _a;
            ((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) === 1
                ? saveAs(response, 'MergedDocuments')
                : this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.InvoicesToPrint = [];
            this.triggeredByPrint = false;
            this.spinner.off();
        }))
            .subscribe();
    }
    bulkUpdateOnHold(options) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `bulk-update`,
            httpMethod: 'POST',
            body: {
                isOnHold: {
                    value: Boolean(Number(options === null || options === void 0 ? void 0 : options.status)),
                },
                onHoldTypeKey: {
                    value: Number(options === null || options === void 0 ? void 0 : options.onHoldReason),
                },
                keys: this.invoicesOnHold,
            },
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.closeOnHoldDialog();
            this.invoicesOnHold = [];
            this.spinner.off();
        }))
            .subscribe();
    }
    closePrintOptionsDialog() {
        this.showPrintOptionsDialog = false;
    }
    openPdfViewer(data) {
        const ref = this.dialogService.open(PdfViewerComponent, {
            data: {
                response: data,
            },
            styleClass: 'pdf-viewer',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
    }
    openExport() {
        const ref = this.dialogService.open(ExportComponent, {
            data: {
                endpoint: `${this.baseUrl}/export/form`,
            },
            showHeader: false,
            styleClass: 'export-dialog',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
        const refSubscription = ref.onClose
            .pipe(mergeMap((exportOptions) => exportOptions ? this.submitExport(exportOptions) : EMPTY), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
            .subscribe();
        this.subscriptions = [...this.subscriptions, refSubscription];
    }
    submitExport(exportOptions) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.spinner.on();
        return this.http
            .fetchWithFqn({
            endpoint: `${this.mp.getConfig().receivedInvoice}/${this.controller}/export`,
            httpMethod: 'POST',
            body: Object.assign(Object.assign({}, exportOptions), { email: this.email, toolkeys: '', keys: [...this.selections].map((_a) => {
                    var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                    return invoiceKey;
                }), page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows }, sort: {
                    field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                    order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                }, search: {
                    filters: this.searchContainerLoaderService.filters,
                    term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
                } }),
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()));
    }
    ngOnDestroy() {
        this.dynamicDialogRefs.forEach((ref) => ref.destroy());
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
    editSubmit(data) {
        this.confirmationService.confirm({
            header: this.translocoService.translate('ACTIONS.SAVE'),
            message: this.translocoService.translate('VALIDATION_MESSAGE.CONFIRMATION_MESSAGE'),
            acceptLabel: this.translocoService.translate('ACTIONS.YES'),
            rejectLabel: this.translocoService.translate('ACTIONS.NO'),
            accept: () => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
                this.showEditDialog = false;
                this.spinner.on();
                this.http
                    .fetchWithFqn({
                    endpoint: `${this.mp.getConfig().receivedInvoice}/${this.controller}/edit/${(_a = this.selections[0]) === null || _a === void 0 ? void 0 : _a.invoiceKey}`,
                    httpMethod: HttpMethod.PUT,
                    body: {
                        marketplaceName: (_d = (_c = (_b = data[0]) === null || _b === void 0 ? void 0 : _b.marketplaceName) === null || _c === void 0 ? void 0 : _c.Key) !== null && _d !== void 0 ? _d : null,
                        supplierName: (_g = (_f = (_e = data[0]) === null || _e === void 0 ? void 0 : _e.supplierName) === null || _f === void 0 ? void 0 : _f.Key) !== null && _g !== void 0 ? _g : null,
                        orderedByName: (_k = (_j = (_h = data[0]) === null || _h === void 0 ? void 0 : _h.orderedByName) === null || _j === void 0 ? void 0 : _j.Key) !== null && _k !== void 0 ? _k : null,
                        shipToName: (_o = (_m = (_l = data[0]) === null || _l === void 0 ? void 0 : _l.shipToName) === null || _m === void 0 ? void 0 : _m.Key) !== null && _o !== void 0 ? _o : null,
                    },
                })
                    .pipe(tap(() => {
                    this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                    this.searchContainerLoaderService.refreshSearch();
                }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                    .subscribe();
            },
        });
    }
    closeDisplayLog() {
        this.showDisplayLog = false;
    }
    closeEdit() {
        this.confirmationService.confirm({
            header: this.translocoService.translate('ACTIONS.CANCEL'),
            message: this.translocoService.translate('COMMON.CONFIRM_LEAVE'),
            acceptLabel: this.translocoService.translate('ACTIONS.YES'),
            rejectLabel: this.translocoService.translate('ACTIONS.NO'),
            accept: () => {
                this.showEditDialog = false;
            },
        });
    }
    closeOnHoldDialog(event) {
        this.showOnHoldDialog = false;
    }
    submitOnHoldDialog(options) {
        this.showOnHoldDialog = false;
        this.searchContainerLoaderService.refreshSearch();
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
    closeActionLogs() {
        this.showActionLogs = false;
    }
    submitActionLogs(options) {
        this.showActionLogs = false;
        this.searchContainerLoaderService.refreshSearch();
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
    openDataGenius() {
        const ref = this.dialogService.open(DataGeniusSelectionComponent, {
            showHeader: false,
            styleClass: 'export-dialog',
            data: {
                selectionCount: this.selections.length,
            },
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
        const refSubscription = ref.onClose
            .pipe(mergeMap((dgOptions) => dgOptions ? this.submitDataGenius(dgOptions) : EMPTY), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
            .subscribe();
        this.subscriptions = [...this.subscriptions, refSubscription];
    }
    submitDataGenius(dgOptions) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.spinner.on();
        return this.http
            .fetchWithFqn({
            endpoint: `${this.mp.getConfig().receivedInvoice}/invoice/rundatagenius`,
            httpMethod: 'POST',
            body: Object.assign(Object.assign({}, dgOptions), { keys: [...this.selections].map((_a) => {
                    var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                    return invoiceKey;
                }), page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows }, sort: {
                    field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                    order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                }, search: {
                    filters: this.searchContainerLoaderService.filters,
                    term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
                } }),
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()));
    }
    closeAccountingExport() {
        this.showAccountingExport = false;
    }
    submitAccountingExport(event) {
        this.showAccountingExport = false;
        this.searchContainerLoaderService.refreshSearch();
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
};
ReceivedInvoiceComponent.ctorParameters = () => [
    { type: ConfirmationService$1 },
    { type: DialogService$1 },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: Store },
    { type: PayService },
    { type: Router },
    { type: ActivatedRoute },
    { type: CdaWizardService },
    { type: PrintOptionsService },
    { type: PopupService }
];
ReceivedInvoiceComponent = __decorate([
    Component({
        selector: 'lib-received-invoice',
        template: "<div class=\"view-invoices\">\r\n  <h2 *ngIf=\"isDirectInvoice\">\r\n    {{ 'BREADCRUMB.DIRECT_INVOICES' | transloco }}\r\n  </h2>\r\n  <div class=\"dashboard\" *ngIf=\"!isDirectInvoice\">\r\n    <lib-dashboard-container\r\n      [dashBoardStateKey]=\"dashBoardStateKey\"\r\n      [dashBoardVisibilityStateKey]=\"dashBoardVisibilityStateKey\"\r\n      [dashBoardHeader]=\"'INVOICE.INVOICE'\"\r\n      [categoryFilter]=\"categoryFilter\"\r\n      [showCategories]=\"showCategories\"\r\n      [defaultDashboardState]=\"defaultDashboardState\"\r\n    ></lib-dashboard-container>\r\n  </div>\r\n  <!-- <button (click)=\"toolbarActionsDispatcher.pay([])\">pay</button> -->\r\n\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"baseUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n\r\n  <p-dialog\r\n    *ngIf=\"showPrintOptionsDialog\"\r\n    [visible]=\"true\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '520px' }\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [showHeader]=\"false\"\r\n    [focusOnShow]=\"false\"\r\n    position=\"center\"\r\n  >\r\n    <lib-print-options-container\r\n      [baseUrl]=\"baseUrl\"\r\n      [selectedPrintOptions]=\"selectedPrintOptions\"\r\n      (closeDialog)=\"closePrintOptionsDialog()\"\r\n      (updatePrintOptions)=\"updatePrintOptions($event)\"\r\n    ></lib-print-options-container>\r\n  </p-dialog>\r\n\r\n  <p-dialog\r\n    *ngIf=\"showOnHoldDialog\"\r\n    [visible]=\"true\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '520px' }\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [showHeader]=\"false\"\r\n    [focusOnShow]=\"false\"\r\n    position=\"center\"\r\n  >\r\n    <lui-wizard-v3\r\n      [baseUrl]=\"wizardBaseUrl\"\r\n      [wizardConfig]=\"onHoldWizardConfig\"\r\n      (submit)=\"submitOnHoldDialog($event)\"\r\n      (cancel)=\"closeOnHoldDialog()\"\r\n    ></lui-wizard-v3>\r\n  </p-dialog>\r\n\r\n  <p-dialog\r\n    *ngIf=\"showWarningsDialog\"\r\n    [visible]=\"true\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '50vw' }\"\r\n    [autoZIndex]=\"false\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [showHeader]=\"false\"\r\n    [focusOnShow]=\"false\"\r\n    position=\"center\"\r\n  >\r\n    <lui-wizard-v3\r\n      [baseUrl]=\"apiBaseUrl\"\r\n      [wizardConfig]=\"warningsDialogWizard\"\r\n      (submit)=\"submitWarningsDialog($event)\"\r\n      (cancel)=\"closeWarningsDialog()\"\r\n    >\r\n      <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n        <div\r\n          class=\"error\"\r\n          style=\"\r\n            min-height: 30vh;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n          \"\r\n        >\r\n          <div>\r\n            <span>\r\n              <i class=\"pi pi-times-circle\"></i>\r\n              {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n            </span>\r\n          </div>\r\n        </div>\r\n        <button pButton (click)=\"closeWarningsDialog()\" class=\"ds secondary\">\r\n          {{ 'ACTIONS.CANCEL' | transloco }}\r\n        </button>\r\n      </ng-template>\r\n    </lui-wizard-v3>\r\n  </p-dialog>\r\n\r\n  <p-dialog\r\n    *ngIf=\"showDisplayLog\"\r\n    [visible]=\"true\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '50vw' }\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [showHeader]=\"false\"\r\n    [focusOnShow]=\"false\"\r\n    position=\"center\"\r\n  >\r\n    <lib-logging\r\n      [baseUrl]=\"loggingUrl\"\r\n      [batchKey]=\"batchKey\"\r\n      (closeLogDialog)=\"closeDisplayLog()\"\r\n    >\r\n    </lib-logging>\r\n  </p-dialog>\r\n\r\n  <p-dialog\r\n    *ngIf=\"showEditDialog\"\r\n    [visible]=\"true\"\r\n    [modal]=\"true\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [showHeader]=\"false\"\r\n    [focusOnShow]=\"false\"\r\n    [autoZIndex]=\"false\"\r\n    [baseZIndex]=\"9\"\r\n    position=\"center\"\r\n    [styleClass]=\"'visible-dropdown edit-invoice-container'\"\r\n  >\r\n    <lui-wizard-v3\r\n      [baseUrl]=\"apiBaseUrl\"\r\n      [wizardConfig]=\"wizardConfig\"\r\n      (submit)=\"editSubmit($event)\"\r\n      (cancel)=\"closeEdit()\"\r\n    >\r\n      <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n        <div>\r\n          <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n        </div>\r\n      </ng-template>\r\n      <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n        <div\r\n          class=\"error\"\r\n          style=\"\r\n            min-height: 30vh;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n          \"\r\n        >\r\n          <div>\r\n            <span>\r\n              <i class=\"pi pi-times-circle\"></i>\r\n              {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n            </span>\r\n          </div>\r\n        </div>\r\n        <button pButton (click)=\"closeEdit()\" class=\"ds secondary\">\r\n          {{ 'ACTIONS.CANCEL' | transloco }}\r\n        </button>\r\n      </ng-template>\r\n    </lui-wizard-v3>\r\n  </p-dialog>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showActionLogs\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"wizardUrl\"\r\n    [wizardConfig]=\"actionLogsWizard\"\r\n    (submit)=\"submitActionLogs($event)\"\r\n    (cancel)=\"closeActionLogs()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n      <div>\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeActionLogs()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showAccountingExport\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '60vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"apiBaseUrl\"\r\n    [wizardConfig]=\"accountExportConfig\"\r\n    (submit)=\"submitAccountingExport($event)\"\r\n    (cancel)=\"closeAccountingExport()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n      <div>\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeAccountingExport()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, DialogService$1]
    })
], ReceivedInvoiceComponent);

const ɵ0$3 = {
    breadcrumb: 'BREADCRUMB.INVOICES',
    url: 'receivedinvoice/invoice',
    directInvoice: false,
}, ɵ1$2 = {
    breadcrumb: 'BREADCRUMB.DIRECT_INVOICES',
    url: 'receivedinvoice/directinvoice',
    directInvoice: true,
}, ɵ2$2 = { breadcrumb: 'NAV.CLAIMS' }, ɵ3$1 = { breadcrumb: 'NAV.CLAIMS' };
const routes$1 = [
    {
        path: 'invoices',
        data: ɵ0$3,
        component: ReceivedInvoiceComponent,
    },
    {
        path: 'direct-invoices',
        data: ɵ1$2,
        component: ReceivedInvoiceComponent,
    },
    {
        path: 'cda-flip',
        component: CdaWizardComponent,
        canDeactivate: [CanDeactivateGuard],
        data: ɵ2$2,
    },
    {
        path: 'di-cda-flip',
        component: CdaWizardComponent,
        canDeactivate: [CanDeactivateGuard],
        data: ɵ3$1,
    },
];

let PoaReceivedComponent = class PoaReceivedComponent {
    constructor(confirmationService, dialogService, mp, http, translocoService, toast, spinner, searchContainerLoaderService, store, printOptionsService) {
        this.confirmationService = confirmationService;
        this.dialogService = dialogService;
        this.mp = mp;
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.store = store;
        this.printOptionsService = printOptionsService;
        // Warnings state
        this.showWarningsDialog = false;
        // kpi dashboard states
        this.dashBoardStateKey = 'receivedPOADashboardState';
        this.dashBoardVisibilityStateKey = 'receivedPOADashboardVisibilityState';
        this.categoryFilter = ['orderingReceiving'];
        this.showCategories = false;
        this.defaultDashboardState = {
            dashboard: ['orderingReceiving.newPOAUnprocessed'],
            gridArea: [[0]],
        };
        // display log states
        this.showDisplayLog = false;
        this.batchKey = 0;
        this.loggingUrl = '';
        // print states
        this.showPrintOptionsDialog = false;
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        this.poasToPrint = [];
        // Action logs
        this.showActionLogs = false;
        this.templateTypes = TemplateTypes;
        // search container loader states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'receivedPoaSearch';
        this.i18nSearchField = 'POA_RECEIVED.SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {
            printOptions: (selection) => {
                this.showPrintOptionsDialog = true;
            },
            print: (selection) => {
                var _a;
                this.poasToPrint = [...selection].map((_a) => {
                    var { poaKey } = _a, _ = __rest(_a, ["poaKey"]);
                    return poaKey;
                });
                if (((_a = Object.keys(this.selectedPrintOptions || {})) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.bulkPrint();
                }
                else {
                    this.triggeredByPrint = true;
                    this.showPrintOptionsDialog = true;
                }
            },
            markProcessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('POA_RECEIVED.PROCESSED_MESSAGE'),
                    header: this.translocoService.translate('POA_RECEIVED.PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'poa/mark-processed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { poaKey } = _a, _ = __rest(_a, ["poaKey"]);
                                return poaKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnprocessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('POA_RECEIVED.UNPROCESSED_MESSAGE'),
                    header: this.translocoService.translate('POA_RECEIVED.PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'poa/mark-unprocessed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { poaKey } = _a, _ = __rest(_a, ["poaKey"]);
                                return poaKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markRead: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('POA_RECEIVED.READ_MESSAGE'),
                    header: this.translocoService.translate('POA_RECEIVED.READ_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'poa/mark-read',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { poaKey } = _a, _ = __rest(_a, ["poaKey"]);
                                return poaKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnread: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('POA_RECEIVED.UNREAD_MESSAGE'),
                    header: this.translocoService.translate('POA_RECEIVED.UNREAD_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'poa/mark-unread',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { poaKey } = _a, _ = __rest(_a, ["poaKey"]);
                                return poaKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            export: (selection) => {
                this.selections = selection;
                this.openExport();
            },
            displayLog: (selection) => {
                var _a;
                this.batchKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.poaKey;
                this.loggingUrl = `${this.mp.getConfig().receivedPoa}/poahistory/${this.batchKey}/form`;
                this.showDisplayLog = true;
            },
            runDataGenius: (selection) => {
                this.selections = selection;
                this.openDataGenius();
            },
            actionLogs: (selection) => {
                var _a;
                const poaKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.poaKey;
                this.actionLogsWizard = {
                    endpoint: `/${poaKey}/actionlogs/form`,
                    httpMethod: HttpMethod$2.GET,
                };
                this.showActionLogs = true;
            },
            warnings: (selection) => {
                const poaKeys = [...selection].map((_a) => {
                    var { poaKey } = _a, _ = __rest(_a, ["poaKey"]);
                    return poaKey;
                });
                this.warningsDialogWizard = {
                    endpoint: `receivedpoa/poa/warning/form`,
                    httpMethod: HttpMethod$2.POST,
                    body: {
                        keys: poaKeys,
                    },
                };
                this.showWarningsDialog = true;
            },
        };
        this.baseUrl = `${this.mp.getConfig().receivedPoa}/poa`;
        this.apiBaseUrl = `${this.mp.getConfig().apiBaseUrl}`;
        this.columnActions = {};
        this.email = '';
        http.baseUrl = mp.getConfig().receivedPoa;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.push(this.store
                .pipe(select(selectors.isAuthorized, {
                edit: toolKeys.MP_POA_VIEW,
                print: toolKeys.MP_RECEIVED_POA_PRINT,
            }), tap((authorizedButtons) => {
                this.columnActions = {
                    poNumber: authorizedButtons.print
                        ? {
                            link: () => ({ path: './' }),
                            event: (receivedPoa) => ({
                                data: { receivedPoa },
                                eventType: EventType.PRINT,
                            }),
                        }
                        : {},
                    warnings: {
                        link: () => {
                            return { path: './' };
                        },
                        event: (receivedPoa) => ({
                            data: { receivedPoa },
                            eventType: EventType.WARNINGS,
                        }),
                        icon: 'exclamation-triangle',
                        styleClass: 'warnings-icon',
                    },
                };
            }))
                .subscribe(), this.store
                .pipe(select(selectors.userProfile), tap((user) => {
                this.email = user.sub;
            }))
                .subscribe());
            this.selectedPrintOptions = yield this.printOptionsService.get('poa', toolKeys.MP_RECEIVED_POA_PRINT);
        });
    }
    print(receivedPoa) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `poa/${receivedPoa === null || receivedPoa === void 0 ? void 0 : receivedPoa.poaKey}/print`,
            httpMethod: 'GET',
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
            .subscribe();
    }
    searchContainerEvent({ data, eventType }) {
        const { receivedPoa } = data;
        switch (eventType) {
            case EventType.PRINT:
                this.print(receivedPoa);
                break;
            case EventType.WARNINGS:
                this.selectedPoaKey = receivedPoa === null || receivedPoa === void 0 ? void 0 : receivedPoa.poaKey;
                this.warningsDialogWizard = {
                    endpoint: `receivedpoa/poa/warning/form`,
                    httpMethod: HttpMethod$2.POST,
                    body: {
                        keys: [this.selectedPoaKey],
                    },
                };
                this.showWarningsDialog = true;
                break;
            default:
                break;
        }
    }
    closeWarningsDialog() {
        this.searchContainerLoaderService.refreshSearch();
        this.showWarningsDialog = false;
    }
    // if triggered from bulk print then it also prints the selected documents
    updatePrintOptions(selectedPrintOptions) {
        this.selectedPrintOptions = selectedPrintOptions;
        if (this.triggeredByPrint) {
            this.bulkPrint();
        }
        this.closePrintOptionsDialog();
    }
    bulkPrint() {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `poa/print`,
            httpMethod: 'POST',
            body: this.poasToPrint,
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            var _a;
            ((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) === 1
                ? saveAs(response, 'MergedDocuments')
                : this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.poasToPrint = [];
            this.triggeredByPrint = false;
            this.spinner.off();
        }))
            .subscribe();
    }
    closePrintOptionsDialog() {
        this.showPrintOptionsDialog = false;
    }
    openPdfViewer(data) {
        const ref = this.dialogService.open(PdfViewerComponent, {
            data: {
                response: data,
            },
            styleClass: 'pdf-viewer',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
    }
    openExport() {
        const ref = this.dialogService.open(ExportComponent, {
            data: {
                endpoint: `${this.baseUrl}/export/form`,
            },
            showHeader: false,
            styleClass: 'export-dialog',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
        const refSubscription = ref.onClose
            .pipe(mergeMap((exportOptions) => exportOptions ? this.submitExport(exportOptions) : EMPTY), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
            .subscribe();
        this.subscriptions = [...this.subscriptions, refSubscription];
    }
    submitExport(exportOptions) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.spinner.on();
        return this.http
            .fetchWithFqn({
            endpoint: `${this.mp.getConfig().receivedPoa}/poa/export`,
            httpMethod: 'POST',
            body: Object.assign(Object.assign({}, exportOptions), { email: this.email, toolkeys: '', keys: [...this.selections].map((_a) => {
                    var { poaKey } = _a, _ = __rest(_a, ["poaKey"]);
                    return poaKey;
                }), page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows }, sort: {
                    field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                    order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                }, search: {
                    filters: this.searchContainerLoaderService.filters,
                    term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
                } }),
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()));
    }
    ngOnDestroy() {
        this.dynamicDialogRefs.forEach((ref) => ref.destroy());
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
    closeDisplayLog() {
        this.showDisplayLog = false;
    }
    closeActionLogs() {
        this.showActionLogs = false;
    }
    submitActionLogs(options) {
        this.showActionLogs = false;
        this.searchContainerLoaderService.refreshSearch();
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
    submitWarningsDialog(event) {
        this.showWarningsDialog = false;
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.searchContainerLoaderService.refreshSearch();
    }
    openDataGenius() {
        const ref = this.dialogService.open(DataGeniusSelectionComponent, {
            showHeader: false,
            styleClass: 'export-dialog',
            data: {
                selectionCount: this.selections.length,
            },
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
        const refSubscription = ref.onClose
            .pipe(mergeMap((dgOptions) => dgOptions ? this.submitDataGenius(dgOptions) : EMPTY), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
            .subscribe();
        this.subscriptions = [...this.subscriptions, refSubscription];
    }
    submitDataGenius(dgOptions) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.spinner.on();
        return this.http
            .fetchWithFqn({
            endpoint: `${this.mp.getConfig().receivedPoa}/poa/rundatagenius`,
            httpMethod: 'POST',
            body: Object.assign(Object.assign({}, dgOptions), { keys: [...this.selections].map((_a) => {
                    var { poaKey } = _a, _ = __rest(_a, ["poaKey"]);
                    return poaKey;
                }), page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows }, sort: {
                    field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                    order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                }, search: {
                    filters: this.searchContainerLoaderService.filters,
                    term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
                } }),
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()));
    }
};
PoaReceivedComponent.ctorParameters = () => [
    { type: ConfirmationService },
    { type: DialogService },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: Store },
    { type: PrintOptionsService }
];
PoaReceivedComponent = __decorate([
    Component({
        selector: 'lib-poa-received-beta',
        template: "<div class=\"view-invoices\">\r\n  <div class=\"dashboard\">\r\n    <lib-dashboard-container\r\n      [dashBoardStateKey]=\"dashBoardStateKey\"\r\n      [dashBoardVisibilityStateKey]=\"dashBoardVisibilityStateKey\"\r\n      [dashBoardHeader]=\"'POA_RECEIVED.POA_RECEIVED'\"\r\n      [categoryFilter]=\"categoryFilter\"\r\n      [showCategories]=\"showCategories\"\r\n      [defaultDashboardState]=\"defaultDashboardState\"\r\n    ></lib-dashboard-container>\r\n  </div>\r\n\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"baseUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showPrintOptionsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-print-options-container\r\n    [baseUrl]=\"baseUrl\"\r\n    [selectedPrintOptions]=\"selectedPrintOptions\"\r\n    (closeDialog)=\"closePrintOptionsDialog()\"\r\n    (updatePrintOptions)=\"updatePrintOptions($event)\"\r\n  ></lib-print-options-container>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showWarningsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"apiBaseUrl\"\r\n    [wizardConfig]=\"warningsDialogWizard\"\r\n    (submit)=\"submitWarningsDialog($event)\"\r\n    (cancel)=\"closeWarningsDialog()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeWarningsDialog()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showDisplayLog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-logging\r\n    [baseUrl]=\"loggingUrl\"\r\n    [batchKey]=\"batchKey\"\r\n    (closeLogDialog)=\"closeDisplayLog()\"\r\n  >\r\n  </lib-logging>\r\n</p-dialog>\r\n<p-dialog\r\n  *ngIf=\"showActionLogs\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"baseUrl\"\r\n    [wizardConfig]=\"actionLogsWizard\"\r\n    (submit)=\"submitActionLogs($event)\"\r\n    (cancel)=\"closeActionLogs()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n      <div>\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeActionLogs()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, DialogService]
    })
], PoaReceivedComponent);

const ɵ0$4 = { breadcrumb: 'BREADCRUMB.POAS_RECEIVED' };
const routes$2 = [
    {
        path: 'poas-received',
        component: PoaReceivedComponent,
        data: ɵ0$4,
    },
];

let ReceivedPOService = class ReceivedPOService {
    constructor() {
        this.redirectUrl = '/MarketplaceModule/order-fulfillment/received-po';
    }
};
ReceivedPOService.ɵprov = ɵɵdefineInjectable({ factory: function ReceivedPOService_Factory() { return new ReceivedPOService(); }, token: ReceivedPOService, providedIn: "root" });
ReceivedPOService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], ReceivedPOService);

let FlipDocTypeComponent = class FlipDocTypeComponent extends ComponentCanDeactivate {
    constructor(poService, confirmationService, translocoService, router) {
        super();
        this.poService = poService;
        this.confirmationService = confirmationService;
        this.translocoService = translocoService;
        this.router = router;
        this.templateTypes = TemplateTypes;
        this.cancelButtonClicked = false;
        this.wizardConfig = poService.wizardConfig;
        this.baseUrl = poService.baseUrl;
    }
    ngOnInit() {
        if (this.wizardConfig === undefined) {
            this.router.navigate([this.poService.redirectUrl]);
        }
    }
    submitNew(event) {
        this.cancelButtonClicked = true;
        this.router.navigate([this.poService.redirectUrl]);
    }
    redirect() {
        this.cancelButtonClicked = true;
        this.router.navigate([this.poService.redirectUrl]);
    }
    canDeactivate(nextState) {
        // when the cancel dialog is open, we don't want the alert to show and just nav away
        if (this.cancelButtonClicked) {
            return true;
        }
        return false;
    }
};
FlipDocTypeComponent.ctorParameters = () => [
    { type: ReceivedPOService },
    { type: ConfirmationService },
    { type: TranslocoService },
    { type: Router }
];
FlipDocTypeComponent = __decorate([
    Component({
        selector: 'lib-flip-doc-type',
        template: "<lui-wizard-v3\r\n  [baseUrl]=\"baseUrl\"\r\n  [wizardConfig]=\"wizardConfig\"\r\n  (submit)=\"submitNew($event)\"\r\n  (cancel)=\"redirect()\"\r\n>\r\n  <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n    <div\r\n      class=\"error\"\r\n      style=\"\r\n        min-height: 30vh;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n      \"\r\n    >\r\n      <div>\r\n        <span>\r\n          <i class=\"pi pi-times-circle\"></i>\r\n          {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n        </span>\r\n      </div>\r\n    </div>\r\n    <button pButton (click)=\"redirect()\" class=\"ds secondary\">\r\n      {{ 'ACTIONS.CANCEL' | transloco }}\r\n    </button>\r\n  </ng-template>\r\n</lui-wizard-v3>\r\n\r\n<p-confirmDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n"
    })
], FlipDocTypeComponent);

let ReceivedPoComponent = class ReceivedPoComponent {
    constructor(confirmationService, dialogService, mp, http, translocoService, toast, spinner, searchContainerLoaderService, store, route, router, poService, printOptionsService) {
        this.confirmationService = confirmationService;
        this.dialogService = dialogService;
        this.mp = mp;
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.store = store;
        this.route = route;
        this.router = router;
        this.poService = poService;
        this.printOptionsService = printOptionsService;
        // Warnings state
        this.showWarningsDialog = false;
        // Warnings List states
        this.showWarningsListDialog = false;
        this.warningSelections = [];
        this.warningsConfirmationLabels = {
            header: 'Clear Warnings',
            message: 'Are you sure you want to clear the selected warnings?',
            acceptLabel: 'Yes',
            rejectLabel: 'No',
        };
        // kpi dashboard states
        this.dashBoardStateKey = 'receivedPoDashboardState';
        this.dashBoardVisibilityStateKey = 'receivedPoDashboardVisibilityState';
        this.categoryFilter = ['orderFulfillment'];
        this.showCategories = false;
        this.defaultDashboardState = {
            dashboard: [
                'orderFulfillment.newPOUnprocessed',
                'orderFulfillment.poReceivedMTD',
                'orderFulfillment.poReceivedYTD',
            ],
            gridArea: [[0, 1, 2]],
        };
        // Action logs
        this.showActionLogs = false;
        this.templateTypes = TemplateTypes;
        // print states
        this.showPrintOptionsDialog = false;
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        this.posToPrint = [];
        // display log states
        this.showDisplayLog = false;
        this.batchKey = 0;
        this.loggingUrl = '';
        // display log states
        this.showConnectorExport = false;
        // Search COntainer state
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'receivedPOSearch';
        this.i18nSearchField = 'PURCHASE_ORDER_RECEIVED.SEARCH_BY';
        this.params = {};
        this.toolbarActionsDispatcher = {
            printOptions: (selection) => {
                this.showPrintOptionsDialog = true;
            },
            print: (selection) => {
                var _a;
                this.posToPrint = [...selection].map((_a) => {
                    var { poKey } = _a, _ = __rest(_a, ["poKey"]);
                    return poKey;
                });
                if (((_a = Object.keys(this.selectedPrintOptions || {})) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.bulkPrint();
                }
                else {
                    this.triggeredByPrint = true;
                    this.showPrintOptionsDialog = true;
                }
            },
            markProcessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('PURCHASE_ORDER_RECEIVED.PROCESSED_MESSAGE'),
                    header: this.translocoService.translate('PURCHASE_ORDER_RECEIVED.PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'po/mark-processed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { poKey } = _a, _ = __rest(_a, ["poKey"]);
                                return poKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnprocessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('INVOICE.PO_UNPROCESSED_MESSAGE'),
                    header: this.translocoService.translate('INVOICE.PO_PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'po/mark-unprocessed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { poKey } = _a, _ = __rest(_a, ["poKey"]);
                                return poKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markRead: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('PURCHASE_ORDER_RECEIVED.READ_MESSAGE'),
                    header: this.translocoService.translate('PURCHASE_ORDER_RECEIVED.READ_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'po/mark-read',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { poKey } = _a, _ = __rest(_a, ["poKey"]);
                                return poKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnread: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('PURCHASE_ORDER_RECEIVED.UNREAD_MESSAGE'),
                    header: this.translocoService.translate('PURCHASE_ORDER_RECEIVED.UNREAD_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'po/mark-unread',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { poKey } = _a, _ = __rest(_a, ["poKey"]);
                                return poKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            export: (selection) => {
                this.selections = selection;
                this.openExport();
            },
            connectorExport: (selection) => {
                this.showConnectorExport = true;
                this.connectorExportWizard = {
                    endpoint: `connector/ui/receivedpo/export`,
                    httpMethod: HttpMethod$2.POST,
                    body: {
                        poKeys: [...selection].map((_a) => {
                            var { poKey } = _a, _ = __rest(_a, ["poKey"]);
                            return poKey;
                        }),
                    },
                };
            },
            displayLog: (selection) => {
                var _a;
                this.batchKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.poKey;
                this.loggingUrl = `${this.mp.getConfig().receivedPo}/pohistory/${this.batchKey}/form`;
                this.showDisplayLog = true;
            },
            warnings: (selection) => {
                this.warningSelections = [...selection].map((_a) => {
                    var { poKey } = _a, _ = __rest(_a, ["poKey"]);
                    return poKey;
                });
                this.warningsDialogWizard = {
                    endpoint: `receivedpo/po/warning/form`,
                    httpMethod: HttpMethod$2.POST,
                    body: {
                        keys: this.warningSelections,
                    },
                };
                this.showWarningsDialog = true;
            },
            createInvoice: (selection) => {
                var _a;
                const selectedPOKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.poKey;
                this.poService.wizardConfig = {
                    endpoint: `receivedpo/po/fliptoinvoice`,
                    httpMethod: HttpMethod$2.POST,
                    body: {
                        key: selectedPOKey,
                    },
                };
                this.poService.baseUrl = this.wizardBaseUrl;
                this.router.navigate(['../flip-invoice'], { relativeTo: this.route });
            },
            createPoa: (selection) => {
                var _a;
                const selectedPOKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.poKey;
                this.poService.wizardConfig = {
                    endpoint: `receivedpo/po/fliptopoa`,
                    httpMethod: HttpMethod$2.POST,
                    body: {
                        key: selectedPOKey,
                    },
                };
                this.poService.baseUrl = this.wizardBaseUrl;
                this.router.navigate(['../flip-poa'], { relativeTo: this.route });
            },
            createAsn: (selection) => {
                var _a;
                const selectedPOKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.poKey;
                this.poService.wizardConfig = {
                    endpoint: `receivedpo/po/fliptoasn`,
                    httpMethod: HttpMethod$2.POST,
                    body: {
                        keys: [...selection].map((_a) => {
                            var { poKey } = _a, _ = __rest(_a, ["poKey"]);
                            return poKey;
                        }),
                    },
                };
                this.poService.baseUrl = this.wizardBaseUrl;
                this.router.navigate(['../flip-asn'], { relativeTo: this.route });
            },
            runDataGenius: (selection) => {
                this.selections = selection;
                this.openDataGenius();
            },
            actionLogs: (selection) => {
                var _a;
                const poKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.poKey;
                this.actionLogsWizard = {
                    endpoint: `/${poKey}/actionlogs/form`,
                    httpMethod: HttpMethod$2.GET,
                };
                this.showActionLogs = true;
            },
        };
        this.baseUrl = `${this.mp.getConfig().receivedPo}/po`;
        this.warningsBaseUrl = `${this.mp.getConfig().receivedPo}/po`;
        this.wizardBaseUrl = `${this.mp.getConfig().apiBaseUrl}`;
        this.warningsUrl = `/warning/form`;
        this.warningsSubmitUrl = `/warning/clear`;
        this.columnActions = {};
        this.email = '';
        http.baseUrl = mp.getConfig().receivedPo;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.push(this.store
                .pipe(select(selectors.isAuthorized, {
                edit: toolKeys.MP_PO_VIEW,
                print: toolKeys.MP_RECEIVED_PO_PRINT,
            }), tap((authorizedButtons) => {
                this.columnActions = {
                    poNumber: authorizedButtons.print
                        ? {
                            link: () => ({ path: './' }),
                            event: (receivedPo) => ({
                                data: { receivedPo },
                                eventType: EventType.PRINT,
                            }),
                        }
                        : {},
                    warnings: {
                        link: () => {
                            return { path: './' };
                        },
                        event: (receivedPo) => ({
                            data: { receivedPo },
                            eventType: EventType.WARNINGS,
                        }),
                        icon: 'exclamation-triangle',
                        styleClass: 'warnings-icon',
                    },
                };
            }))
                .subscribe(), this.store
                .pipe(select(selectors.userProfile), tap((user) => {
                this.email = user.sub;
            }))
                .subscribe());
            this.selectedPrintOptions = yield this.printOptionsService.get('po', toolKeys.MP_RECEIVED_PO_PRINT);
        });
    }
    searchContainerEvent({ data, eventType }) {
        const { receivedPo } = data;
        switch (eventType) {
            case EventType.PRINT:
                this.print(receivedPo);
                break;
            case EventType.WARNINGS:
                this.showWarningsDialog = true;
                this.selectedPoKey = receivedPo === null || receivedPo === void 0 ? void 0 : receivedPo.poKey;
                this.warningsDialogWizard = {
                    endpoint: `receivedpo/po/warning/form`,
                    httpMethod: HttpMethod$2.POST,
                    body: {
                        keys: [this.selectedPoKey],
                    },
                };
                break;
            default:
                break;
        }
    }
    closeWarningsDialog() {
        this.searchContainerLoaderService.refreshSearch();
        this.showWarningsDialog = false;
    }
    submitWarningsDialog(event) {
        this.showWarningsDialog = false;
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.searchContainerLoaderService.refreshSearch();
    }
    print(receivedPo) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `po/${receivedPo === null || receivedPo === void 0 ? void 0 : receivedPo.poKey}/print`,
            httpMethod: 'GET',
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
            .subscribe();
    }
    // if triggered from bulk print then it also prints the selected documents
    updatePrintOptions(selectedPrintOptions) {
        this.selectedPrintOptions = selectedPrintOptions;
        if (this.triggeredByPrint) {
            this.bulkPrint();
        }
        this.closePrintOptionsDialog();
    }
    bulkPrint() {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `po/print`,
            httpMethod: 'POST',
            body: this.posToPrint,
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            var _a;
            ((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) === 1
                ? saveAs(response, 'MergedDocuments')
                : this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.posToPrint = [];
            this.triggeredByPrint = false;
            this.spinner.off();
        }))
            .subscribe();
    }
    closePrintOptionsDialog() {
        this.showPrintOptionsDialog = false;
    }
    openPdfViewer(data) {
        const ref = this.dialogService.open(PdfViewerComponent, {
            data: {
                response: data,
            },
            styleClass: 'pdf-viewer',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
    }
    openExport() {
        const ref = this.dialogService.open(ExportComponent, {
            data: {
                endpoint: `${this.baseUrl}/export/form`,
            },
            showHeader: false,
            styleClass: 'export-dialog',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
        const refSubscription = ref.onClose
            .pipe(mergeMap((exportOptions) => exportOptions ? this.submitExport(exportOptions) : EMPTY), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
            .subscribe();
        this.subscriptions = [...this.subscriptions, refSubscription];
    }
    submitExport(exportOptions) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.http.baseUrl = `${this.mp.getConfig().export}/po/export`;
        this.spinner.on();
        return this.http
            .fetchWithFqn({
            endpoint: `${this.mp.getConfig().export}/po/export`,
            httpMethod: 'POST',
            body: Object.assign(Object.assign({}, exportOptions), { email: this.email, toolkeys: '', keys: [...this.selections].map((_a) => {
                    var { poKey } = _a, _ = __rest(_a, ["poKey"]);
                    return poKey;
                }), page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows }, sort: {
                    field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                    order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                }, search: {
                    filters: this.searchContainerLoaderService.filters,
                    term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
                } }),
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()));
    }
    ngOnDestroy() {
        this.dynamicDialogRefs.forEach((ref) => ref.destroy());
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
    closeDisplayLog() {
        this.showDisplayLog = false;
    }
    closeActionLogs() {
        this.showActionLogs = false;
    }
    submitActionLogs(options) {
        this.showActionLogs = false;
        this.searchContainerLoaderService.refreshSearch();
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
    closeConnectorExport() {
        this.showConnectorExport = false;
    }
    submitConnectorExport(event) {
        this.showConnectorExport = false;
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.searchContainerLoaderService.refreshSearch();
    }
    openDataGenius() {
        const ref = this.dialogService.open(DataGeniusSelectionComponent, {
            showHeader: false,
            styleClass: 'export-dialog',
            data: {
                selectionCount: this.selections.length,
            },
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
        const refSubscription = ref.onClose
            .pipe(mergeMap((dgOptions) => dgOptions ? this.submitDataGenius(dgOptions) : EMPTY), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
            .subscribe();
        this.subscriptions = [...this.subscriptions, refSubscription];
    }
    submitDataGenius(dgOptions) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.spinner.on();
        return this.http
            .fetchWithFqn({
            endpoint: `${this.mp.getConfig().receivedPo}/po/rundatagenius`,
            httpMethod: 'POST',
            body: Object.assign(Object.assign({}, dgOptions), { keys: [...this.selections].map((_a) => {
                    var { poKey } = _a, _ = __rest(_a, ["poKey"]);
                    return poKey;
                }), page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows }, sort: {
                    field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                    order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                }, search: {
                    filters: this.searchContainerLoaderService.filters,
                    term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
                } }),
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()));
    }
};
ReceivedPoComponent.ctorParameters = () => [
    { type: ConfirmationService },
    { type: DialogService$1 },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: Store },
    { type: ActivatedRoute },
    { type: Router },
    { type: ReceivedPOService },
    { type: PrintOptionsService }
];
ReceivedPoComponent = __decorate([
    Component({
        selector: 'lib-received-po',
        template: "<div class=\"view-invoices\">\r\n  <div class=\"dashboard\">\r\n    <lib-dashboard-container\r\n      [dashBoardStateKey]=\"dashBoardStateKey\"\r\n      [dashBoardVisibilityStateKey]=\"dashBoardVisibilityStateKey\"\r\n      [dashBoardHeader]=\"'NAV.RECEIVED_PO'\"\r\n      [categoryFilter]=\"categoryFilter\"\r\n      [showCategories]=\"showCategories\"\r\n      [defaultDashboardState]=\"defaultDashboardState\"\r\n    ></lib-dashboard-container>\r\n  </div>\r\n\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"baseUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showPrintOptionsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-print-options-container\r\n    [baseUrl]=\"baseUrl\"\r\n    [selectedPrintOptions]=\"selectedPrintOptions\"\r\n    (closeDialog)=\"closePrintOptionsDialog()\"\r\n    (updatePrintOptions)=\"updatePrintOptions($event)\"\r\n  ></lib-print-options-container>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showWarningsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [autoZIndex]=\"false\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"wizardBaseUrl\"\r\n    [wizardConfig]=\"warningsDialogWizard\"\r\n    (submit)=\"submitWarningsDialog($event)\"\r\n    (cancel)=\"closeWarningsDialog()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeWarningsDialog()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showDisplayLog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-logging\r\n    [baseUrl]=\"loggingUrl\"\r\n    [batchKey]=\"batchKey\"\r\n    (closeLogDialog)=\"closeDisplayLog()\"\r\n  >\r\n  </lib-logging>\r\n</p-dialog>\r\n<p-dialog\r\n  *ngIf=\"showActionLogs\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"baseUrl\"\r\n    [wizardConfig]=\"actionLogsWizard\"\r\n    (submit)=\"submitActionLogs($event)\"\r\n    (cancel)=\"closeActionLogs()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n      <div>\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeActionLogs()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n<p-dialog\r\n  *ngIf=\"showConnectorExport\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '80vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"wizardBaseUrl\"\r\n    [wizardConfig]=\"connectorExportWizard\"\r\n    (submit)=\"submitConnectorExport($event)\"\r\n    (cancel)=\"closeConnectorExport()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeConnectorExport()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, DialogService$1]
    })
], ReceivedPoComponent);

const ɵ0$5 = {
    breadcrumb: {
        label: 'BREADCRUMB.RECEIVED_PO',
        disable: true,
    },
}, ɵ1$3 = {
    breadcrumb: {
        label: 'BREADCRUMB.RECEIVED_PO',
        disable: true,
    },
}, ɵ2$3 = {
    breadcrumb: {
        label: 'BREADCRUMB.RECEIVED_PO',
        disable: true,
    },
}, ɵ3$2 = {
    breadcrumb: {
        label: 'BREADCRUMB.RECEIVED_PO',
        disable: true,
    },
};
const routes$3 = [
    {
        path: 'received-po',
        data: ɵ0$5,
        component: ReceivedPoComponent,
    },
    {
        path: 'flip-poa',
        data: ɵ1$3,
        component: FlipDocTypeComponent,
        canDeactivate: [CanDeactivateGuard],
    },
    {
        path: 'flip-asn',
        data: ɵ2$3,
        component: FlipDocTypeComponent,
        canDeactivate: [CanDeactivateGuard],
    },
    {
        path: 'flip-invoice',
        data: ɵ3$2,
        component: FlipDocTypeComponent,
        canDeactivate: [CanDeactivateGuard],
    },
];

let NewInvoiceService = class NewInvoiceService {
    constructor(formGenerator, http, toast, translocoService, newInvoiceSrv, confirmationService, translocoSrv, router) {
        this.formGenerator = formGenerator;
        this.http = http;
        this.toast = toast;
        this.translocoService = translocoService;
        this.newInvoiceSrv = newInvoiceSrv;
        this.confirmationService = confirmationService;
        this.translocoSrv = translocoSrv;
        this.router = router;
    }
    reset() {
        // empty
    }
};
NewInvoiceService.ctorParameters = () => [
    { type: GenerateFormService },
    { type: BaseHttpService$2 },
    { type: ToastrNotificationService },
    { type: TranslocoService },
    { type: NewInvoiceService },
    { type: ConfirmationService$1 },
    { type: TranslocoService },
    { type: Router }
];
NewInvoiceService.ɵprov = ɵɵdefineInjectable({ factory: function NewInvoiceService_Factory() { return new NewInvoiceService(ɵɵinject(GenerateFormService), ɵɵinject(BaseHttpService$2), ɵɵinject(ToastrNotificationService), ɵɵinject(TranslocoService), ɵɵinject(NewInvoiceService), ɵɵinject(ConfirmationService$2), ɵɵinject(TranslocoService), ɵɵinject(Router)); }, token: NewInvoiceService, providedIn: "root" });
NewInvoiceService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], NewInvoiceService);

let AsnWizardService = class AsnWizardService {
    reset() {
        // empty
    }
};
AsnWizardService.ɵprov = ɵɵdefineInjectable({ factory: function AsnWizardService_Factory() { return new AsnWizardService(); }, token: AsnWizardService, providedIn: "root" });
AsnWizardService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], AsnWizardService);

let AsnEntryComponent = class AsnEntryComponent extends ComponentCanDeactivate {
    constructor(http, toast, transloco, newInvoiceSrv, confirmationService, translocoSrv, router, mp, asnWizardSrv) {
        super();
        this.http = http;
        this.toast = toast;
        this.transloco = transloco;
        this.newInvoiceSrv = newInvoiceSrv;
        this.confirmationService = confirmationService;
        this.translocoSrv = translocoSrv;
        this.router = router;
        this.mp = mp;
        this.asnWizardSrv = asnWizardSrv;
        this.templateTypes = TemplateTypes;
        this.baseUrl = '';
        this.cancelButtonClicked = false;
        this.wizardConfig = {
            endpoint: this.asnWizardSrv.wizardUrl,
            httpMethod: HttpMethod$2.POST,
        };
        this.baseUrl = `${this.mp.getConfig().apiBaseUrl}`;
    }
    redirect() {
        this.cancelButtonClicked = true;
        this.newInvoiceSrv.reset();
        this.router.navigate([this.asnWizardSrv.redirectUrl]);
    }
    submitNew(event) {
        this.cancelButtonClicked = true;
        this.newInvoiceSrv.reset();
        this.router.navigate([this.asnWizardSrv.redirectUrl]);
    }
    canDeactivate(nextState) {
        // when the cancel dialog is open, we don't want the alert to show and just nav away
        if (this.cancelButtonClicked) {
            return true;
        }
        return false;
    }
};
AsnEntryComponent.ctorParameters = () => [
    { type: BaseHttpService$2 },
    { type: ToastrNotificationService },
    { type: TranslocoService },
    { type: NewInvoiceService },
    { type: ConfirmationService },
    { type: TranslocoService },
    { type: Router },
    { type: MarketplaceService },
    { type: AsnWizardService }
];
AsnEntryComponent = __decorate([
    Component({
        selector: 'lib-asn-entry',
        template: "<lui-wizard-v3\r\n  [baseUrl]=\"baseUrl\"\r\n  [wizardConfig]=\"wizardConfig\"\r\n  (cancel)=\"redirect()\"\r\n  (submit)=\"submitNew($event)\"\r\n>\r\n  <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n    <div>\r\n      <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n    <div\r\n      class=\"error\"\r\n      style=\"\r\n        min-height: 30vh;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n      \"\r\n    >\r\n      <div>\r\n        <span>\r\n          <i class=\"pi pi-times-circle\"></i>\r\n          {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n        </span>\r\n      </div>\r\n    </div>\r\n    <button pButton (click)=\"redirect()\" class=\"ds secondary\">\r\n      {{ 'ACTIONS.CANCEL' | transloco }}\r\n    </button>\r\n  </ng-template>\r\n</lui-wizard-v3>\r\n\r\n<p-confirmDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n",
        providers: [ConfirmationService]
    })
], AsnEntryComponent);

const searchContainerPipe$1 = (searchContainerLoaderService, spinner, toast, translocoService) => pipe(startWith(() => spinner.on()), tap(() => {
    searchContainerLoaderService.refreshSearch();
}), catchError(() => of(toast.errorNotify(translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => spinner.off()));
var EventType$1;
(function (EventType) {
    EventType["PRINT"] = "print";
    EventType["PRINTBARCODE"] = "printbarcode";
    EventType["WARNINGS"] = "warnings";
})(EventType$1 || (EventType$1 = {}));
const printConfig$1 = (sentAsn) => ({
    endpoint: `asn/${sentAsn === null || sentAsn === void 0 ? void 0 : sentAsn.asnKey}/print`,
    httpMethod: 'GET',
    options: {
        responseType: 'blob',
    },
});
const printBarCodeConfig = (sentAsn) => ({
    endpoint: `asn/${sentAsn === null || sentAsn === void 0 ? void 0 : sentAsn.asnKey}/barcode/print`,
    httpMethod: 'GET',
    options: {
        responseType: 'blob',
    },
});

let SentAsnComponent = class SentAsnComponent {
    constructor(dialogService, mp, http, translocoService, toast, spinner, searchContainerLoaderService, store, router, route, confirmationService, asnService, printOptionsService, popupService) {
        var _a;
        this.dialogService = dialogService;
        this.mp = mp;
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.store = store;
        this.router = router;
        this.route = route;
        this.confirmationService = confirmationService;
        this.asnService = asnService;
        this.printOptionsService = printOptionsService;
        this.popupService = popupService;
        // kpi dashboard states
        this.dashBoardStateKey = 'SentASNDashboardState';
        this.dashBoardVisibilityStateKey = 'SentASNDashboardVisibilityState';
        this.categoryFilter = ['orderFulfillment'];
        this.showCategories = false;
        this.defaultDashboardState = {
            dashboard: ['orderFulfillment.asnWarnings'],
            gridArea: [[0]],
        };
        // Warnings state
        this.showWarningsDialog = false;
        // display log states
        this.showDisplayLog = false;
        this.batchKey = 0;
        this.loggingUrl = '';
        // print states
        this.showPrintOptionsDialog = false;
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        this.asnsToPrint = [];
        // Action logs
        this.showActionLogs = false;
        this.templateTypes = TemplateTypes;
        this.showGS1Alert = false;
        // Barcodes state
        this.showBarcodeDialog = false;
        // draft asn states
        this.draftASN = false;
        // draft promote states
        this.showDraftPromote = false;
        // search container loader states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'sentASNSearch';
        this.i18nSearchField = 'ASN_RECEIVED.SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {
            new: (selection) => {
                this.asnService.wizardUrl = apiUrls.entryAsnConfig();
                this.asnService.redirectUrl = moduleUrls.sentAsn();
                this.router.navigate([moduleUrls.asnEntry()]);
            },
            copy: (selection) => {
                this.asnService.wizardUrl = apiUrls.copyAsnConfig(selection[0].asnKey);
                this.asnService.redirectUrl = moduleUrls.sentAsn();
                this.router.navigate([moduleUrls.asnCopy()]);
            },
            print: (selection) => {
                var _a;
                this.asnsToPrint = [...selection].map((_a) => {
                    var { asnKey } = _a, _ = __rest(_a, ["asnKey"]);
                    return asnKey;
                });
                if (((_a = Object.keys(this.selectedPrintOptions || {})) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.bulkPrint();
                }
                else {
                    this.triggeredByPrint = true;
                    this.showPrintOptionsDialog = true;
                }
            },
            printOptions: (selection) => {
                this.showPrintOptionsDialog = true;
            },
            displayLog: (selection) => {
                var _a;
                this.batchKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.asnKey;
                this.loggingUrl = `${this.mp.getConfig().sentAsn}/asnhistory/${this.batchKey}/form`;
                this.showDisplayLog = true;
            },
            runDataGenius: (selection) => {
                this.selections = selection;
                this.openDataGenius();
            },
            actionLogs: (selection) => {
                var _a;
                const asnKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.asnKey;
                this.actionLogsWizard = {
                    endpoint: `/${asnKey}/actionlogs/form`,
                    httpMethod: HttpMethod$2.GET,
                };
                this.showActionLogs = true;
            },
            warnings: (selection) => {
                const asnKeys = [...selection].map((_a) => {
                    var { asnKey } = _a, _ = __rest(_a, ["asnKey"]);
                    return asnKey;
                });
                this.warningsDialogWizard = {
                    endpoint: `sentasn/asn/warning/form`,
                    httpMethod: HttpMethod$2.POST,
                    body: {
                        keys: asnKeys,
                    },
                };
                this.showWarningsDialog = true;
            },
            draftNew: (selection) => {
                this.asnService.wizardUrl = apiUrls.draftNewAsnConfig();
                this.asnService.redirectUrl = moduleUrls.draftASN();
                this.router.navigate([moduleUrls.asnEntry()]);
            },
            draftEdit: (selection) => {
                this.asnService.wizardUrl = apiUrls.draftEditAsnConfig(selection[0].draftAsnKey);
                this.asnService.redirectUrl = moduleUrls.draftASN();
                this.router.navigate([moduleUrls.asnEntry()]);
            },
            draftCopy: (selection) => {
                this.asnService.wizardUrl = apiUrls.draftCopyAsnConfig(selection[0].draftAsnKey);
                this.asnService.redirectUrl = moduleUrls.draftASN();
                this.router.navigate([moduleUrls.asnEntry()]);
            },
            draftPromote: (selection) => {
                const draftASNKeys = [...selection].map((_a) => {
                    var { draftAsnKey } = _a, _ = __rest(_a, ["draftAsnKey"]);
                    return draftAsnKey;
                });
                this.draftPromoteWizard = {
                    endpoint: apiUrls.draftPromoteAsnConfig(),
                    httpMethod: HttpMethod$2.POST,
                    body: {
                        keys: draftASNKeys,
                    },
                };
                this.showDraftPromote = true;
            },
            draftDelete: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('SENT_ASN.DRAFT_DELETE_MESSAGE'),
                    header: this.translocoService.translate('SENT_ASN.DRAFT_DELETE_HEADER'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: apiUrls.draftDeleteAsnUrl(),
                            httpMethod: 'POST',
                            body: {
                                keys: [...selection].map((_a) => {
                                    var { draftAsnKey } = _a, _ = __rest(_a, ["draftAsnKey"]);
                                    return draftAsnKey;
                                }),
                            },
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            draftRestore: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('SENT_ASN.DRAFT_RESTORE_MESSAGE'),
                    header: this.translocoService.translate('SENT_ASN.DRAFT_RESTORE_HEADER'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: apiUrls.draftRestoreAsnUrl(),
                            httpMethod: 'POST',
                            body: {
                                keys: [...selection].map((_a) => {
                                    var { draftAsnKey } = _a, _ = __rest(_a, ["draftAsnKey"]);
                                    return draftAsnKey;
                                }),
                            },
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            reImport: (selection) => {
                this.popupService
                    .openWizard({
                    endpoint: `connector/ui/sentasn/repull`,
                    httpMethod: HttpMethod$2.POST,
                    body: {
                        asnKeys: [...selection].map((_a) => {
                            var { asnKey } = _a, _ = __rest(_a, ["asnKey"]);
                            return asnKey;
                        }),
                    },
                })
                    .pipe(tap((res) => this.submitImport(res)))
                    .subscribe();
            },
            import: (selection) => {
                this.popupService
                    .openWizard({
                    endpoint: `connector/ui/sentasn/pull`,
                    httpMethod: HttpMethod$2.POST,
                    body: {
                        asnKeys: [...selection].map((_a) => {
                            var { asnKey } = _a, _ = __rest(_a, ["asnKey"]);
                            return asnKey;
                        }),
                    },
                })
                    .pipe(tap((res) => this.submitImport(res)))
                    .subscribe();
            },
        };
        this.baseUrl = `${this.mp.getConfig().sentAsn}/asn`;
        this.draftUrl = `${this.mp.getConfig().sentAsn}/draft`;
        this.apiBaseUrl = `${this.mp.getConfig().apiBaseUrl}`;
        this.columnActions = {};
        this.email = '';
        http.baseUrl = mp.getConfig().sentAsn;
        if (((_a = this.route.snapshot.url[0]) === null || _a === void 0 ? void 0 : _a.path) === 'draft-asn') {
            this.baseUrl = this.draftUrl;
            this.draftASN = true;
        }
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.push(this.store
                .pipe(select(selectors.isAuthorized, {
                edit: toolKeys.MP_SENT_ASN_EDIT,
                print: toolKeys.MP_SENT_ASN_PRINT,
            }), tap((authorizedButtons) => {
                this.columnActions = {
                    shipmentId: authorizedButtons.print && !this.draftASN
                        ? {
                            link: () => ({ path: './' }),
                            event: (sentAsn) => ({
                                data: { sentAsn },
                                eventType: EventType$1.PRINT,
                            }),
                        }
                        : {},
                    barCodes: authorizedButtons.print
                        ? {
                            link: () => ({ path: './' }),
                            event: (sentAsn) => ({
                                data: { sentAsn },
                                eventType: EventType$1.PRINTBARCODE,
                            }),
                        }
                        : {},
                    warnings: {
                        link: () => {
                            return { path: './' };
                        },
                        event: (sentAsn) => ({
                            data: { sentAsn },
                            eventType: EventType$1.WARNINGS,
                        }),
                        icon: 'exclamation-triangle',
                        styleClass: 'warnings-icon',
                    },
                };
            }))
                .subscribe(), this.store
                .pipe(select(selectors.userProfile), tap((user) => {
                this.email = user.sub;
            }))
                .subscribe());
            this.selectedPrintOptions = yield this.printOptionsService.get('asn', toolKeys.MP_SENT_ASN_PRINT);
        });
    }
    print(sentAsn) {
        this.http
            .fetch(printConfig$1(sentAsn))
            .pipe(tap((response) => {
            this.openPdfViewer(response);
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        }), this._searchContainerPipe())
            .subscribe();
    }
    searchContainerEvent({ data, eventType }) {
        const { sentAsn } = data;
        switch (eventType) {
            case EventType$1.PRINT:
                this.print(sentAsn);
                break;
            case EventType$1.PRINTBARCODE:
                if (this.draftASN) {
                    const selectedDraftAsnKey = sentAsn === null || sentAsn === void 0 ? void 0 : sentAsn.draftAsnKey;
                    this.barcodeWizardRequest = {
                        endpoint: `sentasn/ui/draft/${selectedDraftAsnKey}/barcode-print`,
                        httpMethod: HttpMethod$2.POST,
                    };
                    this.showBarcodeDialog = true;
                }
                else {
                    this.selectedAsnKey = sentAsn === null || sentAsn === void 0 ? void 0 : sentAsn.asnKey;
                    this.barcodeWizardRequest = {
                        endpoint: `sentasn/form/asn/${this.selectedAsnKey}/barcode-print`,
                        httpMethod: HttpMethod$2.POST,
                    };
                    this.showBarcodeDialog = true;
                }
                break;
            case EventType$1.WARNINGS:
                this.selectedAsnKey = sentAsn === null || sentAsn === void 0 ? void 0 : sentAsn.asnKey;
                this.warningsDialogWizard = {
                    endpoint: `sentasn/asn/warning/form`,
                    httpMethod: HttpMethod$2.POST,
                    body: {
                        keys: [this.selectedAsnKey],
                    },
                };
                this.showWarningsDialog = true;
                break;
            default:
                break;
        }
    }
    closeWarningsDialog() {
        this.searchContainerLoaderService.refreshSearch();
        this.showWarningsDialog = false;
    }
    submitWarningsDialog(event) {
        this.showWarningsDialog = false;
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.searchContainerLoaderService.refreshSearch();
    }
    _searchContainerPipe() {
        return searchContainerPipe$1(this.searchContainerLoaderService, this.spinner, this.toast, this.translocoService);
    }
    openPdfViewer(data) {
        const ref = this.dialogService.open(PdfViewerComponent, {
            data: {
                response: data,
            },
            styleClass: 'pdf-viewer',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
    }
    openExport() {
        const ref = this.dialogService.open(ExportComponent, {
            data: {
                endpoint: `${this.baseUrl}/export/form`,
            },
            showHeader: false,
            styleClass: 'export-dialog',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
        const refSubscription = ref.onClose
            .pipe(mergeMap((exportOptions) => exportOptions ? this.submitExport(exportOptions) : EMPTY), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
            .subscribe();
        this.subscriptions = [...this.subscriptions, refSubscription];
    }
    submitExport(exportOptions) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.http.baseUrl = `${this.mp.getConfig().sentAsn}/asn/export`;
        this.spinner.on();
        return this.http
            .fetchWithFqn({
            endpoint: `${this.mp.getConfig().sentAsn}/asn/export`,
            httpMethod: 'POST',
            body: Object.assign(Object.assign({}, exportOptions), { email: this.email, toolkeys: '', keys: [...this.selections].map((_a) => {
                    var { asnKey } = _a, _ = __rest(_a, ["asnKey"]);
                    return asnKey;
                }), page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows }, sort: {
                    field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                    order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                }, search: {
                    filters: this.searchContainerLoaderService.filters,
                    term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
                } }),
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()));
    }
    ngOnDestroy() {
        this.dynamicDialogRefs.forEach((ref) => ref.destroy());
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
    closeDisplayLog() {
        this.showDisplayLog = false;
    }
    bulkPrint() {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `asn/print`,
            httpMethod: 'POST',
            body: this.asnsToPrint,
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            var _a;
            ((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) === 1
                ? saveAs(response, 'MergedDocuments')
                : this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.asnsToPrint = [];
            this.triggeredByPrint = false;
            this.spinner.off();
        }))
            .subscribe();
    }
    updatePrintOptions(selectedPrintOptions) {
        this.selectedPrintOptions = selectedPrintOptions;
        if (this.triggeredByPrint) {
            this.bulkPrint();
        }
        this.closePrintOptionsDialog();
    }
    closePrintOptionsDialog() {
        this.showPrintOptionsDialog = false;
    }
    closeActionLogs() {
        this.showActionLogs = false;
    }
    submitActionLogs(options) {
        this.showActionLogs = false;
        this.searchContainerLoaderService.refreshSearch();
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
    closeGS1Alert() {
        this.showGS1Alert = false;
    }
    submitBarcodePrint(options) {
        this.showBarcodeDialog = false;
        this.searchContainerLoaderService.refreshSearch();
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
    closeBarcodePrint() {
        this.showBarcodeDialog = false;
    }
    closeDraftPromoteDialog() {
        this.showDraftPromote = false;
    }
    submitDraftPromoteDialog(event) {
        this.showDraftPromote = false;
        this.searchContainerLoaderService.refreshSearch();
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
    submitImport(event) {
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.searchContainerLoaderService.refreshSearch();
    }
    openDataGenius() {
        const ref = this.dialogService.open(DataGeniusSelectionComponent, {
            showHeader: false,
            styleClass: 'export-dialog',
            data: {
                selectionCount: this.selections.length,
            },
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
        const refSubscription = ref.onClose
            .pipe(mergeMap((dgOptions) => dgOptions ? this.submitDataGenius(dgOptions) : EMPTY), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
            .subscribe();
        this.subscriptions = [...this.subscriptions, refSubscription];
    }
    submitDataGenius(dgOptions) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.spinner.on();
        return this.http
            .fetchWithFqn({
            endpoint: `${this.mp.getConfig().sentAsn}/asn/rundatagenius`,
            httpMethod: 'POST',
            body: Object.assign(Object.assign({}, dgOptions), { keys: [...this.selections].map((_a) => {
                    var { asnKey } = _a, _ = __rest(_a, ["asnKey"]);
                    return asnKey;
                }), page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows }, sort: {
                    field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                    order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                }, search: {
                    filters: this.searchContainerLoaderService.filters,
                    term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
                } }),
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()));
    }
};
SentAsnComponent.ctorParameters = () => [
    { type: DialogService },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: Store },
    { type: Router },
    { type: ActivatedRoute },
    { type: ConfirmationService },
    { type: AsnWizardService },
    { type: PrintOptionsService },
    { type: PopupService }
];
SentAsnComponent = __decorate([
    Component({
        selector: 'lib-sent-asn',
        template: "<div class=\"view-invoices\">\r\n  <div class=\"dashboard\" *ngIf=\"!draftASN; else draftTemplate\">\r\n    <lib-dashboard-container\r\n      [dashBoardStateKey]=\"dashBoardStateKey\"\r\n      [dashBoardVisibilityStateKey]=\"dashBoardVisibilityStateKey\"\r\n      [dashBoardHeader]=\"'ASN_RECEIVED.ASN_RECEIVED'\"\r\n      [categoryFilter]=\"categoryFilter\"\r\n      [showCategories]=\"showCategories\"\r\n      [defaultDashboardState]=\"defaultDashboardState\"\r\n    ></lib-dashboard-container>\r\n  </div>\r\n  <ng-template #draftTemplate>\r\n    <h2>{{ 'BREADCRUMB.DRAFT_ASN' | transloco }}</h2>\r\n  </ng-template>\r\n\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"baseUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showWarningsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"apiBaseUrl\"\r\n    [wizardConfig]=\"warningsDialogWizard\"\r\n    (submit)=\"submitWarningsDialog($event)\"\r\n    (cancel)=\"closeWarningsDialog()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeWarningsDialog()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showDisplayLog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-logging\r\n    [baseUrl]=\"loggingUrl\"\r\n    [batchKey]=\"batchKey\"\r\n    (closeLogDialog)=\"closeDisplayLog()\"\r\n  >\r\n  </lib-logging>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showPrintOptionsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-print-options-container\r\n    [baseUrl]=\"baseUrl\"\r\n    [selectedPrintOptions]=\"selectedPrintOptions\"\r\n    (closeDialog)=\"closePrintOptionsDialog()\"\r\n    (updatePrintOptions)=\"updatePrintOptions($event)\"\r\n  ></lib-print-options-container>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showBarcodeDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"apiBaseUrl\"\r\n    [wizardConfig]=\"barcodeWizardRequest\"\r\n    (submit)=\"submitBarcodePrint($event)\"\r\n    (cancel)=\"closeBarcodePrint()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n      <div>\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeBarcodePrint()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n<p-dialog\r\n  *ngIf=\"showDraftPromote\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"apiBaseUrl\"\r\n    [wizardConfig]=\"draftPromoteWizard\"\r\n    (submit)=\"submitDraftPromoteDialog($event)\"\r\n    (cancel)=\"closeDraftPromoteDialog()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n      <div>\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeDraftPromoteDialog()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n<p-dialog\r\n  *ngIf=\"showActionLogs\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"baseUrl\"\r\n    [wizardConfig]=\"actionLogsWizard\"\r\n    (submit)=\"submitActionLogs($event)\"\r\n    (cancel)=\"closeActionLogs()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n      <div>\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeActionLogs()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showGS1Alert\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n  header=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n>\r\n  <div\r\n    style=\"\r\n      min-height: 10vh;\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n    \"\r\n  >\r\n    <div>{{ 'SENT_ASN.NO_BARCODES_AVAILABLE' | transloco }}</div>\r\n  </div>\r\n  <button pButton (click)=\"closeGS1Alert()\" class=\"ds primary\">\r\n    {{ 'ACTIONS.OK' | transloco }}\r\n  </button>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, DialogService]
    })
], SentAsnComponent);

const ɵ0$6 = { breadcrumb: 'BREADCRUMB.ASNS_RECEIVED' }, ɵ1$4 = { breadcrumb: 'BREADCRUMB.DRAFT_ASN' }, ɵ2$4 = { breadcrumb: 'BREADCRUMB.ASNS_RECEIVED' }, ɵ3$3 = { breadcrumb: 'BREADCRUMB.ASNS_RECEIVED' };
const routes$4 = [
    {
        path: 'asns-sent',
        component: SentAsnComponent,
        data: ɵ0$6,
    },
    {
        path: 'draft-asn',
        component: SentAsnComponent,
        data: ɵ1$4,
    },
    {
        path: 'asn-entry',
        component: AsnEntryComponent,
        canDeactivate: [CanDeactivateGuard],
        data: ɵ2$4,
    },
    {
        path: 'asn-copy',
        component: AsnEntryComponent,
        canDeactivate: [CanDeactivateGuard],
        data: ɵ3$3,
    },
];

const searchContainerPipe$2 = (searchContainerLoaderService, spinner, toast, translocoService) => pipe(startWith(() => spinner.on()), tap(() => {
    searchContainerLoaderService.refreshSearch();
}), catchError(() => of(toast.errorNotify(translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => spinner.off()));
const printConfig$2 = (sentPoa) => ({
    endpoint: `poa/${sentPoa === null || sentPoa === void 0 ? void 0 : sentPoa.poaKey}/print`,
    httpMethod: 'GET',
    options: {
        responseType: 'blob',
    },
});

let SentPoaComponent = class SentPoaComponent {
    constructor(dialogService, mp, http, translocoService, toast, spinner, searchContainerLoaderService, store, router, route, confirmationService, printOptionsService) {
        this.dialogService = dialogService;
        this.mp = mp;
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.store = store;
        this.router = router;
        this.route = route;
        this.confirmationService = confirmationService;
        this.printOptionsService = printOptionsService;
        // kpi dashboard states
        this.dashBoardStateKey = 'SentPOADashboardState';
        this.dashBoardVisibilityStateKey = 'SentPOADashboardVisibilityState';
        this.categoryFilter = ['orderFulfillment'];
        this.showCategories = false;
        this.defaultDashboardState = {
            dashboard: ['orderFulfillment.poaWarnings'],
            gridArea: [[0]],
        };
        // display log states
        this.showDisplayLog = false;
        this.batchKey = 0;
        this.loggingUrl = '';
        // Warnings state
        this.showWarningsDialog = false;
        // print states
        this.showPrintOptionsDialog = false;
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        this.poasToPrint = [];
        // Action logs
        this.showActionLogs = false;
        this.templateTypes = TemplateTypes;
        // re import states
        this.showReImportDialog = false;
        // import states
        this.showImportDialog = false;
        // search container loader states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'sentPOASearch';
        this.i18nSearchField = 'POA_RECEIVED.SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {
            export: (selection) => {
                this.selections = selection;
                this.openExport();
            },
            displayLog: (selection) => {
                var _a;
                this.batchKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.poaKey;
                this.loggingUrl = `${this.mp.getConfig().sentPoa}/poahistory/${this.batchKey}/form`;
                this.showDisplayLog = true;
            },
            print: (selection) => {
                var _a;
                this.poasToPrint = [...selection].map((_a) => {
                    var { poaKey } = _a, _ = __rest(_a, ["poaKey"]);
                    return poaKey;
                });
                if (((_a = Object.keys(this.selectedPrintOptions || {})) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.bulkPrint();
                }
                else {
                    this.triggeredByPrint = true;
                    this.showPrintOptionsDialog = true;
                }
            },
            printOptions: (selection) => {
                this.showPrintOptionsDialog = true;
            },
            runDataGenius: (selection) => {
                this.selections = selection;
                this.openDataGenius();
            },
            actionLogs: (selection) => {
                var _a;
                const poaKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.poaKey;
                this.actionLogsWizard = {
                    endpoint: `/${poaKey}/actionlogs/form`,
                    httpMethod: HttpMethod$2.GET,
                };
                this.showActionLogs = true;
            },
            reImport: (selection) => {
                this.showReImportDialog = true;
                this.reImportWizard = {
                    endpoint: `connector/ui/sentpoa/repull`,
                    httpMethod: HttpMethod$2.POST,
                    body: {
                        poaKeys: [...selection].map((_a) => {
                            var { poaKey } = _a, _ = __rest(_a, ["poaKey"]);
                            return poaKey;
                        }),
                    },
                };
            },
            import: (selection) => {
                this.showImportDialog = true;
                this.importWizard = {
                    endpoint: `connector/ui/sentpoa/pull`,
                    httpMethod: HttpMethod$2.POST,
                    body: {
                        poaKeys: [...selection].map((_a) => {
                            var { poaKey } = _a, _ = __rest(_a, ["poaKey"]);
                            return poaKey;
                        }),
                    },
                };
            },
            warnings: (selection) => {
                const poaKeys = [...selection].map((_a) => {
                    var { poaKey } = _a, _ = __rest(_a, ["poaKey"]);
                    return poaKey;
                });
                this.warningsDialogWizard = {
                    endpoint: `sentpoa/poa/warning/form`,
                    httpMethod: HttpMethod$2.POST,
                    body: {
                        keys: poaKeys,
                    },
                };
                this.showWarningsDialog = true;
            },
        };
        this.baseUrl = `${this.mp.getConfig().sentPoa}/poa`;
        this.apiBaseUrl = `${this.mp.getConfig().apiBaseUrl}`;
        this.columnActions = {};
        this.email = '';
        http.baseUrl = mp.getConfig().sentPoa;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.push(this.store
                .pipe(select(selectors.isAuthorized, {
                edit: toolKeys.MP_SENT_POA_EDIT,
                print: toolKeys.MP_SENT_POA_PRINT,
            }), tap((authorizedButtons) => {
                this.columnActions = {
                    poNumber: authorizedButtons.print
                        ? {
                            link: () => {
                                return { path: './' };
                            },
                            event: (sentPoa) => ({
                                data: { sentPoa },
                                eventType: EventType.PRINT,
                            }),
                        }
                        : {},
                    warnings: {
                        link: () => {
                            return { path: './' };
                        },
                        event: (sentPoa) => ({
                            data: { sentPoa },
                            eventType: EventType.WARNINGS,
                        }),
                        icon: 'exclamation-triangle',
                        styleClass: 'warnings-icon',
                    },
                };
            }))
                .subscribe(), this.store
                .pipe(select(selectors.userProfile), tap((user) => {
                this.email = user.sub;
            }))
                .subscribe());
            this.selectedPrintOptions = yield this.printOptionsService.get('poa', toolKeys.MP_SENT_POA_PRINT);
        });
    }
    searchContainerEvent({ data, eventType }) {
        const { sentPoa } = data;
        switch (eventType) {
            case EventType.PRINT:
                this.print(sentPoa);
                break;
            case EventType.WARNINGS:
                this.selectedPoaKey = sentPoa === null || sentPoa === void 0 ? void 0 : sentPoa.poaKey;
                this.warningsDialogWizard = {
                    endpoint: `sentpoa/poa/warning/form`,
                    httpMethod: HttpMethod$2.POST,
                    body: {
                        keys: [this.selectedPoaKey],
                    },
                };
                this.showWarningsDialog = true;
                break;
            default:
                break;
        }
    }
    closeWarningsDialog() {
        this.searchContainerLoaderService.refreshSearch();
        this.showWarningsDialog = false;
    }
    submitWarningsDialog(event) {
        this.showWarningsDialog = false;
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.searchContainerLoaderService.refreshSearch();
    }
    print(sentPoa) {
        this.http
            .fetch(printConfig$2(sentPoa))
            .pipe(tap((response) => {
            this.openPdfViewer(response);
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        }), this._searchContainerPipe())
            .subscribe();
    }
    _searchContainerPipe() {
        return searchContainerPipe$2(this.searchContainerLoaderService, this.spinner, this.toast, this.translocoService);
    }
    openPdfViewer(data) {
        const ref = this.dialogService.open(PdfViewerComponent, {
            data: {
                response: data,
            },
            styleClass: 'pdf-viewer',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
    }
    openExport() {
        const ref = this.dialogService.open(ExportComponent, {
            data: {
                endpoint: `${this.baseUrl}/export/form`,
            },
            showHeader: false,
            styleClass: 'export-dialog',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
        const refSubscription = ref.onClose
            .pipe(mergeMap((exportOptions) => exportOptions ? this.submitExport(exportOptions) : EMPTY), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
            .subscribe();
        this.subscriptions = [...this.subscriptions, refSubscription];
    }
    submitExport(exportOptions) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.spinner.on();
        return this.http
            .fetchWithFqn({
            endpoint: `${this.mp.getConfig().sentPoa}/poa/export`,
            httpMethod: 'POST',
            body: Object.assign(Object.assign({}, exportOptions), { email: this.email, toolkeys: '', keys: [...this.selections].map((_a) => {
                    var { poaKey } = _a, _ = __rest(_a, ["poaKey"]);
                    return poaKey;
                }), page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows }, sort: {
                    field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                    order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                }, search: {
                    filters: this.searchContainerLoaderService.filters,
                    term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
                } }),
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()));
    }
    ngOnDestroy() {
        this.dynamicDialogRefs.forEach((ref) => ref.destroy());
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
    closeDisplayLog() {
        this.showDisplayLog = false;
    }
    bulkPrint() {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `poa/print`,
            httpMethod: 'POST',
            body: this.poasToPrint,
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            var _a;
            ((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) === 1
                ? saveAs(response, 'MergedDocuments')
                : this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.poasToPrint = [];
            this.triggeredByPrint = false;
            this.spinner.off();
        }))
            .subscribe();
    }
    updatePrintOptions(selectedPrintOptions) {
        this.selectedPrintOptions = selectedPrintOptions;
        if (this.triggeredByPrint) {
            this.bulkPrint();
        }
        this.closePrintOptionsDialog();
    }
    closePrintOptionsDialog() {
        this.showPrintOptionsDialog = false;
    }
    closeActionLogs() {
        this.showActionLogs = false;
    }
    submitActionLogs(options) {
        this.showActionLogs = false;
        this.searchContainerLoaderService.refreshSearch();
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
    closeReImport() {
        this.showReImportDialog = false;
    }
    submitReImport(event) {
        this.showReImportDialog = false;
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.searchContainerLoaderService.refreshSearch();
    }
    closeImport() {
        this.showImportDialog = false;
    }
    submitImport(event) {
        this.showImportDialog = false;
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.searchContainerLoaderService.refreshSearch();
    }
    openDataGenius() {
        const ref = this.dialogService.open(DataGeniusSelectionComponent, {
            showHeader: false,
            styleClass: 'export-dialog',
            data: {
                selectionCount: this.selections.length,
            },
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
        const refSubscription = ref.onClose
            .pipe(mergeMap((dgOptions) => dgOptions ? this.submitDataGenius(dgOptions) : EMPTY), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
            .subscribe();
        this.subscriptions = [...this.subscriptions, refSubscription];
    }
    submitDataGenius(dgOptions) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.spinner.on();
        return this.http
            .fetchWithFqn({
            endpoint: `${this.mp.getConfig().sentPoa}/poa/rundatagenius`,
            httpMethod: 'POST',
            body: Object.assign(Object.assign({}, dgOptions), { keys: [...this.selections].map((_a) => {
                    var { poaKey } = _a, _ = __rest(_a, ["poaKey"]);
                    return poaKey;
                }), page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows }, sort: {
                    field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                    order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                }, search: {
                    filters: this.searchContainerLoaderService.filters,
                    term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
                } }),
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()));
    }
};
SentPoaComponent.ctorParameters = () => [
    { type: DialogService },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: Store },
    { type: Router },
    { type: ActivatedRoute },
    { type: ConfirmationService },
    { type: PrintOptionsService }
];
SentPoaComponent = __decorate([
    Component({
        selector: 'lib-sent-poa',
        template: "<div class=\"view-invoices\">\r\n  <div class=\"dashboard\">\r\n    <lib-dashboard-container\r\n      [dashBoardStateKey]=\"dashBoardStateKey\"\r\n      [dashBoardVisibilityStateKey]=\"dashBoardVisibilityStateKey\"\r\n      [dashBoardHeader]=\"'POA_RECEIVED.POA_RECEIVED'\"\r\n      [categoryFilter]=\"categoryFilter\"\r\n      [showCategories]=\"showCategories\"\r\n      [defaultDashboardState]=\"defaultDashboardState\"\r\n    ></lib-dashboard-container>\r\n  </div>\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"baseUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showWarningsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"apiBaseUrl\"\r\n    [wizardConfig]=\"warningsDialogWizard\"\r\n    (submit)=\"submitWarningsDialog($event)\"\r\n    (cancel)=\"closeWarningsDialog()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeWarningsDialog()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showDisplayLog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-logging\r\n    [baseUrl]=\"loggingUrl\"\r\n    [batchKey]=\"batchKey\"\r\n    (closeLogDialog)=\"closeDisplayLog()\"\r\n  >\r\n  </lib-logging>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showPrintOptionsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-print-options-container\r\n    [baseUrl]=\"baseUrl\"\r\n    [selectedPrintOptions]=\"selectedPrintOptions\"\r\n    (closeDialog)=\"closePrintOptionsDialog()\"\r\n    (updatePrintOptions)=\"updatePrintOptions($event)\"\r\n  ></lib-print-options-container>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showActionLogs\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"baseUrl\"\r\n    [wizardConfig]=\"actionLogsWizard\"\r\n    (submit)=\"submitActionLogs($event)\"\r\n    (cancel)=\"closeActionLogs()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n      <div>\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeActionLogs()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showImportDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '70vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"apiBaseUrl\"\r\n    [wizardConfig]=\"importWizard\"\r\n    (submit)=\"submitImport($event)\"\r\n    (cancel)=\"closeImport()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeImport()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n<p-dialog\r\n  *ngIf=\"showReImportDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"apiBaseUrl\"\r\n    [wizardConfig]=\"reImportWizard\"\r\n    (submit)=\"submitReImport($event)\"\r\n    (cancel)=\"closeReImport()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeReImport()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, DialogService]
    })
], SentPoaComponent);

const ɵ0$7 = { breadcrumb: 'BREADCRUMB.POAS_RECEIVED' };
const routes$5 = [
    {
        path: 'poas-sent',
        component: SentPoaComponent,
        data: ɵ0$7,
    },
];

var TableAlignment;
(function (TableAlignment) {
    TableAlignment["LEFT"] = "left";
    TableAlignment["CENTER"] = "center";
    TableAlignment["RIGHT"] = "right";
})(TableAlignment || (TableAlignment = {}));
const transformResponse = (response, { xAxisField, yAxisField, legendField, toolTips, type, columns, valueField: kpiValueField, valueFormattedField, varianceField, varianceFormattedField, }) => {
    if (type === 'table-grid') {
        return {
            columns,
            data: { labels: [], datasets: [], results: response.records },
        };
    }
    if (type === 'variance-gauge') {
        return {
            columns,
            data: {
                labels: [],
                datasets: [],
                results: response.records,
                config: {
                    value: response.records[0] ? response.records[0][kpiValueField] : 0,
                    deltaValue: response.records[0][varianceField],
                    delta: (response.records[0]
                        ? response.records[0][varianceFormattedField]
                        : '0%').toString(),
                },
            },
        };
    }
    const newToolTip = toolTips !== null && toolTips !== void 0 ? toolTips : [];
    const ifHorizontal = type.toLowerCase().includes('horizontal');
    const dimField = ifHorizontal ? yAxisField : xAxisField;
    const valueField = ifHorizontal ? xAxisField : yAxisField;
    const ifLegendField = !!legendField;
    return ifLegendField
        ? {
            columns,
            data: response.records.reduce((_a, dataPoint) => {
                var { labels, datasets } = _a, rest = __rest(_a, ["labels", "datasets"]);
                const newLabels = isNewLabel(dataPoint[dimField], labels);
                const ifDatasetExists = !!datasets.find((dataset) => dataset.label === dataPoint[legendField].toString());
                const newDataSets = ifDatasetExists
                    ? [
                        ...datasets.map((dataset) => {
                            if (dataset.label === dataPoint[legendField].toString()) {
                                const data = [...dataset.data];
                                data[newLabels.indexOf(dataPoint[dimField].toString())] =
                                    dataPoint[valueField];
                                const tooltips = [...dataset.tooltips];
                                tooltips[newLabels.indexOf(dataPoint[dimField].toString())] = newToolTip.reduce((toolTip, config) => {
                                    return [
                                        ...toolTip,
                                        {
                                            label: config.label,
                                            value: dataPoint[config.field],
                                        },
                                    ];
                                }, []);
                                return Object.assign(Object.assign({}, dataset), { data,
                                    tooltips });
                            }
                            return Object.assign({}, dataset);
                        }),
                    ]
                    : [
                        ...datasets,
                        {
                            label: dataPoint[legendField].toString(),
                            data: addToData(newLabels.indexOf(dataPoint[dimField].toString()), dataPoint[valueField]),
                            tooltips: addToTooltip(newLabels.indexOf(dataPoint[dimField].toString()), newToolTip, dataPoint),
                            isProjected: (dataPoint === null || dataPoint === void 0 ? void 0 : dataPoint.isProjected) === 1,
                        },
                    ];
                return Object.assign({ labels: [...newLabels], datasets: [...newDataSets] }, rest);
            }, { labels: [], datasets: [], results: response.records }),
        }
        : {
            columns,
            data: response.records.reduce((_a, dataPoint) => {
                var { labels, datasets } = _a, rest = __rest(_a, ["labels", "datasets"]);
                const newDataSets = {
                    label: datasets[0].label,
                    data: [...datasets[0].data, dataPoint[valueField]],
                    tooltips: [
                        ...datasets[0].tooltips,
                        newToolTip.reduce((toolTip, config) => {
                            return [
                                ...toolTip,
                                { label: config.label, value: dataPoint[config.field] },
                            ];
                        }, []),
                    ],
                    isProjected: (dataPoint === null || dataPoint === void 0 ? void 0 : dataPoint.isProjected) === 1,
                };
                const newLabels = [...labels, dataPoint[dimField].toString()];
                return Object.assign({ labels: [...newLabels], datasets: [Object.assign({}, newDataSets)] }, rest);
            }, {
                labels: [],
                datasets: [{ label: 'data', data: [], tooltips: [] }],
                results: response.records,
            }),
        };
};
const isNewLabel = (xAxisFieldPoint, labels) => {
    if (xAxisFieldPoint && labels.indexOf(xAxisFieldPoint.toString()) === -1) {
        return [...labels, xAxisFieldPoint.toString()];
    }
    return labels;
};
const ɵ0$8 = isNewLabel;
const addToData = (index, value) => {
    const data = [];
    data[index] = value;
    return [...data];
};
const ɵ1$5 = addToData;
const addToTooltip = (index, toolTip, dataPoint) => {
    const tooltip = [];
    tooltip[index] = toolTip.reduce((toolTips, config) => {
        return [
            ...toolTips,
            { label: config.label, value: dataPoint[config.field] },
        ];
    }, []);
    return [...tooltip];
};
const ɵ2$5 = addToTooltip;
const kpiAdaptor = (response, config, type) => {
    switch (type) {
        case 'variance-gauge':
            return {
                value: response.records[0] ? response.records[0][config.valueField] : 0,
                deltaValue: response.records[0][config.varianceField],
                delta: (response.records[0]
                    ? response.records[0][config.varianceFormattedField]
                    : '0%').toString(),
            };
        case 'variance':
            return {
                value: (response.records[0]
                    ? response.records[0][config.valueFormattedField]
                    : '0').toString(),
                delta: (response.records[0]
                    ? response.records[0][config.varianceFormattedField]
                    : '0%').toString(),
                isNegative: response.records[0]
                    ? response.records[0][config.varianceField] < 0
                    : false,
            };
        case 'variance-subtitle':
            return {
                value: (response.records[0]
                    ? response.records[0][config.valueFormattedField]
                    : '0').toString(),
                delta: (response.records[0]
                    ? response.records[0][config.varianceFormattedField]
                    : '0%').toString(),
                isNegative: response.records[0]
                    ? response.records[0][config.varianceField] < 0
                    : false,
            };
        case 'dynamic-status':
            const dynamicStatusRecord = response.records[0] || {};
            return {
                value: dynamicStatusRecord[config.valueFormattedField] || '0',
                delta: (dynamicStatusRecord[config.varianceFormattedField] || '0%').toString(),
                deltaValue: dynamicStatusRecord[config.varianceField] || 0,
                isNegative: dynamicStatusRecord[config.varianceField] < 0 || false,
                maxDate: dynamicStatusRecord['maxDate'] || null,
                checkMaxDate: dynamicStatusRecord['checkMaxDate'] || 0,
                variance: dynamicStatusRecord['variance'] || 0,
                label: dynamicStatusRecord['label'] || 'No Data',
            };
        default:
            return {
                value: (response.records[0]
                    ? response.records[0][config.valueFormattedField]
                    : 0).toString(),
            };
    }
};
const chartNoDataTest = (records, config, type) => {
    return records.totalRecords === 0 ? true : false;
};

let CdaReceivedComponent = class CdaReceivedComponent {
    constructor(dialogService, confirmationService, mp, http, spinner, searchContainerLoaderService, translocoService, toast, store, printOptionsService, popupService) {
        this.dialogService = dialogService;
        this.confirmationService = confirmationService;
        this.mp = mp;
        this.http = http;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.store = store;
        this.printOptionsService = printOptionsService;
        this.popupService = popupService;
        this.baseUrl = `${this.mp.getConfig().receivedCda}`;
        this.searchUrl = `${this.baseUrl}/cda`;
        this.apiBaseUrl = `${this.mp.getConfig().apiBaseUrl}`;
        this.columnActions = {};
        this.email = '';
        // print states
        this.showPrintOptionsDialog = false;
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        this.cdasToPrint = [];
        // Action logs
        this.showActionLogs = false;
        this.templateTypes = TemplateTypes;
        // Warnings states
        this.showWarningsDialog = false;
        // display log states
        this.showDisplayLog = false;
        this.batchKey = 0;
        this.loggingUrl = '';
        // analytics kpi
        this.analyticsEndpoint = this.mp.getConfig().apiBaseUrl +
            '/analytics/query/dashboard/claims-received-cda';
        this.adaptor = transformResponse;
        this.kpiAdaptor = kpiAdaptor;
        this.chartNoDataTest = chartNoDataTest;
        this.paramListener = false;
        // Search container states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'cdaReceivedSearch';
        this.i18nSearchField = 'MARKETPLACE.CREDIT_DEBIT_ADJUSTMENT_SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {
            printOptions: (selection) => {
                this.showPrintOptionsDialog = true;
            },
            print: (selection) => {
                var _a;
                this.cdasToPrint = [...selection].map((_a) => {
                    var { cdaKey } = _a, _ = __rest(_a, ["cdaKey"]);
                    return cdaKey;
                });
                if (((_a = Object.keys(this.selectedPrintOptions || {})) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.bulkPrint();
                }
                else {
                    this.triggeredByPrint = true;
                    this.showPrintOptionsDialog = true;
                }
            },
            markProcessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('CDA_RECEIVED.MARK_PROCESSED_MESSAGE'),
                    header: this.translocoService.translate('CDA_RECEIVED.MARK_PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'cda/mark-processed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { cdaKey } = _a, _ = __rest(_a, ["cdaKey"]);
                                return cdaKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnprocessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('CDA_RECEIVED.MARK_UNPROCESSED_MESSAGE'),
                    header: this.translocoService.translate('CDA_RECEIVED.MARK_UNPROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'cda/mark-unprocessed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { cdaKey } = _a, _ = __rest(_a, ["cdaKey"]);
                                return cdaKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markRead: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('CDA_RECEIVED.MARK_READ_MESSAGE'),
                    header: this.translocoService.translate('CDA_RECEIVED.MARK_READ_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'cda/mark-read',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { cdaKey } = _a, _ = __rest(_a, ["cdaKey"]);
                                return cdaKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnread: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('CDA_RECEIVED.MARK_UNREAD_MESSAGE'),
                    header: this.translocoService.translate('CDA_RECEIVED.MARK_UNREAD_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'cda/mark-unread',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { cdaKey } = _a, _ = __rest(_a, ["cdaKey"]);
                                return cdaKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            delete: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('CDA_RECEIVED.DELETE_CONFIRMATION_MESSAGE'),
                    header: this.translocoService.translate('CDA_RECEIVED.DELETE_CONFIRMATION_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'cda/delete',
                            httpMethod: 'POST',
                            body: {
                                keys: [...selection].map((_a) => {
                                    var { cdaKey } = _a, _ = __rest(_a, ["cdaKey"]);
                                    return cdaKey;
                                }),
                            },
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            restore: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('CDA_RECEIVED.RESTORE_MESSAGE'),
                    header: this.translocoService.translate('CDA_RECEIVED.RESTORE_HEADER'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'cda/restore',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { cdaKey } = _a, _ = __rest(_a, ["cdaKey"]);
                                return cdaKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            runDataGenius: (selection) => {
                this.selections = selection;
                this.openDataGenius();
            },
            approve: (selection) => {
                this.spinner.on();
                this.http
                    .fetch({
                    endpoint: 'cda/approve',
                    httpMethod: 'POST',
                    body: {
                        keys: [...selection].map((_a) => {
                            var { cdaKey } = _a, _ = __rest(_a, ["cdaKey"]);
                            return cdaKey;
                        }),
                    },
                })
                    .pipe(tap(() => {
                    this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                    this.searchContainerLoaderService.refreshSearch();
                }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                    .subscribe();
            },
            actionLogs: (selection) => {
                var _a;
                const cdaKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.cdaKey;
                this.actionLogsWizard = {
                    endpoint: `/${cdaKey}/actionlogs/form`,
                    httpMethod: HttpMethod$2.GET,
                };
                this.showActionLogs = true;
            },
            warnings: (selection) => {
                this.selectedCdaKeys = [...selection].map((_a) => {
                    var { cdaKey } = _a, _ = __rest(_a, ["cdaKey"]);
                    return cdaKey;
                });
                this.warningsDialogWizard = {
                    endpoint: `receivedcda/cda/warning/form`,
                    httpMethod: HttpMethod$2.POST,
                    body: {
                        keys: this.selectedCdaKeys,
                    },
                };
                this.showWarningsDialog = true;
            },
            displayLog: (selection) => {
                var _a;
                this.batchKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.cdaKey;
                this.loggingUrl = `${this.mp.getConfig().receivedCda}/cdaHistory/${this.batchKey}/form`;
                this.showDisplayLog = true;
            },
        };
        http.baseUrl = this.baseUrl;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.push(this.store
                .pipe(select(selectors.isAuthorized, {
                edit: toolKeys.MP_RECEIVED_CDA_EDIT,
                print: toolKeys.MP_RECEIVED_CDA_PRINT,
            }), tap((authorizedButtons) => {
                this.columnActions = {
                    adjustmentNumber: authorizedButtons.print
                        ? {
                            link: () => ({ path: './' }),
                            event: (receivedCda) => ({
                                data: { receivedCda },
                                eventType: EventType.PRINT,
                            }),
                        }
                        : {},
                    warnings: {
                        link: () => {
                            return { path: './' };
                        },
                        event: (receivedCda) => ({
                            data: { receivedCda },
                            eventType: EventType.WARNINGS,
                        }),
                        icon: 'exclamation-triangle',
                        styleClass: 'warnings-icon',
                    },
                    attachmentCount: authorizedButtons.print
                        ? {
                            link: () => {
                                return { path: './' };
                            },
                            event: (receivedCda) => ({
                                data: { receivedCda },
                                eventType: EventType.ATTACHMENT,
                            }),
                            icon: 'paperclip',
                            styleClass: 'column-icon',
                        }
                        : {
                            link: () => {
                                return { path: './' };
                            },
                            event: (receivedCda) => ({
                                data: { receivedCda },
                                eventType: EventType.DISABLED,
                            }),
                            icon: 'paperclip',
                            styleClass: 'column-icon disabled',
                        },
                };
            }))
                .subscribe(), this.store
                .pipe(select(selectors.userProfile), tap((user) => {
                this.email = user.sub;
            }))
                .subscribe());
            this.selectedPrintOptions = yield this.printOptionsService.get('cda', toolKeys.MP_RECEIVED_CDA_PRINT);
        });
    }
    bulkPrint() {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `cda/print`,
            httpMethod: 'POST',
            body: this.cdasToPrint,
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            var _a;
            ((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) === 1
                ? saveAs(response, 'MergedDocuments')
                : this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.cdasToPrint = [];
            this.triggeredByPrint = false;
            this.spinner.off();
        }))
            .subscribe();
    }
    openPdfViewer(data) {
        const ref = this.dialogService.open(PdfViewerComponent, {
            data: {
                response: data,
            },
            styleClass: 'pdf-viewer',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
    }
    closePrintOptionsDialog() {
        this.showPrintOptionsDialog = false;
    }
    updatePrintOptions(selectedPrintOptions) {
        this.selectedPrintOptions = selectedPrintOptions;
        if (this.triggeredByPrint) {
            this.bulkPrint();
        }
        this.closePrintOptionsDialog();
    }
    searchContainerEvent({ data, eventType }) {
        const { receivedCda } = data;
        switch (eventType) {
            case EventType.PRINT:
                this.print(receivedCda);
                break;
            case EventType.WARNINGS:
                const key = receivedCda === null || receivedCda === void 0 ? void 0 : receivedCda.cdaKey;
                this.warningsDialogWizard = {
                    endpoint: `receivedcda/cda/warning/form`,
                    httpMethod: HttpMethod$2.POST,
                    body: {
                        keys: [key],
                    },
                };
                this.showWarningsDialog = true;
                break;
            case EventType.ATTACHMENT:
                const cdaKey = receivedCda === null || receivedCda === void 0 ? void 0 : receivedCda.cdaKey;
                this.popupService.openWizard({
                    endpoint: `/receivedCda/ui/cda/${cdaKey}/attachments`,
                    httpMethod: HttpMethod$2.POST,
                    body: {},
                });
                break;
            default:
                break;
        }
    }
    print(receivedCda) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `cda/${receivedCda === null || receivedCda === void 0 ? void 0 : receivedCda.cdaKey}/print`,
            httpMethod: 'GET',
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
            .subscribe();
    }
    closeActionLogs() {
        this.showActionLogs = false;
    }
    submitActionLogs(options) {
        this.showActionLogs = false;
        this.searchContainerLoaderService.refreshSearch();
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
    closeWarningsDialog() {
        this.searchContainerLoaderService.refreshSearch();
        this.showWarningsDialog = false;
    }
    submitWarningsDialog(event) {
        this.showWarningsDialog = false;
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.searchContainerLoaderService.refreshSearch();
    }
    closeDisplayLog() {
        this.showDisplayLog = false;
    }
    submitDisplayLog(event) {
        this.showDisplayLog = false;
        this.searchContainerLoaderService.refreshSearch();
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
    openDataGenius() {
        const ref = this.dialogService.open(DataGeniusSelectionComponent, {
            showHeader: false,
            styleClass: 'export-dialog',
            data: {
                selectionCount: this.selections.length,
            },
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
        const refSubscription = ref.onClose
            .pipe(mergeMap((dgOptions) => dgOptions ? this.submitDataGenius(dgOptions) : EMPTY), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
            .subscribe();
        this.subscriptions = [...this.subscriptions, refSubscription];
    }
    submitDataGenius(dgOptions) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.spinner.on();
        return this.http
            .fetchWithFqn({
            endpoint: `${this.mp.getConfig().receivedCda}/cda/rundatagenius`,
            httpMethod: 'POST',
            body: Object.assign(Object.assign({}, dgOptions), { keys: [...this.selections].map((_a) => {
                    var { cdaKey } = _a, _ = __rest(_a, ["cdaKey"]);
                    return cdaKey;
                }), page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows }, sort: {
                    field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                    order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                }, search: {
                    filters: this.searchContainerLoaderService.filters,
                    term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
                } }),
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()));
    }
};
CdaReceivedComponent.ctorParameters = () => [
    { type: DialogService },
    { type: ConfirmationService$1 },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: Store },
    { type: PrintOptionsService },
    { type: PopupService }
];
CdaReceivedComponent = __decorate([
    Component({
        selector: 'lib-cda-received',
        template: "<div class=\"view-remittances\">\r\n  <h2>{{ 'BREADCRUMB.CREDIT_DEBIT_ADJUSTMENT' | transloco }}</h2>\r\n  <div class=\"dashboard\">\r\n    <lib-app-dashboard-loader\r\n      class=\"analytics-cda-received-kpi\"\r\n      [configEndpoint]=\"analyticsEndpoint\"\r\n      [chartAdaptor]=\"adaptor\"\r\n      [kpiAdaptor]=\"kpiAdaptor\"\r\n      [chartNoDataTest]=\"chartNoDataTest\"\r\n      [paramListener]=\"paramListener\"\r\n    ></lib-app-dashboard-loader>\r\n  </div>\r\n\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"searchUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showPrintOptionsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-print-options-container\r\n    [baseUrl]=\"searchUrl\"\r\n    [selectedPrintOptions]=\"selectedPrintOptions\"\r\n    (closeDialog)=\"closePrintOptionsDialog()\"\r\n    (updatePrintOptions)=\"updatePrintOptions($event)\"\r\n  ></lib-print-options-container>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showActionLogs\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"searchUrl\"\r\n    [wizardConfig]=\"actionLogsWizard\"\r\n    (submit)=\"submitActionLogs($event)\"\r\n    (cancel)=\"closeActionLogs()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n      <div>\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeActionLogs()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showWarningsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [autoZIndex]=\"false\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"apiBaseUrl\"\r\n    [wizardConfig]=\"warningsDialogWizard\"\r\n    (submit)=\"submitWarningsDialog($event)\"\r\n    (cancel)=\"closeWarningsDialog()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeWarningsDialog()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showDisplayLog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-logging\r\n    [baseUrl]=\"loggingUrl\"\r\n    [batchKey]=\"batchKey\"\r\n    (closeLogDialog)=\"closeDisplayLog()\"\r\n  >\r\n  </lib-logging>\r\n</p-dialog>\r\n",
        encapsulation: ViewEncapsulation.None,
        providers: [SearchContainerLoaderService, DialogService],
        styles: ["", `
      .analytics-cda-received-kpi .dashboard .body {
        min-height: 0 !important;
      }
    `]
    })
], CdaReceivedComponent);

const ɵ0$9 = { breadcrumb: 'BREADCRUMB.CREDIT_DEBIT_ADJUSTMENT' };
const routes$6 = [
    {
        path: 'cda-received',
        component: CdaReceivedComponent,
        data: ɵ0$9,
    },
];

let SentCDAComponent = class SentCDAComponent {
    constructor(dialogService, confirmationService, mp, http, spinner, searchContainerLoaderService, translocoService, toast, store, newCdaSrv, router, printOptionsService, popupService) {
        this.dialogService = dialogService;
        this.confirmationService = confirmationService;
        this.mp = mp;
        this.http = http;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.store = store;
        this.newCdaSrv = newCdaSrv;
        this.router = router;
        this.printOptionsService = printOptionsService;
        this.popupService = popupService;
        this.baseUrl = `${this.mp.getConfig().sentCda}`;
        this.searchUrl = `${this.baseUrl}/cda`;
        this.newCdaUrl = `${this.mp.getConfig().apiBaseUrl}`;
        this.columnActions = {};
        this.email = '';
        // print states
        this.showPrintOptionsDialog = false;
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        this.cdasToPrint = [];
        // display log states
        this.showDisplayLog = false;
        // Action logs
        this.showActionLogs = false;
        this.templateTypes = TemplateTypes;
        // Warnings states
        this.showWarningsDialog = false;
        // analytics kpi
        this.analyticsEndpoint = this.mp.getConfig().apiBaseUrl +
            '/analytics/query/dashboard/claims-sent-cda';
        this.adaptor = transformResponse;
        this.kpiAdaptor = kpiAdaptor;
        this.chartNoDataTest = chartNoDataTest;
        this.paramListener = false;
        // Search container states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'cdaSentSearch';
        this.i18nSearchField = 'MARKETPLACE.CREDIT_DEBIT_ADJUSTMENT_SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {
            printOptions: (selection) => {
                this.showPrintOptionsDialog = true;
            },
            print: (selection) => {
                var _a;
                this.cdasToPrint = [...selection].map((_a) => {
                    var { cdaKey } = _a, _ = __rest(_a, ["cdaKey"]);
                    return cdaKey;
                });
                if (((_a = Object.keys(this.selectedPrintOptions || {})) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.bulkPrint();
                }
                else {
                    this.triggeredByPrint = true;
                    this.showPrintOptionsDialog = true;
                }
            },
            new: (selection) => {
                this.newCdaSrv.wizardConfig = {
                    endpoint: apiUrls.newCdaConfig(),
                    httpMethod: HttpMethod$2.POST,
                };
                this.newCdaSrv.baseUrl = this.newCdaUrl;
                this.newCdaSrv.redirectUrl = moduleUrls.sentCda();
                this.router.navigate([moduleUrls.newCda()]);
            },
            runDataGenius: (selection) => {
                this.selections = selection;
                this.openDataGenius();
            },
            delete: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('CDA_RECEIVED.DELETE_CONFIRMATION_MESSAGE'),
                    header: this.translocoService.translate('CDA_RECEIVED.DELETE_CONFIRMATION_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'cda/delete',
                            httpMethod: 'POST',
                            body: {
                                keys: [...selection].map((_a) => {
                                    var { cdaKey } = _a, _ = __rest(_a, ["cdaKey"]);
                                    return cdaKey;
                                }),
                            },
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            restore: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('CDA_RECEIVED.RESTORE_MESSAGE'),
                    header: this.translocoService.translate('CDA_RECEIVED.RESTORE_HEADER'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'cda/restore',
                            httpMethod: 'POST',
                            body: {
                                keys: [...selection].map((_a) => {
                                    var { cdaKey } = _a, _ = __rest(_a, ["cdaKey"]);
                                    return cdaKey;
                                }),
                            },
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            displayLog: (selection) => {
                var _a;
                this.batchKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.cdaKey;
                this.loggingUrl = `${this.mp.getConfig().sentCda}/cdahistory/${this.batchKey}/form`;
                this.showDisplayLog = true;
            },
            actionLogs: (selection) => {
                var _a;
                const cdaKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.cdaKey;
                this.actionLogsWizard = {
                    endpoint: `/${cdaKey}/actionlogs/form`,
                    httpMethod: HttpMethod$2.GET,
                };
                this.showActionLogs = true;
            },
            warnings: (selection) => {
                this.selectedCdaKeys = [...selection].map((_a) => {
                    var { cdaKey } = _a, _ = __rest(_a, ["cdaKey"]);
                    return cdaKey;
                });
                this.warningsDialogWizard = {
                    endpoint: `sentcda/cda/warning/form`,
                    httpMethod: HttpMethod$2.POST,
                    body: {
                        keys: this.selectedCdaKeys,
                    },
                };
                this.showWarningsDialog = true;
            },
        };
        http.baseUrl = this.baseUrl;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.push(this.store
                .pipe(select(selectors.isAuthorized, {
                edit: toolKeys.MP_SENT_CDA_EDIT,
                print: toolKeys.MP_SENT_CDA_PRINT,
            }), tap((authorizedButtons) => {
                this.columnActions = {
                    adjustmentNumber: authorizedButtons.print
                        ? {
                            link: () => ({ path: './' }),
                            event: (sentCda) => ({
                                data: { sentCda },
                                eventType: EventType.PRINT,
                            }),
                        }
                        : {},
                    warnings: {
                        link: () => {
                            return { path: './' };
                        },
                        event: (sentCda) => ({
                            data: { sentCda },
                            eventType: EventType.WARNINGS,
                        }),
                        icon: 'exclamation-triangle',
                        styleClass: 'warnings-icon',
                    },
                    attachmentCount: authorizedButtons.print
                        ? {
                            link: () => {
                                return { path: './' };
                            },
                            event: (sentCda) => ({
                                data: { sentCda },
                                eventType: EventType.ATTACHMENT,
                            }),
                            icon: 'paperclip',
                            styleClass: 'column-icon',
                        }
                        : {
                            link: () => {
                                return { path: './' };
                            },
                            event: (sentCda) => ({
                                data: { sentCda },
                                eventType: EventType.DISABLED,
                            }),
                            icon: 'paperclip',
                            styleClass: 'column-icon disabled',
                        },
                };
            }))
                .subscribe(), this.store
                .pipe(select(selectors.userProfile), tap((user) => {
                this.email = user.sub;
            }))
                .subscribe());
            this.selectedPrintOptions = yield this.printOptionsService.get('cda', toolKeys.MP_SENT_CDA_PRINT);
        });
    }
    bulkPrint() {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `cda/print`,
            httpMethod: 'POST',
            body: this.cdasToPrint,
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            var _a;
            ((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) === 1
                ? saveAs(response, 'MergedDocuments')
                : this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.cdasToPrint = [];
            this.triggeredByPrint = false;
            this.spinner.off();
        }))
            .subscribe();
    }
    openPdfViewer(data) {
        const ref = this.dialogService.open(PdfViewerComponent, {
            data: {
                response: data,
            },
            styleClass: 'pdf-viewer',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
    }
    closePrintOptionsDialog() {
        this.showPrintOptionsDialog = false;
    }
    updatePrintOptions(selectedPrintOptions) {
        this.selectedPrintOptions = selectedPrintOptions;
        if (this.triggeredByPrint) {
            this.bulkPrint();
        }
        this.closePrintOptionsDialog();
    }
    searchContainerEvent({ data, eventType }) {
        const { sentCda } = data;
        switch (eventType) {
            case EventType.PRINT:
                this.print(sentCda);
                break;
            case EventType.WARNINGS:
                const key = sentCda === null || sentCda === void 0 ? void 0 : sentCda.cdaKey;
                this.warningsDialogWizard = {
                    endpoint: `sentcda/cda/warning/form`,
                    httpMethod: HttpMethod$2.POST,
                    body: {
                        keys: [key],
                    },
                };
                this.showWarningsDialog = true;
                break;
            case EventType.ATTACHMENT:
                const cdaKey = sentCda === null || sentCda === void 0 ? void 0 : sentCda.cdaKey;
                this.popupService.openWizard({
                    endpoint: `/sentCda/ui/cda/${cdaKey}/attachments`,
                    httpMethod: HttpMethod$2.POST,
                    body: {},
                });
                break;
            default:
                break;
        }
    }
    print(sentCda) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `cda/${sentCda === null || sentCda === void 0 ? void 0 : sentCda.cdaKey}/print`,
            httpMethod: 'GET',
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
            .subscribe();
    }
    closeDisplayLog() {
        this.showDisplayLog = false;
    }
    submitDisplayLog(event) {
        this.showDisplayLog = false;
        this.searchContainerLoaderService.refreshSearch();
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
    closeActionLogs() {
        this.showActionLogs = false;
    }
    submitActionLogs(options) {
        this.showActionLogs = false;
        this.searchContainerLoaderService.refreshSearch();
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
    closeWarningsDialog() {
        this.searchContainerLoaderService.refreshSearch();
        this.showWarningsDialog = false;
    }
    submitWarningsDialog(event) {
        this.showWarningsDialog = false;
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.searchContainerLoaderService.refreshSearch();
    }
    openDataGenius() {
        const ref = this.dialogService.open(DataGeniusSelectionComponent, {
            showHeader: false,
            styleClass: 'export-dialog',
            data: {
                selectionCount: this.selections.length,
            },
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
        const refSubscription = ref.onClose
            .pipe(mergeMap((dgOptions) => dgOptions ? this.submitDataGenius(dgOptions) : EMPTY), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
            .subscribe();
        this.subscriptions = [...this.subscriptions, refSubscription];
    }
    submitDataGenius(dgOptions) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.spinner.on();
        return this.http
            .fetchWithFqn({
            endpoint: `${this.mp.getConfig().sentCda}/cda/rundatagenius`,
            httpMethod: 'POST',
            body: Object.assign(Object.assign({}, dgOptions), { keys: [...this.selections].map((_a) => {
                    var { cdaKey } = _a, _ = __rest(_a, ["cdaKey"]);
                    return cdaKey;
                }), page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows }, sort: {
                    field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                    order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                }, search: {
                    filters: this.searchContainerLoaderService.filters,
                    term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
                } }),
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()));
    }
};
SentCDAComponent.ctorParameters = () => [
    { type: DialogService },
    { type: ConfirmationService$1 },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: Store },
    { type: CdaWizardService },
    { type: Router },
    { type: PrintOptionsService },
    { type: PopupService }
];
SentCDAComponent = __decorate([
    Component({
        selector: 'lib-sent-cda',
        template: "<div class=\"view-remittances\">\r\n  <h2>{{ 'BREADCRUMB.CREDIT_DEBIT_ADJUSTMENT' | transloco }}</h2>\r\n  <div class=\"dashboard\">\r\n    <lib-app-dashboard-loader\r\n      class=\"analytics-cda-sent-kpi\"\r\n      [configEndpoint]=\"analyticsEndpoint\"\r\n      [chartAdaptor]=\"adaptor\"\r\n      [kpiAdaptor]=\"kpiAdaptor\"\r\n      [chartNoDataTest]=\"chartNoDataTest\"\r\n      [paramListener]=\"paramListener\"\r\n    ></lib-app-dashboard-loader>\r\n  </div>\r\n\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"searchUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showPrintOptionsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-print-options-container\r\n    [baseUrl]=\"searchUrl\"\r\n    [selectedPrintOptions]=\"selectedPrintOptions\"\r\n    (closeDialog)=\"closePrintOptionsDialog()\"\r\n    (updatePrintOptions)=\"updatePrintOptions($event)\"\r\n  ></lib-print-options-container>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showDisplayLog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-logging\r\n    [baseUrl]=\"loggingUrl\"\r\n    [batchKey]=\"batchKey\"\r\n    (closeLogDialog)=\"closeDisplayLog()\"\r\n  >\r\n  </lib-logging>\r\n</p-dialog>\r\n<p-dialog\r\n  *ngIf=\"showActionLogs\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"searchUrl\"\r\n    [wizardConfig]=\"actionLogsWizard\"\r\n    (submit)=\"submitActionLogs($event)\"\r\n    (cancel)=\"closeActionLogs()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n      <div>\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeActionLogs()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showWarningsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [autoZIndex]=\"false\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"newCdaUrl\"\r\n    [wizardConfig]=\"warningsDialogWizard\"\r\n    (submit)=\"submitWarningsDialog($event)\"\r\n    (cancel)=\"closeWarningsDialog()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeWarningsDialog()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, DialogService],
        encapsulation: ViewEncapsulation.None,
        styles: [`
      .analytics-cda-sent-kpi .dashboard .body {
        min-height: 0 !important;
      }
    `]
    })
], SentCDAComponent);

const ɵ0$a = { breadcrumb: 'BREADCRUMB.CREDIT_DEBIT_ADJUSTMENT' }, ɵ1$6 = { breadcrumb: 'BREADCRUMB.CREDIT_DEBIT_ADJUSTMENT' };
const routes$7 = [
    {
        path: 'cda-sent',
        component: SentCDAComponent,
        data: ɵ0$a,
    },
    {
        path: 'new-cda',
        canDeactivate: [CanDeactivateGuard],
        component: CdaWizardComponent,
        data: ɵ1$6,
    },
];

var CollectionBatchBulkUpdate;
(function (CollectionBatchBulkUpdate) {
    CollectionBatchBulkUpdate[CollectionBatchBulkUpdate["APPROVE"] = 1] = "APPROVE";
    CollectionBatchBulkUpdate[CollectionBatchBulkUpdate["REJECT"] = 3] = "REJECT";
    CollectionBatchBulkUpdate[CollectionBatchBulkUpdate["GENERATE_FILE"] = 4] = "GENERATE_FILE";
})(CollectionBatchBulkUpdate || (CollectionBatchBulkUpdate = {}));
let BatchesComponent = class BatchesComponent {
    constructor(confirmationService, dialogService, translocoService, toast, spinner, marketplaceService, http, searchContainerLoaderService, store) {
        this.confirmationService = confirmationService;
        this.dialogService = dialogService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.marketplaceService = marketplaceService;
        this.http = http;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.store = store;
        // kpi dashboard states
        this.dashBoardStateKey = 'CollectionBatchesDashboardState';
        this.dashBoardVisibilityStateKey = 'CollectionBatchesDashboardVisibilityState';
        this.categoryFilter = ['accountsReceivable'];
        this.showCategories = false;
        this.defaultDashboardState = {
            dashboard: ['accountsReceivable.collectionBatchPending'],
            gridArea: [[0]],
        };
        // search container loader states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'collectionsBatches';
        this.i18nSearchField = 'COLLECTIONS.PAYMENT_REFERENCE_NUMBER';
        this.showViewDialog = false;
        this.showFlipDialog = false;
        this.showGenerateFileDialog = false;
        this.showRejectDialog = false;
        this.collectionsToView = [];
        this.collectionsToFlip = [];
        this.collectionsToGenerateFileFor = [];
        this.fields = null;
        this.toolbarActionsDispatcher = {
            export: (selection) => {
                this.selections = selection;
                this.openExport();
            },
            view: (selection) => {
                const { collectionBatchKey } = selection[0];
                this.collectionsToView = collectionBatchKey;
                this.showViewDialog = true;
            },
            approve: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('INVOICE.COLLECTION_BATCHES_APPROVE_MESSAGE'),
                    header: this.translocoService.translate('INVOICE.COLLECTION_BATCHES_APPROVE_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'collectionbatch/bulk-update',
                            httpMethod: 'POST',
                            body: {
                                keys: [...selection].map((_a) => {
                                    var { collectionBatchKey } = _a, _ = __rest(_a, ["collectionBatchKey"]);
                                    return collectionBatchKey;
                                }),
                                approvalStatusTypeKey: {
                                    value: CollectionBatchBulkUpdate.APPROVE,
                                },
                            },
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            reject: (selection) => {
                this.showRejectDialog = true;
                this.selectedKeys = [...selection].map((_a) => {
                    var { collectionBatchKey } = _a, _ = __rest(_a, ["collectionBatchKey"]);
                    return collectionBatchKey;
                });
            },
            generateFile: (selection) => {
                this.collectionsToGenerateFileFor = [...selection].map((_a) => {
                    var { collectionBatchKey } = _a, _ = __rest(_a, ["collectionBatchKey"]);
                    return collectionBatchKey;
                });
                this.showGenerateFileDialog = true;
            },
            flip: (selection) => {
                this.collectionsToFlip = [...selection].map((_a) => {
                    var { collectionBatchKey } = _a, _ = __rest(_a, ["collectionBatchKey"]);
                    return collectionBatchKey;
                });
                this.showFlipDialog = true;
            },
        };
        this.baseUrl = `${this.marketplaceService.getConfig().sentInvoice}/collectionbatch`;
        this.columnActions = {};
        this.email = '';
        http.baseUrl = marketplaceService.getConfig().sentInvoice;
    }
    ngOnInit() {
        this.subscriptions.push(this.store
            .pipe(select(selectors.userProfile), tap((user) => {
            this.email = user.sub;
        }))
            .subscribe());
    }
    closeReject() {
        this.showRejectDialog = false;
    }
    saveReject(formData) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: 'collectionbatch/bulk-update',
            httpMethod: 'POST',
            body: {
                keys: this.selectedKeys,
                approvalStatusTypeKey: {
                    value: CollectionBatchBulkUpdate.REJECT,
                },
                rejectionNotes: {
                    value: formData === null || formData === void 0 ? void 0 : formData.rejectionNotes,
                },
                rejectionReasonTypeKey: {
                    value: Number(formData === null || formData === void 0 ? void 0 : formData.rejectionReasonTypeKey),
                },
            },
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.spinner.off();
            this.closeReject();
        }))
            .subscribe();
    }
    openExport() {
        const ref = this.dialogService.open(ExportComponent, {
            data: {
                endpoint: `${this.baseUrl}/export/form`,
            },
            showHeader: false,
            styleClass: 'export-dialog',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
        const refSubscription = ref.onClose
            .pipe(mergeMap((exportOptions) => exportOptions ? this.submitExport(exportOptions) : EMPTY), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
            .subscribe();
        this.subscriptions = [...this.subscriptions, refSubscription];
    }
    submitExport(exportOptions) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.spinner.on();
        return this.http
            .fetchWithFqn({
            endpoint: `${this.marketplaceService.getConfig().sentInvoice}/collectionbatch/export`,
            httpMethod: 'POST',
            body: Object.assign(Object.assign({}, exportOptions), { email: this.email, toolkeys: '', keys: [...this.selections].map((_a) => {
                    var { collectionBatchKey } = _a, _ = __rest(_a, ["collectionBatchKey"]);
                    return collectionBatchKey;
                }), page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows }, sort: {
                    field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                    order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                }, search: {
                    filters: this.searchContainerLoaderService.filters,
                    term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
                } }),
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()));
    }
    closeViewDialog() {
        this.showViewDialog = false;
    }
    closeFlipDialog() {
        this.showFlipDialog = false;
    }
    closeGenerateFileDialog() {
        this.showGenerateFileDialog = false;
    }
    flip({ bankAccount }) {
        this.spinner.on();
        this.closeFlipDialog();
        this.http
            .fetch({
            endpoint: `collectionbatch/flip`,
            httpMethod: 'POST',
            body: {
                keys: this.collectionsToFlip,
                accountBankingInfoKey: bankAccount,
            },
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.collectionsToFlip = [];
            this.spinner.off();
        }))
            .subscribe();
    }
    generateFile({ bankAccount, bankFileTemplateKey, effectiveDate }) {
        this.spinner.on();
        this.closeGenerateFileDialog();
        this.http
            .fetch({
            endpoint: `collectionbatch/generate-file`,
            httpMethod: 'POST',
            body: {
                keys: this.collectionsToGenerateFileFor,
                accountBankingInfoKey: bankAccount,
                bankFileTemplateKey,
                effectiveDate,
            },
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.collectionsToGenerateFileFor = [];
            this.spinner.off();
        }))
            .subscribe();
    }
    ngOnDestroy() {
        this.dynamicDialogRefs.forEach((ref) => ref.destroy());
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
};
BatchesComponent.ctorParameters = () => [
    { type: ConfirmationService },
    { type: DialogService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: MarketplaceService },
    { type: BaseHttpService },
    { type: SearchContainerLoaderService },
    { type: Store }
];
BatchesComponent = __decorate([
    Component({
        selector: 'lib-batches',
        template: "<div class=\"view-invoices\">\r\n  <div class=\"dashboard\">\r\n    <lib-dashboard-container\r\n      [dashBoardStateKey]=\"dashBoardStateKey\"\r\n      [dashBoardVisibilityStateKey]=\"dashBoardVisibilityStateKey\"\r\n      [dashBoardHeader]=\"'MARKETPLACE.TAB_PAYMENTS_BATCHES'\"\r\n      [categoryFilter]=\"categoryFilter\"\r\n      [showCategories]=\"showCategories\"\r\n      [defaultDashboardState]=\"defaultDashboardState\"\r\n    ></lib-dashboard-container>\r\n  </div>\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [baseUrl]=\"baseUrl\"\r\n    [columnActions]=\"columnActions\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showViewDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '1040px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-view-container\r\n    [baseUrl]=\"baseUrl\"\r\n    [collectionBatchKey]=\"collectionsToView\"\r\n    (closeViewDialog)=\"closeViewDialog()\"\r\n  ></lib-view-container>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showFlipDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-flip-form-container\r\n    [baseUrl]=\"baseUrl\"\r\n    (closeDialog)=\"closeFlipDialog()\"\r\n    (saveDialog)=\"flip($event)\"\r\n  >\r\n  </lib-flip-form-container>\r\n</p-dialog>\r\n<p-dialog\r\n  *ngIf=\"showGenerateFileDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-generate-file-form-container\r\n    [baseUrl]=\"baseUrl\"\r\n    [selectedKeys]=\"collectionsToGenerateFileFor\"\r\n    (closeDialog)=\"closeGenerateFileDialog()\"\r\n    (saveDialog)=\"generateFile($event)\"\r\n  >\r\n  </lib-generate-file-form-container>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showRejectDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-reject\r\n    [baseUrl]=\"baseUrl\"\r\n    (closeRejectDialog)=\"closeReject()\"\r\n    (saveRejectDialog)=\"saveReject($event)\"\r\n  >\r\n  </lib-reject>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, DialogService]
    })
], BatchesComponent);

const ɵ0$b = { breadcrumb: 'BREADCRUMB.COLLECTIONS' };
const routes$8 = [
    {
        path: 'collections/batches',
        component: BatchesComponent,
        data: ɵ0$b,
    },
];

let EditInvoiceService = class EditInvoiceService {
    reset() {
        // empty
    }
};
EditInvoiceService.ɵprov = ɵɵdefineInjectable({ factory: function EditInvoiceService_Factory() { return new EditInvoiceService(); }, token: EditInvoiceService, providedIn: "root" });
EditInvoiceService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], EditInvoiceService);

let EditInvoiceEntryComponent = class EditInvoiceEntryComponent extends ComponentCanDeactivate {
    constructor(formGenerator, http, toast, transloco, newInvoiceSrv, editInvoiceSrv, confirmationService, translocoSrv, router, mp) {
        super();
        this.formGenerator = formGenerator;
        this.http = http;
        this.toast = toast;
        this.transloco = transloco;
        this.newInvoiceSrv = newInvoiceSrv;
        this.editInvoiceSrv = editInvoiceSrv;
        this.confirmationService = confirmationService;
        this.translocoSrv = translocoSrv;
        this.router = router;
        this.mp = mp;
        this.templateTypes = TemplateTypes;
        this.baseUrl = '';
        this.cancelButtonClicked = false;
        this.wizardConfig = {
            endpoint: this.editInvoiceSrv.wizardUrl,
            httpMethod: HttpMethod$2.GET,
        };
        this.baseUrl = `${this.mp.getConfig().apiBaseUrl}`;
        // if (this.newInvoiceSrv.newInvoiceWizard === undefined) {
        //   this.router.navigate([moduleUrls.invoiceReconcilliation()]);
        // }
        // this.wizardConfig = this.newInvoiceSrv.newInvoiceWizard;
    }
    redirect() {
        this.cancelButtonClicked = true;
        this.editInvoiceSrv.reset();
        this.router.navigate([this.editInvoiceSrv.redirectUrl]);
    }
    submitNew(event) {
        this.cancelButtonClicked = true;
        this.editInvoiceSrv.reset();
        this.router.navigate([this.editInvoiceSrv.redirectUrl]);
    }
    canDeactivate(nextState) {
        // when the cancel dialog is open and submit is clicked, we don't want the alert to show and just nav away
        if (this.cancelButtonClicked) {
            return true;
        }
        return false;
    }
};
EditInvoiceEntryComponent.ctorParameters = () => [
    { type: GenerateFormService },
    { type: BaseHttpService$3 },
    { type: ToastrNotificationService },
    { type: TranslocoService },
    { type: NewInvoiceService },
    { type: EditInvoiceService },
    { type: ConfirmationService },
    { type: TranslocoService },
    { type: Router },
    { type: MarketplaceService }
];
EditInvoiceEntryComponent = __decorate([
    Component({
        selector: 'lib-edit-invoice-entry',
        template: "<lui-wizard-v3\r\n  [baseUrl]=\"baseUrl\"\r\n  [wizardConfig]=\"wizardConfig\"\r\n  (cancel)=\"redirect()\"\r\n  (submit)=\"submitNew($event)\"\r\n>\r\n  <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n    <div>\r\n      <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n    <div\r\n      class=\"error\"\r\n      style=\"\r\n        min-height: 30vh;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n      \"\r\n    >\r\n      <div>\r\n        <span>\r\n          <i class=\"pi pi-times-circle\"></i>\r\n          {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n        </span>\r\n      </div>\r\n    </div>\r\n    <button pButton (click)=\"redirect()\" class=\"ds secondary\">\r\n      {{ 'ACTIONS.CANCEL' | transloco }}\r\n    </button>\r\n  </ng-template>\r\n</lui-wizard-v3>\r\n\r\n<p-confirmDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n",
        providers: [ConfirmationService]
    })
], EditInvoiceEntryComponent);

let ComplianceInvoiceMatchingComponent = class ComplianceInvoiceMatchingComponent {
    constructor(confirmationService, dialogService, mp, http, translocoService, toast, spinner, searchContainerLoaderService, router, route, editInvoiceSrv, store, printOptionsService) {
        this.confirmationService = confirmationService;
        this.dialogService = dialogService;
        this.mp = mp;
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.router = router;
        this.route = route;
        this.editInvoiceSrv = editInvoiceSrv;
        this.store = store;
        this.printOptionsService = printOptionsService;
        // Warnings state
        this.showWarningsDialog = false;
        // display log states
        this.showEditDialog = false;
        this.showDisplayLog = false;
        this.batchKey = 0;
        this.columnActions = {};
        this.email = '';
        this.showUploadBtnDialog = false;
        // Action logs
        this.showActionLogs = false;
        this.showExportDialog = false;
        this.templateTypes = TemplateTypes;
        // kpi dashboard states
        this.dashBoardStateKey = 'receivedASNDashboardState';
        this.dashBoardVisibilityStateKey = 'receivedASNDashboardVisibilityState';
        this.categoryFilter = ['orderingReceiving'];
        this.showCategories = false;
        this.defaultDashboardState = {
            dashboard: ['orderingReceiving.newASNUnprocessed'],
            gridArea: [[0]],
        };
        // print states
        this.showPrintOptionsDialog = false;
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        this.asnsToPrint = [];
        // search container loader states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'receivedASNSearch';
        this.i18nSearchField = 'INVOICE.SENT_INVOICES_SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {
            edit: (selection) => {
                this.editInvoiceSrv.wizardUrl = apiUrls.editComplianceInvoiceUrl(selection[0].draftInvoiceKey);
                this.editInvoiceSrv.redirectUrl = moduleUrls.invoiceReconcilliation();
                this.router.navigate([moduleUrls.editComplianceInvoice()]);
            },
            export: (selection) => {
                const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
                this.selections = selection;
                this.exportWizardConfig = {
                    endpoint: apiUrls.exportWizardUrl(),
                    httpMethod: HttpMethod$2.POST,
                    body: {
                        fileUploadKeys: [...selection].map((_a) => {
                            var { fileUploadKey } = _a, _ = __rest(_a, ["fileUploadKey"]);
                            return fileUploadKey;
                        }),
                    },
                };
                this.showExportDialog = true;
            },
            upload: (selection) => {
                this.wizardConfig = {
                    endpoint: apiUrls.uploadInvoiceWizard(),
                    httpMethod: HttpMethod$2.GET,
                };
                this.showUploadBtnDialog = true;
            },
        };
        this.baseUrl = `${this.mp.getConfig().sentInvoice}`;
        this.newInvoiceUrl = `${this.mp.getConfig().apiBaseUrl}`;
        this.complianceUrl = `${this.baseUrl}/compliance`;
        http.baseUrl = this.complianceUrl;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.push(this.store
                .pipe(select(selectors.isAuthorized, {}), tap((authorizedButtons) => {
                this.columnActions = {};
            }))
                .subscribe()),
                this.subscriptions.push(this.store
                    .pipe(select(selectors.userProfile), tap((user) => {
                    this.email = user.sub;
                    // if (user && user.toolKeys.includes(612)) {
                    //     this.router.navigate([
                    //       moduleUrls.editComplianceInvoice(),
                    //     ]);
                    // }
                }))
                    .subscribe());
        });
    }
    searchContainerEvent({ data, eventType }) {
        const { receivedAsn } = data;
        // switch (eventType) {
        //   case EventType.PRINT:
        //     this.print(receivedAsn);
        //     break;
        //   case EventType.WARNINGS:
        //     this.selectedAsnKey = receivedAsn?.asnKey;
        //     this.warningsDialogWizard = {
        //       endpoint: `receivedasn/asn/warning/form`,
        //       httpMethod: HttpMethod.POST,
        //       body: {
        //         keys: [this.selectedAsnKey],
        //       },
        //     };
        //     this.showWarningsDialog = true;
        //     break;
        //   default:
        //     break;
        // }
    }
    closeEdit() {
        this.showEditDialog = false;
    }
    submitEdit(event) {
        this.showEditDialog = false;
        this.searchContainerLoaderService.refreshSearch();
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
    closeExport() {
        this.showExportDialog = false;
    }
    submitExport(event) {
        this.showExportDialog = false;
        this.searchContainerLoaderService.refreshSearch();
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
    closeOnUploadBtnDialog(event) {
        this.showUploadBtnDialog = false;
    }
    submitOnUploadBtnDialog(options) {
        this.showUploadBtnDialog = false;
        this.searchContainerLoaderService.refreshSearch();
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
    ngOnDestroy() {
        this.dynamicDialogRefs.forEach((ref) => ref.destroy());
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
};
ComplianceInvoiceMatchingComponent.ctorParameters = () => [
    { type: ConfirmationService },
    { type: DialogService },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: Router },
    { type: ActivatedRoute },
    { type: EditInvoiceService },
    { type: Store },
    { type: PrintOptionsService }
];
ComplianceInvoiceMatchingComponent = __decorate([
    Component({
        selector: 'lib-compliance-invoice-matching',
        template: "<h2>{{ 'BREADCRUMB.INVOICE_RECONCILIATION' | transloco }}</h2>\r\n<div class=\"view-invoices\">\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"complianceUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n\r\n  <p-dialog\r\n    *ngIf=\"showExportDialog\"\r\n    [visible]=\"true\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '50vw' }\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [showHeader]=\"false\"\r\n    [focusOnShow]=\"false\"\r\n    position=\"center\"\r\n  >\r\n    <lui-wizard-v3\r\n      [baseUrl]=\"complianceUrl\"\r\n      [wizardConfig]=\"exportWizardConfig\"\r\n      (submit)=\"submitExport($event)\"\r\n      (cancel)=\"closeExport()\"\r\n    >\r\n      <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n        <div\r\n          class=\"error\"\r\n          style=\"\r\n            min-height: 30vh;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n          \"\r\n        >\r\n          <div>\r\n            <span>\r\n              <i class=\"pi pi-times-circle\"></i>\r\n              {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n            </span>\r\n          </div>\r\n        </div>\r\n        <button pButton (click)=\"closeExport()\" class=\"ds secondary\">\r\n          {{ 'ACTIONS.CANCEL' | transloco }}\r\n        </button>\r\n      </ng-template>\r\n    </lui-wizard-v3>\r\n  </p-dialog>\r\n\r\n  <p-dialog\r\n    *ngIf=\"showUploadBtnDialog\"\r\n    [visible]=\"true\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '54vw' }\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"true\"\r\n    [showHeader]=\"false\"\r\n    [focusOnShow]=\"false\"\r\n    position=\"center\"\r\n  >\r\n    <lui-wizard-v3\r\n      [baseUrl]=\"complianceUrl\"\r\n      [style]=\"{ width: '10vw' }\"\r\n      [wizardConfig]=\"wizardConfig\"\r\n      (submit)=\"submitOnUploadBtnDialog($event)\"\r\n      (cancel)=\"closeOnUploadBtnDialog()\"\r\n    >\r\n      <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n        <div>\r\n          <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n        </div>\r\n      </ng-template>\r\n      <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n        <div\r\n          class=\"error\"\r\n          style=\"\r\n            min-height: 30vh;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n          \"\r\n        >\r\n          <div>\r\n            <span>\r\n              <i class=\"pi pi-times-circle\"></i>\r\n              {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n            </span>\r\n          </div>\r\n        </div>\r\n        <button pButton (click)=\"closeOnUploadBtnDialog()\" class=\"ds secondary\">\r\n          {{ 'ACTIONS.CANCEL' | transloco }}\r\n        </button>\r\n      </ng-template>\r\n    </lui-wizard-v3>\r\n  </p-dialog>\r\n</div>\r\n",
        providers: [SearchContainerLoaderService, DialogService]
    })
], ComplianceInvoiceMatchingComponent);

const ɵ0$c = { breadcrumb: 'BREADCRUMB.INVOICE_MATCHING' }, ɵ1$7 = {
    breadcrumb: {
        label: 'BREADCRUMB.INVOICES',
        disable: true,
    },
};
const routes$9 = [
    {
        path: 'invoice-matching',
        component: ComplianceInvoiceMatchingComponent,
        data: ɵ0$c,
    },
    {
        path: 'edit-invoice',
        data: ɵ1$7,
        component: EditInvoiceEntryComponent,
        canDeactivate: [CanDeactivateGuard],
    },
];

let ComplianceStatementMatchingComponent = class ComplianceStatementMatchingComponent {
    constructor(confirmationService, dialogService, mp, http, translocoService, toast, spinner, router, searchContainerLoaderService, store, printOptionsService) {
        this.confirmationService = confirmationService;
        this.dialogService = dialogService;
        this.mp = mp;
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.router = router;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.store = store;
        this.printOptionsService = printOptionsService;
        // Warnings state
        this.showWarningsDialog = false;
        // display log states
        this.showDisplayLog = false;
        this.batchKey = 0;
        // Action logs
        this.showActionLogs = false;
        this.templateTypes = TemplateTypes;
        // kpi dashboard states
        this.dashBoardStateKey = 'receivedASNDashboardState';
        this.dashBoardVisibilityStateKey = 'receivedASNDashboardVisibilityState';
        this.categoryFilter = ['orderingReceiving'];
        this.showCategories = false;
        this.defaultDashboardState = {
            dashboard: ['orderingReceiving.newASNUnprocessed'],
            gridArea: [[0]],
        };
        // print states
        this.showPrintOptionsDialog = false;
        this.asnsToPrint = [];
        // tslint:disable-next-line: array-type
        this.statementsToPrint = [];
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        // search container loader states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'receivedASNSearch';
        this.i18nSearchField = 'STATEMENTS_OF_ACCOUNT.SEARCH';
        this.params = {};
        this.showNotifyDialog = false;
        this.showNewBtnDialog = false;
        this.baseUrl = `${this.mp.getConfig().receivedStatement}`;
        this.apiBaseUrl = `${this.mp.getConfig().apiBaseUrl}`;
        this.payByStatementUrl = `${this.baseUrl}/payment/paybystatement`;
        this.statementPrintUrl = `${this.baseUrl}/payment`;
        this.statementUrl = `${this.baseUrl}/statement`;
        this.loggingUrl = `/`;
        this.email = '';
        this.toolbarActionsDispatcher = {
            manage: (selection) => {
                const [firstSelection] = selection;
                this.router.navigate([
                    `/pay-module/payables/statement-invoices/${firstSelection.statementKey}`,
                ]);
            },
            import: (selection) => {
                this.wizardConfig = {
                    endpoint: apiUrls.newStatementsWizard(),
                    httpMethod: HttpMethod$2.GET,
                };
                this.showNewBtnDialog = true;
            },
            printOptions: (selection) => {
                this.showPrintOptionsDialog = true;
            },
            print: (selection) => {
                var _a;
                this.statementsToPrint = [...selection].map((_a) => {
                    var { statementKey } = _a, _ = __rest(_a, ["statementKey"]);
                    return statementKey;
                });
                if (((_a = Object.keys(this.selectedPrintOptions || {})) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.bulkPrint();
                }
                else {
                    this.triggeredByPrint = true;
                    this.showPrintOptionsDialog = true;
                }
            },
            export: (selection) => {
                this.selections = selection;
                this.openExport();
            },
            displayLog: (selection) => {
                var _a;
                this.batchKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.statementKey;
                this.loggingUrl = apiUrls.displayLogStatements(this.baseUrl, this.batchKey);
                this.showDisplayLog = true;
            },
            notify: (selection) => {
                var _a;
                this.statementKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.statementKey;
                this.wizardConfig = {
                    endpoint: apiUrls.notifyWizard(this.statementKey),
                    httpMethod: HttpMethod$2.GET,
                };
                this.showNotifyDialog = true;
            },
        };
        http.baseUrl = this.baseUrl;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            // this.statementKey = this.route.snapshot.paramMap.get('statementKey');
            this.store
                .pipe(select(selectors.isAuthorized, {
                manage: toolKeys.PAY_PAYABLES_PAY_VIA_STATEMENT,
            }), tap((authorizedButtons) => {
                this.columnActions = {
                    referenceID: authorizedButtons.manage
                        ? {
                            link: (firstSelection) => ({
                                path: `/pay-module/payables/statement-invoices/${firstSelection.statementKey}`,
                            }),
                        }
                        : {},
                    warnings: authorizedButtons.manage
                        ? {
                            link: () => {
                                return { path: './' };
                            },
                            event: (receivedStatement) => ({
                                data: { receivedStatement },
                                eventType: 'warnings',
                            }),
                        }
                        : {},
                };
            }))
                .subscribe(),
                this.subscriptions.push(this.store
                    .pipe(select(selectors.userProfile), tap((user) => {
                    this.email = user.sub;
                    if (user && user.toolKeys.includes(313)) {
                        if (this.statementKey) {
                            this.router.navigate([
                                moduleUrls.manageDetails(this.statementKey),
                            ]);
                        }
                    }
                }))
                    .subscribe()),
                (this.selectedPrintOptions = yield this.printOptionsService.get('payment', toolKeys.MP_RECEIVED_STATEMENT_PRINT));
        });
    }
    searchContainerEvent({ data, eventType }) {
        const { receivedStatement } = data;
        switch (eventType) {
            case 'print':
                this.print(receivedStatement);
                break;
            default:
                break;
        }
    }
    bulkPrint() {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `payment/print`,
            httpMethod: 'POST',
            body: this.statementsToPrint,
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            var _a;
            ((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) === 1
                ? saveAs(response, 'MergedDocuments')
                : this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.statementsToPrint = [];
            this.triggeredByPrint = false;
            this.spinner.off();
        }))
            .subscribe();
    }
    print(receivedStatement) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: apiUrls.printStatement(this.baseUrl, receivedStatement.statementKey),
            httpMethod: 'GET',
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
            .subscribe();
    }
    openPdfViewer(data) {
        const ref = this.dialogService.open(PdfViewerComponent, {
            data: {
                response: data,
            },
            styleClass: 'pdf-viewer',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
    }
    updatePrintOptions(selectedPrintOptions) {
        this.selectedPrintOptions = selectedPrintOptions;
        if (this.triggeredByPrint) {
            this.bulkPrint();
        }
        this.closePrintOptionsDialog();
    }
    closePrintOptionsDialog() {
        this.showPrintOptionsDialog = false;
    }
    openExport() {
        const ref = this.dialogService.open(ExportComponent, {
            data: {
                endpoint: `${this.baseUrl}/export/form`,
            },
            showHeader: false,
            styleClass: 'export-dialog',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
        const refSubscription = ref.onClose
            .pipe(mergeMap((exportOptions) => exportOptions ? this.submitExport(exportOptions) : EMPTY), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
            .subscribe();
        this.subscriptions = [...this.subscriptions, refSubscription];
    }
    submitExport(exportOptions) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.spinner.on();
        return this.http
            .fetchWithFqn({
            endpoint: apiUrls.submitStatementExport(this.baseUrl),
            httpMethod: 'POST',
            body: Object.assign(Object.assign({}, exportOptions), { email: this.email, toolkeys: '', keys: [...this.selections].map((_a) => {
                    var { statementKey } = _a, _ = __rest(_a, ["statementKey"]);
                    return statementKey;
                }), page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows }, sort: {
                    field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                    order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                }, search: {
                    filters: this.searchContainerLoaderService.filters,
                    term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
                } }),
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()));
    }
    closeOnNewBtnDialog(event) {
        this.showNewBtnDialog = false;
    }
    submitOnNewBtnDialog(options) {
        this.showNewBtnDialog = false;
        this.searchContainerLoaderService.refreshSearch();
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
    closeDisplayLog() {
        this.showDisplayLog = false;
    }
    closeNotifyDialog(event) {
        this.showNotifyDialog = false;
    }
    submitNotifyDialog(options) {
        this.showNotifyDialog = false;
        this.searchContainerLoaderService.refreshSearch();
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
};
ComplianceStatementMatchingComponent.ctorParameters = () => [
    { type: ConfirmationService },
    { type: DialogService },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: Router },
    { type: SearchContainerLoaderService },
    { type: Store },
    { type: PrintOptionsService }
];
ComplianceStatementMatchingComponent = __decorate([
    Component({
        selector: 'lib-compliance-statement-matching',
        template: "<h2>{{ 'BREADCRUMB.STATEMENT_RECONCILIATION' | transloco }}</h2>\r\n<div class=\"view-invoices\">\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"payByStatementUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n  <p-dialog\r\n    *ngIf=\"showPrintOptionsDialog\"\r\n    [visible]=\"true\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '520px' }\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [showHeader]=\"false\"\r\n    [focusOnShow]=\"false\"\r\n    position=\"center\"\r\n  >\r\n    <lib-print-options-container\r\n      [baseUrl]=\"statementPrintUrl\"\r\n      [selectedPrintOptions]=\"selectedPrintOptions\"\r\n      (closeDialog)=\"closePrintOptionsDialog()\"\r\n      (updatePrintOptions)=\"updatePrintOptions($event)\"\r\n    ></lib-print-options-container>\r\n  </p-dialog>\r\n\r\n  <p-dialog\r\n    *ngIf=\"showNewBtnDialog\"\r\n    [visible]=\"true\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '54vw' }\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"true\"\r\n    [showHeader]=\"false\"\r\n    [focusOnShow]=\"false\"\r\n    position=\"center\"\r\n  >\r\n    <lui-wizard-v3\r\n      [baseUrl]=\"baseUrl\"\r\n      [style]=\"{ width: '10vw' }\"\r\n      [wizardConfig]=\"wizardConfig\"\r\n      (submit)=\"submitOnNewBtnDialog($event)\"\r\n      (cancel)=\"closeOnNewBtnDialog()\"\r\n    >\r\n      <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n        <div>\r\n          <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n        </div>\r\n      </ng-template>\r\n      <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n        <div\r\n          class=\"error\"\r\n          style=\"\r\n            min-height: 30vh;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n          \"\r\n        >\r\n          <div>\r\n            <span>\r\n              <i class=\"pi pi-times-circle\"></i>\r\n              {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n            </span>\r\n          </div>\r\n        </div>\r\n        <button pButton (click)=\"closeOnNewBtnDialog()\" class=\"ds secondary\">\r\n          {{ 'ACTIONS.CANCEL' | transloco }}\r\n        </button>\r\n      </ng-template>\r\n    </lui-wizard-v3>\r\n  </p-dialog>\r\n\r\n  <p-dialog\r\n    *ngIf=\"showNotifyDialog\"\r\n    [visible]=\"true\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '50vw' }\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [showHeader]=\"false\"\r\n    [focusOnShow]=\"false\"\r\n    position=\"center\"\r\n  >\r\n    <lui-wizard-v3\r\n      [baseUrl]=\"baseUrl\"\r\n      [wizardConfig]=\"wizardConfig\"\r\n      (submit)=\"submitNotifyDialog($event)\"\r\n      (cancel)=\"closeNotifyDialog()\"\r\n    >\r\n      <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n        <div>\r\n          <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n        </div>\r\n      </ng-template>\r\n      <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n        <div\r\n          class=\"error\"\r\n          style=\"\r\n            min-height: 30vh;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n          \"\r\n        >\r\n          <div>\r\n            <span>\r\n              <i class=\"pi pi-times-circle\"></i>\r\n              {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n            </span>\r\n          </div>\r\n        </div>\r\n        <button pButton (click)=\"closeNotifyDialog()\" class=\"ds secondary\">\r\n          {{ 'ACTIONS.CANCEL' | transloco }}\r\n        </button>\r\n      </ng-template>\r\n    </lui-wizard-v3>\r\n  </p-dialog>\r\n</div>\r\n",
        providers: [SearchContainerLoaderService, DialogService]
    })
], ComplianceStatementMatchingComponent);

const ɵ0$d = { breadcrumb: 'BREADCRUMB.STATEMENT_MATCHING' };
const routes$a = [
    {
        path: 'statement-matching',
        component: ComplianceStatementMatchingComponent,
        data: ɵ0$d,
    },
];

let MakePaymentsComponent = class MakePaymentsComponent {
    constructor(confirmationService, payService, dialogService, translocoService, toast, spinner, router, route, mp, http, searchContainerLoaderService, store) {
        this.confirmationService = confirmationService;
        this.payService = payService;
        this.dialogService = dialogService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.router = router;
        this.route = route;
        this.mp = mp;
        this.http = http;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.store = store;
        // search container loader states
        this.searchContainerName = 'makePayments';
        this.i18nSearchField = 'MAKE_PAYMENT.SEARCH';
        // public baseUrl = `${this.configPrv.AppSetting?.uriMarketplace?.receivedInvoiceRootURL}`;
        this.baseUrl = `${this.mp.getConfig().receivedInvoice}`;
        this.searchUrl = `${this.baseUrl}/payment`;
        this.invoiceUrl = `${this.baseUrl}/invoice`;
        this.columnActions = {};
        this.subscriptions = [];
        this.email = '';
        this.showDisplayLog = false;
        this.showPayDialog = false;
        this.batchKey = 0;
        this.dynamicDialogRefs = [];
        // print states
        this.showPrintOptionsDialog = false;
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        this.InvoicesToPrint = [];
        // On Hold states
        this.showOnHoldDialog = false;
        this.invoicesOnHold = [];
        this.toolbarActionsDispatcher = {
            pay: (selection) => {
                const search = Object.assign({}, searchFilters(this.searchContainerLoaderService.term, this.searchContainerLoaderService.pagination, this.searchContainerLoaderService.filters));
                this.wizardConfig = {
                    endpoint: '/invoice/pay/form/step/1',
                    httpMethod: HttpMethod.POST,
                    body: {
                        search,
                        selectedKeys: [...selection].map((_a) => {
                            var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                            return invoiceKey;
                        }),
                    },
                };
                this.payService.search = search;
                this.payService.selectedKeys = [...selection].map((_a) => {
                    var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                    return invoiceKey;
                });
                this.router.navigate(['../../accounts-payable/payment-details'], {
                    relativeTo: this.route,
                });
            },
            printOptions: (selection) => {
                this.showPrintOptionsDialog = true;
            },
            print: (selection) => {
                var _a;
                this.InvoicesToPrint = [...selection].map((_a) => {
                    var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                    return invoiceKey;
                });
                if (((_a = Object.keys(this.selectedPrintOptions || {})) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.bulkPrint();
                }
                else {
                    this.triggeredByPrint = true;
                    this.showPrintOptionsDialog = true;
                }
            },
            onHold: (selection) => {
                this.invoicesOnHold = [...selection].map((_a) => {
                    var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                    return invoiceKey;
                });
                this.showOnHoldDialog = true;
            },
            displayLog: (selection) => {
                var _a;
                this.batchKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.invoiceKey;
                this.showDisplayLog = true;
            },
            export: (selection) => {
                this.selections = selection;
                this.openExport();
            },
        };
        http.baseUrl = this.baseUrl;
    }
    ngOnInit() {
        this.store
            .pipe(select(selectors.userProfile), tap((user) => {
            this.email = user.sub;
        }))
            .subscribe();
    }
    bulkPrint() {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `invoice/print`,
            httpMethod: 'POST',
            body: this.InvoicesToPrint,
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            var _a;
            ((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) === 1
                ? saveAs(response, 'MergedDocuments')
                : this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.InvoicesToPrint = [];
            this.triggeredByPrint = false;
            this.spinner.off();
        }))
            .subscribe();
    }
    openPdfViewer(data) {
        const ref = this.dialogService.open(PdfViewerComponent, {
            data: {
                response: data,
            },
            styleClass: 'pdf-viewer',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
    }
    closePrintOptionsDialog() {
        this.showPrintOptionsDialog = false;
    }
    updatePrintOptions(selectedPrintOptions) {
        this.selectedPrintOptions = selectedPrintOptions;
        if (this.triggeredByPrint) {
            this.bulkPrint();
        }
        this.closePrintOptionsDialog();
    }
    openExport() {
        const ref = this.dialogService.open(ExportComponent, {
            data: {
                endpoint: `${this.baseUrl}/export/form`,
            },
            showHeader: false,
            styleClass: 'export-dialog',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
        const refSubscription = ref.onClose
            .pipe(mergeMap((exportOptions) => exportOptions ? this.submitExport(exportOptions) : EMPTY), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
            .subscribe();
        this.subscriptions = [...this.subscriptions, refSubscription];
    }
    submitExport(exportOptions) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.spinner.on();
        return this.http
            .fetchWithFqn({
            endpoint: `${this.baseUrl}/invoice/export`,
            httpMethod: 'POST',
            body: Object.assign(Object.assign({}, exportOptions), { email: this.email, toolkeys: '', keys: [...this.selections].map((_a) => {
                    var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                    return invoiceKey;
                }), page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows }, sort: {
                    field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                    order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                }, search: {
                    filters: this.searchContainerLoaderService.filters,
                    term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
                } }),
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()));
    }
    closeDisplayLog() {
        this.showDisplayLog = false;
    }
    saveDisplayLog(formData) {
        this.spinner.on();
        this.http
            .fetchWithFqn({
            endpoint: `${this.baseUrl}/logging/${this.batchKey}/search`,
            httpMethod: 'POST',
            body: Object.assign({}, formData),
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.spinner.off();
            this.closeDisplayLog();
        }))
            .subscribe();
    }
    closeOnHoldDialog() {
        this.showOnHoldDialog = false;
    }
    bulkUpdateOnHold(options) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `invoice/bulk-update`,
            httpMethod: 'POST',
            body: {
                isOnHold: {
                    value: Boolean(Number(options === null || options === void 0 ? void 0 : options.status)),
                },
                onHoldTypeKey: {
                    value: Number(options === null || options === void 0 ? void 0 : options.onHoldReason),
                },
                keys: this.invoicesOnHold,
            },
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.closeOnHoldDialog();
            this.invoicesOnHold = [];
            this.spinner.off();
        }))
            .subscribe();
    }
};
MakePaymentsComponent.ctorParameters = () => [
    { type: ConfirmationService$1 },
    { type: PayService },
    { type: DialogService$1 },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: Router },
    { type: ActivatedRoute },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: SearchContainerLoaderService },
    { type: Store }
];
MakePaymentsComponent = __decorate([
    Component({
        // tslint:disable-next-line:component-selector
        selector: 'app-make-payments',
        template: "<h2>{{ 'BREADCRUMB.MAKE_PAYMENTS' | transloco }}</h2>\r\n<div style=\"padding-top: 2rem\">\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [baseUrl]=\"searchUrl\"\r\n    [columnActions]=\"columnActions\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showPrintOptionsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-print-options-container\r\n    [baseUrl]=\"invoiceUrl\"\r\n    [selectedPrintOptions]=\"selectedPrintOptions\"\r\n    (closeDialog)=\"closePrintOptionsDialog()\"\r\n    (updatePrintOptions)=\"updatePrintOptions($event)\"\r\n  ></lib-print-options-container>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showOnHoldDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-on-hold-container\r\n    [baseUrl]=\"invoiceUrl\"\r\n    (closeDialog)=\"closeOnHoldDialog()\"\r\n    (saveDialog)=\"bulkUpdateOnHold($event)\"\r\n  ></lib-on-hold-container>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showDisplayLog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-logging\r\n    [baseUrl]=\"baseUrl\"\r\n    [batchKey]=\"batchKey\"\r\n    (closeLogDialog)=\"closeDisplayLog()\"\r\n    (saveLogDialog)=\"saveDisplayLog($event)\"\r\n  >\r\n  </lib-logging>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, DialogService$1]
    })
], MakePaymentsComponent);

const ɵ0$e = {
    breadcrumb: {
        label: 'BREADCRUMB.MAKE_PAYMENTS',
        disable: true,
    },
};
const routes$b = [
    {
        path: 'make-payments',
        data: ɵ0$e,
        component: MakePaymentsComponent,
    },
];

let OpenReceivablesComponent = class OpenReceivablesComponent {
    constructor(confirmationService, translocoService, toast, spinner, http, mp, dialogService, searchContainerLoaderService, store) {
        this.confirmationService = confirmationService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.http = http;
        this.mp = mp;
        this.dialogService = dialogService;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.store = store;
        // search container loader states
        this.searchContainerName = 'openReceivables';
        this.i18nSearchField = 'OPEN_RECEIVABLE.SEARCH';
        this.baseUrl = `${this.mp.getConfig().sentInvoice}`;
        this.collectionUrl = `${this.baseUrl}/collection`;
        this.invoiceUrl = `${this.baseUrl}/invoice`;
        this.columnActions = {};
        this.subscriptions = [];
        this.dynamicDialogRefs = [];
        this.email = '';
        this.batchKey = 0;
        this.InvoicesToPrint = [];
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        this.showPrintOptionsDialog = false;
        this.showDisplayLog = false;
        this.toolbarActionsDispatcher = {
            printOptions: (selection) => {
                this.showPrintOptionsDialog = true;
            },
            print: (selection) => {
                var _a;
                this.InvoicesToPrint = [...selection].map((_a) => {
                    var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                    return invoiceKey;
                });
                if (((_a = Object.keys(this.selectedPrintOptions || {})) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.bulkPrint();
                }
                else {
                    this.triggeredByPrint = true;
                    this.showPrintOptionsDialog = true;
                }
            },
            displayLog: (selection) => {
                var _a;
                this.batchKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.invoiceKey;
                this.showDisplayLog = true;
            },
            export: (selection) => {
                this.selections = selection;
                this.openExport();
            },
        };
        http.baseUrl = this.collectionUrl;
    }
    ngOnInit() {
        /** empty block */
        this.store
            .pipe(select(selectors.userProfile), tap((user) => {
            this.email = user.sub;
        }))
            .subscribe();
    }
    bulkPrint() {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `invoice/print`,
            httpMethod: 'POST',
            body: this.InvoicesToPrint,
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            var _a;
            ((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) === 1
                ? saveAs(response, 'MergedDocuments')
                : this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.InvoicesToPrint = [];
            this.triggeredByPrint = false;
            this.spinner.off();
        }))
            .subscribe();
    }
    openPdfViewer(data) {
        const ref = this.dialogService.open(PdfViewerComponent, {
            data: {
                response: data,
            },
            styleClass: 'pdf-viewer',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
    }
    updatePrintOptions(selectedPrintOptions) {
        this.selectedPrintOptions = selectedPrintOptions;
        if (this.triggeredByPrint) {
            this.bulkPrint();
        }
        this.closePrintOptionsDialog();
    }
    closePrintOptionsDialog() {
        this.showPrintOptionsDialog = false;
    }
    openExport() {
        const ref = this.dialogService.open(ExportComponent, {
            data: {
                endpoint: `${this.baseUrl}/export/form`,
            },
            showHeader: false,
            styleClass: 'export-dialog',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
        const refSubscription = ref.onClose
            .pipe(mergeMap((exportOptions) => exportOptions ? this.submitExport(exportOptions) : EMPTY), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
            .subscribe();
        this.subscriptions = [...this.subscriptions, refSubscription];
    }
    submitExport(exportOptions) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.spinner.on();
        return this.http
            .fetchWithFqn({
            endpoint: `${this.baseUrl}/invoice/export`,
            httpMethod: 'POST',
            body: Object.assign(Object.assign({}, exportOptions), { email: this.email, toolkeys: '', keys: [...this.selections].map((_a) => {
                    var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                    return invoiceKey;
                }), page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows }, sort: {
                    field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                    order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                }, search: {
                    filters: this.searchContainerLoaderService.filters,
                    term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
                } }),
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()));
    }
    closeDisplayLog() {
        this.showDisplayLog = false;
    }
    saveDisplayLog(formData) {
        this.spinner.on();
        this.http
            .fetchWithFqn({
            endpoint: `${this.baseUrl}/logging/${this.batchKey}/search`,
            httpMethod: 'POST',
            body: Object.assign({}, formData),
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.spinner.off();
            this.closeDisplayLog();
        }))
            .subscribe();
    }
};
OpenReceivablesComponent.ctorParameters = () => [
    { type: ConfirmationService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: BaseHttpService$1 },
    { type: MarketplaceService },
    { type: DialogService$1 },
    { type: SearchContainerLoaderService },
    { type: Store }
];
OpenReceivablesComponent = __decorate([
    Component({
        // tslint:disable-next-line:component-selector
        selector: 'app-open-receivables',
        template: "<h2>{{ 'BREADCRUMB.OPEN_RECEIVABLES' | transloco }}</h2>\r\n<div style=\"padding-top: 2rem\">\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [baseUrl]=\"collectionUrl\"\r\n    [columnActions]=\"columnActions\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showPrintOptionsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-print-options-container\r\n    [baseUrl]=\"invoiceUrl\"\r\n    [selectedPrintOptions]=\"selectedPrintOptions\"\r\n    (closeDialog)=\"closePrintOptionsDialog()\"\r\n    (updatePrintOptions)=\"updatePrintOptions($event)\"\r\n  ></lib-print-options-container>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showDisplayLog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-logging\r\n    [baseUrl]=\"baseUrl\"\r\n    [batchKey]=\"batchKey\"\r\n    (closeLogDialog)=\"closeDisplayLog()\"\r\n    (saveLogDialog)=\"saveDisplayLog($event)\"\r\n  >\r\n  </lib-logging>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, DialogService$1]
    })
], OpenReceivablesComponent);

const ɵ0$f = {
    breadcrumb: {
        label: 'BREADCRUMB.OPEN_RECEIVABLES',
        disable: true,
    },
};
const routes$c = [
    {
        path: 'open-receivables',
        data: ɵ0$f,
        component: OpenReceivablesComponent,
    },
];

let OsReceivedComponent = class OsReceivedComponent {
    constructor(dialogService, confirmationService, mp, http, spinner, searchContainerLoaderService, translocoService, toast, store, printOptionsService) {
        this.dialogService = dialogService;
        this.confirmationService = confirmationService;
        this.mp = mp;
        this.http = http;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.store = store;
        this.printOptionsService = printOptionsService;
        this.baseUrl = `${this.mp.getConfig().receivedOs}`;
        this.searchUrl = `${this.baseUrl}/os`;
        this.columnActions = {};
        // print states
        this.showPrintOptionsDialog = false;
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        this.ossToPrint = [];
        // Search container states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'osReceivedSearch';
        this.i18nSearchField = 'MARKETPLACE.PRODUCT_ACTIVITY_REPORT_SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {
            printOptions: (selection) => {
                this.showPrintOptionsDialog = true;
            },
            print: (selection) => {
                var _a;
                this.ossToPrint = [...selection].map((_a) => {
                    var { osKey } = _a, _ = __rest(_a, ["osKey"]);
                    return osKey;
                });
                if (((_a = Object.keys(this.selectedPrintOptions || {})) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.bulkPrint();
                }
                else {
                    this.triggeredByPrint = true;
                    this.showPrintOptionsDialog = true;
                }
            },
            markProcessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('OS_RECEIVED.MARK_PROCESSED_MESSAGE'),
                    header: this.translocoService.translate('OS_RECEIVED.MARK_PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'os/mark-processed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { osKey } = _a, _ = __rest(_a, ["osKey"]);
                                return osKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnprocessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('OS_RECEIVED.MARK_UNPROCESSED_MESSAGE'),
                    header: this.translocoService.translate('OS_RECEIVED.MARK_UNPROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'os/mark-unprocessed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { osKey } = _a, _ = __rest(_a, ["osKey"]);
                                return osKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markRead: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('OS_RECEIVED.MARK_READ_MESSAGE'),
                    header: this.translocoService.translate('OS_RECEIVED.MARK_READ_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'os/mark-read',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { osKey } = _a, _ = __rest(_a, ["osKey"]);
                                return osKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnread: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('OS_RECEIVED.MARK_UNREAD_MESSAGE'),
                    header: this.translocoService.translate('OS_RECEIVED.MARK_UNREAD_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'os/mark-unread',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { osKey } = _a, _ = __rest(_a, ["osKey"]);
                                return osKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            delete: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('VALIDATION_MESSAGE.DELETE_CONFIRMATION_MESSAGE'),
                    header: this.translocoService.translate('VALIDATION_MESSAGE.DELETE_CONFIRMATION_HEADER'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'os/bulk-update',
                            httpMethod: 'POST',
                            body: {
                                keys: [...selection].map((_a) => {
                                    var { osKey } = _a, _ = __rest(_a, ["osKey"]);
                                    return osKey;
                                }),
                                IsDeleted: {
                                    Value: true,
                                },
                            },
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            restore: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('VALIDATION_MESSAGE.RESTORE_CONFIRMATION_MESSAGE'),
                    header: this.translocoService.translate('VALIDATION_MESSAGE.RESTORE_CONFIRMATION_HEADER'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'os/bulk-update',
                            httpMethod: 'POST',
                            body: {
                                keys: [...selection].map((_a) => {
                                    var { osKey } = _a, _ = __rest(_a, ["osKey"]);
                                    return osKey;
                                }),
                                IsDeleted: {
                                    Value: false,
                                },
                            },
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
        };
        http.baseUrl = this.baseUrl;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.push(this.store
                .pipe(select(selectors.isAuthorized, {
                edit: toolKeys.MP_RECEIVED_OS_EDIT,
                print: toolKeys.MP_RECEIVED_OS_PRINT,
            }), tap((authorizedButtons) => {
                this.columnActions = {
                    purchaseOrderNumber: authorizedButtons.print
                        ? {
                            link: () => ({ path: './' }),
                            event: (receivedOs) => ({
                                data: { receivedOs },
                                eventType: EventType.PRINT,
                            }),
                        }
                        : {},
                };
            }))
                .subscribe());
            this.selectedPrintOptions = yield this.printOptionsService.get('os', toolKeys.MP_RECEIVED_OS_PRINT);
        });
    }
    bulkPrint() {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `os/print`,
            httpMethod: 'POST',
            body: this.ossToPrint,
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            var _a;
            ((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) === 1
                ? saveAs(response, 'MergedDocuments')
                : this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.ossToPrint = [];
            this.triggeredByPrint = false;
            this.spinner.off();
        }))
            .subscribe();
    }
    openPdfViewer(data) {
        const ref = this.dialogService.open(PdfViewerComponent, {
            data: {
                response: data,
            },
            styleClass: 'pdf-viewer',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
    }
    closePrintOptionsDialog() {
        this.showPrintOptionsDialog = false;
    }
    updatePrintOptions(selectedPrintOptions) {
        this.selectedPrintOptions = selectedPrintOptions;
        if (this.triggeredByPrint) {
            this.bulkPrint();
        }
        this.closePrintOptionsDialog();
    }
    searchContainerEvent({ data, eventType }) {
        const { receivedOs } = data;
        switch (eventType) {
            case EventType.PRINT:
                this.print(receivedOs);
                break;
            default:
                break;
        }
    }
    print(receivedOS) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `os/${receivedOS === null || receivedOS === void 0 ? void 0 : receivedOS.osKey}/print`,
            httpMethod: 'GET',
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
            .subscribe();
    }
};
OsReceivedComponent.ctorParameters = () => [
    { type: DialogService },
    { type: ConfirmationService$1 },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: Store },
    { type: PrintOptionsService }
];
OsReceivedComponent = __decorate([
    Component({
        selector: 'lib-os-received',
        template: "<div class=\"view-remittances\">\r\n  <h2>{{ 'BREADCRUMB.ORDER_STATUS' | transloco }}</h2>\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"searchUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showPrintOptionsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-print-options-container\r\n    [baseUrl]=\"searchUrl\"\r\n    [selectedPrintOptions]=\"selectedPrintOptions\"\r\n    (closeDialog)=\"closePrintOptionsDialog()\"\r\n    (updatePrintOptions)=\"updatePrintOptions($event)\"\r\n  ></lib-print-options-container>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, DialogService]
    })
], OsReceivedComponent);

const ɵ0$g = { breadcrumb: 'BREADCRUMB.ORDER_STATUS' };
const routes$d = [
    {
        path: 'os-received',
        component: OsReceivedComponent,
        data: ɵ0$g,
    },
];

let SentOSComponent = class SentOSComponent {
    constructor(dialogService, confirmationService, mp, http, spinner, searchContainerLoaderService, translocoService, toast, store, printOptionsService) {
        this.dialogService = dialogService;
        this.confirmationService = confirmationService;
        this.mp = mp;
        this.http = http;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.store = store;
        this.printOptionsService = printOptionsService;
        this.baseUrl = `${this.mp.getConfig().sentOs}`;
        this.searchUrl = `${this.baseUrl}/os`;
        this.columnActions = {};
        // print states
        this.showPrintOptionsDialog = false;
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        this.ossToPrint = [];
        // Search container states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'osSentSearch';
        this.i18nSearchField = 'MARKETPLACE.PRODUCT_ACTIVITY_REPORT_SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {
            printOptions: (selection) => {
                this.showPrintOptionsDialog = true;
            },
            print: (selection) => {
                var _a;
                this.ossToPrint = [...selection].map((_a) => {
                    var { osKey } = _a, _ = __rest(_a, ["osKey"]);
                    return osKey;
                });
                if (((_a = Object.keys(this.selectedPrintOptions || {})) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.bulkPrint();
                }
                else {
                    this.triggeredByPrint = true;
                    this.showPrintOptionsDialog = true;
                }
            },
        };
        http.baseUrl = this.baseUrl;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.push(this.store
                .pipe(select(selectors.isAuthorized, {
                edit: toolKeys.MP_SENT_OS_EDIT,
                print: toolKeys.MP_SENT_OS_PRINT,
            }), tap((authorizedButtons) => {
                this.columnActions = {
                    purchaseOrderNumber: authorizedButtons.print
                        ? {
                            link: () => ({ path: './' }),
                            event: (sentOs) => ({
                                data: { sentOs },
                                eventType: EventType.PRINT,
                            }),
                        }
                        : {},
                };
            }))
                .subscribe());
            this.selectedPrintOptions = yield this.printOptionsService.get('os', toolKeys.MP_SENT_OS_PRINT);
        });
    }
    bulkPrint() {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `os/print`,
            httpMethod: 'POST',
            body: this.ossToPrint,
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            var _a;
            ((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) === 1
                ? saveAs(response, 'MergedDocuments')
                : this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.ossToPrint = [];
            this.triggeredByPrint = false;
            this.spinner.off();
        }))
            .subscribe();
    }
    openPdfViewer(data) {
        const ref = this.dialogService.open(PdfViewerComponent, {
            data: {
                response: data,
            },
            styleClass: 'pdf-viewer',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
    }
    closePrintOptionsDialog() {
        this.showPrintOptionsDialog = false;
    }
    updatePrintOptions(selectedPrintOptions) {
        this.selectedPrintOptions = selectedPrintOptions;
        if (this.triggeredByPrint) {
            this.bulkPrint();
        }
        this.closePrintOptionsDialog();
    }
    searchContainerEvent({ data, eventType }) {
        const { sentOs } = data;
        switch (eventType) {
            case EventType.PRINT:
                this.print(sentOs);
                break;
            default:
                break;
        }
    }
    print(sentOS) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `os/${sentOS === null || sentOS === void 0 ? void 0 : sentOS.osKey}/print`,
            httpMethod: 'GET',
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
            .subscribe();
    }
};
SentOSComponent.ctorParameters = () => [
    { type: DialogService },
    { type: ConfirmationService$1 },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: Store },
    { type: PrintOptionsService }
];
SentOSComponent = __decorate([
    Component({
        selector: 'lib-sent-os',
        template: "<div class=\"view-remittances\">\r\n  <h2>{{ 'BREADCRUMB.ORDER_STATUS' | transloco }}</h2>\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"searchUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showPrintOptionsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-print-options-container\r\n    [baseUrl]=\"searchUrl\"\r\n    [selectedPrintOptions]=\"selectedPrintOptions\"\r\n    (closeDialog)=\"closePrintOptionsDialog()\"\r\n    (updatePrintOptions)=\"updatePrintOptions($event)\"\r\n  ></lib-print-options-container>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, DialogService]
    })
], SentOSComponent);

const ɵ0$h = { breadcrumb: 'BREADCRUMB.ORDER_STATUS' };
const routes$e = [
    {
        path: 'os-sent',
        component: SentOSComponent,
        data: ɵ0$h,
    },
];

let PadReceivedComponent = class PadReceivedComponent {
    constructor(dialogService, confirmationService, mp, http, spinner, searchContainerLoaderService, translocoService, toast, store, printOptionsService) {
        this.dialogService = dialogService;
        this.confirmationService = confirmationService;
        this.mp = mp;
        this.http = http;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.store = store;
        this.printOptionsService = printOptionsService;
        this.baseUrl = `${this.mp.getConfig().receivedPad}`;
        this.searchUrl = `${this.baseUrl}/pad`;
        this.columnActions = {};
        // print states
        this.showPrintOptionsDialog = false;
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        this.padsToPrint = [];
        // Search container states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'padReceivedSearch';
        this.i18nSearchField = 'MARKETPLACE.PRODUCT_ACTIVITY_REPORT_SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {
            printOptions: (selection) => {
                this.showPrintOptionsDialog = true;
            },
            print: (selection) => {
                var _a;
                this.padsToPrint = [...selection].map((_a) => {
                    var { padKey } = _a, _ = __rest(_a, ["padKey"]);
                    return padKey;
                });
                if (((_a = Object.keys(this.selectedPrintOptions || {})) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.bulkPrint();
                }
                else {
                    this.triggeredByPrint = true;
                    this.showPrintOptionsDialog = true;
                }
            },
            markProcessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('PAD_RECEIVED.MARK_PROCESSED_MESSAGE'),
                    header: this.translocoService.translate('PAD_RECEIVED.MARK_PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'pad/mark-processed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { padKey } = _a, _ = __rest(_a, ["padKey"]);
                                return padKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnprocessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('PAD_RECEIVED.MARK_UNPROCESSED_MESSAGE'),
                    header: this.translocoService.translate('PAD_RECEIVED.MARK_UNPROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'pad/mark-unprocessed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { padKey } = _a, _ = __rest(_a, ["padKey"]);
                                return padKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markRead: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('PAD_RECEIVED.MARK_READ_MESSAGE'),
                    header: this.translocoService.translate('PAD_RECEIVED.MARK_READ_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'pad/mark-read',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { padKey } = _a, _ = __rest(_a, ["padKey"]);
                                return padKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnread: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('PAD_RECEIVED.MARK_UNREAD_MESSAGE'),
                    header: this.translocoService.translate('PAD_RECEIVED.MARK_UNREAD_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'pad/mark-unread',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { padKey } = _a, _ = __rest(_a, ["padKey"]);
                                return padKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            delete: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('VALIDATION_MESSAGE.DELETE_CONFIRMATION_MESSAGE'),
                    header: this.translocoService.translate('VALIDATION_MESSAGE.DELETE_CONFIRMATION_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'pad/bulk-update',
                            httpMethod: 'POST',
                            body: {
                                keys: [...selection].map((_a) => {
                                    var { padKey } = _a, _ = __rest(_a, ["padKey"]);
                                    return padKey;
                                }),
                                IsDeleted: {
                                    Value: true,
                                },
                            },
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            restore: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('VALIDATION_MESSAGE.RESTORE_CONFIRMATION_MESSAGE'),
                    header: this.translocoService.translate('VALIDATION_MESSAGE.RESTORE_CONFIRMATION_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'pad/bulk-update',
                            httpMethod: 'POST',
                            body: {
                                keys: [...selection].map((_a) => {
                                    var { padKey } = _a, _ = __rest(_a, ["padKey"]);
                                    return padKey;
                                }),
                                IsDeleted: {
                                    Value: false,
                                },
                            },
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
        };
        http.baseUrl = this.baseUrl;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.push(this.store
                .pipe(select(selectors.isAuthorized, {
                edit: toolKeys.MP_RECEIVED_PAD_EDIT,
                print: toolKeys.MP_RECEIVED_PAD_PRINT,
            }), tap((authorizedButtons) => {
                this.columnActions = {
                    purchaseOrderNumber: authorizedButtons.print
                        ? {
                            link: () => ({ path: './' }),
                            event: (receivedPad) => ({
                                data: { receivedPad },
                                eventType: EventType.PRINT,
                            }),
                        }
                        : {},
                };
            }))
                .subscribe());
            this.selectedPrintOptions = yield this.printOptionsService.get('pad', toolKeys.MP_RECEIVED_PAD_PRINT);
        });
    }
    bulkPrint() {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `pad/print`,
            httpMethod: 'POST',
            body: this.padsToPrint,
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            var _a;
            ((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) === 1
                ? saveAs(response, 'MergedDocuments')
                : this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.padsToPrint = [];
            this.triggeredByPrint = false;
            this.spinner.off();
        }))
            .subscribe();
    }
    openPdfViewer(data) {
        const ref = this.dialogService.open(PdfViewerComponent, {
            data: {
                response: data,
            },
            styleClass: 'pdf-viewer',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
    }
    closePrintOptionsDialog() {
        this.showPrintOptionsDialog = false;
    }
    updatePrintOptions(selectedPrintOptions) {
        this.selectedPrintOptions = selectedPrintOptions;
        if (this.triggeredByPrint) {
            this.bulkPrint();
        }
        this.closePrintOptionsDialog();
    }
    searchContainerEvent({ data, eventType }) {
        const { receivedPad } = data;
        switch (eventType) {
            case EventType.PRINT:
                this.print(receivedPad);
                break;
            default:
                break;
        }
    }
    print(receivedPAD) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `pad/${receivedPAD === null || receivedPAD === void 0 ? void 0 : receivedPAD.padKey}/print`,
            httpMethod: 'GET',
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
            .subscribe();
    }
};
PadReceivedComponent.ctorParameters = () => [
    { type: DialogService },
    { type: ConfirmationService$1 },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: Store },
    { type: PrintOptionsService }
];
PadReceivedComponent = __decorate([
    Component({
        selector: 'lib-pad-received',
        template: "<div class=\"view-remittances\">\r\n  <h2>{{ 'BREADCRUMB.PRODUCT_ACTIVITY_REPORT' | transloco }}</h2>\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"searchUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showPrintOptionsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-print-options-container\r\n    [baseUrl]=\"searchUrl\"\r\n    [selectedPrintOptions]=\"selectedPrintOptions\"\r\n    (closeDialog)=\"closePrintOptionsDialog()\"\r\n    (updatePrintOptions)=\"updatePrintOptions($event)\"\r\n  ></lib-print-options-container>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, DialogService],
        styles: [""]
    })
], PadReceivedComponent);

const ɵ0$i = { breadcrumb: 'BREADCRUMB.PRODUCT_ACTIVITY_REPORT' };
const routes$f = [
    {
        path: 'pad-received',
        component: PadReceivedComponent,
        data: ɵ0$i,
    },
];

let BatchesComponent$1 = class BatchesComponent {
    constructor(confirmationService, dialogService, translocoService, toast, spinner, marketplaceService, http, searchContainerLoaderService, store) {
        this.confirmationService = confirmationService;
        this.dialogService = dialogService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.marketplaceService = marketplaceService;
        this.http = http;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.store = store;
        // kpi dashboard states
        this.dashBoardStateKey = 'PaymentBatchesDashboardState';
        this.dashBoardVisibilityStateKey = 'PaymentBatchesDashboardVisibilityState';
        this.categoryFilter = ['accountsPayable'];
        this.showCategories = false;
        this.defaultDashboardState = {
            dashboard: [],
            gridArea: [],
        };
        // search container loader states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.showGenerateFileDialog = false;
        this.showViewDialog = false;
        this.showDisplayLog = false;
        this.batchKey = 0;
        this.collectionsToView = [];
        this.collectionsToGenerateFileFor = [];
        this.searchContainerName = 'paymentsBatches';
        this.i18nSearchField = 'PAYMENTS.PAYMENT_REFERENCE_NUMBER';
        this.toolbarActionsDispatcher = {
            view: (selection) => {
                const { paymentBatchKey } = selection[0];
                this.collectionsToView = paymentBatchKey;
                this.showViewDialog = true;
            },
            approve: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('INVOICE.COLLECTION_BATCHES_APPROVE_MESSAGE'),
                    header: this.translocoService.translate('INVOICE.COLLECTION_BATCHES_APPROVE_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'paymentbatch/bulk-update',
                            httpMethod: 'POST',
                            body: {
                                keys: [...selection].map((_a) => {
                                    var { paymentBatchKey } = _a, _ = __rest(_a, ["paymentBatchKey"]);
                                    return paymentBatchKey;
                                }),
                                batchStatusTypeKey: {
                                    value: 1,
                                },
                            },
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            reject: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('INVOICE.COLLECTION_BATCHES_REJECT_MESSAGE'),
                    header: this.translocoService.translate('INVOICE.COLLECTION_BATCHES_REJECT_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'paymentbatch/bulk-update',
                            httpMethod: 'POST',
                            body: {
                                keys: [...selection].map((_a) => {
                                    var { paymentBatchKey } = _a, _ = __rest(_a, ["paymentBatchKey"]);
                                    return paymentBatchKey;
                                }),
                                batchStatusTypeKey: {
                                    value: 3,
                                },
                            },
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            generateFile: (selection) => {
                this.collectionsToGenerateFileFor = [...selection].map((_a) => {
                    var { paymentBatchKey } = _a, _ = __rest(_a, ["paymentBatchKey"]);
                    return paymentBatchKey;
                });
                this.showGenerateFileDialog = true;
            },
            export: (selection) => {
                this.selections = selection;
                this.openExport();
            },
            displayLog: (selection) => {
                var _a;
                this.batchKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.paymentBatchKey;
                this.showDisplayLog = true;
            },
        };
        this.baseUrl = `${this.marketplaceService.getConfig().receivedInvoice}/paymentbatch`;
        this.columnActions = {};
        this.email = '';
        http.baseUrl = marketplaceService.getConfig().receivedInvoice;
    }
    ngOnInit() {
        this.subscriptions.push(this.store
            .pipe(select(selectors.userProfile), tap((user) => {
            this.email = user.sub;
        }))
            .subscribe());
    }
    closeDisplayLog() {
        this.showDisplayLog = false;
    }
    saveDisplayLog(formData) {
        this.spinner.on();
        this.http
            .fetchWithFqn({
            endpoint: `${this.baseUrl}/logging/${this.batchKey}/search`,
            httpMethod: 'POST',
            body: Object.assign({}, formData),
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.spinner.off();
            this.closeDisplayLog();
        }))
            .subscribe();
    }
    openExport() {
        const ref = this.dialogService.open(ExportComponent, {
            data: {
                endpoint: `${this.baseUrl}/export/form`,
            },
            showHeader: false,
            styleClass: 'export-dialog',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
        const refSubscription = ref.onClose
            .pipe(mergeMap((exportOptions) => exportOptions ? this.submitExport(exportOptions) : EMPTY), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
            .subscribe();
        this.subscriptions = [...this.subscriptions, refSubscription];
    }
    submitExport(exportOptions) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.http.baseUrl = `${this.marketplaceService.getConfig().receivedInvoice}/paymentbatch/export`;
        this.spinner.on();
        return this.http
            .fetchWithFqn({
            endpoint: `${this.marketplaceService.getConfig().receivedInvoice}/paymentbatch/export`,
            httpMethod: 'POST',
            body: Object.assign(Object.assign({}, exportOptions), { email: this.email, toolkeys: '', keys: [...this.selections].map((_a) => {
                    var { paymentBatchKey } = _a, _ = __rest(_a, ["paymentBatchKey"]);
                    return paymentBatchKey;
                }), page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows }, sort: {
                    field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                    order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                }, search: {
                    filters: this.searchContainerLoaderService.filters,
                    term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
                } }),
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()));
    }
    closeGenerateFileDialog() {
        this.showGenerateFileDialog = false;
    }
    generateFile({ bankAccount, bankFileTemplateKey }) {
        this.spinner.on();
        this.closeGenerateFileDialog();
        this.http
            .fetch({
            endpoint: `paymentbatch/generate-file`,
            httpMethod: 'POST',
            body: {
                keys: this.collectionsToGenerateFileFor,
                accountBankingInfoKey: bankAccount,
                bankFileTemplateKey,
            },
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.collectionsToGenerateFileFor = [];
            this.spinner.off();
        }))
            .subscribe();
    }
    closeViewDialog() {
        this.showViewDialog = false;
    }
    ngOnDestroy() {
        this.dynamicDialogRefs.forEach((ref) => ref.destroy());
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
};
BatchesComponent$1.ctorParameters = () => [
    { type: ConfirmationService },
    { type: DialogService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: MarketplaceService },
    { type: BaseHttpService },
    { type: SearchContainerLoaderService },
    { type: Store }
];
BatchesComponent$1 = __decorate([
    Component({
        selector: 'lib-batches',
        template: "<!-- <div class=\"view-invoices\">\r\n  <div class=\"dashboard\">\r\n    <lib-dashboard-container\r\n      [dashBoardStateKey]=\"dashBoardStateKey\"\r\n      [dashBoardVisibilityStateKey]=\"dashBoardVisibilityStateKey\"\r\n      [dashBoardHeader]=\"'MARKETPLACE.TAB_PAYMENTS_BATCHES'\"\r\n      [categoryFilter]=\"categoryFilter\"\r\n      [showCategories]=\"showCategories\"\r\n      [defaultDashboardState]=\"defaultDashboardState\"\r\n    ></lib-dashboard-container>\r\n  </div>\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [baseUrl]=\"baseUrl\"\r\n    [columnActions]=\"columnActions\"\r\n  ></lib-search-container-loader>\r\n</div> -->\r\n<h2>{{ 'MARKETPLACE.TAB_PAYMENTS_BATCHES' | transloco }}</h2>\r\n<div style=\"padding-top: 2rem\">\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [baseUrl]=\"baseUrl\"\r\n    [columnActions]=\"columnActions\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showViewDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '1040px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-view-container\r\n    [baseUrl]=\"baseUrl\"\r\n    [paymentBatchKey]=\"collectionsToView\"\r\n    (closeViewDialog)=\"closeViewDialog()\"\r\n  ></lib-view-container>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showGenerateFileDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-generate-file-form-container\r\n    [baseUrl]=\"baseUrl\"\r\n    [selectedKeys]=\"collectionsToGenerateFileFor\"\r\n    (closeDialog)=\"closeGenerateFileDialog()\"\r\n    (saveDialog)=\"generateFile($event)\"\r\n  >\r\n  </lib-generate-file-form-container>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showDisplayLog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-logging\r\n    [baseUrl]=\"baseUrl\"\r\n    [batchKey]=\"batchKey\"\r\n    (closeLogDialog)=\"closeDisplayLog()\"\r\n    (saveLogDialog)=\"saveDisplayLog($event)\"\r\n  >\r\n  </lib-logging>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, DialogService]
    })
], BatchesComponent$1);

const ɵ0$j = { breadcrumb: 'BREADCRUMB.PAYMENTS' };
const routes$g = [
    {
        path: 'payments/batches',
        component: BatchesComponent$1,
        data: ɵ0$j,
    },
];

let PocReceivedComponent = class PocReceivedComponent {
    constructor(dialogService, confirmationService, mp, http, spinner, searchContainerLoaderService, translocoService, toast, store, printOptionsService) {
        this.dialogService = dialogService;
        this.confirmationService = confirmationService;
        this.mp = mp;
        this.http = http;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.store = store;
        this.printOptionsService = printOptionsService;
        this.baseUrl = `${this.mp.getConfig().receivedPoc}`;
        this.searchUrl = `${this.baseUrl}/poc`;
        this.columnActions = {};
        // print states
        this.showPrintOptionsDialog = false;
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        this.pocsToPrint = [];
        // Search container states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'pocReceivedSearch';
        this.i18nSearchField = 'MARKETPLACE.PRODUCT_ACTIVITY_REPORT_SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {
            printOptions: (selection) => {
                this.showPrintOptionsDialog = true;
            },
            print: (selection) => {
                var _a;
                this.pocsToPrint = [...selection].map((_a) => {
                    var { pocKey } = _a, _ = __rest(_a, ["pocKey"]);
                    return pocKey;
                });
                if (((_a = Object.keys(this.selectedPrintOptions || {})) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.bulkPrint();
                }
                else {
                    this.triggeredByPrint = true;
                    this.showPrintOptionsDialog = true;
                }
            },
            markProcessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('POC_RECEIVED.MARK_PROCESSED_MESSAGE'),
                    header: this.translocoService.translate('POC_RECEIVED.MARK_PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'poc/mark-processed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { pocKey } = _a, _ = __rest(_a, ["pocKey"]);
                                return pocKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnprocessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('POC_RECEIVED.MARK_UNPROCESSED_MESSAGE'),
                    header: this.translocoService.translate('POC_RECEIVED.MARK_UNPROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'poc/mark-unprocessed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { pocKey } = _a, _ = __rest(_a, ["pocKey"]);
                                return pocKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markRead: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('POC_RECEIVED.MARK_READ_MESSAGE'),
                    header: this.translocoService.translate('POC_RECEIVED.MARK_READ_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'poc/mark-read',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { pocKey } = _a, _ = __rest(_a, ["pocKey"]);
                                return pocKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnread: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('POC_RECEIVED.MARK_UNREAD_MESSAGE'),
                    header: this.translocoService.translate('POC_RECEIVED.MARK_UNREAD_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'poc/mark-unread',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { pocKey } = _a, _ = __rest(_a, ["pocKey"]);
                                return pocKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            delete: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('VALIDATION_MESSAGE.DELETE_CONFIRMATION_MESSAGE'),
                    header: this.translocoService.translate('VALIDATION_MESSAGE.DELETE_CONFIRMATION_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'poc/bulk-update',
                            httpMethod: 'POST',
                            body: {
                                keys: [...selection].map((_a) => {
                                    var { pocKey } = _a, _ = __rest(_a, ["pocKey"]);
                                    return pocKey;
                                }),
                                IsDeleted: {
                                    Value: true,
                                },
                            },
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            restore: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('VALIDATION_MESSAGE.RESTORE_CONFIRMATION_MESSAGE'),
                    header: this.translocoService.translate('VALIDATION_MESSAGE.RESTORE_CONFIRMATION_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'poc/bulk-update',
                            httpMethod: 'POST',
                            body: {
                                keys: [...selection].map((_a) => {
                                    var { pocKey } = _a, _ = __rest(_a, ["pocKey"]);
                                    return pocKey;
                                }),
                                IsDeleted: {
                                    Value: false,
                                },
                            },
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
        };
        http.baseUrl = this.baseUrl;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.push(this.store
                .pipe(select(selectors.isAuthorized, {
                edit: toolKeys.MP_RECEIVED_POC_EDIT,
                print: toolKeys.MP_RECEIVED_POC_PRINT,
            }), tap((authorizedButtons) => {
                this.columnActions = {
                    poNumber: authorizedButtons.print
                        ? {
                            link: () => ({ path: './' }),
                            event: (receivedPOC) => ({
                                data: { receivedPOC },
                                eventType: EventType.PRINT,
                            }),
                        }
                        : {},
                };
            }))
                .subscribe());
            this.selectedPrintOptions = yield this.printOptionsService.get('poc', toolKeys.MP_RECEIVED_POC_PRINT);
        });
    }
    bulkPrint() {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `poc/print`,
            httpMethod: 'POST',
            body: this.pocsToPrint,
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            var _a;
            ((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) === 1
                ? saveAs(response, 'MergedDocuments')
                : this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.pocsToPrint = [];
            this.triggeredByPrint = false;
            this.spinner.off();
        }))
            .subscribe();
    }
    openPdfViewer(data) {
        const ref = this.dialogService.open(PdfViewerComponent, {
            data: {
                response: data,
            },
            styleClass: 'pdf-viewer',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
    }
    closePrintOptionsDialog() {
        this.showPrintOptionsDialog = false;
    }
    updatePrintOptions(selectedPrintOptions) {
        this.selectedPrintOptions = selectedPrintOptions;
        if (this.triggeredByPrint) {
            this.bulkPrint();
        }
        this.closePrintOptionsDialog();
    }
    searchContainerEvent({ data, eventType }) {
        const { receivedPOC } = data;
        switch (eventType) {
            case EventType.PRINT:
                this.print(receivedPOC);
                break;
            default:
                break;
        }
    }
    print(receivedPOC) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `poc/${receivedPOC === null || receivedPOC === void 0 ? void 0 : receivedPOC.pocKey}/print`,
            httpMethod: 'GET',
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
            .subscribe();
    }
};
PocReceivedComponent.ctorParameters = () => [
    { type: DialogService },
    { type: ConfirmationService$1 },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: Store },
    { type: PrintOptionsService }
];
PocReceivedComponent = __decorate([
    Component({
        selector: 'lib-poc-received',
        template: "<div class=\"view-remittances\">\r\n  <h2>{{ 'BREADCRUMB.PURCHASE_ORDER_CHANGE' | transloco }}</h2>\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"searchUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showPrintOptionsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-print-options-container\r\n    [baseUrl]=\"searchUrl\"\r\n    [selectedPrintOptions]=\"selectedPrintOptions\"\r\n    (closeDialog)=\"closePrintOptionsDialog()\"\r\n    (updatePrintOptions)=\"updatePrintOptions($event)\"\r\n  ></lib-print-options-container>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, DialogService]
    })
], PocReceivedComponent);

const ɵ0$k = { breadcrumb: 'BREADCRUMB.PURCHASE_ORDER_CHANGE' };
const routes$h = [
    {
        path: 'poc-received',
        component: PocReceivedComponent,
        data: ɵ0$k,
    },
];

let SentPOCComponent = class SentPOCComponent {
    constructor(dialogService, confirmationService, mp, http, spinner, searchContainerLoaderService, translocoService, toast, store, printOptionsService) {
        this.dialogService = dialogService;
        this.confirmationService = confirmationService;
        this.mp = mp;
        this.http = http;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.store = store;
        this.printOptionsService = printOptionsService;
        this.baseUrl = `${this.mp.getConfig().sentPoc}`;
        this.searchUrl = `${this.baseUrl}/poc`;
        this.columnActions = {};
        // print states
        this.showPrintOptionsDialog = false;
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        this.pocsToPrint = [];
        // Search container states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'pocSentSearch';
        this.i18nSearchField = 'MARKETPLACE.PRODUCT_ACTIVITY_REPORT_SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {
            printOptions: (selection) => {
                this.showPrintOptionsDialog = true;
            },
            print: (selection) => {
                var _a;
                this.pocsToPrint = [...selection].map((_a) => {
                    var { pocKey } = _a, _ = __rest(_a, ["pocKey"]);
                    return pocKey;
                });
                if (((_a = Object.keys(this.selectedPrintOptions || {})) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.bulkPrint();
                }
                else {
                    this.triggeredByPrint = true;
                    this.showPrintOptionsDialog = true;
                }
            },
        };
        http.baseUrl = this.baseUrl;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.push(this.store
                .pipe(select(selectors.isAuthorized, {
                edit: toolKeys.MP_SENT_POC_EDIT,
                print: toolKeys.MP_SENT_POC_PRINT,
            }), tap((authorizedButtons) => {
                this.columnActions = {
                    poNumber: authorizedButtons.print
                        ? {
                            link: () => ({ path: './' }),
                            event: (sentPOC) => ({
                                data: { sentPOC },
                                eventType: EventType.PRINT,
                            }),
                        }
                        : {},
                };
            }))
                .subscribe());
            this.selectedPrintOptions = yield this.printOptionsService.get('poc', toolKeys.MP_SENT_POC_PRINT);
        });
    }
    bulkPrint() {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `poc/print`,
            httpMethod: 'POST',
            body: this.pocsToPrint,
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            var _a;
            ((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) === 1
                ? saveAs(response, 'MergedDocuments')
                : this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.pocsToPrint = [];
            this.triggeredByPrint = false;
            this.spinner.off();
        }))
            .subscribe();
    }
    openPdfViewer(data) {
        const ref = this.dialogService.open(PdfViewerComponent, {
            data: {
                response: data,
            },
            styleClass: 'pdf-viewer',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
    }
    closePrintOptionsDialog() {
        this.showPrintOptionsDialog = false;
    }
    updatePrintOptions(selectedPrintOptions) {
        this.selectedPrintOptions = selectedPrintOptions;
        if (this.triggeredByPrint) {
            this.bulkPrint();
        }
        this.closePrintOptionsDialog();
    }
    searchContainerEvent({ data, eventType }) {
        const { sentPOC } = data;
        switch (eventType) {
            case EventType.PRINT:
                this.print(sentPOC);
                break;
            default:
                break;
        }
    }
    print(sentPOC) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `poc/${sentPOC === null || sentPOC === void 0 ? void 0 : sentPOC.pocKey}/print`,
            httpMethod: 'GET',
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
            .subscribe();
    }
};
SentPOCComponent.ctorParameters = () => [
    { type: DialogService },
    { type: ConfirmationService$1 },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: Store },
    { type: PrintOptionsService }
];
SentPOCComponent = __decorate([
    Component({
        selector: 'lib-sent-poc',
        template: "<div class=\"view-remittances\">\r\n  <h2>{{ 'BREADCRUMB.PURCHASE_ORDER_CHANGE' | transloco }}</h2>\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"searchUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showPrintOptionsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-print-options-container\r\n    [baseUrl]=\"searchUrl\"\r\n    [selectedPrintOptions]=\"selectedPrintOptions\"\r\n    (closeDialog)=\"closePrintOptionsDialog()\"\r\n    (updatePrintOptions)=\"updatePrintOptions($event)\"\r\n  ></lib-print-options-container>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, DialogService]
    })
], SentPOCComponent);

const ɵ0$l = { breadcrumb: 'BREADCRUMB.PURCHASE_ORDER_CHANGE' };
const routes$i = [
    {
        path: 'poc-sent',
        component: SentPOCComponent,
        data: ɵ0$l,
    },
];

let ReceivedAAComponent = class ReceivedAAComponent {
    constructor(dialogService, confirmationService, mp, http, spinner, searchContainerLoaderService, translocoService, toast, store, printOptionsService) {
        this.dialogService = dialogService;
        this.confirmationService = confirmationService;
        this.mp = mp;
        this.http = http;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.store = store;
        this.printOptionsService = printOptionsService;
        this.columnActions = {};
        this.baseUrl = `${this.mp.getConfig().receivedAA}`;
        this.searchUrl = `${this.baseUrl}/aa`;
        // print states
        this.showPrintOptionsDialog = false;
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        this.aaToPrint = [];
        // Search container states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'aaSentSearch';
        this.i18nSearchField = 'MARKETPLACE.APPLICATION_ADVICE_SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {
            printOptions: (selection) => {
                this.showPrintOptionsDialog = true;
            },
            print: (selection) => {
                var _a;
                this.aaToPrint = [...selection].map((_a) => {
                    var { aaKey } = _a, _ = __rest(_a, ["aaKey"]);
                    return aaKey;
                });
                if (((_a = Object.keys(this.selectedPrintOptions || {})) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.bulkPrint();
                }
                else {
                    this.triggeredByPrint = true;
                    this.showPrintOptionsDialog = true;
                }
            },
            markProcessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('AA_RECEIVED.MARK_PROCESSED_MESSAGE'),
                    header: this.translocoService.translate('AA_RECEIVED.MARK_PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'aa/mark-processed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { aaKey } = _a, _ = __rest(_a, ["aaKey"]);
                                return aaKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnprocessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('AA_RECEIVED.MARK_UNPROCESSED_MESSAGE'),
                    header: this.translocoService.translate('AA_RECEIVED.MARK_UNPROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'aa/mark-unprocessed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { aaKey } = _a, _ = __rest(_a, ["aaKey"]);
                                return aaKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markRead: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('AA_RECEIVED.MARK_READ_MESSAGE'),
                    header: this.translocoService.translate('AA_RECEIVED.MARK_READ_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'aa/mark-read',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { aaKey } = _a, _ = __rest(_a, ["aaKey"]);
                                return aaKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnread: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('AA_RECEIVED.MARK_UNREAD_MESSAGE'),
                    header: this.translocoService.translate('AA_RECEIVED.MARK_UNREAD_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'aa/mark-unread',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { aaKey } = _a, _ = __rest(_a, ["aaKey"]);
                                return aaKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            delete: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('VALIDATION_MESSAGE.DELETE_CONFIRMATION_MESSAGE'),
                    header: this.translocoService.translate('VALIDATION_MESSAGE.DELETE_CONFIRMATION_HEADER'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'aa/bulk-update',
                            httpMethod: 'POST',
                            body: {
                                keys: [...selection].map((_a) => {
                                    var { aaKey } = _a, _ = __rest(_a, ["aaKey"]);
                                    return aaKey;
                                }),
                                IsDeleted: {
                                    Value: true,
                                },
                            },
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            restore: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('VALIDATION_MESSAGE.RESTORE_CONFIRMATION_MESSAGE'),
                    header: this.translocoService.translate('VALIDATION_MESSAGE.RESTORE_CONFIRMATION_HEADER'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'aa/bulk-update',
                            httpMethod: 'POST',
                            body: {
                                keys: [...selection].map((_a) => {
                                    var { aaKey } = _a, _ = __rest(_a, ["aaKey"]);
                                    return aaKey;
                                }),
                                IsDeleted: {
                                    Value: false,
                                },
                            },
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
        };
        http.baseUrl = this.baseUrl;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.push(this.store
                .pipe(select(selectors.isAuthorized, {
                edit: toolKeys.MP_RECEIVED_AA_EDIT,
                print: toolKeys.MP_RECEIVED_AA_PRINT,
            }), tap((authorizedButtons) => {
                this.columnActions = {
                    originalShipmentId: authorizedButtons.print
                        ? {
                            link: () => ({ path: './' }),
                            event: (receivedAA) => ({
                                data: { receivedAA },
                                eventType: EventType.PRINT,
                            }),
                        }
                        : {},
                };
            }))
                .subscribe());
            this.selectedPrintOptions = yield this.printOptionsService.get('aa', toolKeys.MP_RECEIVED_AA_PRINT);
        });
    }
    bulkPrint() {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `aa/print`,
            httpMethod: 'POST',
            body: this.aaToPrint,
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            var _a;
            ((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) === 1
                ? saveAs(response, 'MergedDocuments')
                : this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.aaToPrint = [];
            this.triggeredByPrint = false;
            this.spinner.off();
        }))
            .subscribe();
    }
    openPdfViewer(data) {
        const ref = this.dialogService.open(PdfViewerComponent, {
            data: {
                response: data,
            },
            styleClass: 'pdf-viewer',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
    }
    closePrintOptionsDialog() {
        this.showPrintOptionsDialog = false;
    }
    updatePrintOptions(selectedPrintOptions) {
        this.selectedPrintOptions = selectedPrintOptions;
        if (this.triggeredByPrint) {
            this.bulkPrint();
        }
        this.closePrintOptionsDialog();
    }
    searchContainerEvent({ data, eventType }) {
        const { receivedAA } = data;
        switch (eventType) {
            case EventType.PRINT:
                this.print(receivedAA);
                break;
            default:
                break;
        }
    }
    print(receivedAA) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `aa/${receivedAA === null || receivedAA === void 0 ? void 0 : receivedAA.aaKey}/print`,
            httpMethod: 'GET',
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
            .subscribe();
    }
};
ReceivedAAComponent.ctorParameters = () => [
    { type: DialogService },
    { type: ConfirmationService$1 },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: Store },
    { type: PrintOptionsService }
];
ReceivedAAComponent = __decorate([
    Component({
        selector: 'lib-sent-aa',
        template: "<div class=\"view-remittances\">\r\n  <h2>{{ 'BREADCRUMB.APPLICATION_ADVICE' | transloco }}</h2>\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"searchUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showPrintOptionsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-print-options-container\r\n    [baseUrl]=\"searchUrl\"\r\n    [selectedPrintOptions]=\"selectedPrintOptions\"\r\n    (closeDialog)=\"closePrintOptionsDialog()\"\r\n    (updatePrintOptions)=\"updatePrintOptions($event)\"\r\n  ></lib-print-options-container>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, DialogService]
    })
], ReceivedAAComponent);

const ɵ0$m = { breadcrumb: 'BREADCRUMB.APPLICATION_ADVICE' };
const routes$j = [
    {
        path: 'aa-received',
        component: ReceivedAAComponent,
        data: ɵ0$m,
    },
];

let ReceivedRebateStatementComponent = class ReceivedRebateStatementComponent {
    constructor(confirmationService, dialogService, mp, http, translocoService, toast, spinner, searchContainerLoaderService, store, printOptionsService) {
        this.confirmationService = confirmationService;
        this.dialogService = dialogService;
        this.mp = mp;
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.store = store;
        this.printOptionsService = printOptionsService;
        // kpi dashboard states
        this.dashBoardStateKey = 'receivedRebateStatementDashboardState';
        this.dashBoardVisibilityStateKey = 'receivedRebateStatementDashboardVisibilityState';
        this.categoryFilter = [];
        this.showCategories = false;
        this.defaultDashboardState = {
            dashboard: [],
            gridArea: [],
        };
        // print states
        this.showPrintOptionsDialog = false;
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        this.rebateStatementsToPrint = [];
        // Search Container
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'receivedRebateStatementSearch';
        this.i18nSearchField = 'REBATE_STATEMENT_RECEIVED.SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {
            printOptions: (selection) => {
                this.showPrintOptionsDialog = true;
            },
            print: (selection) => {
                var _a;
                this.rebateStatementsToPrint = [...selection].map((_a) => {
                    var { rebateStatementKey } = _a, _ = __rest(_a, ["rebateStatementKey"]);
                    return rebateStatementKey;
                });
                if (((_a = Object.keys(this.selectedPrintOptions || {})) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.bulkPrint();
                }
                else {
                    this.triggeredByPrint = true;
                    this.showPrintOptionsDialog = true;
                }
            },
            markProcessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('INVOICE.MARK_PROCESSED_MESSAGE'),
                    header: this.translocoService.translate('INVOICE.MARK_PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'rebatestatement/mark-processed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { rebateStatementKey } = _a, _ = __rest(_a, ["rebateStatementKey"]);
                                return rebateStatementKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnprocessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('INVOICE.MARK_UNPROCESSED_MESSAGE'),
                    header: this.translocoService.translate('INVOICE.MARK_UNPROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'rebatestatement/mark-unprocessed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { rebateStatementKey } = _a, _ = __rest(_a, ["rebateStatementKey"]);
                                return rebateStatementKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markRead: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('REBATE_STATEMENT_RECEIVED.MARK_READ_MESSAGE'),
                    header: this.translocoService.translate('REBATE_STATEMENT_RECEIVED.MARK_READ_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'rebatestatement/mark-read',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { rebateStatementKey } = _a, _ = __rest(_a, ["rebateStatementKey"]);
                                return rebateStatementKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnread: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('REBATE_STATEMENT_RECEIVED.MARK_UNREAD_MESSAGE'),
                    header: this.translocoService.translate('REBATE_STATEMENT_RECEIVED.MARK_UNREAD_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'rebatestatement/mark-unread',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { rebateStatementKey } = _a, _ = __rest(_a, ["rebateStatementKey"]);
                                return rebateStatementKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            export: (selection) => {
                this.selections = selection;
                this.openExport();
            },
        };
        this.baseUrl = `${this.mp.getConfig().receivedRebateStatement}/rebatestatement`;
        this.columnActions = {};
        this.email = '';
        http.baseUrl = mp.getConfig().receivedRebateStatement;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.push(this.store
                .pipe(select(selectors.isAuthorized, {
                edit: toolKeys.MP_REBATE_STATEMENT_EDIT,
                print: toolKeys.MP_RECEIVED_REBATE_STATEMENT_PRINT,
            }), tap((authorizedButtons) => {
                this.columnActions = {
                    title: authorizedButtons.print
                        ? {
                            link: () => ({ path: './' }),
                            event: (receivedRebateStatement) => receivedRebateStatement,
                        }
                        : {},
                };
            }))
                .subscribe(), this.store
                .pipe(select(selectors.userProfile), tap((user) => {
                this.email = user.sub;
            }))
                .subscribe());
            this.selectedPrintOptions = yield this.printOptionsService.get('rebatestatement', toolKeys.MP_RECEIVED_REBATE_STATEMENT_PRINT);
        });
    }
    print(rebatestatement) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `rebatestatement/${rebatestatement === null || rebatestatement === void 0 ? void 0 : rebatestatement.rebateStatementKey}/print`,
            httpMethod: 'GET',
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
            .subscribe();
    }
    // if triggered from bulk print then it also prints the selected documents
    updatePrintOptions(selectedPrintOptions) {
        this.selectedPrintOptions = selectedPrintOptions;
        if (this.triggeredByPrint) {
            this.bulkPrint();
        }
        this.closePrintOptionsDialog();
    }
    bulkPrint() {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `rebatestatement/print`,
            httpMethod: 'POST',
            body: this.rebateStatementsToPrint,
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            var _a;
            ((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) === 1
                ? saveAs(response, 'MergedDocuments')
                : this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.rebateStatementsToPrint = [];
            this.triggeredByPrint = false;
            this.spinner.off();
        }))
            .subscribe();
    }
    closePrintOptionsDialog() {
        this.showPrintOptionsDialog = false;
    }
    openPdfViewer(data) {
        const ref = this.dialogService.open(PdfViewerComponent, {
            data: {
                response: data,
            },
            styleClass: 'pdf-viewer',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
    }
    openExport() {
        const ref = this.dialogService.open(ExportComponent, {
            data: {
                endpoint: `${this.baseUrl}/export/form`,
            },
            showHeader: false,
            styleClass: 'export-dialog',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
        const refSubscription = ref.onClose
            .pipe(mergeMap((exportOptions) => exportOptions ? this.submitExport(exportOptions) : EMPTY), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
            .subscribe();
        this.subscriptions = [...this.subscriptions, refSubscription];
    }
    submitExport(exportOptions) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.spinner.on();
        return this.http
            .fetchWithFqn({
            endpoint: `${this.mp.getConfig().receivedRebateStatement}/rebatestatement/export`,
            httpMethod: 'POST',
            body: Object.assign(Object.assign({}, exportOptions), { email: this.email, toolkeys: '', keys: [...this.selections].map((_a) => {
                    var { rebateStatementKey } = _a, _ = __rest(_a, ["rebateStatementKey"]);
                    return rebateStatementKey;
                }), page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows }, sort: {
                    field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                    order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                }, search: {
                    filters: this.searchContainerLoaderService.filters,
                    term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
                } }),
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()));
    }
    ngOnDestroy() {
        this.dynamicDialogRefs.forEach((ref) => ref.destroy());
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
};
ReceivedRebateStatementComponent.ctorParameters = () => [
    { type: ConfirmationService },
    { type: DialogService$1 },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: Store },
    { type: PrintOptionsService }
];
ReceivedRebateStatementComponent = __decorate([
    Component({
        selector: 'lib-received-rebate-statement',
        template: "<h2>{{ 'NAV.REBATE_STATEMENTS' | transloco }}</h2>\r\n<div style=\"padding-top: 2rem\">\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [baseUrl]=\"baseUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"print($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showPrintOptionsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-print-options-container\r\n    [baseUrl]=\"baseUrl\"\r\n    [selectedPrintOptions]=\"selectedPrintOptions\"\r\n    (closeDialog)=\"closePrintOptionsDialog()\"\r\n    (updatePrintOptions)=\"updatePrintOptions($event)\"\r\n  ></lib-print-options-container>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, DialogService$1]
    })
], ReceivedRebateStatementComponent);

const ɵ0$n = {
    breadcrumb: {
        label: 'NAV.REBATE_STATEMENTS',
        disable: true,
    },
};
const routes$k = [
    {
        path: 'rebate-statement',
        data: ɵ0$n,
        component: ReceivedRebateStatementComponent,
    },
];

let ReceivedTmComponent = class ReceivedTmComponent {
    constructor(dialogService, confirmationService, mp, http, spinner, searchContainerLoaderService, translocoService, toast, store, printOptionsService) {
        this.dialogService = dialogService;
        this.confirmationService = confirmationService;
        this.mp = mp;
        this.http = http;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.store = store;
        this.printOptionsService = printOptionsService;
        this.baseUrl = `${this.mp.getConfig().receivedTM}`;
        this.searchUrl = `${this.baseUrl}/tm`;
        this.columnActions = {};
        // print states
        this.showPrintOptionsDialog = false;
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        this.tmsToPrint = [];
        // Search container states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'tmsSentSearch';
        this.i18nSearchField = 'MARKETPLACE.TEXT_MESSAGES_SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {
            printOptions: (selection) => {
                this.showPrintOptionsDialog = true;
            },
            print: (selection) => {
                var _a;
                this.tmsToPrint = [...selection].map((_a) => {
                    var { tmKey } = _a, _ = __rest(_a, ["tmKey"]);
                    return tmKey;
                });
                if (((_a = Object.keys(this.selectedPrintOptions || {})) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.bulkPrint();
                }
                else {
                    this.triggeredByPrint = true;
                    this.showPrintOptionsDialog = true;
                }
            },
            markProcessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('TM_RECEIVED.MARK_PROCESSED_MESSAGE'),
                    header: this.translocoService.translate('TM_RECEIVED.MARK_PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'tm/mark-processed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { tmKey } = _a, _ = __rest(_a, ["tmKey"]);
                                return tmKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnprocessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('TM_RECEIVED.MARK_UNPROCESSED_MESSAGE'),
                    header: this.translocoService.translate('TM_RECEIVED.MARK_PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'tm/mark-unprocessed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { tmKey } = _a, _ = __rest(_a, ["tmKey"]);
                                return tmKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markRead: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('TM_RECEIVED.MARK_READ_MESSAGE'),
                    header: this.translocoService.translate('TM_RECEIVED.MARK_READ_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'tm/mark-read',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { tmKey } = _a, _ = __rest(_a, ["tmKey"]);
                                return tmKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnread: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('TM_RECEIVED.MARK_UNREAD_MESSAGE'),
                    header: this.translocoService.translate('TM_RECEIVED.MARK_UNREAD_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'tm/mark-unread',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { tmKey } = _a, _ = __rest(_a, ["tmKey"]);
                                return tmKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            delete: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('VALIDATION_MESSAGE.DELETE_CONFIRMATION_MESSAGE'),
                    header: this.translocoService.translate('VALIDATION_MESSAGE.DELETE_CONFIRMATION_HEADER'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'tm/bulk-update',
                            httpMethod: 'POST',
                            body: {
                                keys: [...selection].map((_a) => {
                                    var { tmKey } = _a, _ = __rest(_a, ["tmKey"]);
                                    return tmKey;
                                }),
                                IsDeleted: {
                                    Value: true,
                                },
                            },
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            restore: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('VALIDATION_MESSAGE.RESTORE_CONFIRMATION_MESSAGE'),
                    header: this.translocoService.translate('VALIDATION_MESSAGE.RESTORE_CONFIRMATION_HEADER'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'tm/bulk-update',
                            httpMethod: 'POST',
                            body: {
                                keys: [...selection].map((_a) => {
                                    var { tmKey } = _a, _ = __rest(_a, ["tmKey"]);
                                    return tmKey;
                                }),
                                IsDeleted: {
                                    Value: false,
                                },
                            },
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
        };
        http.baseUrl = this.baseUrl;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.push(this.store
                .pipe(select(selectors.isAuthorized, {
                edit: toolKeys.MP_RECEIVED_TM_EDIT,
                print: toolKeys.MP_RECEIVED_TM_PRINT,
            }), tap((authorizedButtons) => {
                this.columnActions = {
                    lbmxDocumentID: authorizedButtons.print
                        ? {
                            link: () => ({ path: './' }),
                            event: (receivedTM) => ({
                                data: { receivedTM },
                                eventType: EventType.PRINT,
                            }),
                        }
                        : {},
                };
            }))
                .subscribe());
            this.selectedPrintOptions = yield this.printOptionsService.get('tm', toolKeys.MP_RECEIVED_TM_PRINT);
        });
    }
    bulkPrint() {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `tm/print`,
            httpMethod: 'POST',
            body: this.tmsToPrint,
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            var _a;
            ((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) === 1
                ? saveAs(response, 'MergedDocuments')
                : this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.tmsToPrint = [];
            this.triggeredByPrint = false;
            this.spinner.off();
        }))
            .subscribe();
    }
    openPdfViewer(data) {
        const ref = this.dialogService.open(PdfViewerComponent, {
            data: {
                response: data,
            },
            styleClass: 'pdf-viewer',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
    }
    closePrintOptionsDialog() {
        this.showPrintOptionsDialog = false;
    }
    updatePrintOptions(selectedPrintOptions) {
        this.selectedPrintOptions = selectedPrintOptions;
        if (this.triggeredByPrint) {
            this.bulkPrint();
        }
        this.closePrintOptionsDialog();
    }
    searchContainerEvent({ data, eventType }) {
        const { receivedTM } = data;
        switch (eventType) {
            case EventType.PRINT:
                this.print(receivedTM);
                break;
            default:
                break;
        }
    }
    print(receivedTM) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `tm/${receivedTM === null || receivedTM === void 0 ? void 0 : receivedTM.tmKey}/print`,
            httpMethod: 'GET',
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
            .subscribe();
    }
};
ReceivedTmComponent.ctorParameters = () => [
    { type: DialogService },
    { type: ConfirmationService$1 },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: Store },
    { type: PrintOptionsService }
];
ReceivedTmComponent = __decorate([
    Component({
        selector: 'lib-received-tm',
        template: "<div class=\"view-remittances\">\r\n  <h2>{{ 'BREADCRUMB.TEXT_MESSAGES' | transloco }}</h2>\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"searchUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showPrintOptionsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-print-options-container\r\n    [baseUrl]=\"searchUrl\"\r\n    [selectedPrintOptions]=\"selectedPrintOptions\"\r\n    (closeDialog)=\"closePrintOptionsDialog()\"\r\n    (updatePrintOptions)=\"updatePrintOptions($event)\"\r\n  ></lib-print-options-container>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, DialogService]
    })
], ReceivedTmComponent);

const ɵ0$o = { breadcrumb: 'BREADCRUMB.TEXT_MESSAGES' };
const routes$l = [
    {
        path: 'tms-received',
        component: ReceivedTmComponent,
        data: ɵ0$o,
    },
];

let RemittancesReceivedComponent = class RemittancesReceivedComponent {
    constructor(dialogService, confirmationService, mp, http, spinner, searchContainerLoaderService, translocoService, toast, store, printOptionsService) {
        this.dialogService = dialogService;
        this.confirmationService = confirmationService;
        this.mp = mp;
        this.http = http;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.store = store;
        this.printOptionsService = printOptionsService;
        // print states
        this.showPrintOptionsDialog = false;
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        this.remittancesToPrint = [];
        // Search container states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'remittancesReceivedSearch';
        this.i18nSearchField = 'COLLECTIONS.PAYMENT_REFERENCE_NUMBER';
        this.params = {};
        this.toolbarActionsDispatcher = {
            printOptions: (selection) => {
                this.showPrintOptionsDialog = true;
            },
            print: (selection) => {
                var _a;
                this.remittancesToPrint = [...selection].map((_a) => {
                    var { remittanceKey } = _a, _ = __rest(_a, ["remittanceKey"]);
                    return remittanceKey;
                });
                if (((_a = Object.keys(this.selectedPrintOptions || {})) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.bulkPrint();
                }
                else {
                    this.triggeredByPrint = true;
                    this.showPrintOptionsDialog = true;
                }
            },
            markProcessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('REMITTANCES_RECEIVED.MARK_PROCESSED_MESSAGE'),
                    header: this.translocoService.translate('REMITTANCES_RECEIVED.MARK_PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'remittance/mark-processed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { remittanceKey } = _a, _ = __rest(_a, ["remittanceKey"]);
                                return remittanceKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnprocessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('REMITTANCES_RECEIVED.MARK_UNPROCESSED_MESSAGE'),
                    header: this.translocoService.translate('REMITTANCES_RECEIVED.MARK_PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'remittance/mark-unprocessed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { remittanceKey } = _a, _ = __rest(_a, ["remittanceKey"]);
                                return remittanceKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markRead: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('REMITTANCES_RECEIVED.MARK_READ_MESSAGE'),
                    header: this.translocoService.translate('REMITTANCES_RECEIVED.MARK_READ_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'remittance/mark-read',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { remittanceKey } = _a, _ = __rest(_a, ["remittanceKey"]);
                                return remittanceKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnread: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('REMITTANCES_RECEIVED.MARK_UNREAD_MESSAGE'),
                    header: this.translocoService.translate('REMITTANCES_RECEIVED.MARK_UNREAD_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'remittance/mark-unread',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { remittanceKey } = _a, _ = __rest(_a, ["remittanceKey"]);
                                return remittanceKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            delete: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('VALIDATION_MESSAGE.DELETE_CONFIRMATION_MESSAGE'),
                    header: this.translocoService.translate('VALIDATION_MESSAGE.DELETE_CONFIRMATION_HEADER'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'remittance/bulk-update',
                            httpMethod: 'POST',
                            body: {
                                keys: [...selection].map((_a) => {
                                    var { remittanceKey } = _a, _ = __rest(_a, ["remittanceKey"]);
                                    return remittanceKey;
                                }),
                                IsDeleted: {
                                    Value: true,
                                },
                            },
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            restore: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('VALIDATION_MESSAGE.RESTORE_CONFIRMATION_MESSAGE'),
                    header: this.translocoService.translate('VALIDATION_MESSAGE.RESTORE_CONFIRMATION_HEADER'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'remittance/bulk-update',
                            httpMethod: 'POST',
                            body: {
                                keys: [...selection].map((_a) => {
                                    var { remittanceKey } = _a, _ = __rest(_a, ["remittanceKey"]);
                                    return remittanceKey;
                                }),
                                IsDeleted: {
                                    Value: false,
                                },
                            },
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
        };
        this.baseUrl = `${this.mp.getConfig().receivedRemittances}`;
        this.searchUrl = `${this.baseUrl}/remittance`;
        this.columnActions = {};
        http.baseUrl = this.baseUrl;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.push(this.store
                .pipe(select(selectors.isAuthorized, {
                edit: toolKeys.MP_REMITTANCES_RECEIVED_VIEW,
                print: toolKeys.MP_RECEIVED_REMITTANCES_PRINT,
            }), tap((authorizedButtons) => {
                this.columnActions = {
                    paymentReferenceNumber: authorizedButtons.print
                        ? {
                            link: () => ({ path: './' }),
                            event: (receivedRemittance) => ({
                                data: { receivedRemittance },
                                eventType: EventType.PRINT,
                            }),
                        }
                        : {},
                };
            }))
                .subscribe());
            this.selectedPrintOptions = yield this.printOptionsService.get('remittance', toolKeys.MP_RECEIVED_REMITTANCES_PRINT);
        });
    }
    bulkPrint() {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `remittance/print`,
            httpMethod: 'POST',
            body: this.remittancesToPrint,
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            var _a;
            ((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) === 1
                ? saveAs(response, 'MergedDocuments')
                : this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.remittancesToPrint = [];
            this.triggeredByPrint = false;
            this.spinner.off();
        }))
            .subscribe();
    }
    openPdfViewer(data) {
        const ref = this.dialogService.open(PdfViewerComponent, {
            data: {
                response: data,
            },
            styleClass: 'pdf-viewer',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
    }
    closePrintOptionsDialog() {
        this.showPrintOptionsDialog = false;
    }
    updatePrintOptions(selectedPrintOptions) {
        this.selectedPrintOptions = selectedPrintOptions;
        if (this.triggeredByPrint) {
            this.bulkPrint();
        }
        this.closePrintOptionsDialog();
    }
    searchContainerEvent({ data, eventType }) {
        const { receivedRemittance } = data;
        switch (eventType) {
            case EventType.PRINT:
                this.print(receivedRemittance);
                break;
            default:
                break;
        }
    }
    print(receivedRemittance) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `remittance/${receivedRemittance === null || receivedRemittance === void 0 ? void 0 : receivedRemittance.remittanceKey}/print`,
            httpMethod: 'GET',
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
            .subscribe();
    }
};
RemittancesReceivedComponent.ctorParameters = () => [
    { type: DialogService$1 },
    { type: ConfirmationService$1 },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: Store },
    { type: PrintOptionsService }
];
RemittancesReceivedComponent = __decorate([
    Component({
        selector: 'lib-remittances-received',
        template: "<div class=\"view-remittances\">\r\n  <h2>{{ 'BREADCRUMB.REMITTANCES_RECEIVED' | transloco }}</h2>\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"searchUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showPrintOptionsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-print-options-container\r\n    [baseUrl]=\"searchUrl\"\r\n    [selectedPrintOptions]=\"selectedPrintOptions\"\r\n    (closeDialog)=\"closePrintOptionsDialog()\"\r\n    (updatePrintOptions)=\"updatePrintOptions($event)\"\r\n  ></lib-print-options-container>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, DialogService$1],
        styles: [""]
    })
], RemittancesReceivedComponent);

const ɵ0$p = { breadcrumb: 'BREADCRUMB.REMITTANCES_RECEIVED' };
const routes$m = [
    {
        path: 'remittances-received',
        component: RemittancesReceivedComponent,
        data: ɵ0$p,
    },
];

const schemaDefinition$3 = (fields) => ({
    fields,
});

let FullInvoiceEntryComponent = class FullInvoiceEntryComponent extends ComponentCanDeactivate {
    constructor(formGenerator, http, toast, transloco, newInvoiceSrv, confirmationService, translocoSrv, router, mp) {
        super();
        this.formGenerator = formGenerator;
        this.http = http;
        this.toast = toast;
        this.transloco = transloco;
        this.newInvoiceSrv = newInvoiceSrv;
        this.confirmationService = confirmationService;
        this.translocoSrv = translocoSrv;
        this.router = router;
        this.mp = mp;
        this.templateTypes = TemplateTypes;
        this.schemaDefinition = schemaDefinition$3;
        this.baseUrl = '';
        this.cancelButtonClicked = false;
        this.baseUrl = `${this.mp.getConfig().apiBaseUrl}`;
        if (this.newInvoiceSrv.newInvoiceWizard === undefined) {
            this.router.navigate([moduleUrls.sentInvoice()]);
        }
        this.wizardConfig = this.newInvoiceSrv.newInvoiceWizard;
    }
    redirect() {
        this.cancelButtonClicked = true;
        this.newInvoiceSrv.reset();
        this.router.navigate([this.newInvoiceSrv.redirectUrl]);
    }
    submitNew(event) {
        this.cancelButtonClicked = true;
        this.newInvoiceSrv.reset();
        this.router.navigate([this.newInvoiceSrv.redirectUrl]);
    }
    canDeactivate(nextState) {
        // when the cancel dialog is open and submit is clicked, we don't want the alert to show and just nav away
        if (this.cancelButtonClicked) {
            return true;
        }
        return false;
    }
};
FullInvoiceEntryComponent.ctorParameters = () => [
    { type: GenerateFormService },
    { type: BaseHttpService$3 },
    { type: ToastrNotificationService },
    { type: TranslocoService },
    { type: NewInvoiceService },
    { type: ConfirmationService },
    { type: TranslocoService },
    { type: Router },
    { type: MarketplaceService }
];
FullInvoiceEntryComponent = __decorate([
    Component({
        selector: 'lib-full-invoice-entry',
        template: "<lui-wizard-v3\r\n  [baseUrl]=\"baseUrl\"\r\n  [wizardConfig]=\"wizardConfig\"\r\n  (cancel)=\"redirect()\"\r\n  (submit)=\"submitNew($event)\"\r\n>\r\n  <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n    <div>\r\n      <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n    </div>\r\n  </ng-template>\r\n  <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n    <div\r\n      class=\"error\"\r\n      style=\"\r\n        min-height: 30vh;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n      \"\r\n    >\r\n      <div>\r\n        <span>\r\n          <i class=\"pi pi-times-circle\"></i>\r\n          {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n        </span>\r\n      </div>\r\n    </div>\r\n    <button pButton (click)=\"redirect()\" class=\"ds secondary\">\r\n      {{ 'ACTIONS.CANCEL' | transloco }}\r\n    </button>\r\n  </ng-template>\r\n</lui-wizard-v3>\r\n\r\n<p-confirmDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n",
        providers: [ConfirmationService]
    })
], FullInvoiceEntryComponent);

let NewInvoiceComponent = class NewInvoiceComponent extends ComponentCanDeactivate {
    constructor(formGenerator, http, toast, transloco, newInvoiceSrv, confirmationService, translocoSrv, router, mp) {
        super();
        this.formGenerator = formGenerator;
        this.http = http;
        this.toast = toast;
        this.transloco = transloco;
        this.newInvoiceSrv = newInvoiceSrv;
        this.confirmationService = confirmationService;
        this.translocoSrv = translocoSrv;
        this.router = router;
        this.mp = mp;
        this.schemaDefinition = schemaDefinition$3;
        this.templateTypes = TemplateTypes;
        this.wizardConfig = {
            endpoint: `sentinvoice/form/invoice/quickentry`,
            httpMethod: HttpMethod$2.POST,
        };
        this.baseUrl = '';
        this.cancelButtonClicked = false;
        this.baseUrl = `${this.mp.getConfig().apiBaseUrl}`;
    }
    redirect() {
        this.cancelButtonClicked = true;
        this.newInvoiceSrv.reset();
        this.router.navigate([this.newInvoiceSrv.redirectUrl]);
    }
    submitNew(event) {
        this.cancelButtonClicked = true;
        this.newInvoiceSrv.reset();
        this.router.navigate([this.newInvoiceSrv.redirectUrl]);
    }
    canDeactivate(nextState) {
        // when the cancel dialog is open, we don't want the alert to show and just nav away
        if (this.cancelButtonClicked) {
            return true;
        }
        return false;
    }
};
NewInvoiceComponent.ctorParameters = () => [
    { type: GenerateFormService },
    { type: BaseHttpService$2 },
    { type: ToastrNotificationService },
    { type: TranslocoService },
    { type: NewInvoiceService },
    { type: ConfirmationService },
    { type: TranslocoService },
    { type: Router },
    { type: MarketplaceService }
];
NewInvoiceComponent = __decorate([
    Component({
        selector: 'lib-new-invoice',
        template: "<div style=\"grid-template-columns: 1fr 2fr 1fr; display: grid\">\r\n  <div></div>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"baseUrl\"\r\n    [wizardConfig]=\"wizardConfig\"\r\n    (cancel)=\"redirect()\"\r\n    (submit)=\"submitNew($event)\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n      <div>\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"redirect()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n  <div></div>\r\n  <p-confirmDialog [closeOnEscape]=\"false\" [closable]=\"false\"></p-confirmDialog>\r\n</div>\r\n",
        providers: [ConfirmationService]
    })
], NewInvoiceComponent);

const wizardConfig$1 = (translateService, baseUrl) => [
    ({ title }) => ({
        fetchUrl: `${baseUrl}/sentinvoice/pull`,
        fetchMethod: 'GET',
        responseField: 'records',
        title: translateService.translate(title),
        form: (options) => ({
            fields: {
                invoiceDateMin: {
                    type: 'calendar',
                    label: translateService.translate('INVOICE.DATE_FROM'),
                    validations: [
                        {
                            test: dateOrderValidation$1('invoiceDateMax'),
                            message: translateService.translate('INVOICE.DATE_FROM_LESS_THAN_VALIDATION'),
                        },
                        {
                            test: dateRangeValidation$1,
                            message: translateService.translate('INVOICE.DATE_RANGE_VALIDATION'),
                        },
                    ],
                    componentProperties: {
                        showIcon: true,
                        showButtonBar: true,
                    },
                    required: true,
                },
                invoiceDateMax: {
                    type: 'calendar',
                    label: translateService.translate('INVOICE.DATE_TO'),
                    validations: [
                        {
                            test: dateOrderValidation$1('invoiceDateMin'),
                            message: translateService.translate('INVOICE.DATE_TO_GREATER_THAN_VALIDATION'),
                        },
                        {
                            test: dateRangeValidation$1,
                            message: translateService.translate('INVOICE.DATE_RANGE_VALIDATION'),
                        },
                    ],
                    componentProperties: {
                        showIcon: true,
                        showButtonBar: true,
                    },
                    required: true,
                },
                connectionKey: {
                    type: 'dropdown',
                    label: translateService.translate('INVOICE.CONNECTIONS'),
                    options: [
                        {
                            value: null,
                            label: translateService.translate('ADMINISTRATION.CHOOSE_CONNECTOR'),
                        },
                        ...toDropdownOptions(options, 'connectionKey', 'description'),
                    ],
                    required: true,
                },
            },
        }),
        response: ({ screenConfig, response }) => {
            const { form } = screenConfig;
            return form(response);
        },
        buttons: {
            cancel: {
                label: translateService.translate('ACTIONS.CANCEL'),
            },
            next: {
                label: translateService.translate('ACTIONS.NEXT'),
                componentProperties: {
                    style: { 'flex-grow': 1 },
                },
            },
        },
    }),
    ({ screens, title }) => ({
        fetchUrl: `${baseUrl}/sentinvoice/pull/${screens[0].connectionKey}/filter`,
        fetchMethod: 'POST',
        body: {
            invoiceDateMin: screens[0].invoiceDateMin,
            invoiceDateMax: transformDate$1(screens[0].invoiceDateMax),
        },
        title: translateService.translate(title),
        response: ({ response }) => {
            return response;
        },
        buttons: {
            cancel: {
                label: translateService.translate('ACTIONS.CANCEL'),
            },
            previous: {
                label: translateService.translate('ACTIONS.PREVIOUS'),
            },
            next: {
                label: translateService.translate('ACTIONS.SUBMIT'),
                componentProperties: {
                    style: { 'flex-grow': 1 },
                },
            },
        },
    }),
    ({ screens, title }) => {
        var _a;
        return ({
            fetchUrl: `${baseUrl}/sentinvoice/pull/${screens[0].connectionKey}`,
            fetchMethod: 'POST',
            body: {
                invoiceKeys: (_a = screens[1]) === null || _a === void 0 ? void 0 : _a.invoiceKeys,
            },
            title: translateService.translate(title),
            response: ({ response }) => {
                return response;
            },
            buttons: {
                submit: {
                    label: translateService.translate('ACTIONS.OK'),
                    componentProperties: {
                        style: { 'flex-grow': 1 },
                    },
                },
            },
        });
    },
];
const dateRangeValidation$1 = ({ invoiceDateMin, invoiceDateMax }) => {
    let diff = null;
    if (invoiceDateMin && invoiceDateMax) {
        diff = differenceInCalendarDays(invoiceDateMin, transformDate$1(invoiceDateMax));
    }
    return diff > -32;
};
const ɵ0$q = dateRangeValidation$1;
const dateOrderValidation$1 = (dateToCheck) => ({ [dateToCheck]: ensurePresent, invoiceDateMin, invoiceDateMax }) => {
    let diff = null;
    if (invoiceDateMin && invoiceDateMax) {
        diff = differenceInCalendarDays(invoiceDateMin, transformDate$1(invoiceDateMax));
    }
    return !!ensurePresent ? diff && diff < 0 : true;
};
const ɵ1$8 = dateOrderValidation$1;
const transformDate$1 = (date) => add(date, { days: 1 });
const ɵ2$6 = transformDate$1;

let SentInvoiceComponent = class SentInvoiceComponent {
    constructor(confirmationService, dialogService, mp, http, spinner, searchContainerLoaderService, translocoService, toast, store, formGenerator, router, route, newInvoiceService, printOptionsService, popupService) {
        var _a;
        this.confirmationService = confirmationService;
        this.dialogService = dialogService;
        this.mp = mp;
        this.http = http;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.store = store;
        this.formGenerator = formGenerator;
        this.router = router;
        this.route = route;
        this.newInvoiceService = newInvoiceService;
        this.printOptionsService = printOptionsService;
        this.popupService = popupService;
        // Print states
        this.showPrintOptionsDialog = false;
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        this.invoicesToPrint = [];
        // Warnings state
        this.showWarningsDialog = false;
        this.showInvoiceQuestionDialog = false;
        this.ableToRenderInvoiceQuestion = false;
        this.routeToSummaryInvoice = false;
        this.routeToDetailInvoice = false;
        // draft new states
        this.showDraftInvoiceQuestionDialog = false;
        // draft promote states
        this.showDraftPromoteDialog = false;
        // Action logs
        this.showActionLogs = false;
        // display log states
        this.showDisplayLog = false;
        this.batchKey = 0;
        this.loggingUrl = '';
        // kpi dashboard states
        this.dashBoardStateKey = 'sentInvoiceDashboardState';
        this.dashBoardVisibilityStateKey = 'sentInvoiceDashboardVisibilityState';
        this.categoryFilter = ['accountsReceivable'];
        this.showCategories = false;
        this.defaultDashboardState = {
            dashboard: [
                'accountsReceivable.invoicesDueNext14Days',
                'accountsReceivable.invoicesDueNext30Days',
                'accountsReceivable.invoicesDueNext60Days',
                'accountsReceivable.invoicesDueNext7Days',
                'accountsReceivable.invoicesSentLast30Days',
                'accountsReceivable.invoicesSentLast60Days',
            ],
            gridArea: [[0, 1, 2, 3, 4, 5]],
        };
        // edit invoice states
        this.showEditDialog = false;
        this.templateTypes = TemplateTypes;
        // re-import states
        this.showReImportDialog = false;
        // Search container states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.showReverseWriteOffDialog = false;
        this.showWriteOffDialog = false;
        this.searchContainerName = 'invoiceSentSearch';
        this.i18nSearchField = 'INVOICE.SENT_INVOICES_SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {
            printOptions: (selection) => {
                this.showPrintOptionsDialog = true;
            },
            reImport: (selection) => {
                this.showReImportDialog = true;
                this.reImportWizard = {
                    endpoint: `/Connector/FormSentInvoice/repull`,
                    httpMethod: HttpMethod.POST,
                    body: {
                        keys: [...selection].map((_a) => {
                            var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                            return invoiceKey;
                        }),
                    },
                };
            },
            print: (selection) => {
                var _a;
                this.invoicesToPrint = [...selection].map((_a) => {
                    var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                    return invoiceKey;
                });
                if (((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) > 0) {
                    this.bulkPrint();
                }
                else {
                    this.triggeredByPrint = true;
                    this.showPrintOptionsDialog = true;
                }
            },
            accountingImport: () => {
                this.showWizard = true;
            },
            export: (selection) => {
                this.selections = selection;
                this.openExport();
            },
            displayLog: (selection) => {
                var _a;
                this.batchKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.invoiceKey;
                this.loggingUrl = `${this.mp.getConfig().sentInvoice}/invoicehistory/${this.batchKey}/form`;
                this.showDisplayLog = true;
            },
            edit: (selection) => {
                var _a;
                this.editInvoiceWizard = {
                    endpoint: `sentinvoice/form/invoice/${(_a = selection[0]) === null || _a === void 0 ? void 0 : _a.invoiceKey}/edit`,
                    httpMethod: HttpMethod.GET,
                };
                this.selections = selection;
                this.showEditDialog = true;
            },
            copy: (selection) => {
                var _a;
                this.newInvoiceService.baseUrl = this.newInvoiceUrl;
                this.newInvoiceService.redirectUrl =
                    '/MarketplaceModule/accounts-receivable/invoices';
                this.newInvoiceService.newInvoiceWizard = {
                    endpoint: `sentinvoice/form/invoice/${(_a = selection[0]) === null || _a === void 0 ? void 0 : _a.invoiceKey}/copy`,
                    httpMethod: HttpMethod.GET,
                };
                this.router.navigate(['../full-invoice'], { relativeTo: this.route });
            },
            warnings: (selection) => {
                this.selectedInvoiceKeys = [...selection].map((_a) => {
                    var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                    return invoiceKey;
                });
                this.warningsDialogWizard = {
                    endpoint: `sentinvoice/invoice/warning/form`,
                    httpMethod: HttpMethod.POST,
                    body: {
                        keys: this.selectedInvoiceKeys,
                    },
                };
                this.showWarningsDialog = true;
            },
            new: () => {
                if (this.ableToRenderInvoiceQuestion) {
                    this.showInvoiceQuestionDialog = true;
                }
                else if (this.routeToSummaryInvoice) {
                    this.navigateToSummaryInvoice();
                }
                else if (this.routeToDetailInvoice) {
                    this.navigateToDetailInvoice();
                }
            },
            delete: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('VALIDATION_MESSAGE.DELETE_CONFIRMATION_MESSAGE'),
                    header: this.translocoService.translate('VALIDATION_MESSAGE.DELETE_CONFIRMATION_HEADER'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'invoice/delete',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                                return invoiceKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError((err) => {
                            var _a;
                            ((_a = err === null || err === void 0 ? void 0 : err.error) === null || _a === void 0 ? void 0 : _a.errorCode) === 5
                                ? this.confirmationService.confirm({
                                    message: this.translocoService.translate('INVOICE.SOME_NOT_DELETED'),
                                    header: this.translocoService.translate('VALIDATION_MESSAGE.DELETE_CONFIRMATION_HEADER'),
                                    acceptVisible: false,
                                    rejectVisible: true,
                                    rejectLabel: this.translocoService.translate('ACTIONS.CLOSE'),
                                    reject: () => {
                                        this.searchContainerLoaderService.refreshSearch();
                                    },
                                })
                                : this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR'));
                            return of({});
                        }), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            restore: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('VALIDATION_MESSAGE.RESTORE_CONFIRMATION_MESSAGE'),
                    header: this.translocoService.translate('VALIDATION_MESSAGE.RESTORE_CONFIRMATION_HEADER'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'invoice/restore',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                                return invoiceKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            runDataGenius: (selection) => {
                this.selections = selection;
                this.openDataGenius();
            },
            writeOff: (selection) => {
                this.selectedInvoiceKeys = [...selection].map((_a) => {
                    var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                    return invoiceKey;
                });
                // console.log('selected',this.selectedInvoiceKeys);
                this.writeOffWizard = {
                    endpoint: `/form/write-off`,
                    httpMethod: HttpMethod.POST,
                    body: {
                        invoiceKeys: this.selectedInvoiceKeys,
                    },
                };
                this.showWriteOffDialog = true;
            },
            reverseWriteOff: (selection) => {
                this.selectedInvoiceKeys = [...selection].map((_a) => {
                    var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                    return invoiceKey;
                });
                this.reverseWriteOffwizard = {
                    endpoint: `/form/reverse-write-off`,
                    httpMethod: HttpMethod.POST,
                    body: {
                        invoiceKeys: this.selectedInvoiceKeys,
                    },
                };
                this.showReverseWriteOffDialog = true;
            },
            actionLogs: (selection) => {
                var _a;
                const invoiceKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.invoiceKey;
                this.actionLogsWizard = {
                    endpoint: `/invoice/${invoiceKey}/actionlogs/form`,
                    httpMethod: HttpMethod.GET,
                };
                this.showActionLogs = true;
            },
            draftNew: (selection) => {
                if (this.ableToRenderInvoiceQuestion) {
                    this.showDraftInvoiceQuestionDialog = true;
                }
                else if (this.routeToSummaryInvoice) {
                    this.navigateToDraftSummaryInvoice();
                }
                else if (this.routeToDetailInvoice) {
                    this.navigateToDraftDetailInvoice();
                }
            },
            draftEdit: (selection) => {
                this.newInvoiceService.baseUrl = this.newInvoiceUrl;
                this.newInvoiceService.redirectUrl =
                    '/MarketplaceModule/accounts-receivable/draft-invoice';
                this.newInvoiceService.newInvoiceWizard = {
                    endpoint: `sentinvoice/ui/draft/${selection[0].draftInvoiceKey}/edit`,
                    httpMethod: HttpMethod.POST,
                };
                this.router.navigate(['../full-invoice'], { relativeTo: this.route });
            },
            draftCopy: (selection) => {
                this.newInvoiceService.baseUrl = this.newInvoiceUrl;
                this.newInvoiceService.redirectUrl =
                    '/MarketplaceModule/accounts-receivable/draft-invoice';
                this.newInvoiceService.newInvoiceWizard = {
                    endpoint: `sentinvoice/ui/draft/${selection[0].draftInvoiceKey}/copy`,
                    httpMethod: HttpMethod.POST,
                };
                this.router.navigate(['../full-invoice'], { relativeTo: this.route });
            },
            draftPromote: (selection) => {
                const selectedDraftKeys = [...selection].map((_a) => {
                    var { draftInvoiceKey } = _a, _ = __rest(_a, ["draftInvoiceKey"]);
                    return draftInvoiceKey;
                });
                this.draftPromoteWizard = {
                    endpoint: `sentInvoice/ui/draft/promote`,
                    httpMethod: HttpMethod.POST,
                    body: {
                        keys: selectedDraftKeys,
                    },
                };
                this.showDraftPromoteDialog = true;
            },
            draftRestore: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('INVOICE.DRAFT_RESTORE_MESSAGE'),
                    header: this.translocoService.translate('INVOICE.DRAFT_RESTORE_HEADER'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'draft/restore',
                            httpMethod: 'POST',
                            body: {
                                keys: [...selection].map((_a) => {
                                    var { draftInvoiceKey } = _a, _ = __rest(_a, ["draftInvoiceKey"]);
                                    return draftInvoiceKey;
                                }),
                            },
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            draftDelete: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('INVOICE.DRAFT_DELETE_MESSAGE'),
                    header: this.translocoService.translate('INVOICE.DRAFT_DELETE_HEADER'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'draft/delete',
                            httpMethod: 'POST',
                            body: {
                                keys: [...selection].map((_a) => {
                                    var { draftInvoiceKey } = _a, _ = __rest(_a, ["draftInvoiceKey"]);
                                    return draftInvoiceKey;
                                }),
                            },
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
        };
        this.baseUrl = `${this.mp.getConfig().sentInvoice}/invoice`;
        this.draftUrl = `${this.mp.getConfig().sentInvoice}/draft`;
        this.newInvoiceUrl = `${this.mp.getConfig().apiBaseUrl}`;
        this.warningsBaseUrl = `${this.mp.getConfig().sentInvoice}/invoice`;
        this.warningsUrl = `/warning/form`;
        this.warningsSubmitUrl = `/warning/clear`;
        this.columnActions = {};
        this.draftInvoice = false;
        this.defaultState = {
            page: 0,
            title: 'INVOICE.ACCOUNTING_IMPORT',
            screens: {},
        };
        this.showWizard = false;
        this.wizardPage = 0;
        this.email = '';
        http.baseUrl = this.mp.getConfig().sentInvoice;
        this.wizardBaseUrl = this.mp.getConfig().sentInvoice;
        if (((_a = this.route.snapshot.url[0]) === null || _a === void 0 ? void 0 : _a.path) === 'draft-invoice') {
            this.baseUrl = this.draftUrl;
            this.draftInvoice = true;
        }
        this.store
            .pipe(select(selectors.userToolKeys), tap((perms) => {
            // if (perms.includes(308) && perms.includes(309)) {
            if (perms.includes(toolKeys.MARKETPLACE_SENT_INVOICE_CREATE_SUMMARY) &&
                perms.includes(toolKeys.MARKETPLACE_SENT_INVOICE_CREATE_DETAIL)) {
                this.ableToRenderInvoiceQuestion = true;
            }
            else if (perms.includes(toolKeys.MARKETPLACE_SENT_INVOICE_CREATE_SUMMARY)) {
                this.routeToSummaryInvoice = true;
            }
            else if (perms.includes(toolKeys.MARKETPLACE_SENT_INVOICE_CREATE_DETAIL)) {
                this.routeToDetailInvoice = true;
            }
        }))
            .subscribe();
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.push(this.store
                .pipe(select(selectors.isAuthorized, {
                edit: toolKeys.MP_SENT_INVOICE_EDIT,
                print: toolKeys.MP_SENT_INVOICE_PRINT,
            }), tap((authorizedButtons) => {
                this.columnActions = {
                    invoiceNumber: authorizedButtons.print && !this.draftInvoice
                        ? {
                            link: () => ({ path: './' }),
                            event: (sentInvoice) => ({
                                data: { sentInvoice },
                                eventType: EventType.PRINT,
                            }),
                        }
                        : {},
                    warnings: {
                        link: () => {
                            return { path: './' };
                        },
                        event: (sentInvoice) => ({
                            data: { sentInvoice },
                            eventType: EventType.WARNINGS,
                        }),
                        icon: 'exclamation-triangle',
                        styleClass: 'warnings-icon',
                    },
                    attachmentCount: authorizedButtons.print
                        ? {
                            link: () => {
                                return { path: './' };
                            },
                            event: (sentInvoice) => ({
                                data: { sentInvoice },
                                eventType: EventType.ATTACHMENT,
                            }),
                            icon: 'paperclip',
                            styleClass: 'column-icon',
                        }
                        : {
                            link: () => {
                                return { path: './' };
                            },
                            event: (sentInvoice) => ({
                                data: { sentInvoice },
                                eventType: EventType.DISABLED,
                            }),
                            icon: 'paperclip',
                            styleClass: 'column-icon disabled',
                        },
                };
            }))
                .subscribe(), this.store
                .pipe(select(selectors.userProfile), tap((user) => {
                this.email = user.sub;
            }))
                .subscribe());
            this.selectedPrintOptions = yield this.printOptionsService.get('invoice', toolKeys.MP_SENT_INVOICE_PRINT);
            this.wizardConfig = wizardConfig$1(this.translocoService, this.mp.getConfig().connectors);
            this.newInvoiceService.baseUrl = this.baseUrl;
        });
    }
    searchContainerEvent({ data, eventType }) {
        const { sentInvoice } = data;
        switch (eventType) {
            case EventType.PRINT:
                this.print(sentInvoice);
                break;
            case EventType.WARNINGS:
                const key = sentInvoice === null || sentInvoice === void 0 ? void 0 : sentInvoice.invoiceKey;
                this.warningsDialogWizard = {
                    endpoint: `sentinvoice/invoice/warning/form`,
                    httpMethod: HttpMethod.POST,
                    body: {
                        keys: [key],
                    },
                };
                this.showWarningsDialog = true;
                break;
            case EventType.ATTACHMENT:
                const invoiceKey = sentInvoice === null || sentInvoice === void 0 ? void 0 : sentInvoice.invoiceKey;
                this.popupService.openWizard({
                    endpoint: `/sentInvoice/ui/invoice/${invoiceKey}/attachments`,
                    httpMethod: HttpMethod.POST,
                    body: {},
                });
                break;
            default:
                break;
        }
    }
    closeWarningsDialog() {
        this.searchContainerLoaderService.refreshSearch();
        this.showWarningsDialog = false;
    }
    submitWarningsDialog(event) {
        this.showWarningsDialog = false;
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.searchContainerLoaderService.refreshSearch();
    }
    print(sentInvoice) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `invoice/${sentInvoice === null || sentInvoice === void 0 ? void 0 : sentInvoice.invoiceKey}/print`,
            httpMethod: 'GET',
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
            .subscribe();
    }
    data(_) {
        this.showWizard = false;
    }
    cancel() {
        this.showWizard = false;
    }
    // if triggered from bulk print then it also prints the selected documents
    updatePrintOptions(selectedPrintOptions) {
        this.selectedPrintOptions = selectedPrintOptions;
        if (this.triggeredByPrint) {
            this.bulkPrint();
        }
        this.closePrintOptionsDialog();
    }
    bulkPrint() {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `invoice/print`,
            httpMethod: 'POST',
            body: this.invoicesToPrint,
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            var _a;
            ((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) === 1
                ? saveAs(response, 'MergedDocuments')
                : this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.invoicesToPrint = [];
            this.triggeredByPrint = false;
            this.spinner.off();
        }))
            .subscribe();
    }
    closePrintOptionsDialog() {
        this.showPrintOptionsDialog = false;
    }
    openPdfViewer(data) {
        const ref = this.dialogService.open(PdfViewerComponent, {
            data: {
                response: data,
            },
            styleClass: 'pdf-viewer',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
    }
    openExport() {
        const ref = this.dialogService.open(ExportComponent, {
            data: {
                endpoint: `${this.baseUrl}/export/form`,
            },
            showHeader: false,
            styleClass: 'export-dialog',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
        const refSubscription = ref.onClose
            .pipe(mergeMap((exportOptions) => exportOptions ? this.submitExport(exportOptions) : EMPTY), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
            .subscribe();
        this.subscriptions = [...this.subscriptions, refSubscription];
    }
    submitExport(exportOptions) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.http.baseUrl = `${this.mp.getConfig().sentInvoice}/invoice/export`;
        this.spinner.on();
        return this.http
            .fetchWithFqn({
            endpoint: `${this.mp.getConfig().sentInvoice}/invoice/export`,
            httpMethod: 'POST',
            body: Object.assign(Object.assign({}, exportOptions), { email: this.email, toolkeys: '', keys: [...this.selections].map((_a) => {
                    var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                    return invoiceKey;
                }), page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows }, sort: {
                    field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                    order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                }, search: {
                    filters: this.searchContainerLoaderService.filters,
                    term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
                } }),
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()));
    }
    openDataGenius() {
        const ref = this.dialogService.open(DataGeniusSelectionComponent, {
            showHeader: false,
            styleClass: 'export-dialog',
            data: {
                selectionCount: this.selections.length,
            },
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
        const refSubscription = ref.onClose
            .pipe(mergeMap((dgOptions) => dgOptions ? this.submitDataGenius(dgOptions) : EMPTY), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
            .subscribe();
        this.subscriptions = [...this.subscriptions, refSubscription];
    }
    submitDataGenius(dgOptions) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.spinner.on();
        return this.http
            .fetchWithFqn({
            endpoint: `${this.mp.getConfig().sentInvoice}/invoice/rundatagenius`,
            httpMethod: 'POST',
            body: Object.assign(Object.assign({}, dgOptions), { keys: [...this.selections].map((_a) => {
                    var { invoiceKey } = _a, _ = __rest(_a, ["invoiceKey"]);
                    return invoiceKey;
                }), page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows }, sort: {
                    field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                    order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                }, search: {
                    filters: this.searchContainerLoaderService.filters,
                    term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
                } }),
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()));
    }
    ngOnDestroy() {
        this.dynamicDialogRefs.forEach((ref) => ref.destroy());
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
    closeDisplayLog() {
        this.showDisplayLog = false;
    }
    closeEdit() {
        this.showEditDialog = false;
    }
    submitEdit(event) {
        this.showEditDialog = false;
        this.searchContainerLoaderService.refreshSearch();
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
    closeNewInvoice() {
        this.showInvoiceQuestionDialog = false;
    }
    closeReImport() {
        this.showReImportDialog = false;
    }
    submitReImport(event) {
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.showReImportDialog = false;
    }
    closeOnReverseWriteOffDialog(event) {
        this.showReverseWriteOffDialog = false;
    }
    submitOnReverseWriteOffDialog(options) {
        this.showReverseWriteOffDialog = false;
        this.searchContainerLoaderService.refreshSearch();
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
    closeOnWriteOffDialog(event) {
        this.showWriteOffDialog = false;
    }
    submitOnWriteOffDialog(options) {
        this.showWriteOffDialog = false;
        this.searchContainerLoaderService.refreshSearch();
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
    checkInvoicePermissions() { }
    navigateNewInvoice() {
        this.newInvoiceService.redirectUrl =
            '/MarketplaceModule/accounts-receivable/invoices';
        if (this.invoiceEntryRadioSelection === 'quickEntry') {
            this.navigateToSummaryInvoice();
        }
        else if (this.invoiceEntryRadioSelection === 'fullEntry') {
            this.navigateToDetailInvoice();
        }
    }
    navigateToSummaryInvoice() {
        this.router.navigate(['../new-invoice'], { relativeTo: this.route });
    }
    navigateToDetailInvoice() {
        this.newInvoiceService.baseUrl = this.newInvoiceUrl;
        this.newInvoiceService.newInvoiceWizard = {
            endpoint: `sentinvoice/form/invoice/entry`,
            httpMethod: HttpMethod.POST,
        };
        this.router.navigate(['../full-invoice'], { relativeTo: this.route });
    }
    navigateNewDraftInvoice() {
        this.newInvoiceService.redirectUrl =
            '/MarketplaceModule/accounts-receivable/draft-invoice';
        this.newInvoiceService.baseUrl = this.newInvoiceUrl;
        if (this.invoiceEntryRadioSelection === 'quickEntry') {
            this.navigateToDraftSummaryInvoice();
        }
        else if (this.invoiceEntryRadioSelection === 'fullEntry') {
            this.navigateToDraftDetailInvoice();
        }
    }
    closeNewDraftInvoice() {
        this.showDraftInvoiceQuestionDialog = false;
    }
    navigateToDraftSummaryInvoice() {
        this.newInvoiceService.redirectUrl =
            '/MarketplaceModule/accounts-receivable/draft-invoice';
        this.newInvoiceService.newInvoiceWizard = {
            endpoint: `sentinvoice/ui/draft/new/summary`,
            httpMethod: HttpMethod.POST,
        };
        this.router.navigate(['../full-invoice'], { relativeTo: this.route });
    }
    navigateToDraftDetailInvoice() {
        this.newInvoiceService.redirectUrl =
            '/MarketplaceModule/accounts-receivable/draft-invoice';
        this.newInvoiceService.newInvoiceWizard = {
            endpoint: `sentinvoice/ui/draft/new/detail`,
            httpMethod: HttpMethod.POST,
        };
        this.router.navigate(['../full-invoice'], { relativeTo: this.route });
    }
    closeActionLogs() {
        this.showActionLogs = false;
    }
    submitActionLogs(event) {
        this.showActionLogs = false;
        this.searchContainerLoaderService.refreshSearch();
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
    closeDraftPromote() {
        this.showDraftPromoteDialog = false;
    }
    submitDraftPromote(event) {
        this.showDraftPromoteDialog = false;
        this.searchContainerLoaderService.refreshSearch();
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
};
SentInvoiceComponent.ctorParameters = () => [
    { type: ConfirmationService },
    { type: DialogService },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: Store },
    { type: GenerateFormService },
    { type: Router },
    { type: ActivatedRoute },
    { type: NewInvoiceService },
    { type: PrintOptionsService },
    { type: PopupService }
];
SentInvoiceComponent = __decorate([
    Component({
        selector: 'lib-sent-invoice',
        template: "<div class=\"view-invoices\">\r\n  <div class=\"dashboard\" *ngIf=\"!draftInvoice; else draftTemplate\">\r\n    <lib-dashboard-container\r\n      [dashBoardStateKey]=\"dashBoardStateKey\"\r\n      [dashBoardVisibilityStateKey]=\"dashBoardVisibilityStateKey\"\r\n      [dashBoardHeader]=\"'INVOICE.INVOICE'\"\r\n      [categoryFilter]=\"categoryFilter\"\r\n      [showCategories]=\"showCategories\"\r\n      [defaultDashboardState]=\"defaultDashboardState\"\r\n    ></lib-dashboard-container>\r\n  </div>\r\n\r\n  <ng-template #draftTemplate>\r\n    <h2>{{ 'BREADCRUMB.DRAFT_INVOICES' | transloco }}</h2>\r\n  </ng-template>\r\n\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"baseUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n\r\n  <p-dialog\r\n    *ngIf=\"showWizard\"\r\n    [visible]=\"true\"\r\n    [showHeader]=\"false\"\r\n    [modal]=\"true\"\r\n    position=\"center\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [responsive]=\"true\"\r\n    [focusOnShow]=\"false\"\r\n    [styleClass]=\"\r\n      wizardPage === 0 ? 'lbmx-modal visible-dropdown' : 'lbmx-modal'\r\n    \"\r\n  >\r\n    <lib-wizard\r\n      [wizardConfig]=\"wizardConfig\"\r\n      [defaultState]=\"defaultState\"\r\n      (finalize)=\"data($event)\"\r\n      (cancel)=\"cancel()\"\r\n      (page)=\"wizardPage = $event\"\r\n    ></lib-wizard>\r\n  </p-dialog>\r\n\r\n  <p-dialog\r\n    *ngIf=\"showPrintOptionsDialog\"\r\n    [visible]=\"true\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '520px' }\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [showHeader]=\"false\"\r\n    [focusOnShow]=\"false\"\r\n    position=\"center\"\r\n  >\r\n    <lib-print-options-container\r\n      [baseUrl]=\"baseUrl\"\r\n      [selectedPrintOptions]=\"selectedPrintOptions\"\r\n      (closeDialog)=\"closePrintOptionsDialog()\"\r\n      (updatePrintOptions)=\"updatePrintOptions($event)\"\r\n    ></lib-print-options-container>\r\n  </p-dialog>\r\n\r\n  <p-dialog\r\n    *ngIf=\"showWarningsDialog\"\r\n    [visible]=\"true\"\r\n    [modal]=\"true\"\r\n    [style]=\"{ width: '50vw' }\"\r\n    [autoZIndex]=\"false\"\r\n    [baseZIndex]=\"10000\"\r\n    [draggable]=\"false\"\r\n    [resizable]=\"false\"\r\n    [showHeader]=\"false\"\r\n    [focusOnShow]=\"false\"\r\n    position=\"center\"\r\n  >\r\n    <lui-wizard-v3\r\n      [baseUrl]=\"newInvoiceUrl\"\r\n      [wizardConfig]=\"warningsDialogWizard\"\r\n      (submit)=\"submitWarningsDialog($event)\"\r\n      (cancel)=\"closeWarningsDialog()\"\r\n    >\r\n      <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n        <div\r\n          class=\"error\"\r\n          style=\"\r\n            min-height: 30vh;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n          \"\r\n        >\r\n          <div>\r\n            <span>\r\n              <i class=\"pi pi-times-circle\"></i>\r\n              {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n            </span>\r\n          </div>\r\n        </div>\r\n        <button pButton (click)=\"closeWarningsDialog()\" class=\"ds secondary\">\r\n          {{ 'ACTIONS.CANCEL' | transloco }}\r\n        </button>\r\n      </ng-template>\r\n    </lui-wizard-v3>\r\n  </p-dialog>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showDisplayLog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-logging\r\n    [baseUrl]=\"loggingUrl\"\r\n    [batchKey]=\"batchKey\"\r\n    (closeLogDialog)=\"closeDisplayLog()\"\r\n  >\r\n  </lib-logging>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showEditDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [autoZIndex]=\"false\"\r\n  [baseZIndex]=\"9\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n  [styleClass]=\"'visible-dropdown edit-invoice-container'\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"newInvoiceUrl\"\r\n    [wizardConfig]=\"editInvoiceWizard\"\r\n    (submit)=\"submitEdit($event)\"\r\n    (cancel)=\"closeEdit()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeEdit()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showReImportDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [autoZIndex]=\"false\"\r\n  [baseZIndex]=\"9\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n  [styleClass]=\"'visible-dropdown edit-invoice-container'\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"newInvoiceUrl\"\r\n    [wizardConfig]=\"reImportWizard\"\r\n    (submit)=\"submitReImport($event)\"\r\n    (cancel)=\"closeReImport()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeReImport()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showWriteOffDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"wizardBaseUrl\"\r\n    [wizardConfig]=\"writeOffWizard\"\r\n    (submit)=\"submitOnWriteOffDialog($event)\"\r\n    (cancel)=\"closeOnWriteOffDialog()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n      <div>\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeOnWriteOffDialog()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showReverseWriteOffDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"wizardBaseUrl\"\r\n    [wizardConfig]=\"reverseWriteOffwizard\"\r\n    (submit)=\"submitOnReverseWriteOffDialog($event)\"\r\n    (cancel)=\"closeOnReverseWriteOffDialog()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n      <div>\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button\r\n        pButton\r\n        (click)=\"closeOnReverseWriteOffDialog()\"\r\n        class=\"ds secondary\"\r\n      >\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showDraftInvoiceQuestionDialog && ableToRenderInvoiceQuestion\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '25vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <div style=\"justify-content: center; display: flex\">\r\n    <h2>{{ 'INVOICE.NEW_INVOICE' | transloco }}</h2>\r\n  </div>\r\n\r\n  <div style=\"justify-content: center; display: flex\">\r\n    {{ 'INVOICE.NEW_INVOICE_MESSAGE' | transloco }}\r\n  </div>\r\n  <div style=\"padding-bottom: 0.5em; padding-top: 1em\">\r\n    <p-radioButton\r\n      name=\"entry\"\r\n      value=\"fullEntry\"\r\n      label=\"Detail Invoice\"\r\n      [(ngModel)]=\"invoiceEntryRadioSelection\"\r\n    ></p-radioButton>\r\n  </div>\r\n  <div style=\"padding-bottom: 1em\">\r\n    <p-radioButton\r\n      name=\"entry\"\r\n      value=\"quickEntry\"\r\n      label=\"Summary Invoice\"\r\n      [(ngModel)]=\"invoiceEntryRadioSelection\"\r\n    ></p-radioButton>\r\n  </div>\r\n  <div class=\"contols\" style=\"display: flex; gap: 0.5em; padding-top: 1em\">\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      (click)=\"closeNewDraftInvoice()\"\r\n    ></button>\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.NEXT' | transloco }}\"\r\n      class=\"ds\"\r\n      [disabled]=\"!invoiceEntryRadioSelection\"\r\n      (click)=\"navigateNewDraftInvoice()\"\r\n      style=\"flex-grow: 1\"\r\n    ></button>\r\n  </div>\r\n</p-dialog>\r\n<p-dialog\r\n  *ngIf=\"showInvoiceQuestionDialog && ableToRenderInvoiceQuestion\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '25vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <div style=\"justify-content: center; display: flex\">\r\n    <h2>{{ 'INVOICE.NEW_INVOICE' | transloco }}</h2>\r\n  </div>\r\n\r\n  <div style=\"justify-content: center; display: flex\">\r\n    {{ 'INVOICE.NEW_INVOICE_MESSAGE' | transloco }}\r\n  </div>\r\n  <div style=\"padding-bottom: 0.5em; padding-top: 1em\">\r\n    <p-radioButton\r\n      name=\"entry\"\r\n      value=\"fullEntry\"\r\n      label=\"Detail Invoice\"\r\n      [(ngModel)]=\"invoiceEntryRadioSelection\"\r\n    ></p-radioButton>\r\n  </div>\r\n  <div style=\"padding-bottom: 1em\">\r\n    <p-radioButton\r\n      name=\"entry\"\r\n      value=\"quickEntry\"\r\n      label=\"Summary Invoice\"\r\n      [(ngModel)]=\"invoiceEntryRadioSelection\"\r\n    ></p-radioButton>\r\n  </div>\r\n  <div class=\"contols\" style=\"display: flex; gap: 0.5em; padding-top: 1em\">\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      (click)=\"closeNewInvoice()\"\r\n    ></button>\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.NEXT' | transloco }}\"\r\n      class=\"ds\"\r\n      (click)=\"navigateNewInvoice()\"\r\n      style=\"flex-grow: 1\"\r\n    ></button>\r\n  </div>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showDraftPromoteDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"newInvoiceUrl\"\r\n    [wizardConfig]=\"draftPromoteWizard\"\r\n    (submit)=\"submitDraftPromote($event)\"\r\n    (cancel)=\"closeDraftPromote()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n      <div>\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeDraftPromote()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showActionLogs\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"wizardBaseUrl\"\r\n    [wizardConfig]=\"actionLogsWizard\"\r\n    (submit)=\"submitActionLogs($event)\"\r\n    (cancel)=\"closeActionLogs()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n      <div>\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeActionLogs()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, DialogService],
        styles: [""]
    })
], SentInvoiceComponent);

const ɵ0$r = {
    breadcrumb: {
        label: 'BREADCRUMB.INVOICES',
        disable: true,
    },
}, ɵ1$9 = {
    breadcrumb: {
        label: 'BREADCRUMB.DRAFT_INVOICES',
        disable: true,
    },
}, ɵ2$7 = {
    breadcrumb: {
        label: 'BREADCRUMB.INVOICES',
        disable: true,
    },
}, ɵ3$4 = {
    breadcrumb: {
        label: 'BREADCRUMB.INVOICES',
        disable: true,
    },
};
const routes$n = [
    {
        path: 'invoices',
        data: ɵ0$r,
        component: SentInvoiceComponent,
    },
    {
        path: 'draft-invoice',
        data: ɵ1$9,
        component: SentInvoiceComponent,
    },
    {
        path: 'new-invoice',
        data: ɵ2$7,
        component: NewInvoiceComponent,
        canDeactivate: [CanDeactivateGuard],
    },
    {
        path: 'full-invoice',
        data: ɵ3$4,
        component: FullInvoiceEntryComponent,
        canDeactivate: [CanDeactivateGuard],
    },
];

let SentPADComponent = class SentPADComponent {
    constructor(dialogService, confirmationService, mp, http, spinner, searchContainerLoaderService, translocoService, toast, store, printOptionsService) {
        this.dialogService = dialogService;
        this.confirmationService = confirmationService;
        this.mp = mp;
        this.http = http;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.store = store;
        this.printOptionsService = printOptionsService;
        this.baseUrl = `${this.mp.getConfig().sentPad}`;
        this.searchUrl = `${this.baseUrl}/pad`;
        this.columnActions = {};
        // print states
        this.showPrintOptionsDialog = false;
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        this.padsToPrint = [];
        // Search container states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'padSentSearch';
        this.i18nSearchField = 'MARKETPLACE.PRODUCT_ACTIVITY_REPORT_SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {
            printOptions: (selection) => {
                this.showPrintOptionsDialog = true;
            },
            print: (selection) => {
                var _a;
                this.padsToPrint = [...selection].map((_a) => {
                    var { padKey } = _a, _ = __rest(_a, ["padKey"]);
                    return padKey;
                });
                if (((_a = Object.keys(this.selectedPrintOptions || {})) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.bulkPrint();
                }
                else {
                    this.triggeredByPrint = true;
                    this.showPrintOptionsDialog = true;
                }
            },
        };
        http.baseUrl = this.baseUrl;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.push(this.store
                .pipe(select(selectors.isAuthorized, {
                edit: toolKeys.MP_SENT_PAD_EDIT,
                print: toolKeys.MP_SENT_PAD_PRINT,
            }), tap((authorizedButtons) => {
                this.columnActions = {
                    purchaseOrderNumber: authorizedButtons.print
                        ? {
                            link: () => ({ path: './' }),
                            event: (sentPad) => ({
                                data: { sentPad },
                                eventType: EventType.PRINT,
                            }),
                        }
                        : {},
                };
            }))
                .subscribe());
            this.selectedPrintOptions = yield this.printOptionsService.get('pad', toolKeys.MP_SENT_PAD_PRINT);
        });
    }
    bulkPrint() {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `pad/print`,
            httpMethod: 'POST',
            body: this.padsToPrint,
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            var _a;
            ((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) === 1
                ? saveAs(response, 'MergedDocuments')
                : this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.padsToPrint = [];
            this.triggeredByPrint = false;
            this.spinner.off();
        }))
            .subscribe();
    }
    searchContainerEvent({ data, eventType }) {
        const { sentPad } = data;
        switch (eventType) {
            case EventType.PRINT:
                this.print(sentPad);
                break;
            default:
                break;
        }
    }
    print(sentPad) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `pad/${sentPad === null || sentPad === void 0 ? void 0 : sentPad.padKey}/print`,
            httpMethod: 'GET',
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
            .subscribe();
    }
    openPdfViewer(data) {
        const ref = this.dialogService.open(PdfViewerComponent, {
            data: {
                response: data,
            },
            styleClass: 'pdf-viewer',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
    }
    closePrintOptionsDialog() {
        this.showPrintOptionsDialog = false;
    }
    updatePrintOptions(selectedPrintOptions) {
        this.selectedPrintOptions = selectedPrintOptions;
        if (this.triggeredByPrint) {
            this.bulkPrint();
        }
        this.closePrintOptionsDialog();
    }
};
SentPADComponent.ctorParameters = () => [
    { type: DialogService },
    { type: ConfirmationService$1 },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: Store },
    { type: PrintOptionsService }
];
SentPADComponent = __decorate([
    Component({
        selector: 'lib-sent-pad',
        template: "<div class=\"view-remittances\">\r\n  <h2>{{ 'BREADCRUMB.PRODUCT_ACTIVITY_REPORT' | transloco }}</h2>\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"searchUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showPrintOptionsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-print-options-container\r\n    [baseUrl]=\"searchUrl\"\r\n    [selectedPrintOptions]=\"selectedPrintOptions\"\r\n    (closeDialog)=\"closePrintOptionsDialog()\"\r\n    (updatePrintOptions)=\"updatePrintOptions($event)\"\r\n  ></lib-print-options-container>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, DialogService],
        styles: [""]
    })
], SentPADComponent);

const ɵ0$s = { breadcrumb: 'BREADCRUMB.PRODUCT_ACTIVITY_REPORT' };
const routes$o = [
    {
        path: 'pad-sent',
        component: SentPADComponent,
        data: ɵ0$s,
    },
];

let SentPoComponent = class SentPoComponent {
    constructor(confirmationService, dialogService, mp, http, translocoService, toast, spinner, searchContainerLoaderService, store, printOptionsService) {
        this.confirmationService = confirmationService;
        this.dialogService = dialogService;
        this.mp = mp;
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.store = store;
        this.printOptionsService = printOptionsService;
        this.templateTypes = TemplateTypes;
        // kpi dashboard states
        this.dashBoardStateKey = 'sentPoDashboardState';
        this.dashBoardVisibilityStateKey = 'sentPoDashboardVisibilityState';
        this.categoryFilter = ['orderingReceiving'];
        this.showCategories = false;
        this.defaultDashboardState = defaultDashboardState;
        // Warnings state
        this.showWarningsDialog = false;
        // Warnings List states
        this.showWarningsListDialog = false;
        this.warningSelections = [];
        this.warningsConfirmationLabels = {
            header: 'Clear Warnings',
            message: 'Are you sure you want to clear the selected warnings?',
            acceptLabel: 'Yes',
            rejectLabel: 'No',
        };
        // public warningsConfirmationLabels = {
        //   header: this.translocoService.translate('WARNINGS.CLEAR_WARNINGS'),
        //   message: this.translocoService.translate('WARNINGS.CONFIRMATION'),
        //   acceptLabel: this.translocoService.translate('WARNINGS.ACCEPT_LABEL'),
        //   rejectLabel: this.translocoService.translate('WARNINGS.REJECT_LABEL'),
        // };
        // print states
        this.showPrintOptionsDialog = false;
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        this.posToPrint = [];
        // display log states
        this.showDisplayLog = false;
        this.batchKey = 0;
        this.loggingUrl = '';
        // Action logs
        this.showActionLogs = false;
        // re import states
        this.showReImportDialog = false;
        // search container loader states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'sentPOSearch';
        this.i18nSearchField = 'SENT_PURCHASE_ORDER.SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {
            printOptions: (selection) => {
                this.showPrintOptionsDialog = true;
            },
            poImport: (selection) => {
                this.showWizard = true;
            },
            print: (selection) => {
                var _a;
                this.posToPrint = [...selection].map((_a) => {
                    var { poKey } = _a, _ = __rest(_a, ["poKey"]);
                    return poKey;
                });
                if (((_a = Object.keys(this.selectedPrintOptions || {})) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.bulkPrint();
                }
                else {
                    this.triggeredByPrint = true;
                    this.showPrintOptionsDialog = true;
                }
            },
            markProcessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('SENT_PURCHASE_ORDER.PROCESSED_MESSAGE'),
                    header: this.translocoService.translate('SENT_PURCHASE_ORDER.PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.http
                            .fetch(bulkUpdateConfig(selection))
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                        }), this._searchContainerPipe())
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            export: (selection) => {
                this.selections = selection;
                this.openExport();
            },
            displayLog: (selection) => {
                var _a;
                this.batchKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.poKey;
                this.loggingUrl = `${this.mp.getConfig().sentPo}/pohistory/${this.batchKey}/form`;
                this.showDisplayLog = true;
            },
            warnings: (selection) => {
                this.warningSelections = [...selection].map((_a) => {
                    var { poKey } = _a, _ = __rest(_a, ["poKey"]);
                    return poKey;
                });
                this.warningsDialogWizard = {
                    endpoint: `sentpo/po/warning/form`,
                    httpMethod: HttpMethod$2.POST,
                    body: {
                        keys: this.warningSelections,
                    },
                };
                this.showWarningsDialog = true;
            },
            reImport: (selection) => {
                this.showReImportDialog = true;
                this.reImportWizard = {
                    endpoint: `FormSentPO/repull`,
                    httpMethod: HttpMethod$2.POST,
                    body: {
                        poKeys: [...selection].map((_a) => {
                            var { poKey } = _a, _ = __rest(_a, ["poKey"]);
                            return poKey;
                        }),
                    },
                };
            },
            runDataGenius: (selection) => {
                this.selections = selection;
                this.openDataGenius();
            },
            actionLogs: (selection) => {
                var _a;
                const poKey = (_a = selection[0]) === null || _a === void 0 ? void 0 : _a.poKey;
                this.actionLogsWizard = {
                    endpoint: `/${poKey}/actionlogs/form`,
                    httpMethod: HttpMethod$2.GET,
                };
                this.showActionLogs = true;
            },
        };
        this.baseUrl = `${this.mp.getConfig().sentPo}/po`;
        this.apiBaseUrl = `${this.mp.getConfig().apiBaseUrl}`;
        this.warningsBaseUrl = `${this.mp.getConfig().sentPo}`;
        this.warningsUrl = `/warning/form`;
        this.warningsSubmitUrl = `/warning/clear`;
        this.wizardUrl = `${this.mp.getConfig().connectorEndpoint}`;
        this.columnActions = {};
        this.defaultState = {
            page: 0,
            title: 'SUPPLIER.IMPORT',
            screens: {},
        };
        this.showWizard = false;
        this.wizardPage = 0;
        this.email = '';
        http.baseUrl = mp.getConfig().sentPo;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.push(this.store
                .pipe(select(selectors.isAuthorized, {
                edit: toolKeys.MP_Sent_PO_VIEW,
                print: toolKeys.MP_SENT_PO_PRINT,
            }), tap((authorizedButtons) => {
                this.columnActions = {
                    poNumber: authorizedButtons.print
                        ? {
                            link: () => {
                                return { path: './' };
                            },
                            event: (sentPo) => ({
                                data: { sentPo },
                                eventType: EventType.PRINT,
                            }),
                        }
                        : {},
                    warnings: {
                        link: () => {
                            return { path: './' };
                        },
                        event: (sentPo) => ({
                            data: { sentPo },
                            eventType: EventType.WARNINGS,
                        }),
                        icon: 'exclamation-triangle',
                        styleClass: 'warnings-icon',
                    },
                };
            }))
                .subscribe(), this.store
                .pipe(select(selectors.userProfile), tap((user) => {
                this.email = user.sub;
            }))
                .subscribe());
            this.selectedPrintOptions = yield this.printOptionsService.get('po', toolKeys.MP_SENT_PO_PRINT);
            this.wizardConfig = wizardConfig(this.translocoService, this.mp.getConfig().connectors);
        });
    }
    searchContainerEvent({ data, eventType }) {
        const { sentPo } = data;
        switch (eventType) {
            case EventType.PRINT:
                this.print(sentPo);
                break;
            case EventType.WARNINGS:
                this.selectedPoKey = sentPo === null || sentPo === void 0 ? void 0 : sentPo.poKey;
                this.warningsDialogWizard = {
                    endpoint: `sentpo/po/warning/form`,
                    httpMethod: HttpMethod$2.POST,
                    body: {
                        keys: [this.selectedPoKey],
                    },
                };
                this.showWarningsDialog = true;
                break;
            default:
                break;
        }
    }
    print(sentPo) {
        this.http
            .fetch(printConfig(sentPo))
            .pipe(tap((response) => {
            this.openPdfViewer(response);
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        }), this._searchContainerPipe())
            .subscribe();
    }
    // if triggered from bulk print then it also prints the selected documents
    updatePrintOptions(selectedPrintOptions) {
        this.closePrintOptionsDialog();
        this.selectedPrintOptions = selectedPrintOptions;
        if (this.triggeredByPrint) {
            this.bulkPrint();
        }
    }
    closePrintOptionsDialog() {
        this.showPrintOptionsDialog = false;
    }
    closeWarningsDialog() {
        this.searchContainerLoaderService.refreshSearch();
        this.showWarningsDialog = false;
    }
    submitWarningsDialog(event) {
        this.showWarningsDialog = false;
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.searchContainerLoaderService.refreshSearch();
    }
    bulkPrint() {
        this.http
            .fetch(bulkPrintConfig(this.posToPrint))
            .pipe(tap((response) => {
            var _a;
            ((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) === 1
                ? saveAs(response, 'MergedDocuments')
                : this.openPdfViewer(response);
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        }), this._searchContainerPipe(), finalize(() => {
            this.posToPrint = [];
            this.triggeredByPrint = false;
        }))
            .subscribe();
    }
    _searchContainerPipe() {
        return searchContainerPipe(this.searchContainerLoaderService, this.spinner, this.toast, this.translocoService);
    }
    openPdfViewer(data) {
        const ref = this.dialogService.open(PdfViewerComponent, {
            data: {
                response: data,
            },
            styleClass: 'pdf-viewer',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
    }
    openExport() {
        const ref = this.dialogService.open(ExportComponent, {
            data: {
                endpoint: `${this.baseUrl}/export/form`,
            },
            showHeader: false,
            styleClass: 'export-dialog',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
        const refSubscription = ref.onClose
            .pipe(mergeMap((exportOptions) => exportOptions ? this.submitExport(exportOptions) : EMPTY), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
            .subscribe();
        this.subscriptions = [...this.subscriptions, refSubscription];
    }
    submitExport(exportOptions) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.spinner.on();
        return this.http
            .fetchWithFqn({
            endpoint: `${this.mp.getConfig().sentPo}/po/export`,
            httpMethod: 'POST',
            body: Object.assign(Object.assign({}, exportOptions), { email: this.email, toolkeys: '', keys: [...this.selections].map((_a) => {
                    var { poKey } = _a, _ = __rest(_a, ["poKey"]);
                    return poKey;
                }), page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows }, sort: {
                    field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                    order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                }, search: {
                    filters: this.searchContainerLoaderService.filters,
                    term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
                } }),
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()));
    }
    ngOnDestroy() {
        this.dynamicDialogRefs.forEach((ref) => ref.destroy());
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
    data(_) {
        this.showWizard = false;
    }
    cancel() {
        this.showWizard = false;
    }
    closeDisplayLog() {
        this.showDisplayLog = false;
    }
    closeReImport() {
        this.showReImportDialog = false;
    }
    submitReImport(event) {
        this.showReImportDialog = false;
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
        this.searchContainerLoaderService.refreshSearch();
    }
    closeActionLogs() {
        this.showActionLogs = false;
    }
    submitActionLogs(options) {
        this.showActionLogs = false;
        this.searchContainerLoaderService.refreshSearch();
        this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
    }
    openDataGenius() {
        const ref = this.dialogService.open(DataGeniusSelectionComponent, {
            showHeader: false,
            styleClass: 'export-dialog',
            data: {
                selectionCount: this.selections.length,
            },
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
        const refSubscription = ref.onClose
            .pipe(mergeMap((dgOptions) => dgOptions ? this.submitDataGenius(dgOptions) : EMPTY), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))))
            .subscribe();
        this.subscriptions = [...this.subscriptions, refSubscription];
    }
    submitDataGenius(dgOptions) {
        const _a = this.searchContainerLoaderService.getCurrentSearchDetails(), { filters } = _a, pagination = __rest(_a, ["filters"]);
        this.spinner.on();
        return this.http
            .fetchWithFqn({
            endpoint: `${this.mp.getConfig().sentPo}/po/rundatagenius`,
            httpMethod: 'POST',
            body: Object.assign(Object.assign({}, dgOptions), { keys: [...this.selections].map((_a) => {
                    var { poKey } = _a, _ = __rest(_a, ["poKey"]);
                    return poKey;
                }), page: { offset: pagination === null || pagination === void 0 ? void 0 : pagination.first, limit: pagination === null || pagination === void 0 ? void 0 : pagination.rows }, sort: {
                    field: pagination === null || pagination === void 0 ? void 0 : pagination.sortField,
                    order: pagination === null || pagination === void 0 ? void 0 : pagination.sortOrder,
                }, search: {
                    filters: this.searchContainerLoaderService.filters,
                    term: (filters === null || filters === void 0 ? void 0 : filters.term) ? filters === null || filters === void 0 ? void 0 : filters.term : '',
                } }),
        })
            .pipe(tap(() => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()));
    }
};
SentPoComponent.ctorParameters = () => [
    { type: ConfirmationService },
    { type: DialogService },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: Store },
    { type: PrintOptionsService }
];
SentPoComponent = __decorate([
    Component({
        selector: 'lib-sent-po-beta',
        template: "<div class=\"view-invoices\">\r\n  <div class=\"dashboard\">\r\n    <lib-dashboard-container\r\n      [dashBoardStateKey]=\"dashBoardStateKey\"\r\n      [dashBoardVisibilityStateKey]=\"dashBoardVisibilityStateKey\"\r\n      [dashBoardHeader]=\"'SENT_PURCHASE_ORDER.SENT_PO'\"\r\n      [categoryFilter]=\"categoryFilter\"\r\n      [showCategories]=\"showCategories\"\r\n      [defaultDashboardState]=\"defaultDashboardState\"\r\n    ></lib-dashboard-container>\r\n  </div>\r\n\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"baseUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showPrintOptionsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-print-options-container\r\n    [baseUrl]=\"baseUrl\"\r\n    [selectedPrintOptions]=\"selectedPrintOptions\"\r\n    (closeDialog)=\"closePrintOptionsDialog()\"\r\n    (updatePrintOptions)=\"updatePrintOptions($event)\"\r\n  ></lib-print-options-container>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showWarningsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [autoZIndex]=\"false\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"apiBaseUrl\"\r\n    [wizardConfig]=\"warningsDialogWizard\"\r\n    (submit)=\"submitWarningsDialog($event)\"\r\n    (cancel)=\"closeWarningsDialog()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeWarningsDialog()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showWizard\"\r\n  [visible]=\"true\"\r\n  [showHeader]=\"false\"\r\n  [modal]=\"true\"\r\n  position=\"center\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [responsive]=\"true\"\r\n  [focusOnShow]=\"false\"\r\n  [styleClass]=\"wizardPage === 0 ? 'lbmx-modal visible-dropdown' : 'lbmx-modal'\"\r\n>\r\n  <lib-wizard\r\n    [wizardConfig]=\"wizardConfig\"\r\n    [defaultState]=\"defaultState\"\r\n    (finalize)=\"data($event)\"\r\n    (cancel)=\"cancel()\"\r\n    (page)=\"wizardPage = $event\"\r\n  ></lib-wizard>\r\n</p-dialog>\r\n<p-dialog\r\n  *ngIf=\"showDisplayLog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-logging\r\n    [baseUrl]=\"loggingUrl\"\r\n    [batchKey]=\"batchKey\"\r\n    (closeLogDialog)=\"closeDisplayLog()\"\r\n  >\r\n  </lib-logging>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showReImportDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"wizardUrl\"\r\n    [wizardConfig]=\"reImportWizard\"\r\n    (submit)=\"submitReImport($event)\"\r\n    (cancel)=\"closeReImport()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeReImport()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  *ngIf=\"showActionLogs\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '50vw' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lui-wizard-v3\r\n    [baseUrl]=\"baseUrl\"\r\n    [wizardConfig]=\"actionLogsWizard\"\r\n    (submit)=\"submitActionLogs($event)\"\r\n    (cancel)=\"closeActionLogs()\"\r\n  >\r\n    <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n      <div>\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"closeActionLogs()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CANCEL' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n  </lui-wizard-v3>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, DialogService]
    })
], SentPoComponent);

const ɵ0$t = { breadcrumb: 'BREADCRUMB.SENT_PO' };
const routes$p = [
    {
        path: 'sent-po',
        component: SentPoComponent,
        data: ɵ0$t,
    },
];

let SentPsrcComponent = class SentPsrcComponent {
    constructor(dialogService, confirmationService, mp, http, spinner, searchContainerLoaderService, translocoService, toast, store, printOptionsService) {
        this.dialogService = dialogService;
        this.confirmationService = confirmationService;
        this.mp = mp;
        this.http = http;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.store = store;
        this.printOptionsService = printOptionsService;
        this.baseUrl = `${this.mp.getConfig().sentPsrc}`;
        this.searchUrl = `${this.baseUrl}/psrc`;
        this.columnActions = {};
        // print states
        this.showPrintOptionsDialog = false;
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        this.psrcsToPrint = [];
        // Search container states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'psrcsSentSearch';
        this.i18nSearchField = 'PLANNING_SCHEDULE_RELEASE_CAPABILITY.SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {
            printOptions: (selection) => {
                this.showPrintOptionsDialog = true;
            },
            print: (selection) => {
                var _a;
                this.psrcsToPrint = [...selection].map((_a) => {
                    var { psrcKey } = _a, _ = __rest(_a, ["psrcKey"]);
                    return psrcKey;
                });
                if (((_a = Object.keys(this.selectedPrintOptions || {})) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.bulkPrint();
                }
                else {
                    this.triggeredByPrint = true;
                    this.showPrintOptionsDialog = true;
                }
            },
            markRead: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('PSRC_SENT.MARK_READ_MESSAGE'),
                    header: this.translocoService.translate('PSRC_SENT.MARK_READ_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'psrc/mark-read',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { psrcKey } = _a, _ = __rest(_a, ["psrcKey"]);
                                return psrcKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnread: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('PSRC_SENT.MARK_UNREAD_MESSAGE'),
                    header: this.translocoService.translate('PSRC_SENT.MARK_UNREAD_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'psrc/mark-unread',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { psrcKey } = _a, _ = __rest(_a, ["psrcKey"]);
                                return psrcKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
        };
        http.baseUrl = this.baseUrl;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.push(this.store
                .pipe(select(selectors.isAuthorized, {
                edit: toolKeys.MP_SENT_PSRC_EDIT,
                print: toolKeys.MP_SENT_PSRC_PRINT,
            }), tap((authorizedButtons) => {
                this.columnActions = {
                    lbmxDocumentId: authorizedButtons.print
                        ? {
                            link: () => ({ path: './' }),
                            event: (SentPSRC) => ({
                                data: { SentPSRC },
                                eventType: EventType.PRINT,
                            }),
                        }
                        : {},
                };
            }))
                .subscribe());
            this.selectedPrintOptions = yield this.printOptionsService.get('psrc', toolKeys.MP_SENT_PSRC_PRINT);
        });
    }
    bulkPrint() {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `psrc/print`,
            httpMethod: 'POST',
            body: this.psrcsToPrint,
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            var _a;
            ((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) === 1
                ? saveAs(response, 'MergedDocuments')
                : this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.psrcsToPrint = [];
            this.triggeredByPrint = false;
            this.spinner.off();
        }))
            .subscribe();
    }
    openPdfViewer(data) {
        const ref = this.dialogService.open(PdfViewerComponent, {
            data: {
                response: data,
            },
            styleClass: 'pdf-viewer',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
    }
    closePrintOptionsDialog() {
        this.showPrintOptionsDialog = false;
    }
    updatePrintOptions(selectedPrintOptions) {
        this.selectedPrintOptions = selectedPrintOptions;
        if (this.triggeredByPrint) {
            this.bulkPrint();
        }
        this.closePrintOptionsDialog();
    }
    searchContainerEvent({ data, eventType }) {
        const { SentPSRC } = data;
        switch (eventType) {
            case EventType.PRINT:
                this.print(SentPSRC);
                break;
            default:
                break;
        }
    }
    print(SentPSRC) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `psrc/${SentPSRC === null || SentPSRC === void 0 ? void 0 : SentPSRC.psrcKey}/print`,
            httpMethod: 'GET',
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
            .subscribe();
    }
};
SentPsrcComponent.ctorParameters = () => [
    { type: DialogService },
    { type: ConfirmationService$1 },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: Store },
    { type: PrintOptionsService }
];
SentPsrcComponent = __decorate([
    Component({
        selector: 'lib-sent-psrc',
        template: "<div class=\"view-psrcs\">\r\n  <h2>{{ 'BREADCRUMB.PLANNING_SCHEDULE' | transloco }}</h2>\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"searchUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showPrintOptionsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-print-options-container\r\n    [baseUrl]=\"searchUrl\"\r\n    [selectedPrintOptions]=\"selectedPrintOptions\"\r\n    (closeDialog)=\"closePrintOptionsDialog()\"\r\n    (updatePrintOptions)=\"updatePrintOptions($event)\"\r\n  ></lib-print-options-container>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, DialogService]
    })
], SentPsrcComponent);

const ɵ0$u = { breadcrumb: 'BREADCRUMB.SENT_PLANNING_SCHEDULE' };
const routes$q = [
    {
        path: 'sent',
        component: SentPsrcComponent,
        data: ɵ0$u,
    },
];

let ReceivedPsrcComponent = class ReceivedPsrcComponent {
    constructor(dialogService, confirmationService, mp, http, spinner, searchContainerLoaderService, translocoService, toast, store, printOptionsService) {
        this.dialogService = dialogService;
        this.confirmationService = confirmationService;
        this.mp = mp;
        this.http = http;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.store = store;
        this.printOptionsService = printOptionsService;
        this.baseUrl = `${this.mp.getConfig().receivedPsrc}`;
        this.searchUrl = `${this.baseUrl}/psrc`;
        this.columnActions = {};
        // print states
        this.showPrintOptionsDialog = false;
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        this.psrcsToPrint = [];
        // Search container states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'psrcsReceivedSearch';
        this.i18nSearchField = 'PLANNING_SCHEDULE_RELEASE_CAPABILITY.SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {
            printOptions: (selection) => {
                this.showPrintOptionsDialog = true;
            },
            print: (selection) => {
                var _a;
                this.psrcsToPrint = [...selection].map((_a) => {
                    var { psrcKey } = _a, _ = __rest(_a, ["psrcKey"]);
                    return psrcKey;
                });
                if (((_a = Object.keys(this.selectedPrintOptions || {})) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.bulkPrint();
                }
                else {
                    this.triggeredByPrint = true;
                    this.showPrintOptionsDialog = true;
                }
            },
            markProcessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('PSRC_RECEIVED.MARK_PROCESSED_MESSAGE'),
                    header: this.translocoService.translate('PSRC_RECEIVED.MARK_PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'psrc/mark-processed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { psrcKey } = _a, _ = __rest(_a, ["psrcKey"]);
                                return psrcKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnprocessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('PSRC_RECEIVED.MARK_UNPROCESSED_MESSAGE'),
                    header: this.translocoService.translate('PSRC_RECEIVED.MARK_PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'psrc/mark-unprocessed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { psrcKey } = _a, _ = __rest(_a, ["psrcKey"]);
                                return psrcKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markRead: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('PSRC_RECEIVED.MARK_READ_MESSAGE'),
                    header: this.translocoService.translate('PSRC_RECEIVED.MARK_READ_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'psrc/mark-read',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { psrcKey } = _a, _ = __rest(_a, ["psrcKey"]);
                                return psrcKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnread: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('PSRC_RECEIVED.MARK_UNREAD_MESSAGE'),
                    header: this.translocoService.translate('PSRC_RECEIVED.MARK_UNREAD_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'psrc/mark-unread',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { psrcKey } = _a, _ = __rest(_a, ["psrcKey"]);
                                return psrcKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
        };
        http.baseUrl = this.baseUrl;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.push(this.store
                .pipe(select(selectors.isAuthorized, {
                print: toolKeys.MP_RECEIVED_PSRC_PRINT,
            }), tap((authorizedButtons) => {
                this.columnActions = {
                    lbmxDocumentId: authorizedButtons.print
                        ? {
                            link: () => ({ path: './' }),
                            event: (ReceivedPSRC) => ({
                                data: { ReceivedPSRC },
                                eventType: EventType.PRINT,
                            }),
                        }
                        : {},
                };
            }))
                .subscribe());
            this.selectedPrintOptions = yield this.printOptionsService.get('psrc', toolKeys.MP_RECEIVED_PSRC_PRINT);
        });
    }
    bulkPrint() {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `psrc/print`,
            httpMethod: 'POST',
            body: this.psrcsToPrint,
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            var _a;
            ((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) === 1
                ? saveAs(response, 'MergedDocuments')
                : this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.psrcsToPrint = [];
            this.triggeredByPrint = false;
            this.spinner.off();
        }))
            .subscribe();
    }
    openPdfViewer(data) {
        const ref = this.dialogService.open(PdfViewerComponent, {
            data: {
                response: data,
            },
            styleClass: 'pdf-viewer',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
    }
    closePrintOptionsDialog() {
        this.showPrintOptionsDialog = false;
    }
    updatePrintOptions(selectedPrintOptions) {
        this.selectedPrintOptions = selectedPrintOptions;
        if (this.triggeredByPrint) {
            this.bulkPrint();
        }
        this.closePrintOptionsDialog();
    }
    searchContainerEvent({ data, eventType }) {
        const { ReceivedPSRC } = data;
        switch (eventType) {
            case EventType.PRINT:
                this.print(ReceivedPSRC);
                break;
            default:
                break;
        }
    }
    print(ReceivedPSRC) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `psrc/${ReceivedPSRC === null || ReceivedPSRC === void 0 ? void 0 : ReceivedPSRC.psrcKey}/print`,
            httpMethod: 'GET',
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
            .subscribe();
    }
};
ReceivedPsrcComponent.ctorParameters = () => [
    { type: DialogService },
    { type: ConfirmationService$1 },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: Store },
    { type: PrintOptionsService }
];
ReceivedPsrcComponent = __decorate([
    Component({
        selector: 'lib-received-psrc',
        template: "<div class=\"view-psrcs\">\r\n  <h2>{{ 'BREADCRUMB.PLANNING_SCHEDULE' | transloco }}</h2>\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"searchUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showPrintOptionsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-print-options-container\r\n    [baseUrl]=\"searchUrl\"\r\n    [selectedPrintOptions]=\"selectedPrintOptions\"\r\n    (closeDialog)=\"closePrintOptionsDialog()\"\r\n    (updatePrintOptions)=\"updatePrintOptions($event)\"\r\n  ></lib-print-options-container>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, DialogService]
    })
], ReceivedPsrcComponent);

const ɵ0$v = { breadcrumb: 'BREADCRUMB.RECEIVED_PLANNING_SCHEDULE' };
const routes$r = [
    {
        path: 'received',
        component: ReceivedPsrcComponent,
        data: ɵ0$v,
    },
];

let RemittancesSentComponent = class RemittancesSentComponent {
    constructor(dialogService, confirmationService, mp, http, spinner, searchContainerLoaderService, translocoService, toast, store, printOptionsService) {
        this.dialogService = dialogService;
        this.confirmationService = confirmationService;
        this.mp = mp;
        this.http = http;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.store = store;
        this.printOptionsService = printOptionsService;
        // print states
        this.showPrintOptionsDialog = false;
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        this.remittancesToPrint = [];
        this.columnActions = {};
        this.baseUrl = `${this.mp.getConfig().sentRemittances}`;
        this.searchUrl = `${this.baseUrl}/remittance`;
        // Search container states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'remittancesSentSearch';
        this.i18nSearchField = 'COLLECTIONS.PAYMENT_REFERENCE_NUMBER';
        this.params = {};
        this.toolbarActionsDispatcher = {
            printOptions: (selection) => {
                this.showPrintOptionsDialog = true;
            },
            print: (selection) => {
                var _a;
                this.remittancesToPrint = [...selection].map((_a) => {
                    var { remittanceKey } = _a, _ = __rest(_a, ["remittanceKey"]);
                    return remittanceKey;
                });
                if (((_a = Object.keys(this.selectedPrintOptions || {})) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.bulkPrint();
                }
                else {
                    this.triggeredByPrint = true;
                    this.showPrintOptionsDialog = true;
                }
            },
        };
        http.baseUrl = this.baseUrl;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.push(this.store
                .pipe(select(selectors.isAuthorized, {
                edit: toolKeys.MP_SENT_REMITTANCE_EDIT,
                print: toolKeys.MP_SENT_REMITTANCE_PRINT,
            }), tap((authorizedButtons) => {
                this.columnActions = {
                    paymentReferenceNumber: authorizedButtons.print
                        ? {
                            link: () => ({ path: './' }),
                            event: (sentRemittance) => ({
                                data: { sentRemittance },
                                eventType: EventType.PRINT,
                            }),
                        }
                        : {},
                };
            }))
                .subscribe());
            this.selectedPrintOptions = yield this.printOptionsService.get('remittance', toolKeys.MP_SENT_REMITTANCE_PRINT);
        });
    }
    bulkPrint() {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `remittance/print`,
            httpMethod: 'POST',
            body: this.remittancesToPrint,
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            var _a;
            ((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) === 1
                ? saveAs(response, 'MergedDocuments')
                : this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.remittancesToPrint = [];
            this.triggeredByPrint = false;
            this.spinner.off();
        }))
            .subscribe();
    }
    openPdfViewer(data) {
        const ref = this.dialogService.open(PdfViewerComponent, {
            data: {
                response: data,
            },
            styleClass: 'pdf-viewer',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
    }
    closePrintOptionsDialog() {
        this.showPrintOptionsDialog = false;
    }
    updatePrintOptions(selectedPrintOptions) {
        this.selectedPrintOptions = selectedPrintOptions;
        if (this.triggeredByPrint) {
            this.bulkPrint();
        }
        this.closePrintOptionsDialog();
    }
    searchContainerEvent({ data, eventType }) {
        const { sentRemittance } = data;
        switch (eventType) {
            case EventType.PRINT:
                this.print(sentRemittance);
                break;
            default:
                break;
        }
    }
    print(sentRemittance) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `remittance/${sentRemittance === null || sentRemittance === void 0 ? void 0 : sentRemittance.remittanceKey}/print`,
            httpMethod: 'GET',
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
            .subscribe();
    }
};
RemittancesSentComponent.ctorParameters = () => [
    { type: DialogService$1 },
    { type: ConfirmationService$1 },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: Store },
    { type: PrintOptionsService }
];
RemittancesSentComponent = __decorate([
    Component({
        selector: 'lib-sent-remittances',
        template: "<div class=\"view-remittances\">\r\n  <h2>{{ 'BREADCRUMB.REMITTANCES_SENT' | transloco }}</h2>\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"searchUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showPrintOptionsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-print-options-container\r\n    [baseUrl]=\"searchUrl\"\r\n    [selectedPrintOptions]=\"selectedPrintOptions\"\r\n    (closeDialog)=\"closePrintOptionsDialog()\"\r\n    (updatePrintOptions)=\"updatePrintOptions($event)\"\r\n  ></lib-print-options-container>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, DialogService$1],
        styles: [""]
    })
], RemittancesSentComponent);

const ɵ0$w = { breadcrumb: 'BREADCRUMB.REMITTANCES_SENT' };
const routes$s = [
    {
        path: 'remittances-sent',
        component: RemittancesSentComponent,
        data: ɵ0$w,
    },
];

let StatementReceivedComponent = class StatementReceivedComponent {
    constructor(dialogService, confirmationService, mp, http, spinner, searchContainerLoaderService, translocoService, toast, store, printOptionsService) {
        this.dialogService = dialogService;
        this.confirmationService = confirmationService;
        this.mp = mp;
        this.http = http;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.store = store;
        this.printOptionsService = printOptionsService;
        this.baseUrl = `${this.mp.getConfig().receivedStatement}`;
        this.searchUrl = `${this.baseUrl}/statement`;
        this.columnActions = {};
        // print states
        this.showPrintOptionsDialog = false;
        this.selectedPrintOptions = {};
        this.triggeredByPrint = false;
        this.statementsToPrint = [];
        // Search container states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'statementReceivedSearch';
        this.i18nSearchField = 'MARKETPLACE.RECEIVED_STATEMENT_SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {
            printOptions: (selection) => {
                this.showPrintOptionsDialog = true;
            },
            print: (selection) => {
                var _a;
                this.statementsToPrint = [...selection].map((_a) => {
                    var { statementKey } = _a, _ = __rest(_a, ["statementKey"]);
                    return statementKey;
                });
                if (((_a = Object.keys(this.selectedPrintOptions || {})) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                    this.bulkPrint();
                }
                else {
                    this.triggeredByPrint = true;
                    this.showPrintOptionsDialog = true;
                }
            },
            markProcessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('STATEMENT_RECEIVED.MARK_PROCESSED_MESSAGE'),
                    header: this.translocoService.translate('STATEMENT_RECEIVED.MARK_PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'statement/mark-processed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { statementKey } = _a, _ = __rest(_a, ["statementKey"]);
                                return statementKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnprocessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('STATEMENT_RECEIVED.MARK_UNPROCESSED_MESSAGE'),
                    header: this.translocoService.translate('STATEMENT_RECEIVED.MARK_PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'statement/mark-unprocessed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { statementKey } = _a, _ = __rest(_a, ["statementKey"]);
                                return statementKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markRead: (selection) => {
                this.confirmationService.confirm({
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    message: this.translocoService.translate('STATEMENT_RECEIVED.MARK_READ_MESSAGE'),
                    header: this.translocoService.translate('STATEMENT_RECEIVED.MARK_READ_HEADER'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'statement/mark-read',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { statementKey } = _a, _ = __rest(_a, ["statementKey"]);
                                return statementKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnread: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('STATEMENT_RECEIVED.MARK_UNREAD_MESSAGE'),
                    header: this.translocoService.translate('STATEMENT_RECEIVED.MARK_UNREAD_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'statement/mark-unread',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { statementKey } = _a, _ = __rest(_a, ["statementKey"]);
                                return statementKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
        };
        http.baseUrl = this.baseUrl;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.push(this.store
                .pipe(select(selectors.isAuthorized, {
                edit: toolKeys.MP_RECEIVED_STATEMENT_EDIT,
                print: toolKeys.MP_RECEIVED_STATEMENT_PRINT,
            }), tap((authorizedButtons) => {
                this.columnActions = {
                    referenceID: authorizedButtons.print
                        ? {
                            link: () => ({
                                path: `./`,
                            }),
                            event: (receivedStatement) => ({
                                data: { receivedStatement },
                                eventType: EventType.PRINT,
                            }),
                        }
                        : {},
                };
            }))
                .subscribe());
            this.selectedPrintOptions = yield this.printOptionsService.get('statement', toolKeys.MP_RECEIVED_STATEMENT_PRINT);
        });
    }
    searchContainerEvent({ data, eventType }) {
        const { receivedStatement } = data;
        switch (eventType) {
            case EventType.PRINT:
                this.print(receivedStatement);
                break;
            default:
                break;
        }
    }
    bulkPrint() {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `statement/print`,
            httpMethod: 'POST',
            body: this.statementsToPrint,
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            var _a;
            ((_a = this.selectedPrintOptions) === null || _a === void 0 ? void 0 : _a.printOption) === 1
                ? saveAs(response, 'MergedDocuments')
                : this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => {
            this.statementsToPrint = [];
            this.triggeredByPrint = false;
            this.spinner.off();
        }))
            .subscribe();
    }
    openPdfViewer(data) {
        const ref = this.dialogService.open(PdfViewerComponent, {
            data: {
                response: data,
            },
            styleClass: 'pdf-viewer',
        });
        this.dynamicDialogRefs = [...this.dynamicDialogRefs, ref];
    }
    closePrintOptionsDialog() {
        this.showPrintOptionsDialog = false;
    }
    updatePrintOptions(selectedPrintOptions) {
        this.selectedPrintOptions = selectedPrintOptions;
        if (this.triggeredByPrint) {
            this.bulkPrint();
        }
        this.closePrintOptionsDialog();
    }
    print(receivedStatement) {
        this.spinner.on();
        this.http
            .fetch({
            endpoint: `statement/${receivedStatement === null || receivedStatement === void 0 ? void 0 : receivedStatement.statementKey}/print`,
            httpMethod: 'GET',
            options: {
                responseType: 'blob',
            },
        })
            .pipe(tap((response) => {
            this.openPdfViewer(response);
            this.searchContainerLoaderService.refreshSearch();
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
            .subscribe();
    }
};
StatementReceivedComponent.ctorParameters = () => [
    { type: DialogService },
    { type: ConfirmationService$1 },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: Store },
    { type: PrintOptionsService }
];
StatementReceivedComponent = __decorate([
    Component({
        selector: 'lib-statement-received',
        template: "<div class=\"view-remittances\">\r\n  <h2>{{ 'BREADCRUMB.RECEIVED_STATEMENT' | transloco }}</h2>\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"searchUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n\r\n<p-dialog\r\n  *ngIf=\"showPrintOptionsDialog\"\r\n  [visible]=\"true\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '520px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  [focusOnShow]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <lib-print-options-container\r\n    [baseUrl]=\"searchUrl\"\r\n    [selectedPrintOptions]=\"selectedPrintOptions\"\r\n    (closeDialog)=\"closePrintOptionsDialog()\"\r\n    (updatePrintOptions)=\"updatePrintOptions($event)\"\r\n  ></lib-print-options-container>\r\n</p-dialog>\r\n",
        providers: [SearchContainerLoaderService, DialogService]
    })
], StatementReceivedComponent);

const ɵ0$x = { breadcrumb: 'BREADCRUMB.RECEIVED_STATEMENT' };
const routes$t = [
    {
        path: 'statement-received',
        component: StatementReceivedComponent,
        data: ɵ0$x,
    },
];

let SentDSDSIComponent = class SentDSDSIComponent {
    constructor(dialogService, confirmationService, mp, http, spinner, searchContainerLoaderService, translocoService, toast, store, printOptionsService) {
        this.dialogService = dialogService;
        this.confirmationService = confirmationService;
        this.mp = mp;
        this.http = http;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.store = store;
        this.printOptionsService = printOptionsService;
        this.baseUrl = `${this.mp.getConfig().sentDsdsi}`;
        this.searchUrl = `${this.baseUrl}/dsdsi`;
        this.columnActions = {};
        // Search container states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'dsdsiSentSearch';
        this.i18nSearchField = 'DSDSI_SENT.SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {};
        http.baseUrl = this.baseUrl;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    searchContainerEvent({ data, eventType }) {
        const { sentDSDSI } = data;
        switch (eventType) {
            default:
                break;
        }
    }
};
SentDSDSIComponent.ctorParameters = () => [
    { type: DialogService },
    { type: ConfirmationService$1 },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: Store },
    { type: PrintOptionsService }
];
SentDSDSIComponent = __decorate([
    Component({
        selector: 'lib-sent-dsdsi',
        template: "<div class=\"view-remittances\">\r\n  <h2>{{ 'BREADCRUMB.SENT_DIRECT_STORE_DELIVERY_SUMMARY' | transloco }}</h2>\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"searchUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n",
        providers: [SearchContainerLoaderService, DialogService]
    })
], SentDSDSIComponent);

const ɵ0$y = { breadcrumb: 'BREADCRUMB.SENT_DIRECT_STORE_DELIVERY_SUMMARY' };
const routes$u = [
    {
        path: 'sent',
        component: SentDSDSIComponent,
        data: ɵ0$y,
    },
];

let ReceivedDSDSIComponent = class ReceivedDSDSIComponent {
    constructor(dialogService, confirmationService, mp, http, spinner, searchContainerLoaderService, translocoService, toast, store, printOptionsService) {
        this.dialogService = dialogService;
        this.confirmationService = confirmationService;
        this.mp = mp;
        this.http = http;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.store = store;
        this.printOptionsService = printOptionsService;
        this.baseUrl = `${this.mp.getConfig().receivedDsdsi}`;
        this.searchUrl = `${this.baseUrl}/dsdsi`;
        this.columnActions = {};
        // Search container states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'dsdsiReceivedSearch';
        this.i18nSearchField = 'DSDSI_RECEIVED.SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {
            markProcessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('DSDSI_RECEIVED.MARK_PROCESSED_MESSAGE'),
                    header: this.translocoService.translate('DSDSI_RECEIVED.MARK_PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'dsdsi/mark-processed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { dsdsiKey } = _a, _ = __rest(_a, ["dsdsiKey"]);
                                return dsdsiKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnprocessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('DSDSI_RECEIVED.MARK_UNPROCESSED_MESSAGE'),
                    header: this.translocoService.translate('DSDSI_RECEIVED.MARK_UNPROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'dsdsi/mark-unprocessed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { dsdsiKey } = _a, _ = __rest(_a, ["dsdsiKey"]);
                                return dsdsiKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markRead: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('DSDSI_RECEIVED.MARK_READ_MESSAGE'),
                    header: this.translocoService.translate('DSDSI_RECEIVED.MARK_READ_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'dsdsi/mark-read',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { dsdsiKey } = _a, _ = __rest(_a, ["dsdsiKey"]);
                                return dsdsiKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnread: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('DSDSI_RECEIVED.MARK_UNREAD_MESSAGE'),
                    header: this.translocoService.translate('DSDSI_RECEIVED.MARK_UNREAD_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'dsdsi/mark-unread',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { dsdsiKey } = _a, _ = __rest(_a, ["dsdsiKey"]);
                                return dsdsiKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
        };
        http.baseUrl = this.baseUrl;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    searchContainerEvent({ data, eventType }) {
        const { receivedDSDSI } = data;
        switch (eventType) {
            default:
                break;
        }
    }
};
ReceivedDSDSIComponent.ctorParameters = () => [
    { type: DialogService },
    { type: ConfirmationService$1 },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: Store },
    { type: PrintOptionsService }
];
ReceivedDSDSIComponent = __decorate([
    Component({
        selector: 'lib-received-dsdsi',
        template: "<div class=\"view-remittances\">\r\n  <h2>{{ 'BREADCRUMB.RECEIVED_DIRECT_STORE_DELIVERY_SUMMARY' | transloco }}</h2>\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"searchUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n",
        providers: [SearchContainerLoaderService, DialogService]
    })
], ReceivedDSDSIComponent);

const ɵ0$z = { breadcrumb: 'BREADCRUMB.RECEIVED_DIRECT_STORE_DELIVERY_SUMMARY' };
const routes$v = [
    {
        path: 'received',
        component: ReceivedDSDSIComponent,
        data: ɵ0$z,
    },
];

let SentPIComponent = class SentPIComponent {
    constructor(dialogService, confirmationService, mp, http, spinner, searchContainerLoaderService, translocoService, toast, store, printOptionsService) {
        this.dialogService = dialogService;
        this.confirmationService = confirmationService;
        this.mp = mp;
        this.http = http;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.store = store;
        this.printOptionsService = printOptionsService;
        this.baseUrl = `${this.mp.getConfig().sentPi}`;
        this.searchUrl = `${this.baseUrl}/pi`;
        this.columnActions = {};
        // Search container states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'piSentSearch';
        this.i18nSearchField = 'MARKETPLACE.PRICE_INFORMATION_SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {};
        http.baseUrl = this.baseUrl;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    searchContainerEvent({ data, eventType }) {
        const { sentPI } = data;
        switch (eventType) {
            default:
                break;
        }
    }
};
SentPIComponent.ctorParameters = () => [
    { type: DialogService },
    { type: ConfirmationService$1 },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: Store },
    { type: PrintOptionsService }
];
SentPIComponent = __decorate([
    Component({
        selector: 'lib-sent-pi',
        template: "<div class=\"view-remittances\">\r\n  <h2>{{ 'BREADCRUMB.SENT_PRICE_INFORMATION' | transloco }}</h2>\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"searchUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n",
        providers: [SearchContainerLoaderService, DialogService]
    })
], SentPIComponent);

const ɵ0$A = { breadcrumb: 'BREADCRUMB.SENT_PRICE_INFORMATION' };
const routes$w = [
    {
        path: 'sent',
        component: SentPIComponent,
        data: ɵ0$A,
    },
];

let ReceivedPIComponent = class ReceivedPIComponent {
    constructor(dialogService, confirmationService, mp, http, spinner, searchContainerLoaderService, translocoService, toast, store, printOptionsService) {
        this.dialogService = dialogService;
        this.confirmationService = confirmationService;
        this.mp = mp;
        this.http = http;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.store = store;
        this.printOptionsService = printOptionsService;
        this.baseUrl = `${this.mp.getConfig().receivedPi}`;
        this.searchUrl = `${this.baseUrl}/pi`;
        this.columnActions = {};
        // Search container states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'piReceivedSearch';
        this.i18nSearchField = 'MARKETPLACE.PRICE_INFORMATION_SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {
            markRead: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('PI_RECEIVED.MARK_READ_MESSAGE'),
                    header: this.translocoService.translate('PI_RECEIVED.MARK_READ_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'pi/mark-read',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { piKey } = _a, _ = __rest(_a, ["piKey"]);
                                return piKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnread: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('PI_RECEIVED.MARK_UNREAD_MESSAGE'),
                    header: this.translocoService.translate('PI_RECEIVED.MARK_UNREAD_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'pi/mark-unread',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { piKey } = _a, _ = __rest(_a, ["piKey"]);
                                return piKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markProcessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('PI_RECEIVED.MARK_PROCESSED_MESSAGE'),
                    header: this.translocoService.translate('PI_RECEIVED.MARK_PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'pi/mark-processed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { piKey } = _a, _ = __rest(_a, ["piKey"]);
                                return piKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnprocessed: (selection) => {
                this.confirmationService.confirm({
                    message: this.translocoService.translate('PI_RECEIVED.MARK_UNPROCESSED_MESSAGE'),
                    header: this.translocoService.translate('PI_RECEIVED.MARK_PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'pi/mark-unprocessed',
                            httpMethod: 'POST',
                            body: [...selection].map((_a) => {
                                var { piKey } = _a, _ = __rest(_a, ["piKey"]);
                                return piKey;
                            }),
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
        };
        http.baseUrl = this.baseUrl;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    searchContainerEvent({ data, eventType }) {
        const { receivedPI } = data;
        switch (eventType) {
            default:
                break;
        }
    }
};
ReceivedPIComponent.ctorParameters = () => [
    { type: DialogService },
    { type: ConfirmationService$1 },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: Store },
    { type: PrintOptionsService }
];
ReceivedPIComponent = __decorate([
    Component({
        selector: 'lib-received-pi',
        template: "<div class=\"view-remittances\">\r\n  <h2>{{ 'BREADCRUMB.RECEIVED_PRICE_INFORMATION' | transloco }}</h2>\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"searchUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n",
        providers: [SearchContainerLoaderService, DialogService]
    })
], ReceivedPIComponent);

const ɵ0$B = { breadcrumb: 'BREADCRUMB.RECEIVED_PRICE_INFORMATION' };
const routes$x = [
    {
        path: 'received',
        component: ReceivedPIComponent,
        data: ɵ0$B,
    },
];

let SentWarehouseComponent = class SentWarehouseComponent {
    constructor(dialogService, confirmationService, mp, http, spinner, searchContainerLoaderService, translocoService, toast, store, printOptionsService) {
        this.dialogService = dialogService;
        this.confirmationService = confirmationService;
        this.mp = mp;
        this.http = http;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.store = store;
        this.printOptionsService = printOptionsService;
        this.baseUrl = `${this.mp.getConfig().sentWarehouse}`;
        this.searchUrl = `${this.baseUrl}/wh`;
        this.columnActions = {};
        // Search container states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'warehouseSentSearch';
        this.i18nSearchField = 'MARKETPLACE.WAREHOUSE_SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {};
        http.baseUrl = this.baseUrl;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    searchContainerEvent({ data, eventType }) {
        const { sentwarehouse } = data;
        switch (eventType) {
            default:
                break;
        }
    }
};
SentWarehouseComponent.ctorParameters = () => [
    { type: DialogService },
    { type: ConfirmationService$1 },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: Store },
    { type: PrintOptionsService }
];
SentWarehouseComponent = __decorate([
    Component({
        selector: 'lib-sent-warehouse',
        template: "<div class=\"view-remittances\">\r\n  <h2>{{ 'BREADCRUMB.SENT_WAREHOUSE' | transloco }}</h2>\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"searchUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n",
        providers: [SearchContainerLoaderService, DialogService]
    })
], SentWarehouseComponent);

const ɵ0$C = { breadcrumb: 'BREADCRUMB.SENT_WAREHOUSE' };
const routes$y = [
    {
        path: 'sent',
        component: SentWarehouseComponent,
        data: ɵ0$C,
    },
];

let ReceivedWarehouseComponent = class ReceivedWarehouseComponent {
    constructor(dialogService, confirmationService, mp, http, spinner, searchContainerLoaderService, translocoService, toast, store, printOptionsService) {
        this.dialogService = dialogService;
        this.confirmationService = confirmationService;
        this.mp = mp;
        this.http = http;
        this.spinner = spinner;
        this.searchContainerLoaderService = searchContainerLoaderService;
        this.translocoService = translocoService;
        this.toast = toast;
        this.store = store;
        this.printOptionsService = printOptionsService;
        this.baseUrl = `${this.mp.getConfig().receivedWarehouse}`;
        this.searchUrl = `${this.baseUrl}/wh`;
        this.columnActions = {};
        // Search container states
        this.dynamicDialogRefs = [];
        this.subscriptions = [];
        this.searchContainerName = 'warehouseReceivedSearch';
        this.i18nSearchField = 'MARKETPLACE.WAREHOUSE_SEARCH';
        this.params = {};
        this.toolbarActionsDispatcher = {
            markProcessed: (selection) => {
                const whBody = selection.map(({ docKey, docType }) => ({
                    key: docKey,
                    docType,
                }));
                this.confirmationService.confirm({
                    message: this.translocoService.translate('WH_RECEIVED.PROCESSED_MESSAGE'),
                    header: this.translocoService.translate('WH_RECEIVED.PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'wh/mark-processed',
                            httpMethod: 'POST',
                            body: whBody,
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnprocessed: (selection) => {
                const whBody = selection.map(({ docKey, docType }) => ({
                    key: docKey,
                    docType,
                }));
                this.confirmationService.confirm({
                    message: this.translocoService.translate('WH_RECEIVED.UNPROCESSED_MESSAGE'),
                    header: this.translocoService.translate('WH_RECEIVED.PROCESSED_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'wh/mark-unprocessed',
                            httpMethod: 'POST',
                            body: whBody,
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markRead: (selection) => {
                const whBody = selection.map(({ docKey, docType }) => ({
                    key: docKey,
                    docType,
                }));
                this.confirmationService.confirm({
                    message: this.translocoService.translate('WH_RECEIVED.READ_MESSAGE'),
                    header: this.translocoService.translate('WH_RECEIVED.READ_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'wh/mark-read',
                            httpMethod: 'POST',
                            body: whBody,
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
            markUnread: (selection) => {
                const whBody = selection.map(({ docKey, docType }) => ({
                    key: docKey,
                    docType,
                }));
                this.confirmationService.confirm({
                    message: this.translocoService.translate('WH_RECEIVED.UNREAD_MESSAGE'),
                    header: this.translocoService.translate('WH_RECEIVED.UNREAD_HEADER'),
                    acceptLabel: this.translocoService.translate('ACTIONS.YES'),
                    rejectLabel: this.translocoService.translate('ACTIONS.NO'),
                    accept: () => {
                        this.spinner.on();
                        this.http
                            .fetch({
                            endpoint: 'wh/mark-unread',
                            httpMethod: 'POST',
                            body: whBody,
                        })
                            .pipe(tap(() => {
                            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
                            this.searchContainerLoaderService.refreshSearch();
                        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => this.spinner.off()))
                            .subscribe();
                    },
                    reject: () => { },
                });
            },
        };
        http.baseUrl = this.baseUrl;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    searchContainerEvent({ data, eventType }) {
        const { receivedwarehouse } = data;
        switch (eventType) {
            default:
                break;
        }
    }
};
ReceivedWarehouseComponent.ctorParameters = () => [
    { type: DialogService },
    { type: ConfirmationService$1 },
    { type: MarketplaceService },
    { type: BaseHttpService$1 },
    { type: SpinnerService },
    { type: SearchContainerLoaderService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: Store },
    { type: PrintOptionsService }
];
ReceivedWarehouseComponent = __decorate([
    Component({
        selector: 'lib-received-warehouse',
        template: "<div class=\"view-remittances\">\r\n  <h2>{{ 'BREADCRUMB.RECEIVED_WAREHOUSE' | transloco }}</h2>\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [params]=\"params\"\r\n    [baseUrl]=\"searchUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    (field)=\"searchContainerEvent($event)\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n",
        providers: [SearchContainerLoaderService, DialogService]
    })
], ReceivedWarehouseComponent);

const ɵ0$D = { breadcrumb: 'BREADCRUMB.RECEIVED_WAREHOUSE' };
const routes$z = [
    {
        path: 'received',
        component: ReceivedWarehouseComponent,
        data: ɵ0$D,
    },
];

var routePermissions = {
    'accounts-payable_invoices': toolKeys.MP_INVOICE,
    'accounts-payable_payment-details': toolKeys.MP_INVOICE,
    'accounts-payable_payments': toolKeys.MARKETPLACE_PAYMENT,
    'accounts-payable_payments_batches': toolKeys.MARKETPLACE_PAYMENT,
    'accounts-payable_statement-received': toolKeys.MP_RECEIVED_STATEMENT,
    'accounts-payable_remittances-sent': toolKeys.MP_SENT_REMITTANCE,
    'accounts-payable_direct-invoices': toolKeys.MP_DIRECT_INVOICE,
    'error-messages_tms-received': toolKeys.MP_RECEIVED_TM,
    'error-messages_aa-received': toolKeys.MP_RECEIVED_AA,
    'order-fulfillment_pad-received': toolKeys.MP_RECEIVED_PAD,
    'accounts-receivable_cda-received': toolKeys.MP_RECEIVED_CDA,
    'order-fulfillment_poc-received': toolKeys.MP_RECEIVED_POC,
    'ordering_os-received': toolKeys.MP_RECEIVED_OS,
    'ordering_poc-sent': toolKeys.MP_SENT_POC,
    'ordering_pad-sent': toolKeys.MP_SENT_PAD,
    'order-fulfillment_os-sent': toolKeys.MP_SENT_OS,
    'accounts-payable_cda-sent': toolKeys.MP_SENT_CDA,
    'compliance_invoice-matching': toolKeys.MP_COMPLIANCE_INVOICE_MATCHING,
    'compliance_statement-matching': toolKeys.MP_COMPLIANCE_STATEMENT_MATCHING,
    'compliance_edit-invoice': toolKeys.MP_COMPLIANCE_INVOICE_MATCHING,
    purchase_order: toolKeys.MP_PO,
    'ordering_sent-po': toolKeys.MP_Sent_PO,
    ordering: toolKeys.MP,
    'ordering_poas-received': toolKeys.MP_POA,
    'ordering_asns-received': toolKeys.MP_ASN,
    claims_received: toolKeys.MP_CLAIMS_RECEIVED,
    'accounts-receivable_remittances-received': toolKeys.MP_REMITTANCES_RECEIVED,
    'accounts-receivable_invoices': toolKeys.MP_SENT_INVOICE,
    'accounts-receivable_draft-invoice': toolKeys.MP_SENT_INVOICE,
    'accounts-receivable_new-invoice': toolKeys.MP_SENT_INVOICE,
    'accounts-receivable_statement-received': toolKeys.MP_SENT_INVOICE,
    'accounts-receivable_full-invoice': toolKeys.MP_SENT_INVOICE,
    // 'accounts-receivable_edit-invoice': toolKeys.MP_SENT_INVOICE,
    'accounts-receivable_collections': toolKeys.MARKETPLACE_COLLECTION,
    'accounts-receivable_collections_batches': toolKeys.MARKETPLACE_COLLECTION,
    'order-fulfillment_received-po': toolKeys.MP_PO,
    'order-fulfillment_flip-poa': toolKeys.MP_PO_FLIP_TO_POA,
    'order-fulfillment_flip-asn': toolKeys.MP_PO_FLIP_TO_ASN,
    'order-fulfillment_flip-invoice': toolKeys.MP_PO_FLIP_TO_INVOICE,
    'order-fulfillment_poas-sent': toolKeys.MP_SENT_POA,
    'order-fulfillment_asns-sent': toolKeys.MP_SENT_ASN,
    'order-fulfillment_draft-asn': toolKeys.MP_SENT_ASN,
    'order-fulfillment_asn-entry': toolKeys.MP_SENT_ASN,
    'order-fulfillment_asn-copy': toolKeys.MP_SENT_ASN,
    'rebates_rebate-statement': toolKeys.MP_REBATE_STATEMENT,
    'payments_make-payments': toolKeys.MP_INVOICE,
    'payments_payment-details': toolKeys.MP_INVOICE,
    'receivables_open-receivables': toolKeys.MP_REBATE_STATEMENT,
    'accounts-payable_cda-flip': toolKeys.MP_INVOICE,
    'accounts-payable_di-cda-flip': toolKeys.MP_DIRECT_INVOICE,
    'accounts-payable_new-cda': toolKeys.MP_SENT_CDA,
    dsdsi_sent: toolKeys.DOCUMENTS_SENT_DSDSI,
    dsdsi_received: toolKeys.DOCUMENTS_RECEIVED_DSDSI,
    psrc_sent: toolKeys.MP_SENT_PSRC,
    psrc_received: toolKeys.MP_RECEIVED_PSRC,
    pi_sent: toolKeys.DOCUMENTS_SENT_PI,
    pi_received: toolKeys.DOCUMENTS_RECEIVED_PI,
    wh_sent: toolKeys.DOCUMENTS_SENT_WAREHOUSE,
    wh_received: toolKeys.DOCUMENTS_RECEIVED_WAREHOUSE,
};

let AuthGuardService = class AuthGuardService {
    constructor(router, store) {
        this.router = router;
        this.store = store;
    }
    canActivateChild(_, state) {
        const [modulePath, ...path] = state.url
            .split('?')[0]
            .split('/')
            .filter((x) => x !== '');
        const permissionKey = this.urlToPermissionKey(path);
        return this.store.pipe(select(selectors.isAuthorized, routePermissions), switchMap((permissions) => of(permissions[permissionKey] || this.router.parseUrl(`/${modulePath}`))), catchError(() => of(this.router.parseUrl(`/${modulePath}`))));
    }
    urlToPermissionKey(url) {
        return url.filter((path) => isNaN(parseInt(path, 10))).join('_');
    }
};
AuthGuardService.ctorParameters = () => [
    { type: Router },
    { type: Store }
];
AuthGuardService.ɵprov = ɵɵdefineInjectable({ factory: function AuthGuardService_Factory() { return new AuthGuardService(ɵɵinject(Router), ɵɵinject(Store)); }, token: AuthGuardService, providedIn: "root" });
AuthGuardService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], AuthGuardService);

const ɵ0$E = { breadcrumb: { label: 'BREADCRUMB.DOCUMENTS', disable: true } }, ɵ1$a = {
    breadcrumb: {
        label: 'BREADCRUMB.ORDERING',
        disable: true,
    },
}, ɵ2$8 = {
    breadcrumb: {
        label: 'BREADCRUMB.ACCOUNTS_PAYABLE',
        disable: true,
    },
}, ɵ3$5 = {
    breadcrumb: {
        label: 'BREADCRUMB.COMPLIANCE',
        disable: true,
    },
}, ɵ4$1 = {
    breadcrumb: {
        label: 'BREADCRUMB.ACCOUNTS_RECEIVABLE',
        disable: true,
    },
}, ɵ5$1 = {
    breadcrumb: {
        label: 'BREADCRUMB.ORDER_FULFILLMENT',
        disable: true,
    },
}, ɵ6$1 = {
    breadcrumb: {
        label: 'BREADCRUMB.ERROR_MESSAGES',
        disable: true,
    },
}, ɵ7$1 = {
    breadcrumb: {
        label: 'BREADCRUMB.PLANNING_SCHEDULE',
        disable: true,
    },
}, ɵ8$1 = {
    breadcrumb: {
        label: 'NAV.REBATES',
        disable: true,
    },
}, ɵ9$1 = {
    breadcrumb: {
        label: 'BREADCRUMB.MAKE_PAYMENTS',
        disable: true,
    },
}, ɵ10$1 = {
    breadcrumb: {
        label: 'BREADCRUMB.MAKE_PAYMENTS',
        disable: true,
    },
}, ɵ11$1 = {
    breadcrumb: {
        label: 'BREADCRUMB.DIRECT_STORE_DELIVERY_SUMMARY',
        disable: true,
    },
}, ɵ12$1 = {
    breadcrumb: {
        label: 'BREADCRUMB.PLANNING_SCHEDULE',
        disable: true,
    },
}, ɵ13$1 = {
    breadcrumb: {
        label: 'BREADCRUMB.PRICE_INFORMATION',
        disable: true,
    },
}, ɵ14$1 = {
    breadcrumb: {
        label: 'BREADCRUMB.WAREHOUSE',
        disable: true,
    },
};
const routes$A = [
    {
        path: '',
        data: ɵ0$E,
        component: MarketplaceComponent,
        canActivateChild: [AuthGuardService],
        children: [
            {
                path: 'ordering',
                data: ɵ1$a,
                children: [
                    ...routes$p,
                    ...routes$2,
                    ...routes,
                    ...routes$o,
                    ...routes$i,
                    ...routes$d,
                ],
            },
            {
                path: 'accounts-payable',
                data: ɵ2$8,
                children: [
                    ...routes$1,
                    ...routes$t,
                    ...routes$s,
                    ...routes$g,
                    ...routes$7,
                ],
            },
            {
                path: 'compliance',
                data: ɵ3$5,
                children: [...routes$9, ...routes$a],
            },
            {
                path: 'accounts-receivable',
                data: ɵ4$1,
                children: [
                    ...routes$n,
                    ...routes$m,
                    ...routes$8,
                    ...routes$6,
                ],
            },
            {
                path: 'order-fulfillment',
                data: ɵ5$1,
                children: [
                    ...routes$3,
                    ...routes$h,
                    ...routes$4,
                    ...routes$5,
                    ...routes$f,
                    ...routes$e,
                ],
            },
            {
                path: 'error-messages',
                data: ɵ6$1,
                children: [...routes$l, ...routes$j],
            },
            {
                path: 'planning-schedule',
                data: ɵ7$1,
                children: [...routes$q, ...routes$r],
            },
            {
                path: 'rebates',
                data: ɵ8$1,
                children: [...routes$k],
            },
            {
                path: 'payments',
                data: ɵ9$1,
                children: [...routes$b],
            },
            {
                path: 'receivables',
                data: ɵ10$1,
                children: [...routes$c],
            },
            {
                path: 'dsdsi',
                data: ɵ11$1,
                children: [...routes$u, ...routes$v],
            },
            {
                path: 'psrc',
                data: ɵ12$1,
                children: [...routes$q, ...routes$r],
            },
            {
                path: 'pi',
                data: ɵ13$1,
                children: [...routes$w, ...routes$x],
            },
            {
                path: 'wh',
                data: ɵ14$1,
                children: [...routes$y, ...routes$z],
            },
        ],
    },
];

const defaultState = {
    analytics: {},
    selectedCategory: '',
    selectedKpi: '',
    categoryDropdown: [],
    kpiDropdown: [],
    showCategories: true,
    categoryFilter: [],
};
const ɵ0$F = (analyticsState, { categoryFilter }) => {
    const allowedCategories = categoryFilter.length > 0
        ? categoryFilter
        : Object.keys(analyticsState.categories);
    return {
        analytics: analyticsState,
        categoryDropdown: Object.entries(analyticsState.categories).reduce((dropdownOptions, [category, description]) => {
            return allowedCategories.includes(category)
                ? [
                    ...dropdownOptions,
                    {
                        label: description,
                        value: category,
                    },
                ]
                : dropdownOptions;
        }, []),
    };
}, ɵ1$b = (category, { analytics }) => {
    const filteredKpis = Object.entries(analytics.kpis).filter(([kpi]) => {
        const [categoryName] = kpi.split('.');
        return category === categoryName;
    });
    return {
        selectedCategory: category,
        kpiDropdown: filteredKpis.map(([kpi, config]) => ({
            label: config.description,
            value: kpi,
        })),
    };
}, ɵ2$9 = (_, { analytics, categoryFilter }) => {
    const filteredKpis = Object.entries(analytics.kpis).filter(([kpi]) => {
        const [categoryName] = kpi.split('.');
        return categoryFilter.includes(categoryName);
    });
    return {
        kpiDropdown: filteredKpis.map(([kpi, config]) => ({
            label: config.description,
            value: kpi,
        })),
    };
}, ɵ3$6 = (kpi) => ({
    selectedKpi: kpi,
}), ɵ4$2 = (filters) => ({
    categoryFilter: filters,
}), ɵ5$2 = (show, { showCategories }) => {
    return {
        showCategories: show === undefined ? showCategories : show,
    };
};
const schema = {
    setAnalyticsState: {
        command: ɵ0$F,
    },
    setSelectedCategory: {
        command: ɵ1$b,
    },
    setKpiDropdown: {
        command: ɵ2$9,
    },
    setSelectedKpi: {
        command: ɵ3$6,
    },
    setCategoryFilter: {
        command: ɵ4$2,
    },
    setShowCategories: {
        command: ɵ5$2,
    },
};

let KpiSelectionModalComponent = class KpiSelectionModalComponent {
    constructor(actionUi, ref, dialogConfig) {
        this.actionUi = actionUi;
        this.ref = ref;
        this.dialogConfig = dialogConfig;
        this.actions = Action.createDispatcher(schema);
        this.actionUi.initialize(defaultState, this.actions);
        this.actionUi.state
            .pipe(tap((state) => (this.state = Object.assign({}, state))), takeUntil(this.actionUi.shouldDestroy))
            .subscribe();
        this.actions.setShowCategories.dispatch(this.dialogConfig.data.showCategories);
        if (this.dialogConfig.data.categoryFilter) {
            this.actions.setCategoryFilter.dispatch(this.dialogConfig.data.categoryFilter);
        }
        this.actions.setAnalyticsState.dispatch(this.dialogConfig.data.analyticsState);
        if (!this.state.showCategories) {
            this.actions.setKpiDropdown.dispatch();
        }
    }
    closeDialog(save = true) {
        const data = save ? this.state.selectedKpi : null;
        this.ref.close(data);
    }
};
KpiSelectionModalComponent.ctorParameters = () => [
    { type: ActionUiService },
    { type: DynamicDialogRef },
    { type: DynamicDialogConfig }
];
KpiSelectionModalComponent = __decorate([
    Component({
        selector: 'lib-kpi-selection-modal',
        template: "<div class=\"kpi-selection\">\r\n  <div class=\"vertical-flow space-before-100 space-between-100\">\r\n    <h2 class=\"dialog-title\">{{ 'ANALYTICS.KPI_SELECTION' | transloco }}</h2>\r\n    <div\r\n      *ngIf=\"state.showCategories\"\r\n      class=\"vertical-flow space-between-025 input\"\r\n    >\r\n      <label>{{ 'ANALYTICS.SELECT_KPI_CATEGORY' | transloco }}</label>\r\n      <p-dropdown\r\n        placeholder=\"SELECT\"\r\n        [ngModel]=\"state.selectedCategory\"\r\n        [options]=\"state.categoryDropdown\"\r\n        (onChange)=\"actions.setSelectedCategory.dispatch($event.value)\"\r\n        filter=\"true\"\r\n      >\r\n      </p-dropdown>\r\n    </div>\r\n    <div class=\"vertical-flow space-between-025 input\">\r\n      <p-dropdown\r\n        placeholder=\"{{ 'ANALYTICS.SELECT_KPI' | transloco }}\"\r\n        [ngModel]=\"state.selectedKpi\"\r\n        [options]=\"state.kpiDropdown\"\r\n        [disabled]=\"state.kpiDropdown.length === 0\"\r\n        (onChange)=\"actions.setSelectedKpi.dispatch($event.value)\"\r\n        filter=\"true\"\r\n      >\r\n      </p-dropdown>\r\n    </div>\r\n  </div>\r\n  <div class=\"horizontal-flow space-between-050 form-controls\">\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      autowidth=\"false\"\r\n      (click)=\"closeDialog(false)\"\r\n    ></button>\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      [disabled]=\"state.selectedKpi === ''\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      class=\"ds primary\"\r\n      autowidth=\"false\"\r\n      (click)=\"closeDialog()\"\r\n    ></button>\r\n  </div>\r\n</div>\r\n"
    })
], KpiSelectionModalComponent);

var HttpMethod$1;
(function (HttpMethod) {
    HttpMethod["DELETE"] = "delete";
    HttpMethod["GET"] = "get";
    HttpMethod["POST"] = "post";
    HttpMethod["PUT"] = "put";
})(HttpMethod$1 || (HttpMethod$1 = {}));
const defaultDashboardState$1 = {
    dashboard: [],
    config: {},
    gridArea: [],
    status: AnalyticsStatus.READY,
    settings: false,
};
const ɵ0$G = (_, state) => {
    const status = state.status < 0 ? state.status : AnalyticsStatus.DONE;
    return { status };
}, ɵ1$c = (dashboard) => ({ dashboard }), ɵ2$a = (gridArea) => ({ gridArea }), ɵ3$7 = (config) => ({ config }), ɵ4$3 = (status) => ({ status }), ɵ5$3 = ({ index, name }, { dashboard }) => {
    const kpiDashboard = [...dashboard];
    kpiDashboard[index] = name;
    return { dashboard: [...kpiDashboard] };
}, ɵ6$2 = (state) => {
    return state;
};
const dashboardSchema = {
    finalize: {
        command: ɵ0$G,
    },
    setDashboard: { command: ɵ1$c },
    setGridArea: { command: ɵ2$a },
    setConfig: { command: ɵ3$7 },
    setStatus: { command: ɵ4$3 },
    setWidget: {
        command: ɵ5$3,
    },
    updateState: {
        command: ɵ6$2,
    },
};

let DashboardComponent = class DashboardComponent {
    constructor(actionUi, dialogService, store, http, router, mp, siteTypeService) {
        this.actionUi = actionUi;
        this.dialogService = dialogService;
        this.store = store;
        this.http = http;
        this.router = router;
        this.mp = mp;
        this.siteTypeService = siteTypeService;
        this.showCategories = true;
        this.templateTypes = TemplateTypes$1;
        this.fetch = new Subject();
        this.analyticsState = new BehaviorSubject({});
        this.analyticsState$ = this.store.pipe(select(selectors.analyticsFeature), first((analyticsFeature) => analyticsFeature !== null), tap((analyticsState) => this.analyticsState.next(analyticsState)));
        this.actions = Action.createDispatcher(dashboardSchema);
        this.actionUi.initialize(defaultDashboardState$1, this.actions);
    }
    ngOnInit() {
        this.dashboardSettings$ = this.store.pipe(select(selectors.setting, { key: this.stateKey }), first((dashboardSettings) => dashboardSettings !== null));
        this.actions.updateState.dispatch(this.defaultDashboardState);
        this.actionUi.state
            .pipe(tap((state) => (this.state = Object.assign({}, state))), takeUntil(this.actionUi.shouldDestroy))
            .subscribe();
        this.fetch
            .pipe(tap(() => this.actions.setStatus.dispatch(AnalyticsStatus.LOADING)), exhaustMap(() => forkJoin([this.dashboardSettings$, this.analyticsState$]).pipe(map(([dashboardSettings, analyticsState]) => {
            if (Object.entries(dashboardSettings || {}).length > 0) {
                this.actions.setDashboard.dispatch(dashboardSettings.dashboard);
                this.actions.setGridArea.dispatch(dashboardSettings.gridArea);
            }
            return this.transformAnalyticsState(analyticsState.kpis);
        }), catchError((err) => {
            this.actions.setStatus.dispatch(AnalyticsStatus.ERROR);
            return of(err);
        }), finalize(() => this.actions.finalize.dispatch()))), tap((value) => this.actions.setConfig.dispatch(value)), takeUntil(this.actionUi.shouldDestroy))
            .subscribe();
        this.fetch.next();
    }
    transformAnalyticsState(kpis) {
        return Object.entries(kpis).reduce((kpiConfigs, [kpiName, config]) => (Object.assign(Object.assign({}, kpiConfigs), { [kpiName]: this.transformConfig(config) })), {});
    }
    transformConfig(config) {
        return Object.assign(Object.assign({}, config), { request: this.buildRequest(this.buildEndpoint(config), config.httpMethod, config.Filters).pipe(map((res) => { var _a; return (_a = res === null || res === void 0 ? void 0 : res.count) !== null && _a !== void 0 ? _a : res === null || res === void 0 ? void 0 : res.value; })) });
    }
    show(index) {
        const ref = this.dialogService.open(KpiSelectionModalComponent, {
            data: {
                analyticsState: this.analyticsState.value,
                showCategories: this.showCategories,
                categoryFilter: this.categoryFilter,
            },
            showHeader: false,
            styleClass: `kpi-dialog ${this.siteTypeService.siteName}`,
        });
        ref.onClose
            .pipe(tap((name) => {
            if (name) {
                this.actions.setWidget.dispatch({ name, index });
                this.store.dispatch(actions.updateSettings({
                    endPoints: this.mp.getConfig().uriUserState,
                    stateKey: this.stateKey,
                    state: {
                        dashboard: this.state.dashboard,
                        gridArea: this.state.gridArea,
                    },
                }));
            }
        }), takeUntil(this.actionUi.shouldDestroy))
            .subscribe();
    }
    buildEndpoint(config) {
        return `${this.mp.getConfig()[`${config.service}`]}${config.endpoint}`;
    }
    buildRequest(endpoint, httpMethod, body) {
        switch (httpMethod) {
            case HttpMethod$1.GET:
                return this.http.get(endpoint, {
                    params: this.buildDocumentsBody(body),
                    withCredentials: true,
                });
            case HttpMethod$1.POST:
                return this.http.post(endpoint, body, { withCredentials: true });
            case HttpMethod$1.PUT:
                return this.http.put(endpoint, body, { withCredentials: true });
            case HttpMethod$1.DELETE:
                return this.http.delete(endpoint, { withCredentials: true });
        }
    }
    buildDocumentsBody(body) {
        const { Filters } = body, documentsBody = __rest(body, ["Filters"]);
        body = Object.assign(Object.assign({}, documentsBody), Filters);
        return body;
    }
    navigate(config) {
        var _a;
        const filters = (_a = config.Filters) === null || _a === void 0 ? void 0 : _a.Filters;
        this.router
            .navigate([config.redirectUrl], { queryParams: {} })
            .finally(() => this.router.navigate([config.redirectUrl], {
            queryParams: { filters: JSON.stringify(filters) },
        }));
    }
};
DashboardComponent.ctorParameters = () => [
    { type: ActionUiService },
    { type: DialogService$1 },
    { type: Store },
    { type: HttpClient },
    { type: Router },
    { type: MarketplaceService },
    { type: SiteTypeService }
];
__decorate([
    Input()
], DashboardComponent.prototype, "defaultDashboardState", void 0);
__decorate([
    Input()
], DashboardComponent.prototype, "stateKey", void 0);
__decorate([
    Input()
], DashboardComponent.prototype, "categoryFilter", void 0);
__decorate([
    Input()
], DashboardComponent.prototype, "showCategories", void 0);
DashboardComponent = __decorate([
    Component({
        selector: 'lib-dashboard',
        template: "<lbmx-dashboard-wrapper class=\"position-relative\">\r\n  <ng-template [laTemplate]=\"templateTypes.DONE\" let-dashboardState>\r\n    <ng-container *ngFor=\"let name of dashboardState.dashboard; index as i\">\r\n      <lbmx-widget-wrapper\r\n        laWidget\r\n        class=\"position-relative elevated\"\r\n        [request]=\"dashboardState.config[name]?.request\"\r\n      >\r\n        <ng-template [laTemplate]=\"templateTypes.HEADER\" let-refresh=\"refresh\">\r\n          <i class=\"pi pi-refresh\" (click)=\"refresh()\"></i>\r\n          <i class=\"pi pi-ellipsis-v\" (click)=\"show(i)\"></i>\r\n        </ng-template>\r\n        <ng-template [laTemplate]=\"templateTypes.DONE\" let-widgetState>\r\n          <div\r\n            class=\"center done\"\r\n            (click)=\"navigate(dashboardState.config[name])\"\r\n          >\r\n            <h3 class=\"no-margin-top no-margin-bottom\">\r\n              {{ dashboardState.config[name].title }}\r\n            </h3>\r\n            <h1 class=\"margin-2\">\r\n              {{ widgetState.value }}\r\n            </h1>\r\n            <p class=\"fontSize14px margin-top-5\">\r\n              {{ dashboardState.config[name].subTitle }}\r\n            </p>\r\n          </div>\r\n        </ng-template>\r\n        <ng-template [laTemplate]=\"templateTypes.READY\">\r\n          <div class=\"center ready\">\r\n            <h1>{{ 'ANALYTICS.SELECT_KPI' | transloco }}</h1>\r\n          </div>\r\n        </ng-template>\r\n        <ng-template [laTemplate]=\"templateTypes.LOADING\">\r\n          <div class=\"spinner-background\">\r\n            <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n          </div>\r\n        </ng-template>\r\n        <ng-template [laTemplate]=\"templateTypes.ERROR\">\r\n          <div class=\"error\" style=\"cursor: default\">\r\n            <div class=\"message\">\r\n              <i class=\"pi pi-times-circle\"></i>\r\n              <span>{{ 'ANALYTICS.ERROR' | transloco }}</span>\r\n            </div>\r\n          </div>\r\n        </ng-template>\r\n      </lbmx-widget-wrapper>\r\n    </ng-container>\r\n  </ng-template>\r\n  <ng-template [laTemplate]=\"templateTypes.LOADING\">\r\n    <div class=\"spinner-background\">\r\n      <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner></div\r\n  ></ng-template>\r\n</lbmx-dashboard-wrapper>\r\n",
        providers: [ActionUiService, DialogService$1]
    })
], DashboardComponent);

const defaultDashboardContainerState = {
    hide: false,
};
const ɵ0$H = (_, state) => ({
    hide: !state.hide,
});
const dashboardContainerSchema = {
    toggleHide: {
        command: ɵ0$H,
    },
};

let DashboardContainerComponent = class DashboardContainerComponent {
    constructor(actionUi) {
        this.actionUi = actionUi;
        this.categoryFilter = [];
        this.showCategories = false;
        this.defaultDashboardState = {};
        this.dashBoardStateKey = '';
        this.dashBoardHeader = '';
        this.dashBoardVisibilityStateKey = '';
        this.actions = Action.createDispatcher(dashboardContainerSchema);
    }
    ngOnInit() {
        this.actionUi.initialize(Object.assign(Object.assign({}, defaultDashboardContainerState), JSON.parse(localStorage.getItem(this.dashBoardVisibilityStateKey))), this.actions);
        this.actionUi.state
            .pipe(tap((state) => (this.state = Object.assign({}, state))), takeUntil(this.actionUi.shouldDestroy))
            .subscribe();
    }
    toggleHide() {
        this.actions.toggleHide.dispatch();
        this.save();
    }
    save() {
        localStorage.setItem(this.dashBoardVisibilityStateKey, JSON.stringify({
            hide: this.state.hide,
        }));
    }
};
DashboardContainerComponent.ctorParameters = () => [
    { type: ActionUiService }
];
__decorate([
    Input()
], DashboardContainerComponent.prototype, "categoryFilter", void 0);
__decorate([
    Input()
], DashboardContainerComponent.prototype, "showCategories", void 0);
__decorate([
    Input()
], DashboardContainerComponent.prototype, "defaultDashboardState", void 0);
__decorate([
    Input()
], DashboardContainerComponent.prototype, "dashBoardStateKey", void 0);
__decorate([
    Input()
], DashboardContainerComponent.prototype, "dashBoardHeader", void 0);
__decorate([
    Input()
], DashboardContainerComponent.prototype, "dashBoardVisibilityStateKey", void 0);
DashboardContainerComponent = __decorate([
    Component({
        selector: 'lib-dashboard-container',
        template: "<div class=\"dashboard-container\">\r\n  <div class=\"header\">\r\n    <h2>{{ dashBoardHeader | transloco }}</h2>\r\n    <div class=\"controls\">\r\n      <i\r\n        *ngIf=\"state.hide === true\"\r\n        class=\"pi pi-angle-down stash medium\"\r\n        (click)=\"toggleHide()\"\r\n      ></i>\r\n      <i\r\n        *ngIf=\"state.hide === false\"\r\n        class=\"pi pi-angle-up stash medium\"\r\n        (click)=\"toggleHide()\"\r\n      ></i>\r\n    </div>\r\n  </div>\r\n  <div class=\"body stash medium\" *ngIf=\"!state.hide\">\r\n    <lib-dashboard\r\n      [stateKey]=\"dashBoardStateKey\"\r\n      [categoryFilter]=\"categoryFilter\"\r\n      [showCategories]=\"showCategories\"\r\n      [defaultDashboardState]=\"defaultDashboardState\"\r\n    ></lib-dashboard>\r\n  </div>\r\n</div>\r\n"
    })
], DashboardContainerComponent);

let DashboardModule = class DashboardModule {
};
DashboardModule = __decorate([
    NgModule({
        declarations: [
            DashboardComponent,
            DashboardContainerComponent,
            KpiSelectionModalComponent,
        ],
        imports: [
            AnalyticsModule,
            ButtonModule,
            CommonModule,
            DropdownModule,
            TranslocoModule,
            ProgressSpinnerModule,
            FormsModule,
        ],
        exports: [DashboardContainerComponent, DashboardComponent],
        entryComponents: [KpiSelectionModalComponent],
    })
], DashboardModule);

let ExportFormComponent = class ExportFormComponent {
    constructor() {
        this.closeForm = new EventEmitter();
        this.save = new EventEmitter();
    }
};
__decorate([
    Input()
], ExportFormComponent.prototype, "form", void 0);
__decorate([
    Output()
], ExportFormComponent.prototype, "closeForm", void 0);
__decorate([
    Output()
], ExportFormComponent.prototype, "save", void 0);
ExportFormComponent = __decorate([
    Component({
        selector: 'lib-export-form',
        template: "<div class=\"export-dialogue\" style=\"display: flex; flex-direction: column\">\r\n  <h2 class=\"dialog-title\">\r\n    {{ 'MARKETPLACE.EXPORT' | transloco }}\r\n  </h2>\r\n  <div style=\"flex-grow: 1; position: relative\">\r\n    <lui-form *ngIf=\"form; else formNotAvailable\" [form]=\"form\"></lui-form>\r\n    <ng-template #formNotAvailable>\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <div\r\n    class=\"contols\"\r\n    style=\"display: flex; gap: 0.5em; padding-top: 1em; padding-bottom: 5em\"\r\n  >\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      (click)=\"closeForm.emit()\"\r\n    ></button>\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SUBMIT' | transloco }}\"\r\n      class=\"ds\"\r\n      (click)=\"save.emit(form.values)\"\r\n      [disabled]=\"!form?.valid\"\r\n      style=\"flex-grow: 1\"\r\n    ></button>\r\n  </div>\r\n</div>\r\n"
    })
], ExportFormComponent);

let ExportModule = class ExportModule {
};
ExportModule = __decorate([
    NgModule({
        declarations: [ExportComponent, ExportFormComponent],
        imports: [
            CommonModule,
            TranslocoModule,
            PerFormPrimengModule,
            ProgressSpinnerModule$1,
            ButtonModule$1,
            UtilsModule,
            DialogModule,
        ],
        exports: [ExportComponent],
    })
], ExportModule);

let PdfViewerModule = class PdfViewerModule {
};
PdfViewerModule = __decorate([
    NgModule({
        declarations: [PdfViewerComponent],
        imports: [CommonModule, DialogModule$1],
        exports: [PdfViewerComponent],
    })
], PdfViewerModule);

const schemaDefinition$4 = ({ fields, }) => {
    const def = Object.assign({ fields: Object.assign({}, fields) }, fields.printOption && Object.assign(Object.assign({}, fields.printOption), { validations: [
            {
                test: ({ printOption }) => {
                    return printOption > 0;
                },
                message: 'Please select a Print Option',
            },
        ] }), fields.attachmentOption && Object.assign(Object.assign({}, fields.attachmentOption), { validations: [
            {
                test: ({ attachmentOption }) => {
                    return attachmentOption > 0;
                },
                message: 'Please select an Attachment Option',
            },
        ] }));
    return def;
};

let PrintOptionsContainerComponent = class PrintOptionsContainerComponent {
    constructor(http, spinner, translocoService, toast, formGenerator) {
        this.http = http;
        this.spinner = spinner;
        this.translocoService = translocoService;
        this.toast = toast;
        this.formGenerator = formGenerator;
        this.closeDialog = new EventEmitter();
        this.updatePrintOptions = new EventEmitter();
        this.schemaDefinition = schemaDefinition$4;
    }
    ngOnInit() {
        this.http
            .fetchWithFqn({
            endpoint: `${this.baseUrl}/print-options/form`,
            httpMethod: 'GET',
        })
            .pipe(tap((fields) => {
            this.form = this.formGenerator.init(this.schemaDefinition(fields), this.selectedPrintOptions);
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))))
            .subscribe();
    }
    save(formValues) {
        this.spinner.on();
        this.http
            .fetchWithFqn({
            endpoint: `${this.baseUrl}/print-options`,
            httpMethod: 'POST',
            body: formValues,
        })
            .pipe(tap((response) => {
            this.toast.successNotify(this.translocoService.translate('GROUP.SUCCESS_TOAST_MESSAGE'));
            this.updatePrintOptions.emit(response === null || response === void 0 ? void 0 : response.record);
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))), finalize(() => this.spinner.off()))
            .subscribe();
    }
};
PrintOptionsContainerComponent.ctorParameters = () => [
    { type: BaseHttpService },
    { type: SpinnerService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: GenerateFormService }
];
__decorate([
    Input()
], PrintOptionsContainerComponent.prototype, "baseUrl", void 0);
__decorate([
    Input()
], PrintOptionsContainerComponent.prototype, "selectedPrintOptions", void 0);
__decorate([
    Output()
], PrintOptionsContainerComponent.prototype, "closeDialog", void 0);
__decorate([
    Output()
], PrintOptionsContainerComponent.prototype, "updatePrintOptions", void 0);
PrintOptionsContainerComponent = __decorate([
    Component({
        selector: 'lib-print-options-container',
        template: ` <lib-print-options
    [form]="form"
    (closeDialog)="closeDialog.emit()"
    (saveDialog)="save($event)"
  ></lib-print-options>`
    })
], PrintOptionsContainerComponent);

let PrintOptionsComponent = class PrintOptionsComponent {
    constructor() {
        this.closeDialog = new EventEmitter();
        this.saveDialog = new EventEmitter();
    }
    ngOnInit() { }
    save() {
        this.saveDialog.emit(this.form.values);
    }
    close() {
        this.closeDialog.emit();
    }
};
__decorate([
    Input()
], PrintOptionsComponent.prototype, "form", void 0);
__decorate([
    Output()
], PrintOptionsComponent.prototype, "closeDialog", void 0);
__decorate([
    Output()
], PrintOptionsComponent.prototype, "saveDialog", void 0);
PrintOptionsComponent = __decorate([
    Component({
        selector: 'lib-print-options',
        template: "<div\r\n  class=\"crossrefrences-dialogue\"\r\n  style=\"display: flex; flex-direction: column\"\r\n>\r\n  <h2 class=\"dialog-title\">\r\n    {{ 'MARKETPLACE_ADVANCED_SEARCH.PRINT_OPTIONS' | transloco }}\r\n  </h2>\r\n  <div style=\"flex-grow: 1; position: relative\">\r\n    <lui-form *ngIf=\"form; else formNotAvailable\" [form]=\"form\"></lui-form>\r\n    <ng-template #formNotAvailable>\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <div\r\n    class=\"contols\"\r\n    style=\"display: flex; gap: 0.5em; padding-top: 1em; padding-bottom: 5em\"\r\n  >\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      (click)=\"close()\"\r\n    ></button>\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      class=\"ds\"\r\n      (click)=\"save()\"\r\n      [disabled]=\"!form?.valid\"\r\n      style=\"flex-grow: 1\"\r\n    ></button>\r\n  </div>\r\n</div>\r\n"
    })
], PrintOptionsComponent);

let PrintOptionsModule = class PrintOptionsModule {
};
PrintOptionsModule = __decorate([
    NgModule({
        declarations: [PrintOptionsComponent, PrintOptionsContainerComponent],
        imports: [
            CommonModule,
            TranslocoModule,
            PerFormPrimengModule,
            ProgressSpinnerModule$1,
            ButtonModule$1,
            UtilsModule,
        ],
        exports: [PrintOptionsContainerComponent],
    })
], PrintOptionsModule);

let LoggingFormComponent = class LoggingFormComponent {
    constructor() {
        this.closeForm = new EventEmitter();
        this.saveForm = new EventEmitter();
    }
    set formSetter(form) {
        this.form = form;
        this.checkFormValidity();
    }
    checkFormValidity() {
        var _a;
        Object.keys(Object.assign({}, (_a = this.form) === null || _a === void 0 ? void 0 : _a.schema)).forEach((field) => {
            this.form.setStatus(field, 'touched', true);
        });
    }
};
__decorate([
    Input('form')
], LoggingFormComponent.prototype, "formSetter", null);
__decorate([
    Output()
], LoggingFormComponent.prototype, "closeForm", void 0);
__decorate([
    Output()
], LoggingFormComponent.prototype, "saveForm", void 0);
LoggingFormComponent = __decorate([
    Component({
        selector: 'lib-logging-form',
        template: "<div\r\n  class=\"crossrefrences-dialogue\"\r\n  style=\"display: flex; flex-direction: column\"\r\n>\r\n  <h2 class=\"dialog-title\">\r\n    {{ 'INVOICE.PAYMENT_BATCHES_DISPLAY_LOGS' | transloco }}\r\n  </h2>\r\n  <div class=\"display-log\">\r\n    <lui-form *ngIf=\"form; else formNotAvailable\" [form]=\"form\"></lui-form>\r\n    <ng-template #formNotAvailable>\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <div\r\n    class=\"contol\"\r\n    style=\"display: flex; gap: 0.5em; padding-top: 1em; padding-bottom: 5em\"\r\n  >\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CLOSE' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      style=\"width: 25%\"\r\n      (click)=\"closeForm.emit()\"\r\n    ></button>\r\n  </div>\r\n</div>\r\n"
    })
], LoggingFormComponent);

const schemaDefinition$5 = (fields) => ({
    fields,
});

let LoggingComponent = class LoggingComponent {
    constructor(http, translocoService, toast, formGenerator) {
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.formGenerator = formGenerator;
        this.closeLogDialog = new EventEmitter();
        this.saveLogDialog = new EventEmitter();
        this.schemaDefinition = schemaDefinition$5;
    }
    ngOnInit() {
        this.http
            .fetchWithFqn({
            endpoint: `${this.baseUrl}`,
            httpMethod: 'GET',
        })
            .pipe(tap((formData) => {
            const _fields = this.schemaDefinition(formData === null || formData === void 0 ? void 0 : formData.fields);
            this.form = this.formGenerator.init(_fields);
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))))
            .subscribe();
    }
};
LoggingComponent.ctorParameters = () => [
    { type: BaseHttpService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: GenerateFormService }
];
__decorate([
    Input()
], LoggingComponent.prototype, "baseUrl", void 0);
__decorate([
    Input()
], LoggingComponent.prototype, "batchKey", void 0);
__decorate([
    Output()
], LoggingComponent.prototype, "closeLogDialog", void 0);
__decorate([
    Output()
], LoggingComponent.prototype, "saveLogDialog", void 0);
LoggingComponent = __decorate([
    Component({
        selector: 'lib-logging',
        template: `<lib-logging-form
    [form]="form"
    (closeForm)="closeLogDialog.emit()"
    (saveForm)="saveLogDialog.emit($event)"
  ></lib-logging-form>`
    })
], LoggingComponent);

let LoggingModule = class LoggingModule {
};
LoggingModule = __decorate([
    NgModule({
        declarations: [LoggingComponent, LoggingFormComponent],
        imports: [
            CommonModule,
            DialogModule$1,
            ExportModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            UtilsModule,
            PerFormPrimengModule,
            PdfViewerModule,
            ButtonModule$1,
            PrintOptionsModule,
            ProgressSpinnerModule$1,
        ],
        entryComponents: [PdfViewerComponent, ExportComponent],
        exports: [LoggingComponent],
    })
], LoggingModule);

const schemaDefinition$6 = (fields) => ({
    fields,
});
const warningsConfig$1 = (baseUrl, itemSelected) => ({
    endpoint: `${baseUrl}/${itemSelected === null || itemSelected === void 0 ? void 0 : itemSelected.poKey}/warning/form`,
    httpMethod: 'GET',
});

let WarningsContainerComponent = class WarningsContainerComponent {
    constructor(http, translocoService, toast, formGenerator, spinner, confirmationService) {
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.formGenerator = formGenerator;
        this.spinner = spinner;
        this.confirmationService = confirmationService;
        this.closeWarningsDialog = new EventEmitter();
        this.schemaDefinition = schemaDefinition$6;
        this.hasSelectionId = false;
    }
    ngOnInit() {
        this.fetchWarnings();
    }
    clear() {
        this.confirmationService.confirm(Object.assign(Object.assign({}, this.confirmation), { acceptLabel: this.translocoService.translate('ACTIONS.YES'), rejectLabel: this.translocoService.translate('ACTIONS.NO'), accept: () => {
                this.http
                    .fetch({
                    endpoint: `${this.baseUrl}/${this.itemKey}/warning/clear`,
                    httpMethod: HttpMethod$2.POST,
                    body: { warningKeys: [...this.form.values.warnings] },
                })
                    .pipe(finalize(() => {
                    this.fetchWarnings();
                }))
                    .subscribe();
                this.form = undefined;
            } }));
    }
    fetchWarnings() {
        this.http
            .fetchWithFqn({
            endpoint: `${this.baseUrl}/${this.itemKey}/warning/form`,
            httpMethod: 'GET',
        })
            .pipe(tap(({ fields }) => {
            this.form = this.formGenerator.init(this.schemaDefinition(fields));
            this.hasSelectionId =
                'selectionId' in fields.warnings.componentProperties;
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))))
            .subscribe();
    }
};
WarningsContainerComponent.ctorParameters = () => [
    { type: BaseHttpService$3 },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: GenerateFormService },
    { type: SpinnerService },
    { type: ConfirmationService }
];
__decorate([
    Input()
], WarningsContainerComponent.prototype, "baseUrl", void 0);
__decorate([
    Input()
], WarningsContainerComponent.prototype, "itemKey", void 0);
__decorate([
    Input()
], WarningsContainerComponent.prototype, "confirmation", void 0);
__decorate([
    Output()
], WarningsContainerComponent.prototype, "closeWarningsDialog", void 0);
WarningsContainerComponent = __decorate([
    Component({
        selector: 'lib-warnings-container',
        template: ` <lib-warnings-form
    [form]="form"
    [hasSelectionId]="hasSelectionId"
    [baseUrl]="baseUrl"
    [itemKey]="itemKey"
    (clear)="clear()"
    (closeWarningsDialog)="closeWarningsDialog.emit()"
  ></lib-warnings-form>`
    })
], WarningsContainerComponent);

let WarningsFormComponent = class WarningsFormComponent {
    constructor() {
        this.closeWarningsDialog = new EventEmitter();
        this.clear = new EventEmitter();
    }
    close() {
        this.closeWarningsDialog.emit();
    }
    clearClick() {
        this.clear.emit();
    }
};
__decorate([
    Output()
], WarningsFormComponent.prototype, "closeWarningsDialog", void 0);
__decorate([
    Output()
], WarningsFormComponent.prototype, "clear", void 0);
__decorate([
    Input()
], WarningsFormComponent.prototype, "form", void 0);
__decorate([
    Input()
], WarningsFormComponent.prototype, "baseUrl", void 0);
__decorate([
    Input()
], WarningsFormComponent.prototype, "itemKey", void 0);
__decorate([
    Input()
], WarningsFormComponent.prototype, "hasSelectionId", void 0);
WarningsFormComponent = __decorate([
    Component({
        selector: 'lib-warnings-form',
        template: "<div\r\n  class=\"crossrefrences-dialogue\"\r\n  style=\"display: flex; flex-direction: column\"\r\n>\r\n  <div style=\"justify-content: center\">\r\n    <h2 class=\"dialog-title\">{{ 'MARKETPLACE.VIEW_WARNINGS' | transloco }}</h2>\r\n    <div style=\"flex-grow: 1; position: relative\">\r\n      <lui-form *ngIf=\"form; else formNotAvailable\" [form]=\"form\"></lui-form>\r\n      <ng-template #formNotAvailable>\r\n        <div\r\n          class=\"spinner-background\"\r\n          style=\"min-height: 30vh; position: relative\"\r\n        >\r\n          <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n        </div>\r\n      </ng-template>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"contols\" style=\"display: flex; gap: 0.5em; padding-top: 1em\">\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CLOSE' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      (click)=\"close()\"\r\n      style=\"flex-grow: 1\"\r\n    ></button>\r\n    <button\r\n      *ngIf=\"hasSelectionId\"\r\n      [disabled]=\"!form?.valid\"\r\n      pButton\r\n      type=\"button\"\r\n      label=\"Clear\"\r\n      class=\"ds primary\"\r\n      (click)=\"clearClick()\"\r\n      style=\"flex-grow: 1\"\r\n    ></button>\r\n  </div>\r\n</div>\r\n"
    })
], WarningsFormComponent);

let WarningsModule = class WarningsModule {
};
WarningsModule = __decorate([
    NgModule({
        declarations: [WarningsContainerComponent, WarningsFormComponent],
        imports: [
            CommonModule,
            TranslocoModule,
            PerFormPrimengModule,
            ProgressSpinnerModule$1,
            ButtonModule$1,
            UtilsModule,
            DialogModule$1,
        ],
        exports: [WarningsContainerComponent],
    })
], WarningsModule);

let AsnReceivedModule = class AsnReceivedModule {
};
AsnReceivedModule = __decorate([
    NgModule({
        declarations: [AsnReceivedComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            DashboardModule,
            DialogModule$1,
            PerFormPrimengModule,
            ProgressSpinnerModule$1,
            CommonModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            PrintOptionsModule,
            PdfViewerModule,
            ExportModule,
            LoggingModule,
            WarningsModule,
            LuiWizardModule,
            LuiWizardV3Module,
            LuiWidgetWrapperModule,
        ],
        entryComponents: [
            PdfViewerComponent,
            ExportComponent,
            DataGeniusSelectionComponent,
        ],
    })
], AsnReceivedModule);

let ViewLogTemplateComponent = class ViewLogTemplateComponent {
    constructor() {
        this.showLogDialogue = false;
        this.dialogueHeader = '';
        this.showLogDialogueChange = new EventEmitter();
        this.logList = [];
        this.logDetails = { logList: [], filterOptions: [] };
    }
    set logDetailsSetter(logDetails) {
        this.logList = logDetails.logList;
        this.logDetails = logDetails;
    }
    ngOnInit() {
        // this.logList = this.logDetails.logList;
    }
    clearFilters() {
        this.selectedLogCodes = [];
        this.logList = this.logInfoList.logList;
    }
    filterLogs() {
        if (this.selectedLogCodes.length === 0) {
            return;
        }
        const filteredCodes = [];
        this.selectedLogCodes.filter((logCode) => {
            filteredCodes.push(logCode.code);
        });
        const resp = this.logInfoList.logList.filter((logs) => filteredCodes.includes(logs.logTypeCode));
        this.logList = resp;
    }
    closeViewLogDialogue() {
        this.showLogDialogueChange.emit(false);
    }
};
__decorate([
    Input()
], ViewLogTemplateComponent.prototype, "showLogDialogue", void 0);
__decorate([
    Input()
], ViewLogTemplateComponent.prototype, "dialogueHeader", void 0);
__decorate([
    Input()
], ViewLogTemplateComponent.prototype, "logInfoList", void 0);
__decorate([
    Input('logDetails')
], ViewLogTemplateComponent.prototype, "logDetailsSetter", null);
__decorate([
    Output()
], ViewLogTemplateComponent.prototype, "showLogDialogueChange", void 0);
ViewLogTemplateComponent = __decorate([
    Component({
        selector: 'lib-view-log-template',
        template: "<p-dialog\r\n  [(visible)]=\"showLogDialogue\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '960px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  position=\"center\"\r\n  styleClass=\"view-log-dialogue\"\r\n>\r\n  <div class=\"vertical-flow space-between-325\">\r\n    <!-- dialogue header and filter table container-->\r\n    <div class=\"vertical-flow space-between-025\">\r\n      <div class=\"horizontal-fixed space-between-000 dialogue-form\">\r\n        <div class=\"width-100\">\r\n          <h2 class=\"center\">{{ dialogueHeader }}</h2>\r\n        </div>\r\n        <div\r\n          (click)=\"closeViewLogDialogue()\"\r\n          class=\"pi pi-times header clickable\"\r\n        ></div>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-050\">\r\n        <div>\r\n          <p>\r\n            {{ 'PURCHASE_ORDER_RECEIVED.LOG_MESSAGE' | transloco }}\r\n          </p>\r\n        </div>\r\n        <div class=\"light-grey-border\">\r\n          <p-table\r\n            [value]=\"logDetails.filterOptions\"\r\n            selectionMode=\"multiple\"\r\n            [(selection)]=\"selectedLogCodes\"\r\n            dataKey=\"code\"\r\n            [scrollable]=\"true\"\r\n            scrollHeight=\"150px\"\r\n            styleClass=\"log-message-container \"\r\n          >\r\n            <ng-template pTemplate=\"body\" let-row>\r\n              <tr [pSelectableRow]=\"row\" ngClass=\"table-no-background\">\r\n                <td class=\"advancedSearchTableCheckbox\">\r\n                  <p-tableCheckbox\r\n                    [value]=\"row\"\r\n                    [pSelectableRow]=\"row\"\r\n                  ></p-tableCheckbox>\r\n                </td>\r\n                <td class=\"\">\r\n                  {{ row.value }}\r\n                </td>\r\n              </tr>\r\n            </ng-template>\r\n          </p-table>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <!-- End of dialogue header and filter table container -->\r\n    <!-- Search & Clear button container-->\r\n    <div class=\"horizontal-flow space-between-100\">\r\n      <button\r\n        class=\"ds\"\r\n        pButton\r\n        type=\"button\"\r\n        label=\"{{ 'ADVANCED_SEARCH.CLEAR' | transloco }}\"\r\n        (click)=\"clearFilters()\"\r\n      ></button>\r\n      <button\r\n        class=\"ds\"\r\n        pButton\r\n        type=\"button\"\r\n        label=\"{{ 'ACTIONS.SEARCH' | transloco }}\"\r\n        (click)=\"filterLogs()\"\r\n      ></button>\r\n    </div>\r\n    <!-- End of Search & Clear button container-->\r\n    <!-- Results table container-->\r\n    <div class=\"space-between-025\">\r\n      <p-table [value]=\"logList\" [scrollable]=\"true\" scrollHeight=\"250px\">\r\n        <ng-template pTemplate=\"header\">\r\n          <tr class=\"width-100\">\r\n            <th\r\n              class=\"light-grey-border-right width-40\"\r\n              pSortableColumn=\"message\"\r\n            >\r\n              {{ 'PURCHASE_ORDER_RECEIVED.MESSAGE' | transloco }}\r\n            </th>\r\n            <th\r\n              class=\"light-grey-border-right width-30\"\r\n              pSortableColumn=\"logTypeDescription\"\r\n            >\r\n              {{ 'PURCHASE_ORDER_RECEIVED.TYPE' | transloco }}\r\n            </th>\r\n            <th\r\n              class=\"light-grey-border-right width-15\"\r\n              pSortableColumn=\"addedBy\"\r\n            >\r\n              {{ 'PURCHASE_ORDER_RECEIVED.USER_NAME' | transloco }}\r\n            </th>\r\n            <th class=\"width-15\" pSortableColumn=\"addedOn\">\r\n              {{ 'MARKETPLACE_ADVANCED_SEARCH.DATE_ADDED' | transloco }}\r\n            </th>\r\n          </tr>\r\n        </ng-template>\r\n        <ng-template pTemplate=\"body\" let-log>\r\n          <tr class=\"width-100\">\r\n            <td class=\"width-40\">{{ log.message }}</td>\r\n            <td class=\"width-30\">{{ log.logTypeDescription }}</td>\r\n            <td class=\"width-15\">{{ log.addedBy }}</td>\r\n            <td class=\"width-15\">{{ log.addedOn }}</td>\r\n          </tr>\r\n        </ng-template>\r\n      </p-table>\r\n    </div>\r\n    <!-- End of Results table container-->\r\n    <!-- Close button container-->\r\n    <div class=\"margin-bottom-1-5em\">\r\n      <button\r\n        class=\"ds\"\r\n        pButton\r\n        type=\"button\"\r\n        label=\"{{ 'ACTIONS.CLOSE' | transloco }}\"\r\n        (click)=\"closeViewLogDialogue()\"\r\n      ></button>\r\n    </div>\r\n    <!-- End of Close button container-->\r\n  </div>\r\n</p-dialog>\r\n",
        styles: [""]
    })
], ViewLogTemplateComponent);

let CommonSharedModuleModule = class CommonSharedModuleModule {
};
CommonSharedModuleModule = __decorate([
    NgModule({
        declarations: [ViewLogTemplateComponent],
        imports: [
            CommonModule,
            DialogModule,
            TranslocoModule,
            TableModule,
            CheckboxModule,
            ButtonModule,
        ],
        exports: [ViewLogTemplateComponent],
    })
], CommonSharedModuleModule);

let EditInvoiceComponent = class EditInvoiceComponent {
    constructor() { }
    ngOnInit() { }
};
__decorate([
    Input()
], EditInvoiceComponent.prototype, "form", void 0);
EditInvoiceComponent = __decorate([
    Component({
        selector: 'lib-edit-invoice',
        template: "<div class=\"lui-per-form edit-invoice\" *ngIf=\"form\">\r\n  <form pfForm>\r\n    <div [pfFieldset]=\"form\" class=\"pf-fieldset\">\r\n      <div\r\n        pfStatus=\"marketplaceName\"\r\n        class=\"input-group\"\r\n        style=\"grid-area: 'marketplaceName'\"\r\n      >\r\n        <div class=\"lui-input-vertical\">\r\n          <label pfLabel=\"marketplaceName\"></label>\r\n          <lui-prime-field\r\n            [field]=\"form.schema['marketplaceName']\"\r\n            name=\"marketplaceName\"\r\n          ></lui-prime-field>\r\n        </div>\r\n        <span pfFeedback=\"marketplaceName\"></span>\r\n        <div>\r\n          <b>{{ 'COMMON.NAME' | transloco }}:</b>\r\n          {{ form.values['marketplaceName']?.Name }}\r\n        </div>\r\n        <div>\r\n          <b>{{ 'GROUP.NUMBER' | transloco }}:</b>\r\n          {{ form.values['marketplaceName']?.Number }}\r\n        </div>\r\n        <div>\r\n          <b>{{ 'GROUP.ADDRESS_ONE' | transloco }}:</b>\r\n          {{ form.values['marketplaceName']?.Address }}\r\n        </div>\r\n        <div>\r\n          <b>{{ 'GROUP.ADDRESS_TWO' | transloco }}:</b>\r\n          {{ form.values['marketplaceName']?.Address2 }}\r\n        </div>\r\n        <div>\r\n          <b>{{ 'GROUP.CITY' | transloco }}:</b>\r\n          {{ form.values['marketplaceName']?.City }}\r\n        </div>\r\n        <div>\r\n          <b>{{ 'MEMBER.STATE_PROVINCE' | transloco }}:</b>\r\n          {{ form.values['marketplaceName']?.Province }}\r\n        </div>\r\n        <div>\r\n          <b> {{ 'MEMBER.ZIP_POSTAL_CODE' | transloco }}:</b>\r\n          {{ form.values['marketplaceName']?.PostalCode }}\r\n        </div>\r\n        <div>\r\n          <b>{{ 'MEMBER.COUNTRY' | transloco }}:</b>\r\n          {{ form.values['marketplaceName']?.Country }}\r\n        </div>\r\n      </div>\r\n      <div\r\n        pfStatus=\"supplierName\"\r\n        class=\"input-group\"\r\n        style=\"grid-area: 'supplierName'\"\r\n      >\r\n        <div class=\"lui-input-vertical\">\r\n          <label pfLabel=\"supplierName\"></label>\r\n          <lui-prime-field\r\n            [field]=\"form.schema['supplierName']\"\r\n            name=\"supplierName\"\r\n          ></lui-prime-field>\r\n        </div>\r\n        <span pfFeedback=\"supplierName\"></span>\r\n        <div>\r\n          <b>{{ 'COMMON.NAME' | transloco }}:</b>\r\n          {{ form.values['supplierName']?.Name }}\r\n        </div>\r\n        <div>\r\n          <b>{{ 'GROUP.NUMBER' | transloco }}:</b>\r\n          {{ form.values['supplierName']?.Number }}\r\n        </div>\r\n        <div>\r\n          <b>{{ 'GROUP.ADDRESS_ONE' | transloco }}:</b>\r\n          {{ form.values['supplierName']?.Address }}\r\n        </div>\r\n        <div>\r\n          <b>{{ 'GROUP.ADDRESS_TWO' | transloco }}:</b>\r\n          {{ form.values['supplierName']?.Address2 }}\r\n        </div>\r\n        <div>\r\n          <b>{{ 'GROUP.CITY' | transloco }}:</b>\r\n          {{ form.values['supplierName']?.City }}\r\n        </div>\r\n        <div>\r\n          <b>{{ 'MEMBER.STATE_PROVINCE' | transloco }}:</b>\r\n          {{ form.values['supplierName']?.Province }}\r\n        </div>\r\n        <div>\r\n          <b> {{ 'MEMBER.ZIP_POSTAL_CODE' | transloco }}:</b>\r\n          {{ form.values['supplierName']?.PostalCode }}\r\n        </div>\r\n        <div>\r\n          <b>{{ 'MEMBER.COUNTRY' | transloco }}:</b>\r\n          {{ form.values['supplierName']?.Country }}\r\n        </div>\r\n      </div>\r\n      <div\r\n        pfStatus=\"orderedByName\"\r\n        class=\"input-group\"\r\n        style=\"grid-area: 'orderedByName'\"\r\n      >\r\n        <div class=\"lui-input-vertical\">\r\n          <label pfLabel=\"orderedByName\"></label>\r\n          <lui-prime-field\r\n            [field]=\"form.schema['orderedByName']\"\r\n            name=\"orderedByName\"\r\n          ></lui-prime-field>\r\n        </div>\r\n        <span pfFeedback=\"orderedByName\"></span>\r\n        <div>\r\n          <b>{{ 'COMMON.NAME' | transloco }}:</b>\r\n          {{ form.values['orderedByName']?.Name }}\r\n        </div>\r\n        <div>\r\n          <b>{{ 'GROUP.NUMBER' | transloco }}:</b>\r\n          {{ form.values['orderedByName']?.Number }}\r\n        </div>\r\n        <div>\r\n          <b>{{ 'GROUP.ADDRESS_ONE' | transloco }}:</b>\r\n          {{ form.values['orderedByName']?.Address }}\r\n        </div>\r\n        <div>\r\n          <b>{{ 'GROUP.ADDRESS_TWO' | transloco }}:</b>\r\n          {{ form.values['orderedByName']?.Address2 }}\r\n        </div>\r\n        <div>\r\n          <b>{{ 'GROUP.CITY' | transloco }}:</b>\r\n          {{ form.values['orderedByName']?.City }}\r\n        </div>\r\n        <div>\r\n          <b>{{ 'MEMBER.STATE_PROVINCE' | transloco }}:</b>\r\n          {{ form.values['orderedByName']?.Province }}\r\n        </div>\r\n        <div>\r\n          <b> {{ 'MEMBER.ZIP_POSTAL_CODE' | transloco }}:</b>\r\n          {{ form.values['orderedByName']?.PostalCode }}\r\n        </div>\r\n        <div>\r\n          <b>{{ 'MEMBER.COUNTRY' | transloco }}:</b>\r\n          {{ form.values['orderedByName']?.Country }}\r\n        </div>\r\n      </div>\r\n      <div\r\n        pfStatus=\"shipToName\"\r\n        class=\"input-group\"\r\n        style=\"grid-area: 'shipToName'\"\r\n      >\r\n        <div class=\"lui-input-vertical\">\r\n          <label pfLabel=\"shipToName\"></label>\r\n          <lui-prime-field\r\n            [field]=\"form.schema['shipToName']\"\r\n            name=\"shipToName\"\r\n          ></lui-prime-field>\r\n        </div>\r\n        <span pfFeedback=\"shipToName\"></span>\r\n        <div>\r\n          <b>{{ 'COMMON.NAME' | transloco }}:</b>\r\n          {{ form.values['shipToName']?.Name }}\r\n        </div>\r\n        <div>\r\n          <b>{{ 'GROUP.NUMBER' | transloco }}:</b>\r\n          {{ form.values['shipToName']?.Number }}\r\n        </div>\r\n        <div>\r\n          <b>{{ 'GROUP.ADDRESS_ONE' | transloco }}:</b>\r\n          {{ form.values['shipToName']?.Address }}\r\n        </div>\r\n        <div>\r\n          <b>{{ 'GROUP.ADDRESS_TWO' | transloco }}:</b>\r\n          {{ form.values['shipToName']?.Address2 }}\r\n        </div>\r\n        <div>\r\n          <b>{{ 'GROUP.CITY' | transloco }}:</b>\r\n          {{ form.values['shipToName']?.City }}\r\n        </div>\r\n        <div>\r\n          <b>{{ 'MEMBER.STATE_PROVINCE' | transloco }}:</b>\r\n          {{ form.values['shipToName']?.Province }}\r\n        </div>\r\n        <div>\r\n          <b> {{ 'MEMBER.ZIP_POSTAL_CODE' | transloco }}:</b>\r\n          {{ form.values['shipToName']?.PostalCode }}\r\n        </div>\r\n        <div>\r\n          <b>{{ 'MEMBER.COUNTRY' | transloco }}:</b>\r\n          {{ form.values['shipToName']?.Country }}\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </form>\r\n</div>\r\n",
        styles: [""]
    })
], EditInvoiceComponent);

let EditInvoiceModule = class EditInvoiceModule {
};
EditInvoiceModule = __decorate([
    NgModule({
        declarations: [EditInvoiceComponent],
        imports: [
            ButtonModule$2,
            CommonSharedModuleModule,
            CommonModule,
            DialogModule,
            FormsModule,
            RouterModule,
            TranslocoModule,
            TableModule$1,
            PerFormModule,
            PerFormPrimengModule,
        ],
        exports: [EditInvoiceComponent],
    })
], EditInvoiceModule);

var Status;
(function (Status) {
    Status[Status["ERROR"] = -1] = "ERROR";
    Status[Status["READY"] = 0] = "READY";
    Status[Status["LOADING"] = 1] = "LOADING";
    Status[Status["DONE"] = 2] = "DONE";
})(Status || (Status = {}));
const defaultScreenState = {
    page: 0,
    screens: {},
    status: Status.LOADING,
};
const ɵ0$I = (_, state) => {
    const status = state.status < 0 ? state.status : Status.DONE;
    return { status };
}, ɵ1$d = (status) => ({ status }), ɵ2$b = (screens) => ({ screens }), ɵ3$8 = (_, { page }) => ({
    status: Status.LOADING,
    page: page + 1,
}), ɵ4$4 = (_, { page }) => ({
    status: Status.LOADING,
    page: page - 1,
}), ɵ5$4 = ({ screen, index }, { screens }) => {
    return { screens: Object.assign(Object.assign({}, screens), { [index]: screen }) };
};
const screenSchema = {
    finalize: {
        command: ɵ0$I,
    },
    setStatus: { command: ɵ1$d },
    setScreens: { command: ɵ2$b },
    nextPage: {
        command: ɵ3$8,
    },
    previousPage: {
        command: ɵ4$4,
    },
    addScreen: {
        command: ɵ5$4,
    },
};
const ɵ6$3 = () => ({
    fetchUrl: '/connectors/type',
    fetchMethod: 'GET',
    title: 'New Connector',
    form: (options) => ({
        fields: {
            description: { type: 'text', required: true },
            connectorType: { type: 'pDropdown', options, required: true },
        },
    }),
    response: ({ screenConfig, response }) => {
        const { form } = screenConfig;
        return form(response);
    },
}), ɵ7$2 = ({ screens }) => ({
    fetchUrl: `/connectors/type/${screens[0].connectorType}`,
    fetchMethod: 'GET',
    title: `Configuration`,
    response: ({ response }) => {
        return response;
    },
}), ɵ8$2 = ({ screens }) => ({
    fetchUrl: `/connectors/type/${screens[0].connectorType}/form`,
    fetchMethod: 'POST',
    title: `Actions`,
    response: ({ response }) => {
        return response;
    },
});
const wizardConfig$2 = [
    ɵ6$3,
    ɵ7$2,
    ɵ8$2,
];

var DefaultButtons;
(function (DefaultButtons) {
    DefaultButtons["CANCEL"] = "cancel";
    DefaultButtons["NEXT"] = "next";
    DefaultButtons["PREVIOUS"] = "previous";
    DefaultButtons["SUBMIT"] = "submit";
})(DefaultButtons || (DefaultButtons = {}));
const defaultButtonProperties = {
    icon: '',
    iconPos: 'left',
    style: {},
};
const ɵ0$J = ({ events }) => {
    events.cancel.emit();
}, ɵ1$e = (state, form) => false, ɵ2$c = ({ actions, state, form }) => {
    actions.addScreen.dispatch({
        screen: form.values,
        index: state.page,
    });
    actions.nextPage.dispatch();
}, ɵ3$9 = (state, form) => !(form === null || form === void 0 ? void 0 : form.valid), ɵ4$5 = ({ actions }) => {
    actions.previousPage.dispatch();
}, ɵ5$5 = (state, form) => state.page === 0, ɵ6$4 = ({ actions, form, state, events }) => {
    actions.addScreen.dispatch({
        screen: form.values,
        index: state.page,
    });
    events.submit.emit();
}, ɵ7$3 = (state, form) => !(form === null || form === void 0 ? void 0 : form.valid), ɵ8$3 = (_) => { }, ɵ9$2 = (state, form) => false;
const buttonDefaults = {
    cancel: {
        label: '',
        componentProperties: defaultButtonProperties,
        role: 'secondary',
        callback: ɵ0$J,
        disabled: ɵ1$e,
    },
    next: {
        label: '',
        componentProperties: defaultButtonProperties,
        role: 'primary',
        callback: ɵ2$c,
        disabled: ɵ3$9,
    },
    previous: {
        label: '',
        componentProperties: defaultButtonProperties,
        role: 'secondary',
        callback: ɵ4$5,
        disabled: ɵ5$5,
    },
    submit: {
        label: '',
        componentProperties: defaultButtonProperties,
        role: 'primary',
        callback: ɵ6$4,
        disabled: ɵ7$3,
    },
    default: {
        label: '',
        componentProperties: defaultButtonProperties,
        role: 'primary',
        callback: ɵ8$3,
        disabled: ɵ9$2,
    },
};

let ScreenComponent = class ScreenComponent {
    constructor(actionUi, formGenerator, http) {
        this.actionUi = actionUi;
        this.formGenerator = formGenerator;
        this.http = http;
        this.screenSubmit = new EventEmitter();
        this.screenCancel = new EventEmitter();
        this.fetch = new Subject();
        this.statusEnum = Status;
        this.isValid = false;
        this.actionUi.state
            .pipe(tap((state) => (this.state = Object.assign({}, state))), tap((state) => (this.status = state.status)), tap((_) => { var _a; return (this.isValid = ((_a = this.form) === null || _a === void 0 ? void 0 : _a.valid) || false); }), takeUntil(this.actionUi.shouldDestroy))
            .subscribe();
        this.fetch
            .pipe(exhaustMap(() => this.request.pipe(catchError((err) => {
            this.actions.setStatus.dispatch(Status.ERROR);
            return of(err);
        }), finalize(() => this.actions.finalize.dispatch()))), tap((form) => {
            this.form = this.formGenerator.init(this.screen.response({
                screenConfig: this.screen,
                response: form,
            }), this.state.screens[this.state.page] || {});
        }), takeUntil(this.actionUi.shouldDestroy))
            .subscribe();
    }
    buildRequest() {
        this.request = this.http.fetchWithFqn({
            endpoint: this.screen.fetchUrl,
            httpMethod: this.screen.fetchMethod,
            responseField: this.screen.responseField,
            body: this.screen.body,
        });
    }
    ngOnInit() {
        this.screen = this.config(this.state);
        this.buttons = this.addButtonDefaults(this.screen.buttons);
        this.buildRequest();
        this.fetch.next();
    }
    submit() {
        this.actions.setStatus.dispatch(Status.LOADING);
        this.actions.addScreen.dispatch({
            screen: this.form.values,
            index: this.state.page,
        });
        this.actions.nextPage.dispatch();
        this.screenSubmit.emit();
    }
    previous() {
        this.actions.setStatus.dispatch(Status.LOADING);
        this.actions.previousPage.dispatch();
    }
    addButtonDefaults(buttons) {
        return Object.entries(buttons).reduce((controlSchema, [key, button]) => {
            const newButton = button.componentProperties
                ? Object.assign(Object.assign({}, button), { componentProperties: Object.assign(Object.assign({}, defaultButtonProperties), button.componentProperties) }) : Object.assign(Object.assign({}, button), { componentProperties: Object.assign({}, defaultButtonProperties) });
            switch (key) {
                case DefaultButtons.CANCEL:
                    return Object.assign(Object.assign({}, controlSchema), { [key]: Object.assign(Object.assign({}, buttonDefaults.cancel), newButton) });
                case DefaultButtons.NEXT:
                    return Object.assign(Object.assign({}, controlSchema), { [key]: Object.assign(Object.assign({}, buttonDefaults.next), newButton) });
                case DefaultButtons.PREVIOUS:
                    return Object.assign(Object.assign({}, controlSchema), { [key]: Object.assign(Object.assign({}, buttonDefaults.previous), newButton) });
                case DefaultButtons.SUBMIT:
                    return Object.assign(Object.assign({}, controlSchema), { [key]: Object.assign(Object.assign({}, buttonDefaults.submit), newButton) });
                default:
                    return Object.assign(Object.assign({}, controlSchema), { [key]: Object.assign(Object.assign({}, buttonDefaults.default), newButton) });
            }
        }, {});
    }
    get screenControls() {
        return {
            actions: this.actions,
            state: this.state,
            form: this.form,
            events: { submit: this.screenSubmit, cancel: this.screenCancel },
        };
    }
    preserveOrder() {
        return 0;
    }
};
ScreenComponent.ctorParameters = () => [
    { type: ActionUiService },
    { type: GenerateFormService },
    { type: BaseHttpService }
];
__decorate([
    Input()
], ScreenComponent.prototype, "config", void 0);
__decorate([
    Input()
], ScreenComponent.prototype, "actions", void 0);
__decorate([
    Output()
], ScreenComponent.prototype, "screenSubmit", void 0);
__decorate([
    Output()
], ScreenComponent.prototype, "screenCancel", void 0);
ScreenComponent = __decorate([
    Component({
        selector: 'lib-screen',
        template: "<div class=\"screen\" style=\"display: flex; flex-direction: column\">\r\n  <div style=\"flex-grow: 1; position: relative\">\r\n    <ng-container *ngIf=\"status === statusEnum.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n    <ng-container *ngIf=\"status === statusEnum.READY\"> ready</ng-container>\r\n    <ng-container *ngIf=\"status === statusEnum.LOADING\">\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-container>\r\n    <ng-container *ngIf=\"status === statusEnum.DONE\">\r\n      <div style=\"display: flex; justify-content: center\">\r\n        <h2>{{ screen.title }}</h2>\r\n      </div>\r\n      <lui-form *ngIf=\"form\" [form]=\"form\"></lui-form>\r\n    </ng-container>\r\n  </div>\r\n  <div\r\n    class=\"contols\"\r\n    style=\"display: flex; gap: 0.5em; padding-top: 1em; margin-bottom: 5em\"\r\n  >\r\n    <button\r\n      *ngFor=\"let button of buttons | keyvalue: preserveOrder\"\r\n      pButton\r\n      (click)=\"button.value.callback(screenControls)\"\r\n      [disabled]=\"button.value.disabled(state, form)\"\r\n      [icon]=\"button.value.componentProperties.icon\"\r\n      [iconPos]=\"button.value.componentProperties.iconPos\"\r\n      [label]=\"button.value.label\"\r\n      [ngStyle]=\"button.value.componentProperties.style\"\r\n      class=\"ds {{ button.value.role }}\"\r\n    ></button>\r\n  </div>\r\n</div>\r\n",
        styles: [".controls{display:flex;flex-direction:row}"]
    })
], ScreenComponent);

let WizardComponent = class WizardComponent {
    constructor(actionUi) {
        this.actionUi = actionUi;
        this.defaultState = {};
        this.finalize = new EventEmitter();
        this.cancel = new EventEmitter();
        this.page = new EventEmitter();
        this.actions = Action.createDispatcher(screenSchema);
    }
    ngOnInit() {
        this.actionUi.initialize(Object.assign(Object.assign({}, defaultScreenState), this.defaultState), this.actions);
        this.actionUi.state
            .pipe(tap((state) => (this.state = Object.assign({}, state))), queryChange('page'), tap((page) => this.page.emit(page)), takeUntil(this.actionUi.shouldDestroy))
            .subscribe();
    }
    screenSubmit() {
        this.finalize.emit(Object.values(this.state.screens));
    }
};
WizardComponent.ctorParameters = () => [
    { type: ActionUiService }
];
__decorate([
    Input()
], WizardComponent.prototype, "wizardConfig", void 0);
__decorate([
    Input()
], WizardComponent.prototype, "defaultState", void 0);
__decorate([
    Output()
], WizardComponent.prototype, "finalize", void 0);
__decorate([
    Output()
], WizardComponent.prototype, "cancel", void 0);
__decorate([
    Output()
], WizardComponent.prototype, "page", void 0);
WizardComponent = __decorate([
    Component({
        selector: 'lib-wizard',
        template: "<div class=\"wizard\" [ngClass]=\"{ 'visible-dropdown': state.page === 0 }\">\r\n  <ng-container *ngFor=\"let screen of wizardConfig; index as i\">\r\n    <lib-screen\r\n      *ngIf=\"state.page === i\"\r\n      appScreen\r\n      [config]=\"screen\"\r\n      [actions]=\"actions\"\r\n      (screenCancel)=\"cancel.emit()\"\r\n      (screenSubmit)=\"screenSubmit()\"\r\n    ></lib-screen>\r\n  </ng-container>\r\n</div>\r\n",
        providers: [ActionUiService]
    })
], WizardComponent);

let WizardModule = class WizardModule {
};
WizardModule = __decorate([
    NgModule({
        declarations: [WizardComponent, ScreenComponent],
        imports: [
            CommonModule,
            PerFormPrimengModule,
            PerFormModule,
            ButtonModule$3,
            ProgressSpinnerModule$2,
            TranslocoModule,
        ],
        exports: [WizardComponent],
    })
], WizardModule);

var FilterType;
(function (FilterType) {
    FilterType["FILTER"] = "filter";
    FilterType["SORT_FIELD"] = "sortField";
    FilterType["SORT_ORDER"] = "sortOrder";
    FilterType["VARIANCE"] = "variance";
})(FilterType || (FilterType = {}));
const createReportFilters = (form) => {
    return Object.entries(form.values).reduce((reportFilters, [key, value]) => {
        switch (form.schema[key].filterType) {
            case FilterType.VARIANCE:
                return Object.assign(Object.assign({}, reportFilters), { variances: [
                        ...reportVariance(key, value ? value[0] : null, value ? value[1] : null, form.schema[key].varianceCount),
                    ] });
            case FilterType.FILTER:
                return Object.assign(Object.assign({}, reportFilters), { filters: Object.assign(Object.assign({}, reportFilters.filters), doForType(form.schema, key, value)) });
            case FilterType.SORT_FIELD:
                return Object.assign(Object.assign({}, reportFilters), { sort: value === '' || value === null || value === undefined
                        ? []
                        : [
                            Object.assign(Object.assign({}, reportFilters.sort[0]), { field: value }),
                        ] });
            case FilterType.SORT_ORDER:
                return Object.assign(Object.assign({}, reportFilters), { sort: value === '' || value === null || value === undefined
                        ? []
                        : [
                            Object.assign(Object.assign({}, reportFilters.sort[0]), { order: value }),
                        ] });
            default:
                return Object.assign({}, reportFilters);
        }
    }, { variances: [], filters: {}, sort: [] });
};
const reportVariance = (name, min, max, count = 1) => {
    let variance = [];
    for (let i = 0; i < count; i++) {
        variance = [
            ...variance,
            dateRange(name, min ? sub(min, { years: i }) : null, max ? sub(max, { years: i }) : null),
        ];
    }
    return variance;
};
const createSort = (values, sortField, orderField) => {
    return values[sortField]
        ? [
            {
                field: values[sortField],
                order: values[orderField] ? values[orderField] : 1,
            },
        ]
        : [];
};
const createFilters = (schema, values) => {
    return Object.entries(values).reduce((filters, [key, value]) => (Object.assign(Object.assign({}, filters), doForType(schema, key, value))), {});
};
const doForType = (schema, name, value) => {
    switch (schema[name].type) {
        case 'dateRange':
        case 'dateTimeRange':
            return dateRange(name, value ? value[0] : null, value ? value[1] : null);
        case 'checkboxSelection':
        case 'multiSelect':
            return eqArray(name, value);
        case 'text':
            return fz(name, value);
        default:
            return eq(name, value);
    }
};
const fz = (name, value = '') => {
    return value === '' ? {} : { [name]: { fz: [value] } };
};
const ɵ0$K = fz;
const dateRange = (name, min, max) => {
    const body = Object.assign({}, min && { gte: [min.toISOString().split('T')[0]] }, max && { lt: [add$1(max, { days: 1 }).toISOString().split('T')[0]] });
    return min || max
        ? {
            [name]: body,
        }
        : {};
};
const ɵ1$f = dateRange;
// const dateRange = ( name: string, min: any, max:)
const range = (name, min, max) => {
    const body = Object.assign({}, min && { gte: [`${min}`] }, max && { lte: [`${max}`] });
    return min || max
        ? {
            [name]: body,
        }
        : {};
};
const ɵ2$d = range;
const eqArray = (name, values = []) => {
    return (values === null || values === void 0 ? void 0 : values.length) === 0 || (values === null || values === void 0 ? void 0 : values.length) === undefined
        ? {}
        : { [name]: { eq: values } };
};
const ɵ3$a = eqArray;
const eq = (name, value = null) => {
    return `${value}` && value !== null
        ? {
            [name]: {
                eq: [
                    value.constructor === Date
                        ? value.toISOString().split('T')[0]
                        : `${value}`,
                ],
            },
        }
        : {};
};
const ɵ4$6 = eq;

const deconstructParams = (schema, filters) => {
    return Object.entries(filters || {}).reduce((initialValues, [key, filter]) => {
        return Object.assign(Object.assign({}, initialValues), deconstructFilter(schema, key, filter));
    }, {});
};
const deconstructFilter = (schema, key, filter) => {
    switch (schema[key].type) {
        case 'text':
            return fz$1(key, filter);
        case 'dateRange':
        case 'dateTimeRange':
            return dateRange$1(key, filter);
        case 'checkboxSelection':
        case 'multiSelect':
            return eqArray$1(key, filter);
        case 'dropdown':
            return eq$1(key, filter);
        default:
            return {};
    }
};
const ɵ0$L = deconstructFilter;
const fz$1 = (key, filter) => {
    return (filter === null || filter === void 0 ? void 0 : filter.fz) ? ((filter === null || filter === void 0 ? void 0 : filter.fz[0]) ? { [key]: filter === null || filter === void 0 ? void 0 : filter.fz[0] } : {}) : {};
};
const ɵ1$g = fz$1;
const dateRange$1 = (key, filter) => {
    return (filter === null || filter === void 0 ? void 0 : filter.gte) || (filter === null || filter === void 0 ? void 0 : filter.lt)
        ? {
            [key]: [
                (filter === null || filter === void 0 ? void 0 : filter.gte) ? (filter === null || filter === void 0 ? void 0 : filter.gte[0]) ? new Date(filter.gte[0])
                    : null
                    : null,
                (filter === null || filter === void 0 ? void 0 : filter.lt) ? (filter === null || filter === void 0 ? void 0 : filter.lt[0]) ? add$1(new Date(filter.lt[0]), { days: -1 })
                    : null
                    : null,
            ],
        }
        : {};
};
const ɵ2$e = dateRange$1;
const eqArray$1 = (key, filter) => {
    return (filter === null || filter === void 0 ? void 0 : filter.eq) ? { [key]: filter.eq } : {};
};
const ɵ3$b = eqArray$1;
const eq$1 = (key, filter) => {
    return (filter === null || filter === void 0 ? void 0 : filter.eq) ? (filter.eq[0] ? { [key]: filter.eq[0] } : {}) : {};
};
const ɵ4$7 = eq$1;

var WidgetTypes;
(function (WidgetTypes) {
    WidgetTypes["CHART"] = "chart";
    WidgetTypes["KPI"] = "kpi";
    WidgetTypes["GAUGE"] = "gauge";
})(WidgetTypes || (WidgetTypes = {}));
const ɵ0$M = (_, state) => {
    const status = state.status < 0 ? state.status : AnalyticsStatus.DONE;
    return { status };
}, ɵ1$h = (configured) => ({ configured }), ɵ2$f = (gridArea) => ({ gridArea }), ɵ3$c = (status) => ({ status }), ɵ4$8 = ({ index, name }, { configured }) => {
    const newConfigured = [...configured];
    newConfigured[index] = name;
    return { configured: [...newConfigured] };
}, ɵ5$6 = (state) => (Object.assign({}, state));
const dashboardSchema$1 = {
    finalize: {
        command: ɵ0$M,
    },
    setConfigured: { command: ɵ1$h },
    setGridArea: { command: ɵ2$f },
    setStatus: { command: ɵ3$c },
    setWidget: {
        command: ɵ4$8,
    },
    updateState: {
        command: ɵ5$6,
    },
};
const defaultDashboardState$2 = {
    configured: [],
    types: [],
    gridArea: [],
    available: {},
    status: AnalyticsStatus.READY,
};

const formSchema = (options, type, close, transloco) => ({
    layout: {
        'row-gap': '1em',
    },
    controls: {
        cancel: {
            label: transloco.translate('ACTIONS.CANCEL'),
            callback: close,
            role: FormControlRole.SECONDARY,
        },
        save: {
            label: transloco.translate('ACTIONS.SAVE'),
            disabled: (form) => {
                var _a;
                return !((_a = form === null || form === void 0 ? void 0 : form.values) === null || _a === void 0 ? void 0 : _a.selectWidget);
            },
            componentProperties: {
                style: {
                    'flex-grow': 1,
                },
            },
        },
    },
    fields: {
        selectWidget: {
            type: 'dropdown',
            label: '',
            defaultValue: null,
            options: [...options],
            componentProperties: {
                placeholder: type === WidgetTypes.KPI
                    ? transloco.translate('ANALYTICS.SELECT_KPI')
                    : transloco.translate('ANALYTICS.SELECT_CHART'),
                filter: true,
            },
        },
    },
});

let WidgetSelectionComponent = class WidgetSelectionComponent {
    constructor(formGenerator, ref, dialogConfig, translocoService) {
        this.formGenerator = formGenerator;
        this.ref = ref;
        this.dialogConfig = dialogConfig;
        this.translocoService = translocoService;
        this.widgetTypes = WidgetTypes;
        this.close = () => this.ref.close();
        this.dashState = this.dialogConfig.data.state;
        this.type = this.dialogConfig.data.type;
    }
    ngOnInit() {
        this.form = this.formGenerator.init(formSchema(this.buildOptions(this.dashState), this.type, this.close, this.translocoService));
    }
    buildOptions(state) {
        return Object.entries(state).reduce((options, [key, value]) => {
            var _a, _b;
            return value.type === this.type
                ? [
                    ...options,
                    {
                        label: ((_a = value === null || value === void 0 ? void 0 : value.widgets) === null || _a === void 0 ? void 0 : _a.subTitle) ? `${(value === null || value === void 0 ? void 0 : value.description) || ''} | ${(_b = value === null || value === void 0 ? void 0 : value.widgets) === null || _b === void 0 ? void 0 : _b.subTitle}`
                            : (value === null || value === void 0 ? void 0 : value.description) || '',
                        value: key,
                    },
                ]
                : [...options];
        }, []);
    }
    submit(values) {
        this.ref.close(values.selectWidget);
    }
};
WidgetSelectionComponent.ctorParameters = () => [
    { type: GenerateFormService },
    { type: DynamicDialogRef$1 },
    { type: DynamicDialogConfig$1 },
    { type: TranslocoService }
];
WidgetSelectionComponent = __decorate([
    Component({
        selector: 'lib-app-widget-selection',
        template: "<h2 class=\"dialog-title\">\r\n  {{\r\n    (type === widgetTypes.KPI\r\n      ? 'ANALYTICS.KPI_SELECTION'\r\n      : 'ANALYTICS.CHART_SELECTION'\r\n    ) | transloco\r\n  }}\r\n</h2>\r\n<lui-form [form]=\"form\" (save)=\"submit($event)\"></lui-form>\r\n",
        styles: [":host ::ng-deep .lui-per-form{margin-bottom:10em}"]
    })
], WidgetSelectionComponent);

let DashboardLoaderComponent = class DashboardLoaderComponent {
    constructor(actionUi, formGenerator, dialogService, route, router, http, mp, siteTypeService) {
        this.actionUi = actionUi;
        this.formGenerator = formGenerator;
        this.dialogService = dialogService;
        this.route = route;
        this.router = router;
        this.http = http;
        this.mp = mp;
        this.siteTypeService = siteTypeService;
        this.configEndpoint = '';
        this.paramListener = true;
        this.header = '';
        this.fetch = new Subject();
        this.templateTypes = TemplateTypes$1;
        this.widgetTypes = WidgetTypes;
        this.actions = Action.createDispatcher(dashboardSchema$1);
        this.dashboardFilters = {};
        this.icons = [
            { icon: 'pi pi-refresh', callback: (controls) => controls.refresh() },
            {
                icon: 'pi pi-ellipsis-v',
                callback: (controls) => this.setChart(controls.index),
            },
        ];
        this.dashConfig = {};
        this.actionUi.initialize(defaultDashboardState$2, this.actions);
        this.actionUi.state
            .pipe(tap((state) => (this.state = Object.assign({}, state))), tap(({ available }) => (this.dashConfig = Object.entries(available).reduce((widgets, [key, availableWidget]) => {
            var _a, _b;
            const type = key.toLowerCase().includes(WidgetTypes.KPI)
                ? WidgetTypes.KPI
                : WidgetTypes.CHART;
            switch (type) {
                case WidgetTypes.KPI:
                    return Object.assign(Object.assign({}, widgets), { [key]: {
                            description: (availableWidget === null || availableWidget === void 0 ? void 0 : availableWidget.label) || '',
                            type,
                            widgets: {
                                type: availableWidget.type,
                                title: availableWidget === null || availableWidget === void 0 ? void 0 : availableWidget.label,
                                subTitle: (availableWidget === null || availableWidget === void 0 ? void 0 : availableWidget.subLabel) || '',
                                query: availableWidget.defaultQuery || {},
                                endpoint: this.mp.getConfig().apiBaseUrl +
                                    '/analytics/query' +
                                    availableWidget.endpoint,
                                kpiConfig: Object.assign({}, availableWidget),
                                redirect: (_a = availableWidget === null || availableWidget === void 0 ? void 0 : availableWidget.redirect) !== null && _a !== void 0 ? _a : null,
                            },
                        } });
                case WidgetTypes.CHART:
                    return Object.assign(Object.assign({}, widgets), { [key]: {
                            description: (availableWidget === null || availableWidget === void 0 ? void 0 : availableWidget.label) || '',
                            type,
                            widgets: {
                                [key]: {
                                    label: (availableWidget === null || availableWidget === void 0 ? void 0 : availableWidget.label) || '',
                                    query: (availableWidget === null || availableWidget === void 0 ? void 0 : availableWidget.defaultQuery) || {},
                                    endpoint: this.mp.getConfig().apiBaseUrl +
                                        '/analytics/query' +
                                        availableWidget.endpoint,
                                    type: availableWidget.type === 'line'
                                        ? 'projected'
                                        : availableWidget.type,
                                    colorType: availableWidget.colorType || ColorType.SERIES,
                                    options: (availableWidget === null || availableWidget === void 0 ? void 0 : availableWidget.options) || {},
                                    config: Object.assign({}, availableWidget),
                                    columns: availableWidget === null || availableWidget === void 0 ? void 0 : availableWidget.columns,
                                    redirect: (_b = availableWidget === null || availableWidget === void 0 ? void 0 : availableWidget.redirect) !== null && _b !== void 0 ? _b : null,
                                },
                            },
                        } });
            }
        }, {}))), takeUntil(this.actionUi.shouldDestroy))
            .subscribe();
        this.fetch
            .pipe(tap(() => this.actions.setStatus.dispatch(AnalyticsStatus.LOADING)), switchMap(() => forkJoin([
            this.http
                .get(this.configEndpoint, {
                withCredentials: true,
            })
                .pipe(
            // map(() => mockConfig),
            map(({ record }) => record)),
            this.route.queryParams.pipe(first()),
        ]).pipe(catchError((err) => {
            this.actions.setStatus.dispatch(AnalyticsStatus.ERROR);
            this.router.navigate(['/home']);
            return of(err);
        }))), tap(([{ label, filters, widgets }, params]) => {
            var _a, _b;
            this.header = label;
            this.form = this.formGenerator.init({
                fields: filters,
                layout: window.innerWidth > 592
                    ? {
                        'grid-template-columns': '1fr 1fr 1fr 1fr',
                        'column-gap': '1.5em',
                    }
                    : {},
            }, deconstructParams(filters, this.paramListener
                ? (params === null || params === void 0 ? void 0 : params.filters) ? JSON.parse(params === null || params === void 0 ? void 0 : params.filters)
                    : {}
                : {}));
            this.actions.updateState.dispatch({
                gridArea: ((_a = widgets === null || widgets === void 0 ? void 0 : widgets.grid) === null || _a === void 0 ? void 0 : _a.layout) || [],
                types: ((_b = widgets === null || widgets === void 0 ? void 0 : widgets.grid) === null || _b === void 0 ? void 0 : _b.types) || [],
                configured: (widgets === null || widgets === void 0 ? void 0 : widgets.configured) || [],
                available: (widgets === null || widgets === void 0 ? void 0 : widgets.available) || {},
                smallGridArea: {
                    breakPoint: 592,
                    gridArea: widgets === null || widgets === void 0 ? void 0 : widgets.configured.reduce((grid, _, index) => [
                        ...grid,
                        [index],
                    ], []),
                },
            });
            this.form.values$
                .pipe(map((dashboardFilters) => (this.dashboardFilters = createFilters(this.form.schema, dashboardFilters))), tap((formFilters) => this.router.navigate(['./'], {
                relativeTo: this.route,
                queryParams: Object.keys(formFilters).length !== 0
                    ? { filters: JSON.stringify(formFilters) }
                    : {},
            })), takeUntil(this.actionUi.shouldDestroy))
                .subscribe();
        }), tap(() => this.actions.finalize.dispatch()), takeUntil(this.actionUi.shouldDestroy))
            .subscribe();
    }
    ngOnInit() {
        this.fetch.next();
    }
    setChart(index) {
        const type = this.state.types[index];
        const ref = this.dialogService.open(WidgetSelectionComponent, {
            data: {
                state: Object.assign({}, this.dashConfig),
                type,
            },
            showHeader: false,
            styleClass: `kpi-dialog ${this.siteTypeService.siteName}`,
        });
        ref.onClose
            .pipe(tap((name) => name && this.actions.setWidget.dispatch({ index, name })), tap((name) => name &&
            this.http
                .post(this.configEndpoint, {
                widgets: [...this.state.configured],
            }, { withCredentials: true })
                .pipe(takeUntil(this.actionUi.shouldDestroy))
                .subscribe()), takeUntil(this.actionUi.shouldDestroy))
            .subscribe();
    }
};
DashboardLoaderComponent.ctorParameters = () => [
    { type: ActionUiService },
    { type: GenerateFormService },
    { type: DialogService },
    { type: ActivatedRoute },
    { type: Router },
    { type: HttpClient },
    { type: MarketplaceService },
    { type: SiteTypeService }
];
__decorate([
    Input()
], DashboardLoaderComponent.prototype, "configEndpoint", void 0);
__decorate([
    Input()
], DashboardLoaderComponent.prototype, "chartAdaptor", void 0);
__decorate([
    Input()
], DashboardLoaderComponent.prototype, "kpiAdaptor", void 0);
__decorate([
    Input()
], DashboardLoaderComponent.prototype, "chartNoDataTest", void 0);
__decorate([
    Input()
], DashboardLoaderComponent.prototype, "paramListener", void 0);
DashboardLoaderComponent = __decorate([
    Component({
        selector: 'lib-app-dashboard-loader',
        template: "<h2>{{ header }}</h2>\r\n<lui-form *ngIf=\"form\" [form]=\"form\"></lui-form>\r\n<lbmx-dashboard-wrapper class=\"position-relative\">\r\n  <ng-template [laTemplate]=\"templateTypes.DONE\" let-dashboardState>\r\n    <ng-container *ngFor=\"let name of dashboardState.configured; let i = index\">\r\n      <ng-container\r\n        [ngSwitch]=\"dashConfig[name] ? dashConfig[name].type : null\"\r\n      >\r\n        <lbmx-kpi\r\n          *ngSwitchCase=\"'kpi'\"\r\n          laWidget\r\n          [config]=\"dashConfig[name].widgets\"\r\n          [filters]=\"dashboardFilters\"\r\n          [icons]=\"icons\"\r\n          [handle]=\"i\"\r\n          [adaptor]=\"kpiAdaptor\"\r\n          class=\"position-relative elevated\"\r\n          style=\"min-height: 15vh\"\r\n        >\r\n          <ng-template [laTemplate]=\"templateTypes.READY\">\r\n            <div class=\"center ready\">\r\n              <h1>{{ 'ANALYTICS.SELECT_KPI' | transloco }}</h1>\r\n            </div>\r\n          </ng-template>\r\n          <ng-template [laTemplate]=\"templateTypes.LOADING\">\r\n            <div class=\"spinner-background\">\r\n              <p-progressSpinner\r\n                styleClass=\"custom-spinner\"\r\n              ></p-progressSpinner>\r\n            </div>\r\n          </ng-template>\r\n          <ng-template [laTemplate]=\"templateTypes.ERROR\">\r\n            <div class=\"center error\" style=\"cursor: default\">\r\n              <div class=\"message\">\r\n                <i class=\"pi pi-times-circle\"></i>\r\n                <span>{{ 'ANALYTICS.ERROR' | transloco }}</span>\r\n              </div>\r\n            </div>\r\n          </ng-template>\r\n        </lbmx-kpi>\r\n        <lbmx-tab-chart\r\n          *ngSwitchCase=\"'chart'\"\r\n          laWidget\r\n          [chartTabs]=\"dashConfig[name].widgets\"\r\n          [filters]=\"dashboardFilters\"\r\n          [adaptor]=\"chartAdaptor\"\r\n          [icons]=\"icons\"\r\n          [handle]=\"i\"\r\n          [noDataTest]=\"chartNoDataTest\"\r\n          class=\"position-relative elevated\"\r\n          style=\"min-height: 20vh\"\r\n        >\r\n          <ng-template [laTemplate]=\"templateTypes.READY\">\r\n            <div class=\"center ready\">\r\n              <h1>{{ 'ANALYTICS.SELECT_KPI' | transloco }}</h1>\r\n            </div>\r\n          </ng-template>\r\n          <ng-template [laTemplate]=\"templateTypes.LOADING\">\r\n            <div class=\"spinner-background\">\r\n              <p-progressSpinner\r\n                styleClass=\"custom-spinner\"\r\n              ></p-progressSpinner>\r\n            </div>\r\n          </ng-template>\r\n          <ng-template [laTemplate]=\"templateTypes.ERROR\">\r\n            <div class=\"center error\" style=\"cursor: default\">\r\n              <div class=\"message\">\r\n                <i class=\"pi pi-times-circle\"></i>\r\n                <span>{{ 'ANALYTICS.ERROR' | transloco }}</span>\r\n              </div>\r\n            </div>\r\n          </ng-template>\r\n          <ng-template [laTemplate]=\"templateTypes.NO_DATA\">\r\n            <div class=\"center\">\r\n              <h1>{{ 'ANALYTICS.NO_DATA' | transloco }}</h1>\r\n            </div>\r\n          </ng-template>\r\n        </lbmx-tab-chart>\r\n        <div\r\n          *ngSwitchDefault\r\n          laWidget\r\n          class=\"position-relative elevated\"\r\n          style=\"min-height: 15vh\"\r\n          (click)=\"setChart(i)\"\r\n        >\r\n          <div\r\n            class=\"clickable\"\r\n            style=\"\r\n              height: 100%;\r\n              display: flex;\r\n              justify-content: center;\r\n              align-items: center;\r\n            \"\r\n          >\r\n            <h1>\r\n              {{\r\n                (dashboardState.types[i] === widgetTypes.KPI\r\n                  ? 'ANALYTICS.SELECT_KPI'\r\n                  : 'ANALYTICS.SELECT_CHART'\r\n                ) | transloco\r\n              }}\r\n            </h1>\r\n          </div>\r\n        </div>\r\n      </ng-container>\r\n    </ng-container>\r\n  </ng-template>\r\n  <ng-template [laTemplate]=\"templateTypes.LOADING\">\r\n    <div class=\"spinner-background\">\r\n      <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n    </div>\r\n  </ng-template>\r\n</lbmx-dashboard-wrapper>\r\n",
        providers: [ActionUiService, DialogService],
        styles: [":host ::ng-deep .dashboard>.body{position:relative;min-height:40vh;grid-auto-rows:unset;gap:1.5em}:host ::ng-deep .widget{display:flex;flex-direction:column}:host ::ng-deep .widget .body{height:100%;width:100%}:host ::ng-deep .widget .body .center{height:100%;display:flex;justify-content:center;align-items:center}:host ::ng-deep .la-negative .widget{background-color:#bd0024}:host ::ng-deep .la-negative .widget i{color:#fff}:host ::ng-deep .la-negative .widget .la-widget-header{color:#fff}:host ::ng-deep .la-negative .widget .la-widget-value{color:#fff}:host ::ng-deep .la-negative .widget .la-widget-subtitle{color:#fff}:host ::ng-deep .la-negative .widget .la-widget-sub{display:flex;flex-direction:row;justify-content:center}:host ::ng-deep .la-negative .widget .la-widget-sub .la-widget-variance{font-weight:700;color:#fff}:host ::ng-deep .la-positive .widget .la-widget-sub{display:flex;flex-direction:row;justify-content:center}:host ::ng-deep .la-widget:has(.la-widget-fullscreen){position:absolute;left:0;background-color:#fff;right:0;top:0;bottom:0;z-index:50}:host ::ng-deep .pointer{cursor:pointer}:host ::ng-deep .tab-widget{height:100%;width:100%}:host ::ng-deep .tab-widget .tab-header{display:flex}:host ::ng-deep .tab-widget .tab-header .header{flex-grow:1;display:flex;justify-content:flex-end;align-items:center;-moz-column-gap:.5em;column-gap:.5em;padding:.5em .5em .75em}:host ::ng-deep .tab-widget .tab-header .tabs{padding:0 1em;display:flex;-moz-column-gap:.5em;column-gap:.5em}:host ::ng-deep .tab-widget .tab-header .tabs .header.selected{font-weight:400}:host ::ng-deep .tab-widget .body{padding:0 1em .5em;height:100%}:host ::ng-deep .tab-widget .center{height:100%;display:flex;justify-content:center;align-items:center}"]
    })
], DashboardLoaderComponent);

let DashboardTemplateComponent = class DashboardTemplateComponent {
    constructor(activatedRoute, mp) {
        this.activatedRoute = activatedRoute;
        this.mp = mp;
        this.endpoint = '';
        this.adaptor = transformResponse;
        this.kpiAdaptor = kpiAdaptor;
        this.chartNoDataTest = chartNoDataTest;
        this.load = false;
    }
    ngOnInit() {
        this.activatedRoute.params
            .pipe(tap(() => (this.load = false)), delay(0), tap(() => (this.load = true)), tap((data) => (this.endpoint = `${this.mp.getConfig().apiBaseUrl + '/analytics/query/dashboard/'}${data === null || data === void 0 ? void 0 : data.dashboard}`)))
            .subscribe();
    }
};
DashboardTemplateComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: MarketplaceService }
];
DashboardTemplateComponent = __decorate([
    Component({
        selector: 'lib-app-dashboard-template',
        template: "<lib-app-dashboard-loader\r\n  *ngIf=\"load\"\r\n  [configEndpoint]=\"endpoint\"\r\n  [chartAdaptor]=\"adaptor\"\r\n  [kpiAdaptor]=\"kpiAdaptor\"\r\n  [chartNoDataTest]=\"chartNoDataTest\"\r\n></lib-app-dashboard-loader>\r\n",
        styles: [""]
    })
], DashboardTemplateComponent);

let MarketplaceAnalyticsModule = class MarketplaceAnalyticsModule {
};
MarketplaceAnalyticsModule = __decorate([
    NgModule({
        declarations: [
            DashboardLoaderComponent,
            DashboardTemplateComponent,
            WidgetSelectionComponent,
        ],
        imports: [
            AnalyticsModule,
            CdTableModule,
            CommonModule,
            DynamicDialogModule,
            PerFormPrimengModule,
            ProgressSpinnerModule$1,
            TranslocoModule,
            FlexmonsterPivotModule,
            DropdownModule,
            FormsModule,
            InputTextModule,
            ReactiveFormsModule,
            DialogModule,
            ButtonModule,
            SearchContainerLoaderModule,
        ],
        exports: [DashboardLoaderComponent],
        entryComponents: [WidgetSelectionComponent],
    })
], MarketplaceAnalyticsModule);

let CdaReceivedModule = class CdaReceivedModule {
};
CdaReceivedModule = __decorate([
    NgModule({
        declarations: [CdaReceivedComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            DashboardModule,
            DialogModule$1,
            CommonModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            WizardModule,
            PdfViewerModule,
            ExportModule,
            LoggingModule,
            EditInvoiceModule,
            WarningsModule,
            PrintOptionsModule,
            ProgressSpinnerModule$1,
            LuiWizardModule,
            LuiWizardV3Module,
            LuiWidgetWrapperModule,
            MarketplaceAnalyticsModule,
        ],
        entryComponents: [
            PdfViewerComponent,
            ExportComponent,
            DataGeniusSelectionComponent,
        ],
    })
], CdaReceivedModule);

let SentCDAModule = class SentCDAModule {
};
SentCDAModule = __decorate([
    NgModule({
        declarations: [SentCDAComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            DashboardModule,
            DialogModule$1,
            CommonModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            WizardModule,
            PdfViewerModule,
            ExportModule,
            LoggingModule,
            EditInvoiceModule,
            WarningsModule,
            PrintOptionsModule,
            ProgressSpinnerModule$1,
            LuiWizardModule,
            LuiWizardV3Module,
            LuiWidgetWrapperModule,
            MarketplaceAnalyticsModule,
        ],
        entryComponents: [
            PdfViewerComponent,
            ExportComponent,
            DataGeniusSelectionComponent,
        ],
    })
], SentCDAModule);

let ClaimsReceivedComponent = class ClaimsReceivedComponent {
    constructor() { }
    ngOnInit() { }
};
ClaimsReceivedComponent = __decorate([
    Component({
        selector: 'lib-claims-received',
        template: `<router-outlet></router-outlet>`
    })
], ClaimsReceivedComponent);

/** Claims Received List - Display columns  */
const columnsToDisplay = [
    'claimNo',
    'originalSenderName',
    'receiverName',
    'dateAdded',
    'totalAmount',
];

/** MOCK Database to get fake data */
const purchaseOrders = [
    {
        puchaseOrderKey: 1,
        PONo: 107089284,
        senderName: 'Test sender',
        senderNumber: 105539284,
        receiverName: 'Skipstorm',
        receiverNumber: 56894,
        dateAdded: '2020-02-25',
        PODate: '2020-02-25',
        totalAmount: 996666,
        dateExported: '2020-02-25',
        invoiceNo: 443333,
        POANo: 2222,
        ASNNo: 45666,
        LBMXDocumentID: 511473331,
        LBMXDocumentId: 511473331,
        currency: 'CAD',
        expectedDeliveryDate: '2020-02-25',
        requestedDeliveryDate: '2020-02-25',
        dataSource: 'test',
        test: 'Yes',
        deleted: 'No',
    },
    {
        puchaseOrderKey: 1,
        PONo: 98765432,
        senderName: 'Second sender',
        senderNumber: 23344556,
        receiverName: 'Second Best Hat',
        receiverNumber: 778965,
        dateAdded: '2020-04-12',
        PODate: '2020-02-25',
        totalAmount: 996666,
        dateExported: '2020-02-25',
        invoiceNo: 112789,
        POANo: 55667,
        ASNNo: 344456,
        LBMXDocumentID: 511486344,
        currency: 'CAD',
        expectedDeliveryDate: '2020-02-25',
        requestedDeliveryDate: '2020-02-25',
        dataSource: 'test',
        test: 'Yes',
        deleted: 'No',
    },
];
const purchaseOrderYear = [
    { label: '2018', value: '2018' },
    { label: '2019', value: '2019' },
    { label: '2020', value: '2020' },
];
const senderName = [
    { label: 'Name 01', value: 'Name 01' },
    { label: 'Name 02', value: 'Name 02' },
    { label: 'Name 03', value: 'Name 03' },
    { label: 'Name 04', value: 'Name 04' },
    { label: 'Name 05', value: 'Name 05' },
    { label: 'Name 06', value: 'Name 06' },
];
const receiverName = [
    { label: 'Receiver Name 01', value: 'Receiver Name 01' },
    { label: 'Receiver Name 02', value: 'Receiver Name 02' },
    { label: 'Receiver Name 03', value: 'Receiver Name 03' },
    { label: 'Receiver Name 04', value: 'Receiver Name 04' },
    { label: 'Receiver Name 05', value: 'Receiver Name 05' },
    { label: 'Receiver Name 06', value: 'Receiver Name 06' },
];
const currency = [
    { label: 'CAD', value: 'CAD' },
    { label: 'USD', value: 'USD' },
    { label: 'EUR', value: 'EUR' },
    { label: 'AUD', value: 'AUD' },
    { label: 'NZD', value: 'NZD' },
    { label: 'ZAR', value: 'ZAR' },
];
const senderDropdown = [
    { label: 'Sender 01', value: '1' },
    { label: 'Sender 02', value: '2' },
    { label: 'Sender 03', value: '3' },
    { label: 'Sender 04', value: '4' },
    { label: 'Sender 05', value: '5' },
    { label: 'Sender 06', value: '6' },
];
const approvalDropdown = [
    { label: 'Approved', value: '1' },
    { label: 'Not Approved', value: '2' },
    { label: 'All', value: '3' },
];
const logList = [
    {
        message: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
        logTypeCode: 'logTypeCode1',
        logTypeDescription: 'logTypeDescription 1',
        addedOn: '2020-09-16',
        addedBy: 'test user1',
    },
    {
        message: 'message 2',
        logTypeCode: 'logTypeCode2',
        logTypeDescription: 'logTypeDescription 5',
        addedOn: '2020-03-10',
        addedBy: 'test user2',
    },
    {
        message: 'message 3',
        logTypeCode: 'abclogTypeCode3',
        logTypeDescription: 'logTypeDescription 2',
        addedOn: '2019-09-10',
        addedBy: 'test user3',
    },
    {
        message: 'message 4',
        logTypeCode: 'logTypeCode8',
        logTypeDescription: 'logTypeDescription 4',
        addedOn: '2016-04-10',
        addedBy: 'abc user',
    },
    {
        message: 'message 5',
        logTypeCode: 'batlogTypeCode7',
        logTypeDescription: 'logTypeDescription 3',
        addedOn: '2020-09-10',
        addedBy: 'test user4',
    },
    {
        message: 'message 6',
        logTypeCode: 'logTypeCode4',
        logTypeDescription: 'logTypeDescription 6',
        addedOn: '2020-08-20',
        addedBy: 'xyz user',
    },
    {
        message: 'message 7',
        logTypeCode: 'logTypeCode5',
        logTypeDescription: 'logTypeDescription 7',
        addedOn: '2020-02-10',
        addedBy: 'test user5',
    },
    {
        message: 'message 21',
        logTypeCode: 'logTypeCode6',
        logTypeDescription: 'c-logTypeDescription 8',
        addedOn: '2020-09-10',
        addedBy: 'test user6',
    },
    {
        message: 'message 31',
        logTypeCode: 'logTypeCode9',
        logTypeDescription: 'logTypeDescription 9',
        addedOn: '2020-07-11',
        addedBy: 'test user7',
    },
    {
        message: 'message 41',
        logTypeCode: 'logTypeCode10',
        logTypeDescription: 'b-logTypeDescription 10',
        addedOn: '2020-09-10',
        addedBy: 'test user8',
    },
    {
        message: 'message 51',
        logTypeCode: 'logTypeCode11',
        logTypeDescription: 'logTypeDescription 11',
        addedOn: '2020-09-10',
        addedBy: 'test user9',
    },
    {
        message: 'message 61',
        logTypeCode: 'logTypeCode12',
        logTypeDescription: 'logTypeDescription 12',
        addedOn: '2020-09-10',
        addedBy: 'test user10',
    },
    {
        message: 'message 71',
        logTypeCode: 'a-logTypeCode13',
        logTypeDescription: 'logTypeDescription 13',
        addedOn: '2020-09-10',
        addedBy: 'test user11',
    },
];

let PurchaseOrderService = class PurchaseOrderService {
    constructor(store) {
        this.store = store;
        this.subscriptions = [];
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    getPOReceived() {
        return of(purchaseOrders);
    }
    getLogList() {
        // logs list will be sorted by added date in descending order
        let filterOptions;
        // Filter options should be unique
        filterOptions = logList.map((value) => {
            return {
                code: value.logTypeCode,
                value: value.logTypeDescription,
            };
        });
        return of({ logList, filterOptions });
    }
    getFacetData() {
        const response = {
            years: purchaseOrderYear,
            senderName,
            receiverName,
            currencyList: currency,
            senderBasicSearch: senderDropdown,
            approvalBasicSearch: approvalDropdown,
        };
        return response;
    }
    getUserDateFormat() {
        let resp;
        this.subscriptions.push(this.store
            .pipe(select(selectors.userProfile), tap((user) => {
            resp = {
                format: user.userInfo.DateTypeFormat,
                description: user.userInfo.DateTypeDescription,
                primeNgFormat: user.userInfo.PrimeNGDateTypeFormat,
            };
        }))
            .subscribe());
        return resp;
    }
    isEmptyObject(obj) {
        return JSON.stringify(obj) === '{}';
    }
    getUserPermissions() {
        let toolkeys;
        this.subscriptions.push(this.store
            .pipe(select(selectors.userProfile), tap((user) => {
            toolkeys = user.toolKeys;
        }))
            .subscribe());
        return toolkeys;
    }
};
PurchaseOrderService.ctorParameters = () => [
    { type: Store }
];
PurchaseOrderService.ɵprov = ɵɵdefineInjectable({ factory: function PurchaseOrderService_Factory() { return new PurchaseOrderService(ɵɵinject(Store)); }, token: PurchaseOrderService, providedIn: "root" });
PurchaseOrderService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], PurchaseOrderService);

/** MOCK Database to get fake data */
const claimsReceived = [
    {
        claimsKey: 1,
        claimNo: 633534,
        originalSenderName: 'Test sender',
        senderNumber: 105539284,
        receiverName: 'Skipstorm',
        receiverNumber: 56894,
        dateAdded: '2020-02-25',
        claimDate: '2020-02-25',
        totalAmount: 94294894,
        dateExported: '2020-02-25',
        attachment: [
            { label: 'fileName1.pdf', attachmentNumber: 1 },
            { label: 'fileName2.pdf', attachmentNumber: 2 },
            { label: 'fileName3.pdf', attachmentNumber: 3 },
        ],
        invoiceNumber: 2222,
        LBMXDocumentID: 9999,
        currency: 'CAD',
        dataSource: 'test',
        test: 'Yes',
        deleted: 'No',
    },
    {
        claimsKey: 2,
        claimNo: 78678678,
        originalSenderName: 'Second sender',
        senderNumber: 346777,
        receiverName: 'Second Receiver',
        receiverNumber: 546767,
        dateAdded: '2019-02-25',
        claimDate: '2020-92-15',
        totalAmount: 94294894,
        dateExported: '2020-02-25',
        attachment: [],
        invoiceNumber: 2233322,
        LBMXDocumentID: 2245678,
        currency: 'CAD',
        dataSource: 'test',
        test: 'Yes',
        deleted: 'No',
    },
    {
        claimsKey: 3,
        claimNo: 3455466,
        originalSenderName: 'Third sender',
        senderNumber: 87989890,
        receiverName: 'Third Receiver',
        receiverNumber: 2343454,
        dateAdded: '2020-05-20',
        claimDate: '2020-03-25',
        totalAmount: 898065576,
        dateExported: '2020-02-19',
        attachment: [],
        invoiceNumber: 2222,
        LBMXDocumentID: 9999,
        currency: 'CAD',
        dataSource: 'test',
        test: 'Yes',
        deleted: 'No',
    },
];
const claimsReceivedYear = [
    { label: '2017', value: '2017' },
    { label: '2018', value: '2018' },
    { label: '2019', value: '2019' },
    { label: '2020', value: '2020' },
];
const senderName$1 = [
    { label: 'Name 01', value: 'Name 01' },
    { label: 'Name 02', value: 'Name 02' },
    { label: 'Name 03', value: 'Name 03' },
    { label: 'Name 04', value: 'Name 04' },
    { label: 'Name 05', value: 'Name 05' },
    { label: 'Name 06', value: 'Name 06' },
];
const receiverName$1 = [
    { label: 'Receiver Name 01', value: 'Receiver Name 01' },
    { label: 'Receiver Name 02', value: 'Receiver Name 02' },
    { label: 'Receiver Name 03', value: 'Receiver Name 03' },
    { label: 'Receiver Name 04', value: 'Receiver Name 04' },
    { label: 'Receiver Name 05', value: 'Receiver Name 05' },
    { label: 'Receiver Name 06', value: 'Receiver Name 06' },
];
const currency$1 = [
    { label: 'CAD', value: 'CAD' },
    { label: 'USD', value: 'USD' },
    { label: 'EUR', value: 'EUR' },
    { label: 'AUD', value: 'AUD' },
    { label: 'NZD', value: 'NZD' },
    { label: 'ZAR', value: 'ZAR' },
];
const processedDropdown = [
    { label: 'Processed', value: '1' },
    { label: 'Not Processed', value: '2' },
    { label: 'All', value: '3' },
];

let ClaimsReceivedService = class ClaimsReceivedService {
    constructor() { }
    getClaimsReceived() {
        return of(claimsReceived);
    }
    getFacetData() {
        const response = {
            years: claimsReceivedYear,
            senderName: senderName$1,
            receiverName: receiverName$1,
            currencyList: currency$1,
            processedBasicSearch: processedDropdown,
        };
        return response;
    }
    getAttachment() {
        // TO DO: CALL BACK END API TO GET LIST OF ATTACHMENTS
        return of({});
    }
    getLogList() {
        // logs list will be sorted by added date in descending order
        let filterOptions;
        // Filter options should be unique
        filterOptions = logList.map((value) => {
            return {
                code: value.logTypeCode,
                value: value.logTypeDescription,
            };
        });
        return of({ logList, filterOptions });
    }
};
ClaimsReceivedService.ɵprov = ɵɵdefineInjectable({ factory: function ClaimsReceivedService_Factory() { return new ClaimsReceivedService(); }, token: ClaimsReceivedService, providedIn: "root" });
ClaimsReceivedService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], ClaimsReceivedService);

let DocumentServerService = class DocumentServerService {
    constructor(baseApiService, mp, httpClient) {
        this.baseApiService = baseApiService;
        this.mp = mp;
        this.httpClient = httpClient;
        this.baseUri = this.mp.getConfig().getDocumentServerEndpoint;
        this.documentBaseUri = this.mp.getConfig().getDocumentEndpoint;
        this.configBaseUri = this.mp.getConfig().getConfigEndpoint;
        this.userBaseUri = this.mp.getConfig().getUserEndpoint;
    }
    ViewPDFDocument(type, LBMXDocumentID) {
        return this.httpClient.get(urlJoin(this.baseUri, type, 'View', LBMXDocumentID), {
            responseType: 'blob',
            withCredentials: true,
        });
    }
    getPrintOptions() {
        this.baseApiService.set(`${this.configBaseUri}/printoption`);
        return this.baseApiService.get().pipe(map((printOptionsResponse) => {
            return {
                printOpt: printOptionsResponse.printOptions
                    ? printOptionsResponse.printOptions.map((option) => {
                        return {
                            label: option.description,
                            value: option.printOptionKey,
                        };
                    })
                    : [],
            };
        }));
    }
    getAttachmentOptions() {
        this.baseApiService.set(`${this.configBaseUri}/attachmentoption`);
        return this.baseApiService.get().pipe(map((attachmentOptionsResponse) => {
            return {
                attachmentOpt: attachmentOptionsResponse.attachmentOptions
                    ? attachmentOptionsResponse.attachmentOptions.map((option) => {
                        return {
                            label: option.description,
                            value: option.attachmentOptionKey,
                        };
                    })
                    : [],
            };
        }));
    }
    getPrintConfiguration(documentType) {
        this.baseApiService.set(`${this.userBaseUri}/userprintoption/${documentType}`);
        return this.baseApiService.get().pipe(map((userConfig) => {
            var _a, _b;
            return {
                printOption: userConfig
                    ? (_a = userConfig.userPrintOption) === null || _a === void 0 ? void 0 : _a.printOptionKey : null,
                attachmentOption: userConfig
                    ? (_b = userConfig.userPrintOption) === null || _b === void 0 ? void 0 : _b.attachmentOptionKey : null,
            };
        }));
    }
    savePrintConfiguration(printConfig) {
        this.baseApiService.set(`${this.userBaseUri}/userprintoption`);
        return this.baseApiService.post(printConfig);
    }
    printDocument(type, documentPrintCommand) {
        this.baseApiService.set(`${this.baseUri}/${type}/print`);
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Accept: 'application/json'
        });
        return this.httpClient.post(`${this.baseUri}/${type}/print`, documentPrintCommand, { headers, responseType: 'blob', withCredentials: true }).pipe();
    }
    getFacetData(type, year = 'Last90') {
        const advanceFilterUrl = year != null
            ? `${this.documentBaseUri}/${type}/advancedfilters/${year}`
            : `${this.documentBaseUri}/${type}/advancedfilters`;
        this.baseApiService.set(advanceFilterUrl);
        return this.baseApiService.get().pipe(map((advancedFiltersResponse) => {
            return {
                years: advancedFiltersResponse.advancedFilters.years
                    ? advancedFiltersResponse.advancedFilters.years.map((yearInfo) => {
                        return {
                            name: yearInfo.label,
                            key: yearInfo.value,
                        };
                    })
                    : [],
                senderName: advancedFiltersResponse.advancedFilters.senderNames
                    ? advancedFiltersResponse.advancedFilters.senderNames.map((sender) => {
                        return {
                            label: `${sender.senderName} (${sender.senderId})`,
                            value: sender.senderId,
                        };
                    })
                    : [],
                receiverName: advancedFiltersResponse.advancedFilters.receiverNames
                    ? advancedFiltersResponse.advancedFilters.receiverNames.map((receiver) => {
                        return {
                            label: `${receiver.receiverName} (${receiver.receiverId})`,
                            value: receiver.receiverId,
                        };
                    })
                    : [],
                currencyList: advancedFiltersResponse.advancedFilters.currencies
                    ? advancedFiltersResponse.advancedFilters.currencies
                        .filter((currency) => currency !== null && currency !== '')
                        .map((currency) => {
                        return {
                            label: currency,
                            value: currency,
                        };
                    })
                    : [],
                SupplierProductNumbers: advancedFiltersResponse.advancedFilters.supplierProductNumbers
                    ? advancedFiltersResponse.advancedFilters.supplierProductNumbers.map((supplierNumber) => {
                        return {
                            supplierNumber
                        };
                    })
                    : [],
            };
        }));
    }
};
DocumentServerService.ctorParameters = () => [
    { type: BaseAPIService },
    { type: MarketplaceService },
    { type: HttpClient }
];
DocumentServerService.ɵprov = ɵɵdefineInjectable({ factory: function DocumentServerService_Factory() { return new DocumentServerService(ɵɵinject(BaseAPIService), ɵɵinject(MarketplaceService), ɵɵinject(HttpClient)); }, token: DocumentServerService, providedIn: "root" });
DocumentServerService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], DocumentServerService);

let ViewClaimsReceivedComponent = class ViewClaimsReceivedComponent {
    constructor(claimsReceivedService, purchaseOrderService, documentServerService, translocoService, store) {
        this.claimsReceivedService = claimsReceivedService;
        this.purchaseOrderService = purchaseOrderService;
        this.documentServerService = documentServerService;
        this.translocoService = translocoService;
        this.store = store;
        this.showLogDialogue = false;
        this.showAttachmentDialogue = false;
        this.dataLoading = false;
        this.columnsAvailable = false;
        this.claimNumber = '';
        this.showViewDataDialogue = false;
        this.claimsReceivedData = [];
        this.logDetails = {};
        this.claimsLogInfo = {};
        this.authorizedButtons = {};
        this.attachmentList = [];
        this.subscriptions = [];
    }
    ngOnInit() {
        const buttonPermissions = {
            markProcessed: toolKeys.MP_CLAIMS_RECEIVED_PROCESS,
            view: toolKeys.MP_CLAIMS_RECEIVED_VIEW,
            viewData: toolKeys.MP_CLAIMS_RECEIVED_VIEW_DATA,
            viewLog: toolKeys.MP_CLAIMS_RECEIVED_VIEW_LOG,
            erpExport: toolKeys.MP_CLAIMS_RECEIVED_ERP_EXPORT,
            delete: toolKeys.MP_CLAIMS_RECEIVED_DELETE,
            destroy: toolKeys.MP_CLAIMS_RECEIVED_DESTROY,
            move: toolKeys.MP_CLAIMS_RECEIVED_MOVE,
        };
        this.subscriptions.push(this.store
            .pipe(select(selectors.isAuthorized, buttonPermissions), tap((authorizedButtons) => {
            this.authorizedButtons = authorizedButtons;
        }))
            .subscribe());
        /* Get translated Search Container Columns Headers */
        this.getTranslatedLabels();
        /* Get List of Claims Received */
        this.getClaimsReceived();
        this.columnsToDisplay = columnsToDisplay;
        this.dateType = this.purchaseOrderService.getUserDateFormat();
    }
    ngOnDestroy() {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
    getClaimsReceived() {
        this.dataLoading = true;
        this.data$ = this.claimsReceivedService.getClaimsReceived().pipe(tap((claims) => (this.claimsReceivedList = claims)), finalize(() => (this.dataLoading = false)));
    }
    clear() {
        this.getClaimsReceived();
    }
    search($event) {
        this.searchKey = $event.filters.key === undefined ? '' : $event.filters.key;
        // TODO: back end search integration with search text
    }
    onToolbarClick({ command, selection }) {
        this.claimNumber =
            selection[0].claimNo !== undefined ? selection[0].claimNo : '';
        switch (command) {
            case 'viewLog':
                this.getLogInfo();
                break;
            case 'viewData':
                this.claimsReceivedData = selection;
                this.showViewDataDialogue = true;
                break;
            case 'view Print':
                this.subscriptions.push(this.documentServerService
                    .ViewPDFDocument('claim', selection.LBMXDocumentID)
                    .subscribe());
                break;
            default:
                break;
        }
    }
    closeViewDataDialogue() {
        this.showViewDataDialogue = false;
    }
    getTranslatedLabels() {
        this.subscriptions.push(this.translocoService
            .selectTranslate('MARKETPLACE_ADVANCED_SEARCH')
            .pipe(tap((translate) => {
            /** Claims Received List - Available columns  */
            this.columns = [
                {
                    field: 'claimNo',
                    width: 100,
                    header: translate.CLAIM_NUMBER,
                    link: () => ({ path: './' }),
                    event: ({ LBMXDocumentID, claimNo, }) => ({ LBMXDocumentID, claimNo }),
                },
                {
                    field: 'originalSenderName',
                    header: translate.ORIGINAL_SENDER_NAME,
                },
                { field: 'senderNumber', header: translate.SENDER_NUMBER },
                { field: 'receiverName', header: translate.RECEIVER_NAME },
                { field: 'receiverNumber', header: translate.RECEIVER_NUMBER },
                { field: 'dateAdded', header: translate.DATE_ADDED },
                { field: 'claimDate', header: translate.CLAIM_DATE },
                { field: 'totalAmount', header: translate.TOTAL_AMOUNT },
                { field: 'dateExported', header: translate.DATE_EXPORTED },
                {
                    field: 'attachment',
                    header: translate.ATTACHMENT,
                    link: () => {
                        return { path: './' };
                    },
                    icon: 'paperclip',
                    shouldRender: ({ attachment }) => attachment.length !== 0,
                    event: ({ attachment }) => ({
                        attachment,
                    }),
                    styleClass: 'remove-link-styling',
                },
                {
                    field: 'invoiceNo',
                    header: translate.INVOICE_NUMBER,
                    link: (invoiceNo) => {
                        // TODO Link to new view PO page and display linked documents
                        return { path: 'invoiceNo' };
                    },
                },
                { field: 'LBMXDocumentID', header: translate.LBMX_DOCUMENT_ID },
                { field: 'currency', header: translate.CURRENCY },
                { field: 'dataSource', header: translate.DATA_SOURCE },
                { field: 'test', header: translate.TEST },
                { field: 'deleted', header: translate.DELETED },
            ];
            /** Claims Received List - Toolbar Buttons  */
            // TODO:  button SINGLE/MULTIPLE Enable mode is need to configured while each functionality is being implemented
            this.toolbarButtons = [
                {
                    name: 'view',
                    label: translate.PRINT_VIEW,
                    disabled: !this.authorizedButtons.view,
                    mode: 1 /* SINGLE */,
                },
                {
                    name: 'markProcessed',
                    label: translate.MARK_PROCESSED,
                    disabled: !this.authorizedButtons.markProcessed,
                    mode: 1 /* SINGLE */,
                },
                {
                    name: 'viewData',
                    label: translate.VIEW_DATA,
                    disabled: !this.authorizedButtons.viewData,
                    mode: 2 /* MULTIPLE */,
                    parent: 'more',
                },
                {
                    name: 'viewLog',
                    label: translate.VIEW_LOG,
                    disabled: !this.authorizedButtons.viewLog,
                    mode: 1 /* SINGLE */,
                    parent: 'more',
                },
                {
                    name: 'erpExport',
                    label: translate.ERP_EXPORT,
                    disabled: !this.authorizedButtons.erpExport,
                    mode: 2 /* MULTIPLE */,
                },
                {
                    name: 'delete',
                    label: translate.DELETE,
                    disabled: !this.authorizedButtons.delete,
                    mode: 2 /* MULTIPLE */,
                    parent: 'more',
                },
                {
                    name: 'destroy',
                    label: translate.DESTROY,
                    disabled: !this.authorizedButtons.destroy,
                    mode: 2 /* MULTIPLE */,
                    parent: 'more',
                },
                {
                    name: 'move',
                    label: translate.MOVE,
                    disabled: !this.authorizedButtons.move,
                    mode: 2 /* MULTIPLE */,
                    parent: 'more',
                },
            ];
            this.columnsAvailable = true;
        }))
            .subscribe());
    }
    getLogInfo() {
        this.subscriptions.push(this.claimsReceivedService
            .getLogList()
            .pipe(tap((logInfo) => ((this.logDetails = logInfo), (this.claimsLogInfo = logInfo))), finalize(() => (this.showLogDialogue = true)))
            .subscribe());
    }
    openAttachment($event) {
        this.attachmentList = $event.attachment ? $event.attachment : [];
        this.showAttachmentDialogue =
            this.attachmentList.length !== 0 ? true : false;
    }
    downloadAttachment() {
        this.subscriptions.push(this.claimsReceivedService
            .getAttachment()
            .pipe(tap(), 
        // TO DO: PULL OUT AND DOWNLOAD ATTACHMENT FROM BACK END CALL
        finalize(() => (this.showAttachmentDialogue = true)))
            .subscribe());
    }
    closeAttachmentDialogue() {
        this.showAttachmentDialogue = false;
        this.attachmentList = [];
    }
    viewPDF({ LBMXDocumentID, claimNo }) {
        this.subscriptions.push(this.documentServerService
            .ViewPDFDocument('claim', `${LBMXDocumentID}`)
            .subscribe((response) => saveAs(response, claimNo)));
    }
};
ViewClaimsReceivedComponent.ctorParameters = () => [
    { type: ClaimsReceivedService },
    { type: PurchaseOrderService },
    { type: DocumentServerService },
    { type: TranslocoService },
    { type: Store }
];
ViewClaimsReceivedComponent = __decorate([
    Component({
        selector: 'lib-view-claims-received',
        template: "<div class=\"vertical-flow space-between-200\">\r\n  <h2>{{ 'CLAIMS_RECEIVED.CLAIMS_RECEIVED' | transloco }}</h2>\r\n  <lib-search-container\r\n    *ngIf=\"columnsAvailable\"\r\n    i18nSearchField=\"{{ 'CLAIMS_RECEIVED.SEARCH' | transloco }}\"\r\n    name=\"claimSearch\"\r\n    searchProperty=\"key\"\r\n    [loading]=\"dataLoading\"\r\n    [buttons]=\"toolbarButtons\"\r\n    [columns]=\"columns\"\r\n    [columnsToDisplay]=\"columnsToDisplay\"\r\n    [results]=\"data$\"\r\n    (clear)=\"clear()\"\r\n    (query)=\"search($event)\"\r\n    (toolbar)=\"onToolbarClick($event)\"\r\n    (field)=\"openAttachment($event)\"\r\n    (field)=\"viewPDF($event)\"\r\n  >\r\n    <lib-advanced-search libSearch [dateType]=\"dateType\"> </lib-advanced-search>\r\n  </lib-search-container>\r\n</div>\r\n\r\n<lib-view-log-template\r\n  [(showLogDialogue)]=\"showLogDialogue\"\r\n  [dialogueHeader]=\"\r\n    ('CLAIMS_RECEIVED.CLAIMS_RECEIVED_LOG' | transloco) + ' - ' + claimNumber\r\n  \"\r\n  [logDetails]=\"logDetails\"\r\n  [logInfoList]=\"logDetails\"\r\n></lib-view-log-template>\r\n\r\n<p-dialog\r\n  [(visible)]=\"showAttachmentDialogue\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '960px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <div class=\"vertical-flow space-between-325\">\r\n    <!-- dialogue header and filter table container-->\r\n    <div class=\"vertical-flow space-between-025\">\r\n      <div class=\"horizontal-fixed space-between-00 dialogue-form\">\r\n        <div class=\"width-100\">\r\n          <h2 class=\"center\">\r\n            {{ 'CLAIMS_RECEIVED.ATTACHMENT_HEADER' | transloco }}\r\n          </h2>\r\n        </div>\r\n        <div\r\n          (click)=\"closeAttachmentDialogue()\"\r\n          class=\"pi pi-times header clickable\"\r\n        ></div>\r\n      </div>\r\n      <div class=\"vertical-flow space-between-050\">\r\n        <div>\r\n          <p>\r\n            {{ 'MARKETPLACE_ADVANCED_SEARCH.ATTACHMENT' | transloco }}\r\n          </p>\r\n        </div>\r\n        <div class=\"light-grey-border\">\r\n          <div\r\n            class=\"vertical-flow space-before-125 horizontal-flow margin-bottom-1-5em\"\r\n          >\r\n            <div\r\n              *ngFor=\"let item of attachmentList\"\r\n              class=\"vertical-flow space-before-125\"\r\n            >\r\n              <!-- TO DO: Link URL to back end call to download attachment -->\r\n              <a href=\"#\">{{ item.label }}</a>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <!-- End of dialogue header container -->\r\n    <!-- Close button container-->\r\n    <div class=\"margin-bottom-1-5em\">\r\n      <button\r\n        class=\"ds\"\r\n        pButton\r\n        type=\"button\"\r\n        label=\"{{ 'ACTIONS.CLOSE' | transloco }}\"\r\n        (click)=\"closeAttachmentDialogue()\"\r\n      ></button>\r\n    </div>\r\n    <!-- End of Close button container-->\r\n  </div>\r\n</p-dialog>\r\n\r\n<p-dialog\r\n  [(visible)]=\"showViewDataDialogue\"\r\n  [modal]=\"true\"\r\n  [style]=\"{ width: '960px' }\"\r\n  [baseZIndex]=\"10000\"\r\n  [draggable]=\"false\"\r\n  [resizable]=\"false\"\r\n  [showHeader]=\"false\"\r\n  position=\"center\"\r\n>\r\n  <pre [innerHTML]=\"claimsReceivedData | json\"></pre>\r\n  <button\r\n    class=\"ds center\"\r\n    pButton\r\n    type=\"button\"\r\n    label=\"{{ 'ACTIONS.CLOSE' | transloco }}\"\r\n    (click)=\"closeViewDataDialogue()\"\r\n  ></button>\r\n</p-dialog>\r\n",
        styles: [""]
    })
], ViewClaimsReceivedComponent);

let AdvancedSearchComponent = class AdvancedSearchComponent {
    constructor(claimsReceivedService, purchaseOrderService, translocoService) {
        this.claimsReceivedService = claimsReceivedService;
        this.purchaseOrderService = purchaseOrderService;
        this.translocoService = translocoService;
        this.setFilterEvent = new EventEmitter();
        this.appliedIcon = 'assets/images/filter-on.png';
        this.selectedListItems = {};
        this.claimNumber = '';
        this.senderNumber = '';
        this.receiverNumber = '';
        this.invoiceNumber = '';
        this.dateAddedMin = '';
        this.dateAddedMax = '';
        this.documentDateMin = '';
        this.documentDateMax = '';
        this.dateExportedMin = '';
        this.dateExportedMax = '';
        this.subscriptions = [];
    }
    ngOnInit() {
        this.getFilterObj();
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
    getFilterObj() {
        this.filterData = this.claimsReceivedService.getFacetData();
        this.subscriptions.push(this.translocoService
            .selectTranslate('MARKETPLACE_ADVANCED_SEARCH')
            .pipe(map((translate) => translate), tap((translate) => {
            this.filterObj = [
                {
                    label: translate.YEAR,
                    value: this.filterData.years,
                    name: 'selectedYears',
                    type: 'multi-select',
                },
                {
                    label: translate.CLAIM_NUMBER,
                    value: '',
                    name: 'claimNumber',
                    type: 'text-box',
                },
                {
                    label: translate.SENDER,
                    value: '',
                    name: 'senderNumber',
                    type: 'text-box',
                },
                {
                    label: translate.SENDER_NAME,
                    value: this.filterData.senderName,
                    name: 'selectedSenders',
                    type: 'multi-select',
                },
                {
                    label: translate.RECEIVER,
                    value: '',
                    name: 'receiverNumber',
                    type: 'text-box',
                },
                {
                    label: translate.RECEIVER_NAME,
                    value: this.filterData.receiverName,
                    name: 'selectedReceivers',
                    type: 'multi-select',
                },
                {
                    label: translate.PRINT_STATUS,
                    value: [
                        { label: translate.PRINTED, value: 'printed' },
                        { label: translate.NOT_PRINTED, value: 'notPrinted' },
                    ],
                    name: 'selectedPrintStatus',
                    type: 'multi-select',
                },
                {
                    label: translate.APPROVAL_STATUS,
                    value: [
                        { label: translate.APPROVED, value: 'approved' },
                        { label: translate.NOT_APPROVED, value: 'notApproved' },
                    ],
                    name: 'selectedApprovalStatus',
                    type: 'multi-select',
                },
                {
                    label: translate.DATE_ADDED,
                    value: '',
                    name: 'dateAdded',
                    type: 'date-range',
                },
                {
                    label: translate.DOCUMENT_DATE,
                    value: '',
                    name: 'documentDate',
                    type: 'date-range',
                },
                {
                    label: translate.DATE_EXPORTED,
                    value: '',
                    name: 'dateExported',
                    type: 'date-range',
                },
                {
                    label: translate.INVOICE_NUMBER,
                    value: '',
                    name: 'invoiceNumber',
                    type: 'text-box',
                },
                {
                    label: translate.CURRENCY,
                    value: this.filterData.currencyList,
                    name: 'selectedCurrencies',
                    type: 'multi-select',
                },
                {
                    label: translate.TOTAL_AMOUNT,
                    value: '',
                    name: 'totalAmount',
                    type: 'number-range',
                },
                {
                    label: translate.TEST,
                    value: [
                        { label: translate.YES, value: 'test' },
                        { label: translate.NO, value: 'notTest' },
                    ],
                    name: 'test',
                    type: 'multi-select',
                },
                {
                    label: translate.DELETED,
                    value: [
                        { label: translate.YES, value: 'deleted' },
                        { label: translate.NO, value: 'notDeleted' },
                    ],
                    name: 'deleted',
                    type: 'multi-select',
                },
            ];
        }))
            .subscribe());
    }
    handleClear() {
        this.selectedListItems = {};
        this.warning = false;
        this.processedStatus = '';
        this.filterObj.forEach((facet) => {
            switch (facet.type) {
                case 'text-box':
                    this[facet.name] = '';
                    break;
                case 'date-range':
                case 'number-range':
                    this[facet.name + 'Min'] = null;
                    this[facet.name + 'Max'] = null;
                    break;
            }
        });
        this.filtersEvent({});
    }
    handleAdvancedSearch() {
        this.filtersEvent(this.getAppliedFilters());
    }
    getAppliedFilters() {
        let filters = {};
        let temp = {};
        // selected list items filtered options
        if (this.selectedListItems &&
            !this.purchaseOrderService.isEmptyObject(this.selectedListItems)) {
            const selectedItems = Object.entries(this.selectedListItems).reduce((prev, [key, value]) => (Object.assign(Object.assign({}, prev), { [key]: [value] })), {});
            if (!this.purchaseOrderService.isEmptyObject(selectedItems)) {
                filters = Object.assign(Object.assign({}, filters), { selectedItems });
            }
        }
        this.filterObj.forEach((facet) => {
            switch (facet.type) {
                case 'text-box':
                    if (this[facet.name]) {
                        filters[facet.name] = this[facet.name];
                    }
                    break;
                case 'date-range':
                case 'number-range':
                    temp =
                        !this[facet.name + 'Min'] && !this[facet.name + 'Max']
                            ? {}
                            : this[facet.name + 'Min'] && this[facet.name + 'Max']
                                ? {
                                    [facet.name + 'Min']: this[facet.name + 'Min'],
                                    [facet.name + 'Max']: this[facet.name + 'Max'],
                                }
                                : this[facet.name + 'Min']
                                    ? { [facet.name + 'Min']: this[facet.name + 'Min'] }
                                    : { [facet.name + 'Max']: this[facet.name + 'Max'] };
                    if (!this.purchaseOrderService.isEmptyObject(temp)) {
                        filters[facet.name] = temp;
                    }
                    break;
            }
        });
        // warning
        if (this.warning) {
            const warning = { warning: this.warning };
            filters = Object.assign(Object.assign({}, filters), { warning });
        }
        // processed status filter
        if (this.processedStatus) {
            const processedStatus = { processedStatus: this.processedStatus };
            filters = Object.assign(Object.assign({}, filters), { processedStatus });
        }
        return filters;
    }
    filtersEvent(filters) {
        this.setFilterEvent.emit({
            filters,
            options: { search: true },
        });
    }
    getValidDate($event, type, field) {
        if (type === 'min') {
            this[field + 'Min'] = $event;
        }
        else {
            this[field + 'Max'] = $event;
        }
    }
};
AdvancedSearchComponent.ctorParameters = () => [
    { type: ClaimsReceivedService },
    { type: PurchaseOrderService },
    { type: TranslocoService }
];
__decorate([
    Input()
], AdvancedSearchComponent.prototype, "dateType", void 0);
__decorate([
    Output()
], AdvancedSearchComponent.prototype, "setFilterEvent", void 0);
AdvancedSearchComponent = __decorate([
    Component({
        selector: 'lib-advanced-search',
        template: "<div class=\"vertical-flow advanced-search\">\r\n  <div class=\"horizontal-fixed space-between-075\">\r\n    <button\r\n      pButton\r\n      class=\"ds width-50\"\r\n      type=\"button\"\r\n      label=\"{{ 'ADVANCED_SEARCH.CLEAR' | transloco }}\"\r\n      (click)=\"handleClear()\"\r\n    ></button>\r\n    <button\r\n      pButton\r\n      class=\"ds width-50\"\r\n      type=\"button\"\r\n      label=\"{{ 'ADVANCED_SEARCH.APPLY' | transloco }}\"\r\n      (click)=\"handleAdvancedSearch()\"\r\n    ></button>\r\n  </div>\r\n  <div class=\"space-before-100\">\r\n    <p-accordion\r\n      styleClass=\"advancedSearchTabHeader\"\r\n      expandIcon=\"pi pi-caret-right\"\r\n      collapseIcon=\"pi pi-caret-down\"\r\n      [multiple]=\"true\"\r\n    >\r\n      <div class=\"vertical-flow space-between-025\">\r\n        <ng-container *ngFor=\"let filter of filterObj\">\r\n          <p-accordionTab *ngIf=\"filter.type === 'multi-select'\">\r\n            <p-header>\r\n              <div class=\"facet-header\">\r\n                <div class=\"facet-title\">\r\n                  {{ filter.label }}\r\n                </div>\r\n                <div\r\n                  class=\"facet-icon\"\r\n                  *ngIf=\"selectedListItems[filter.name]?.length\"\r\n                >\r\n                  <img [src]=\"appliedIcon\" />\r\n                </div>\r\n              </div>\r\n            </p-header>\r\n            <div\r\n              *ngFor=\"let x of filter.value; let i = index\"\r\n              class=\"vertical-flow\"\r\n            >\r\n              <p-checkbox\r\n                [ngClass]=\"i > 0 ? 'space-before-075' : ' '\"\r\n                [label]=\"x.label\"\r\n                [name]=\"filter.name\"\r\n                [value]=\"x.value\"\r\n                [(ngModel)]=\"selectedListItems[filter.name]\"\r\n              >\r\n              </p-checkbox>\r\n            </div>\r\n          </p-accordionTab>\r\n          <p-accordionTab *ngIf=\"filter.type === 'text-box'\">\r\n            <p-header>\r\n              <div class=\"facet-header\">\r\n                <div class=\"facet-title\">\r\n                  {{ filter.label }}\r\n                </div>\r\n                <div class=\"facet-icon\" *ngIf=\"this[filter.name]\">\r\n                  <img [src]=\"appliedIcon\" />\r\n                </div>\r\n              </div>\r\n            </p-header>\r\n            <div class=\"vertical-flow\">\r\n              <input\r\n                pInputText\r\n                type=\"text\"\r\n                class=\"ui-inputtext space-before-025\"\r\n                [(ngModel)]=\"this[filter.name]\"\r\n              />\r\n            </div>\r\n          </p-accordionTab>\r\n          <p-accordionTab *ngIf=\"filter.type === 'date-range'\">\r\n            <p-header>\r\n              <div class=\"facet-header\">\r\n                <div class=\"facet-title\">\r\n                  {{ filter.label }}\r\n                </div>\r\n                <div\r\n                  class=\"facet-icon\"\r\n                  *ngIf=\"this[filter.name + 'Min'] || this[filter.name + 'Max']\"\r\n                >\r\n                  <img [src]=\"appliedIcon\" />\r\n                </div>\r\n              </div>\r\n            </p-header>\r\n            <div class=\"vertical-flow space-between-075 input-filter\">\r\n              <div>{{ 'ADVANCED_SEARCH.RANGE' | transloco }}</div>\r\n              <div>\r\n                <p-calendar\r\n                  [showIcon]=\"true\"\r\n                  [dateFormat]=\"dateType.primeNgFormat\"\r\n                  [placeholder]=\"dateType.description\"\r\n                  [(ngModel)]=\"this[filter.name + 'Min']\"\r\n                  [maxDate]=\"this[filter.name + 'Max']\"\r\n                  [readonlyInput]=\"true\"\r\n                  (onSelect)=\"getValidDate($event, 'min', filter.name)\"\r\n                  appendTo=\"body\"\r\n                ></p-calendar>\r\n              </div>\r\n              <div>\r\n                <p-calendar\r\n                  [dateFormat]=\"dateType.primeNgFormat\"\r\n                  [placeholder]=\"dateType.description\"\r\n                  [(ngModel)]=\"this[filter.name + 'Max']\"\r\n                  [minDate]=\"this[filter.name + 'Min']\"\r\n                  [readonlyInput]=\"true\"\r\n                  (onSelect)=\"getValidDate($event, 'max', filter.name)\"\r\n                  [showIcon]=\"true\"\r\n                  appendTo=\"body\"\r\n                ></p-calendar>\r\n              </div>\r\n            </div>\r\n          </p-accordionTab>\r\n          <p-accordionTab *ngIf=\"filter.type === 'number-range'\">\r\n            <p-header>\r\n              <div class=\"facet-header\">\r\n                <div class=\"facet-title\">\r\n                  {{ filter.label }}\r\n                </div>\r\n                <div\r\n                  class=\"facet-icon\"\r\n                  *ngIf=\"this[filter.name + 'Min'] || this[filter.name + 'Max']\"\r\n                >\r\n                  <img [src]=\"appliedIcon\" />\r\n                </div>\r\n              </div>\r\n            </p-header>\r\n            <div class=\"vertical-flow space-between-075 input-filter\">\r\n              <div>{{ 'ADVANCED_SEARCH.MINMAX' | transloco }}</div>\r\n              <div>\r\n                <p-inputNumber\r\n                  mode=\"decimal\"\r\n                  class=\"\"\r\n                  placeholder=\"$0\"\r\n                  [(ngModel)]=\"this[filter.name + 'Min']\"\r\n                ></p-inputNumber>\r\n              </div>\r\n              <div>\r\n                <p-inputNumber\r\n                  mode=\"decimal\"\r\n                  class=\"\"\r\n                  placeholder=\"$1000000\"\r\n                  [(ngModel)]=\"this[filter.name + 'Max']\"\r\n                ></p-inputNumber>\r\n              </div>\r\n            </div>\r\n          </p-accordionTab>\r\n        </ng-container>\r\n        <!--  need to be part of  Basic search - -->\r\n        <p-accordionTab>\r\n          <p-header>\r\n            <div class=\"facet-header\">\r\n              <div class=\"facet-title\">\r\n                {{ 'MARKETPLACE_ADVANCED_SEARCH.PROCESSED' | transloco }}\r\n              </div>\r\n\r\n              <div class=\"facet-icon\" *ngIf=\"processedStatus\">\r\n                <img [src]=\"appliedIcon\" />\r\n              </div>\r\n            </div>\r\n          </p-header>\r\n          <div class=\"vertical-flow\">\r\n            <p-dropdown\r\n              [options]=\"filterData.processedBasicSearch\"\r\n              [(ngModel)]=\"processedStatus\"\r\n              styleClass=\"width-100\"\r\n              autoWidth=\"false\"\r\n              optionLabel=\"label\"\r\n              placeholder=\"{{\r\n                'MARKETPLACE_ADVANCED_SEARCH.SELECT' | transloco\r\n              }}\"\r\n              appendTo=\"body\"\r\n            >\r\n            </p-dropdown>\r\n          </div>\r\n        </p-accordionTab>\r\n        <p-accordionTab>\r\n          <p-header>\r\n            <div class=\"facet-header\">\r\n              <div class=\"facet-title\">\r\n                {{ 'MARKETPLACE_ADVANCED_SEARCH.WARNING' | transloco }}\r\n              </div>\r\n\r\n              <div class=\"facet-icon\" *ngIf=\"warning\">\r\n                <img [src]=\"appliedIcon\" />\r\n              </div>\r\n            </div>\r\n          </p-header>\r\n          <div class=\"vertical-flow\">\r\n            <p-checkbox\r\n              [(ngModel)]=\"warning\"\r\n              [binary]=\"true\"\r\n              label=\"{{ 'MARKETPLACE_ADVANCED_SEARCH.WARNING' | transloco }}\"\r\n            >\r\n            </p-checkbox>\r\n          </div>\r\n        </p-accordionTab>\r\n      </div>\r\n    </p-accordion>\r\n  </div>\r\n</div>\r\n",
        styles: [""]
    })
], AdvancedSearchComponent);

let ClaimsReceivedModule = class ClaimsReceivedModule {
};
ClaimsReceivedModule = __decorate([
    NgModule({
        declarations: [
            ClaimsReceivedComponent,
            ViewClaimsReceivedComponent,
            AdvancedSearchComponent,
        ],
        imports: [
            AccordionModule,
            CheckboxModule,
            CommonModule,
            CommonSharedModuleModule,
            ConfirmDialogModule,
            CalendarModule,
            DialogModule,
            DropdownModule,
            DialogModule,
            FormsModule,
            InputNumberModule,
            RouterModule,
            SearchContainerModule,
            TableModule,
            TranslocoModule,
        ],
    })
], ClaimsReceivedModule);

const schemaDefinition$7 = (fields) => ({
    fields,
});

let FlipFormContainerComponent = class FlipFormContainerComponent {
    constructor(http, translocoService, toast, formGenerator) {
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.formGenerator = formGenerator;
        this.closeDialog = new EventEmitter();
        this.saveDialog = new EventEmitter();
        this.schemaDefinition = schemaDefinition$7;
    }
    ngOnInit() {
        this.http
            .fetchWithFqn({
            endpoint: `${this.baseUrl}/flip/form`,
            httpMethod: 'GET',
        })
            .pipe(tap(({ fields }) => {
            this.form = this.formGenerator.init(this.schemaDefinition(fields));
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))))
            .subscribe();
    }
};
FlipFormContainerComponent.ctorParameters = () => [
    { type: BaseHttpService$3 },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: GenerateFormService }
];
__decorate([
    Input()
], FlipFormContainerComponent.prototype, "baseUrl", void 0);
__decorate([
    Output()
], FlipFormContainerComponent.prototype, "closeDialog", void 0);
__decorate([
    Output()
], FlipFormContainerComponent.prototype, "saveDialog", void 0);
FlipFormContainerComponent = __decorate([
    Component({
        selector: 'lib-flip-form-container',
        template: ` <lib-flip-form
    [form]="form"
    (closeDialog)="closeDialog.emit()"
    (saveDialog)="saveDialog.emit($event)"
  ></lib-flip-form>`
    })
], FlipFormContainerComponent);

let FlipFormComponent = class FlipFormComponent {
    constructor() {
        this.closeDialog = new EventEmitter();
        this.saveDialog = new EventEmitter();
    }
    set formSetter(form) {
        this.form = form;
        this.checkFormValidity();
    }
    save() {
        this.saveDialog.emit(this.form.values);
    }
    close() {
        this.closeDialog.emit();
    }
    checkFormValidity() {
        var _a;
        Object.keys(Object.assign({}, (_a = this.form) === null || _a === void 0 ? void 0 : _a.schema)).forEach((field) => {
            this.form.setStatus(field, 'touched', true);
        });
    }
};
__decorate([
    Input('form')
], FlipFormComponent.prototype, "formSetter", null);
__decorate([
    Output()
], FlipFormComponent.prototype, "closeDialog", void 0);
__decorate([
    Output()
], FlipFormComponent.prototype, "saveDialog", void 0);
FlipFormComponent = __decorate([
    Component({
        selector: 'lib-flip-form',
        template: "<div\r\n  class=\"crossrefrences-dialogue\"\r\n  style=\"display: flex; flex-direction: column\"\r\n>\r\n  <h2 class=\"dialog-title\">\r\n    {{ 'INVOICE.COLLECTION_BATCHES_FLIP_HEADER' | transloco }}\r\n  </h2>\r\n  <span>\r\n    {{ 'INVOICE.COLLECTION_BATCHES_FLIP_MESSAGE' | transloco }}\r\n  </span>\r\n  <br />\r\n  <div style=\"flex-grow: 1; position: relative\">\r\n    <lui-form *ngIf=\"form; else formNotAvailable\" [form]=\"form\"></lui-form>\r\n    <ng-template #formNotAvailable>\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <div\r\n    class=\"contols\"\r\n    style=\"display: flex; gap: 0.5em; padding-top: 1em; padding-bottom: 5em\"\r\n  >\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      (click)=\"close()\"\r\n    ></button>\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      class=\"ds\"\r\n      (click)=\"save()\"\r\n      [disabled]=\"!form?.valid\"\r\n      style=\"flex-grow: 1\"\r\n    ></button>\r\n  </div>\r\n</div>\r\n"
    })
], FlipFormComponent);

let ViewComponent = class ViewComponent {
    constructor() {
        this.closeDialog = new EventEmitter();
    }
    close() {
        this.closeDialog.emit();
    }
};
__decorate([
    Output()
], ViewComponent.prototype, "closeDialog", void 0);
__decorate([
    Input()
], ViewComponent.prototype, "form", void 0);
ViewComponent = __decorate([
    Component({
        selector: 'lib-view',
        template: "<div\r\n  class=\"crossrefrences-dialogue\"\r\n  style=\"display: flex; flex-direction: column\"\r\n>\r\n  <div style=\"justify-content: center\">\r\n    <h2 class=\"dialog-title\">\r\n      {{ 'INVOICE.COLLECTION_BATCHES_VIEW' | transloco }}\r\n    </h2>\r\n    <div style=\"flex-grow: 1; position: relative\">\r\n      <lui-form *ngIf=\"form; else formNotAvailable\" [form]=\"form\"></lui-form>\r\n      <ng-template #formNotAvailable>\r\n        <div\r\n          class=\"spinner-background\"\r\n          style=\"min-height: 30vh; position: relative\"\r\n        >\r\n          <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n        </div>\r\n      </ng-template>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"contols\" style=\"display: flex; gap: 0.5em; padding-top: 1em\">\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CLOSE' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      (click)=\"close()\"\r\n      style=\"flex-grow: 1\"\r\n    ></button>\r\n  </div>\r\n</div>\r\n"
    })
], ViewComponent);

let CollectionsComponent = class CollectionsComponent {
    constructor(translocoService) {
        this.translocoService = translocoService;
        this.items = [];
        this.subscriptions = [];
    }
    ngOnInit() {
        this.translateTabNames();
    }
    translateTabNames() {
        this.subscriptions.push(this.translocoService
            .selectTranslate('MARKETPLACE')
            .pipe(map((translate) => translate), tap((translate) => {
            this.items = [
                {
                    label: translate.TAB_COLLECTIONS_BATCHES,
                    routerLink: 'batches',
                },
            ];
        }))
            .subscribe());
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
};
CollectionsComponent.ctorParameters = () => [
    { type: TranslocoService }
];
CollectionsComponent = __decorate([
    Component({
        selector: 'lib-collections',
        template: "<h2>{{ 'MARKETPLACE.COLLECTIONS' | transloco }}</h2>\r\n<div>\r\n  <p-tabMenu [model]=\"items\"></p-tabMenu>\r\n  <router-outlet></router-outlet>\r\n</div>\r\n"
    })
], CollectionsComponent);

let EFTACHSettingsComponent = class EFTACHSettingsComponent {
    constructor(translocoService, toast, spinner, marketplaceService, http, searchContainerLoaderService) {
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.marketplaceService = marketplaceService;
        this.http = http;
        this.searchContainerLoaderService = searchContainerLoaderService;
        // search container loader states
        this.searchContainerName = 'paymentsEFTACHSettings';
        this.i18nSearchField = 'COMPANY.SEARCH';
        this.toolbarActionsDispatcher = {
            view: (selection) => { },
            edit: (selection) => { },
            editList: (selection) => { },
        };
        this.baseUrl = `${this.marketplaceService.getConfig()}`;
        this.columnActions = {};
        // `${this.marketplaceService.getConfig()}`;
        // http.baseUrl = marketplaceService.getConfig().getAccountRootURL;
    }
    ngOnInit() { }
};
EFTACHSettingsComponent.ctorParameters = () => [
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: MarketplaceService },
    { type: BaseHttpService },
    { type: SearchContainerLoaderService }
];
EFTACHSettingsComponent = __decorate([
    Component({
        selector: 'lib-eft-ach-settings',
        template: "<div style=\"padding-top: 2rem\">\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [baseUrl]=\"baseUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    [disableAdvancedSearch]=\"true\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n",
        providers: [SearchContainerLoaderService]
    })
], EFTACHSettingsComponent);

let GenerateFileFormContainerComponent = class GenerateFileFormContainerComponent {
    constructor(http, translocoService, toast, formGenerator) {
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.formGenerator = formGenerator;
        this.closeDialog = new EventEmitter();
        this.saveDialog = new EventEmitter();
        this.schemaDefinition = schemaDefinition$5;
    }
    ngOnInit() {
        this.http
            .fetchWithFqn({
            endpoint: `${this.baseUrl}/generate-file/form`,
            httpMethod: 'POST',
            body: {
                keys: this.selectedKeys,
            },
        })
            .pipe(tap(({ fields }) => {
            const _fields = Object.entries(Object.assign({}, fields)).map(([_, fieldValue]) => {
                var _a, _b;
                return (fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.type) === 'calendar'
                    ? Object.assign(Object.assign({}, fieldValue), { componentProperties: Object.assign(Object.assign({}, fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.componentProperties), { placeholder: (_a = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.componentProperties) === null || _a === void 0 ? void 0 : _a.dateFormat, showIcon: true, minDate: new Date((_b = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.componentProperties) === null || _b === void 0 ? void 0 : _b.minDate) }) }) : fieldValue;
            });
            this.form = this.formGenerator.init(this.schemaDefinition(_fields));
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))))
            .subscribe();
    }
};
GenerateFileFormContainerComponent.ctorParameters = () => [
    { type: BaseHttpService$3 },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: GenerateFormService }
];
__decorate([
    Input()
], GenerateFileFormContainerComponent.prototype, "baseUrl", void 0);
__decorate([
    Input()
], GenerateFileFormContainerComponent.prototype, "selectedKeys", void 0);
__decorate([
    Output()
], GenerateFileFormContainerComponent.prototype, "closeDialog", void 0);
__decorate([
    Output()
], GenerateFileFormContainerComponent.prototype, "saveDialog", void 0);
GenerateFileFormContainerComponent = __decorate([
    Component({
        selector: 'lib-generate-file-form-container',
        template: ` <lib-generate-file-form
    [form]="form"
    (closeDialog)="closeDialog.emit()"
    (saveDialog)="saveDialog.emit($event)"
  ></lib-generate-file-form>`
    })
], GenerateFileFormContainerComponent);

let GenerateFileFormComponent = class GenerateFileFormComponent {
    constructor() {
        this.closeDialog = new EventEmitter();
        this.saveDialog = new EventEmitter();
    }
    set formSetter(form) {
        this.form = form;
        this.checkFormValidity();
    }
    save() {
        this.saveDialog.emit(this.form.values);
    }
    close() {
        this.closeDialog.emit();
    }
    checkFormValidity() {
        var _a;
        Object.keys(Object.assign({}, (_a = this.form) === null || _a === void 0 ? void 0 : _a.schema)).forEach((field) => {
            this.form.setStatus(field, 'touched', true);
        });
    }
};
__decorate([
    Input('form')
], GenerateFileFormComponent.prototype, "formSetter", null);
__decorate([
    Output()
], GenerateFileFormComponent.prototype, "closeDialog", void 0);
__decorate([
    Output()
], GenerateFileFormComponent.prototype, "saveDialog", void 0);
GenerateFileFormComponent = __decorate([
    Component({
        selector: 'lib-generate-file-form',
        template: "<div\r\n  class=\"crossrefrences-dialogue\"\r\n  style=\"display: flex; flex-direction: column\"\r\n>\r\n  <h2 class=\"dialog-title\">\r\n    {{ 'INVOICE.COLLECTION_BATCHES_GENERATE_FILE_HEADER' | transloco }}\r\n  </h2>\r\n  <span>\r\n    {{ 'INVOICE.COLLECTION_BATCHES_GENERATE_FILE_MESSAGE' | transloco }}\r\n  </span>\r\n  <br />\r\n  <div style=\"flex-grow: 1; position: relative\">\r\n    <lui-form *ngIf=\"form; else formNotAvailable\" [form]=\"form\"></lui-form>\r\n    <ng-template #formNotAvailable>\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <div\r\n    class=\"contols\"\r\n    style=\"display: flex; gap: 0.5em; padding-top: 1em; padding-bottom: 5em\"\r\n  >\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      (click)=\"close()\"\r\n    ></button>\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      class=\"ds\"\r\n      (click)=\"save()\"\r\n      [disabled]=\"!form?.valid\"\r\n      style=\"flex-grow: 1\"\r\n    ></button>\r\n  </div>\r\n</div>\r\n"
    })
], GenerateFileFormComponent);

const schemaDefinition$8 = (fields) => ({
    fields,
});

let ViewContainerComponent = class ViewContainerComponent {
    constructor(http, translocoService, toast, formGenerator) {
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.formGenerator = formGenerator;
        this.closeViewDialog = new EventEmitter();
        this.schemaDefinition = schemaDefinition$8;
    }
    ngOnInit() {
        this.http
            .fetchWithFqn({
            endpoint: `${this.baseUrl}/view/${this.collectionBatchKey}`,
            httpMethod: 'GET',
        })
            .pipe(tap(({ fields }) => {
            this.form = this.formGenerator.init(this.schemaDefinition(fields));
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))))
            .subscribe();
    }
};
ViewContainerComponent.ctorParameters = () => [
    { type: BaseHttpService$3 },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: GenerateFormService }
];
__decorate([
    Input()
], ViewContainerComponent.prototype, "baseUrl", void 0);
__decorate([
    Input()
], ViewContainerComponent.prototype, "collectionBatchKey", void 0);
__decorate([
    Output()
], ViewContainerComponent.prototype, "closeViewDialog", void 0);
ViewContainerComponent = __decorate([
    Component({
        selector: 'lib-view-container',
        template: ` <lib-view
    [form]="form"
    (closeDialog)="closeViewDialog.emit()"
  ></lib-view>`
    })
], ViewContainerComponent);

let RejectComponent = class RejectComponent {
    constructor(http, translocoService, toast, formGenerator) {
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.formGenerator = formGenerator;
        this.closeRejectDialog = new EventEmitter();
        this.saveRejectDialog = new EventEmitter();
        this.schemaDefinition = schemaDefinition$5;
    }
    ngOnInit() {
        this.http
            .fetchWithFqn({
            endpoint: `${this.baseUrl}/reject/form`,
            httpMethod: 'GET',
        })
            .pipe(tap((formData) => {
            const _fields = this.schemaDefinition(formData === null || formData === void 0 ? void 0 : formData.fields);
            this.form = this.formGenerator.init(_fields);
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))))
            .subscribe();
    }
};
RejectComponent.ctorParameters = () => [
    { type: BaseHttpService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: GenerateFormService }
];
__decorate([
    Input()
], RejectComponent.prototype, "baseUrl", void 0);
__decorate([
    Output()
], RejectComponent.prototype, "closeRejectDialog", void 0);
__decorate([
    Output()
], RejectComponent.prototype, "saveRejectDialog", void 0);
RejectComponent = __decorate([
    Component({
        selector: 'lib-reject',
        template: `<lib-reject-form
    [form]="form"
    (closeForm)="closeRejectDialog.emit()"
    (saveForm)="saveRejectDialog.emit($event)"
  ></lib-reject-form>`
    })
], RejectComponent);

let RejectFormComponent = class RejectFormComponent {
    constructor() {
        this.closeForm = new EventEmitter();
        this.saveForm = new EventEmitter();
    }
    set formSetter(form) {
        this.form = form;
        this.checkFormValidity();
    }
    checkFormValidity() {
        var _a;
        Object.keys(Object.assign({}, (_a = this.form) === null || _a === void 0 ? void 0 : _a.schema)).forEach((field) => {
            this.form.setStatus(field, 'touched', true);
        });
    }
};
__decorate([
    Input('form')
], RejectFormComponent.prototype, "formSetter", null);
__decorate([
    Output()
], RejectFormComponent.prototype, "closeForm", void 0);
__decorate([
    Output()
], RejectFormComponent.prototype, "saveForm", void 0);
RejectFormComponent = __decorate([
    Component({
        selector: 'lib-reject-form',
        template: "<div\r\n  class=\"crossrefrences-dialogue\"\r\n  style=\"display: flex; flex-direction: column\"\r\n>\r\n  <h2 class=\"dialog-title\">\r\n    {{ 'INVOICE.COLLECTION_BATCHES_REJECT_HEADER' | transloco }}\r\n  </h2>\r\n  <div style=\"flex-grow: 1; position: relative\">\r\n    <lui-form *ngIf=\"form; else formNotAvailable\" [form]=\"form\"></lui-form>\r\n    <ng-template #formNotAvailable>\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <div\r\n    class=\"contols\"\r\n    style=\"display: flex; gap: 0.5em; padding-top: 1em; padding-bottom: 5em\"\r\n  >\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      (click)=\"closeForm.emit()\"\r\n    ></button>\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SUBMIT' | transloco }}\"\r\n      class=\"ds\"\r\n      (click)=\"saveForm.emit(form?.values)\"\r\n      [disabled]=\"!form?.valid\"\r\n      style=\"flex-grow: 1\"\r\n    ></button>\r\n  </div>\r\n</div>\r\n"
    })
], RejectFormComponent);

let CollectionsModule = class CollectionsModule {
};
CollectionsModule = __decorate([
    NgModule({
        declarations: [
            CollectionsComponent,
            BatchesComponent,
            EFTACHSettingsComponent,
            ViewComponent,
            FlipFormContainerComponent,
            FlipFormComponent,
            GenerateFileFormContainerComponent,
            GenerateFileFormComponent,
            ViewContainerComponent,
            RejectComponent,
            RejectFormComponent,
        ],
        imports: [
            CommonModule,
            DialogModule$1,
            RouterModule,
            TabMenuModule,
            CommonModule,
            TranslocoModule,
            PerFormPrimengModule,
            ProgressSpinnerModule$1,
            ButtonModule$1,
            UtilsModule,
            RouterModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            UtilsModule,
            ExportModule,
            AnalyticsModule,
            DashboardModule,
        ],
        entryComponents: [ExportComponent],
    })
], CollectionsModule);

const defaultPayState = {
    stage: 0,
};
const ɵ0$N = (stage) => ({
    stage,
});
const paySchema = {
    setStage: {
        command: ɵ0$N,
    },
};

let PayWizardComponent = class PayWizardComponent {
    constructor(actionUi, payService, router, mp, confirmationService, translocoService) {
        this.actionUi = actionUi;
        this.payService = payService;
        this.router = router;
        this.mp = mp;
        this.confirmationService = confirmationService;
        this.translocoService = translocoService;
        this.actions = Action.createDispatcher(paySchema);
        this.steps = [];
        this.wizardDefaultState = {};
        this.templateTypes = TemplateTypes;
        // tslint:disable-next-line:no-unused-expression
        this.payService.search === null &&
            this.router.navigate([this.payService.redirectUrl]);
        this.wizardBaseUrl = this.mp.getConfig().receivedInvoice;
        this.wizardConfig = {
            endpoint: '/invoice/pay/form/step/1',
            httpMethod: HttpMethod.POST,
            body: {
                search: this.payService.search,
                selectedKeys: this.payService.selectedKeys,
            },
        };
        this.actionUi.initialize(Object.assign({}, defaultPayState), this.actions);
        this.actionUi.state
            .pipe(tap((state) => (this.state = Object.assign({}, state))), takeUntil(this.actionUi.shouldDestroy))
            .subscribe();
    }
    onCancel() {
        this.confirmationService.confirm({
            header: this.translocoService.translate('ACTIONS.CANCEL'),
            message: this.translocoService.translate('COMMON.CONFIRM_LEAVE'),
            acceptLabel: this.translocoService.translate('ACTIONS.YES'),
            rejectLabel: this.translocoService.translate('ACTIONS.NO'),
            accept: () => {
                this.payService.reset();
                this.router.navigate([this.payService.redirectUrl]);
            },
        });
    }
    openPayDetails(data) {
        this.payService.payInit(data);
        this.actions.setStage.dispatch(1);
    }
    onBack() {
        this.wizardConfig = {
            endpoint: '/invoice/pay/form/step/2',
            httpMethod: HttpMethod.POST,
            body: {
                search: this.payService.search,
                selectedKeys: this.payService.selectedKeys,
            },
        };
        this.wizardDefaultState = {
            screens: this.payService.wizardData.reduce((total, current, index) => {
                return Object.assign(Object.assign({}, total), { [index]: current });
            }, {}),
            steps: this.steps,
            page: 1,
        };
        this.actions.setStage.dispatch(0);
    }
};
PayWizardComponent.ctorParameters = () => [
    { type: ActionUiService },
    { type: PayService },
    { type: Router },
    { type: MarketplaceService },
    { type: ConfirmationService },
    { type: TranslocoService }
];
PayWizardComponent = __decorate([
    Component({
        selector: 'lib-pay-wizard',
        template: "<div class=\"pay-details\">\r\n  <ng-container [ngSwitch]=\"state.stage\">\r\n    <ng-container *ngSwitchCase=\"0\">\r\n      <lui-wizard\r\n        [baseUrl]=\"wizardBaseUrl\"\r\n        [wizardConfig]=\"wizardConfig\"\r\n        [defaultState]=\"wizardDefaultState\"\r\n        (submit)=\"openPayDetails($event)\"\r\n        (cancel)=\"onCancel()\"\r\n        (steps)=\"steps = $event\"\r\n      >\r\n        <ng-template [luiWidget]=\"templateTypes.READY\">\r\n          <div class=\"center ready\">\r\n            <h1>rdy msg</h1>\r\n          </div>\r\n        </ng-template>\r\n        <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n          <div class=\"spinner-background\">\r\n            <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n          </div>\r\n        </ng-template>\r\n        <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n          <div\r\n            class=\"error\"\r\n            style=\"\r\n              min-height: 30vh;\r\n              display: flex;\r\n              justify-content: center;\r\n              align-items: center;\r\n            \"\r\n          >\r\n            <div>\r\n              <span>\r\n                <i class=\"pi pi-times-circle\"></i>\r\n                {{ 'COMMON.FAILURE_TOAST_MESSAGE' | transloco }}\r\n              </span>\r\n            </div>\r\n          </div>\r\n          <button pButton (click)=\"onCancel()\" class=\"ds secondary\">\r\n            {{ 'ACTIONS.CANCEL' | transloco }}\r\n          </button>\r\n        </ng-template>\r\n      </lui-wizard>\r\n    </ng-container>\r\n    <ng-container *ngSwitchCase=\"1\">\r\n      <div class=\"wizard-v2\">\r\n        <div class=\"wizard-box\">\r\n          <div class=\"steps\" *ngIf=\"steps.length !== 0\">\r\n            <div\r\n              class=\"step\"\r\n              *ngFor=\"let step of steps; let i = index\"\r\n              [ngClass]=\"{ selected: i === page, future: i > page }\"\r\n            >\r\n              {{ step }}\r\n            </div>\r\n          </div>\r\n          <div class=\"screen-menu\">\r\n            <lib-pay-v2 (back)=\"onBack()\" (page)=\"page = $event\"></lib-pay-v2>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </ng-container>\r\n  </ng-container>\r\n</div>\r\n\r\n<p-confirmDialog [closable]=\"false\" [closeOnEscape]=\"false\"></p-confirmDialog>\r\n",
        providers: [ActionUiService, ConfirmationService],
        styles: [""]
    })
], PayWizardComponent);

const DEFAULT_PAGE_SIZE = 25;
let DefaultPaginatorComponent = class DefaultPaginatorComponent {
    constructor(changeDetector) {
        this.changeDetector = changeDetector;
        this._pageSizeOptions = [
            {
                label: 25,
                value: 25,
            },
            {
                label: 50,
                value: 50,
            },
            {
                label: 75,
                value: 75,
            },
            {
                label: 100,
                value: 100,
            },
        ];
        this._pageIndex = 0;
        this.page = new EventEmitter();
    }
    get pageIndex() {
        return this._pageIndex;
    }
    set pageIndex(value) {
        this._pageIndex = Math.max(value, 0);
    }
    get length() {
        return this._length;
    }
    set length(n) {
        this._length = n;
        this.updatePageLinks();
    }
    get pageSize() {
        return this._pageSize;
    }
    set pageSize(n) {
        this._pageSize = n;
        this._updateDisplayedPageSizeOptions();
        this.updatePageLinks();
    }
    get pageSizeOptions() {
        return this._pageSizeOptions;
    }
    set pageSizeOptions(options) {
        this._pageSizeOptions = options;
        this._updateDisplayedPageSizeOptions();
    }
    ngOnInit() {
        this._updateDisplayedPageSizeOptions();
        this.initialized = new Observable((s) => {
            s.next();
            s.complete();
        });
    }
    ngAfterContentChecked() {
        this.changeDetector.detectChanges();
    }
    nextPage() {
        if (!this.hasNextPage()) {
            return;
        }
        const previousPageIndex = this.pageIndex;
        this.pageIndex = this.pageIndex + 1;
        this._emitPageEvent(previousPageIndex);
    }
    previousPage() {
        if (!this.hasPreviousPage()) {
            return;
        }
        const previousPageIndex = this.pageIndex;
        this.pageIndex = this.pageIndex - 1;
        this._emitPageEvent(previousPageIndex);
    }
    firstPage() {
        if (!this.hasPreviousPage()) {
            return;
        }
        const previousPageIndex = this.pageIndex;
        this.pageIndex = 0;
        this._emitPageEvent(previousPageIndex);
    }
    lastPage() {
        if (!this.hasNextPage()) {
            return;
        }
        const previousPageIndex = this.pageIndex;
        this.pageIndex = this.getNumberOfPages() - 1;
        this._emitPageEvent(previousPageIndex);
    }
    hasPreviousPage() {
        return this.pageIndex >= 1 && this.pageSize !== 0;
    }
    hasNextPage() {
        const maxPageIndex = this.getNumberOfPages() - 1;
        return this.pageIndex < maxPageIndex && this.pageSize !== 0;
    }
    _changePageSize(event) {
        this._pageSize = event;
        this._pageIndex = 0;
        if (this.hasNextPage()) {
            this._emitPageEvent();
        }
    }
    _emitPageEvent(previousPageIndex) {
        this.page.emit({
            previousPageIndex,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            length: this.length,
        });
    }
    _updateDisplayedPageSizeOptions() {
        if (!this._pageSize) {
            this._pageSize = DEFAULT_PAGE_SIZE;
        }
    }
    getNumberOfPages() {
        if (!this._pageSize || !this.length) {
            return 0;
        }
        return Math.ceil(this.length / this.pageSize);
    }
    calculatePageLinkBoundaries() {
        const numberOfPages = this.getNumberOfPages();
        const visiblePages = Math.min(5, numberOfPages);
        // calculate range, keep current in middle if necessary
        let start = Math.max(0, Math.ceil(this._pageIndex - visiblePages / 2));
        const end = Math.min(numberOfPages - 1, start + visiblePages - 1);
        // check when approaching to last page
        const delta = 5 - (end - start + 1);
        start = Math.max(0, start - delta);
        return [start, end];
    }
    updatePageLinks() {
        this.pageLinks = [];
        const boundaries = this.calculatePageLinkBoundaries();
        const start = boundaries[0];
        const end = boundaries[1];
        for (let i = start; i <= end; i++) {
            this.pageLinks.push(i + 1);
        }
    }
    onPageLinkClick(event, page) {
        this.pageIndex = page;
        this._emitPageEvent();
        event.preventDefault();
    }
};
DefaultPaginatorComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
__decorate([
    Input()
], DefaultPaginatorComponent.prototype, "pageIndex", null);
__decorate([
    Input()
], DefaultPaginatorComponent.prototype, "length", null);
__decorate([
    Input()
], DefaultPaginatorComponent.prototype, "pageSize", null);
__decorate([
    Input()
], DefaultPaginatorComponent.prototype, "pageSizeOptions", null);
__decorate([
    Output()
], DefaultPaginatorComponent.prototype, "page", void 0);
DefaultPaginatorComponent = __decorate([
    Component({
        // tslint:disable-next-line:component-selector
        selector: 'lui-default-paginator',
        exportAs: 'luiDefaultPaginator',
        template: "<div\r\n  class=\"ui-paginator-bottom ui-paginator ui-widget ui-widget-header ui-unselectable-text ui-helper-clearfix ng-star-inserted\"\r\n>\r\n  <a\r\n    class=\"ui-paginator-first ui-paginator-element ui-state-default ui-corner-all\"\r\n    [ngClass]=\"{'ui-state-disabled' : !hasPreviousPage()}\"\r\n    (click)=\"firstPage()\"\r\n  >\r\n    <span class=\"ui-paginator-icon pi pi-step-backward\"></span>\r\n  </a>\r\n  <a\r\n    class=\"ui-paginator-prev ui-paginator-element ui-state-default ui-corner-all ng-star-inserted\"\r\n    [ngClass]=\"{'ui-state-disabled' : !hasPreviousPage()}\"\r\n    (click)=\"previousPage()\"\r\n  >\r\n    <span class=\"ui-paginator-icon pi pi-caret-left\"></span>\r\n  </a>\r\n  <span class=\"ui-paginator-pages\">\r\n    <a\r\n      class=\"ui-paginator-page ui-paginator-element ui-state-default ui-corner-all ui-state-active ng-star-inserted\"\r\n      *ngFor=\"let pageLink of pageLinks\"\r\n      [ngClass]=\"{'ui-state-active' : pageLink - 1 === pageIndex}\"\r\n      (click)=\"onPageLinkClick($event, pageLink - 1)\"\r\n    >\r\n      {{ pageLink }}\r\n    </a>\r\n  </span>\r\n  <a\r\n    class=\"ui-paginator-next ui-paginator-element ui-state-default ui-corner-all ng-star-inserted\"\r\n    [ngClass]=\"{'ui-state-disabled' : !hasNextPage()}\"\r\n    (click)=\"nextPage()\"\r\n  >\r\n    <span class=\"ui-paginator-icon pi pi-caret-right\"></span>\r\n  </a>\r\n  <a\r\n    class=\"ui-paginator-last ui-paginator-element ui-state-default ui-corner-all\"\r\n    [ngClass]=\"{'ui-state-disabled' : !hasNextPage()}\"\r\n    (click)=\"lastPage()\"\r\n    >\r\n    <span class=\"ui-paginator-icon pi pi-step-forward\"></span>\r\n  </a>\r\n  <!-- <div>Items per page:</div> -->\r\n\r\n  <p-dropdown\r\n    lui-select\r\n    [options]=\"pageSizeOptions\"\r\n    (ngModelChange)=\"_changePageSize($event)\"\r\n    [ngModel]=\"pageSize\"\r\n  >\r\n  </p-dropdown>\r\n</div>\r\n",
        encapsulation: ViewEncapsulation.None
    })
], DefaultPaginatorComponent);

var TableAlignment$1;
(function (TableAlignment) {
    TableAlignment["LEFT"] = "left";
    TableAlignment["CENTER"] = "center";
    TableAlignment["RIGHT"] = "right";
})(TableAlignment$1 || (TableAlignment$1 = {}));

class EditTableDataSource extends DataSource {
    constructor(schema, formGenerator, reducers, reducerInitialValue, data = [], triggers = {}, searchService) {
        super();
        this.formGenerator = formGenerator;
        this.forms$ = new BehaviorSubject([]);
        this.displayedForms$ = new BehaviorSubject([]);
        this._displayedColumns = [];
        this._onDestroy = new Subject();
        this._pageLimit = 25;
        this._pageOffset = 0;
        this._searchService = null;
        this._searchBody = {
            page: {
                limit: 25,
                offset: 0,
            },
        };
        this._aggregation = new BehaviorSubject(reducerInitialValue);
        this._schema = Object.assign(Object.assign({}, schema), { fields: Object.entries(schema.fields).reduce((fields, [key, field]) => {
                const classes = this.getAlignment(field === null || field === void 0 ? void 0 : field.alignment);
                if ((field === null || field === void 0 ? void 0 : field.type) === 'dropdown') {
                    field.componentProperties = { autoZIndex: false };
                }
                return Object.assign(Object.assign({}, fields), { [key]: (field === null || field === void 0 ? void 0 : field.width) ? Object.assign(Object.assign({}, field), { style: {
                            'white-space': 'normal',
                            'max-width': `${field === null || field === void 0 ? void 0 : field.width}px`,
                            'min-width': `${field === null || field === void 0 ? void 0 : field.width}px`,
                        }, classes }) : Object.assign(Object.assign({}, field), { classes }) });
            }, {}) });
        this._displayedColumns = Object.entries(this._schema.fields).reduce((displayedColumns, [key, field]) => {
            var _a;
            return ((_a = field.display) !== null && _a !== void 0 ? _a : true) === true
                ? [...displayedColumns, key]
                : [...displayedColumns];
        }, []);
        this.forms$
            .asObservable()
            .pipe(switchMap((forms) => combineLatest([...forms.map((form) => form.values$)])), throttleTime(250, undefined, { leading: true, trailing: true }), map((values) => values.reduce(reducers, reducerInitialValue)), tap((value) => this._aggregation.next(value)), takeUntil(this._onDestroy))
            .subscribe();
        this.forms$
            .asObservable()
            .pipe(switchMap((forms) => merge(...forms.map((form) => form.errors$))), takeUntil(this._onDestroy))
            .subscribe();
        this.forms$
            .asObservable()
            .pipe(switchMap((forms) => merge(...forms.reduce((formTriggers, form) => {
            return [
                ...formTriggers,
                ...Object.entries(triggers).map(([key, { trigger, action }]) => {
                    return form.values$.pipe(queryChange(key), filter((value) => trigger(form, value)), delay(0), tap((value) => action(form, value)));
                }),
            ];
        }, []))), takeUntil(this._onDestroy))
            .subscribe();
        this.searchService = searchService;
        this.updateData(data);
    }
    set paginator(paginator) {
        this._paginator = paginator;
        this._setupPaginator();
    }
    _setupPaginator() {
        this._paginator.length = this.forms$.value.length;
        this._paginator.pageIndex = this._pageOffset;
        this._paginator.pageSize = this._pageLimit;
        this._paginator.page
            .pipe(tap((page) => {
            this._paginator.pageSize = page.pageSize;
            this._searchBody = {
                page: {
                    limit: page.pageSize,
                    offset: page.pageIndex * page.pageSize,
                },
            };
            this._searcher
                .pipe(tap((disForms) => this.displayedForms$.next(disForms.records)))
                .subscribe();
            this._searchService.search(this._searchBody);
        }), takeUntil(this._onDestroy))
            .subscribe();
    }
    set searchService(searchService) {
        this._searchService = searchService;
    }
    connect() {
        return this.displayedForms$;
    }
    disconnect() {
        this._onDestroy.next(true);
    }
    addRows(...data) {
        this.forms$.next([
            ...this.forms$.value,
            ...data.map((newRow) => this.formGenerator.init(this.schema, newRow)),
        ]);
    }
    removeRows(...indexes) {
        this.forms$.next([
            ...this.forms$.value.reduce((total, curr, index) => indexes.includes(index) ? [...total] : [...total, curr], []),
        ]);
    }
    updateData(updatedData) {
        this.forms$.next(updatedData.map((data) => this.formGenerator.init(Object.assign(Object.assign({}, this.schema), { fields: Object.assign({}, Object.entries(this.schema.fields).reduce((fields, [key, field]) => {
                var _a, _b, _c, _d, _e;
                return (Object.assign(Object.assign({}, fields), { [key]: Object.assign(Object.assign(Object.assign({}, field), ((_a = data[key]) !== null && _a !== void 0 ? _a : {})), { componentProperties: Object.assign(Object.assign({}, ((_b = field === null || field === void 0 ? void 0 : field.componentProperties) !== null && _b !== void 0 ? _b : {})), ((_e = (_d = ((_c = data[key]) !== null && _c !== void 0 ? _c : {})) === null || _d === void 0 ? void 0 : _d.componentProperties) !== null && _e !== void 0 ? _e : {})) }) }));
            }, {})) }))));
        this._searcher = this._searchService.load(this.forms$.value);
        this._searcher
            .pipe(tap((disForms) => this.displayedForms$.next(disForms.records)))
            .subscribe();
        this._searchService.search(this._searchBody);
    }
    get aggregation() {
        return this._aggregation.value;
    }
    get schema() {
        return this._schema;
    }
    get displayedColumns() {
        return this._displayedColumns;
    }
    get values() {
        return this.forms$.value.map((form) => form.values);
    }
    get isValid() {
        return this.forms$.value.reduce((isValid, form) => form.valid ? isValid : false, true);
    }
    getAlignment(alignment) {
        switch (alignment) {
            case TableAlignment$1.RIGHT:
                return { 'content-end': true };
            case TableAlignment$1.CENTER:
                return { center: true };
            case TableAlignment$1.LEFT:
            default:
                return {};
        }
    }
}

let LocalSearchService = class LocalSearchService {
    constructor() {
        this._data = new BehaviorSubject([]);
        this._data$ = this._data.asObservable();
        this._searchBody = new Subject();
        this._searchBody$ = this._searchBody.asObservable();
        // slice the data based on the offset and limit and return the corresponding object
        this._searcher = combineLatest([this._data$, this._searchBody$]).pipe(map(([data, body]) => {
            const splitData = data.slice(body.page.offset, body.page.offset + body.page.limit);
            return { records: splitData, totalRecords: data.length, errorCode: 0 };
        }), first());
    }
    // load the records into the service
    load(data) {
        this._data.next(data);
        return this._searcher;
    }
    // supply the search body to the observable
    search(body) {
        this._searchBody.next(body);
    }
};
LocalSearchService = __decorate([
    Injectable()
], LocalSearchService);

class PaySummeryDataSource extends DataSource {
    constructor(schema, editDataSource) {
        super();
        this.summeryData$ = new BehaviorSubject([]);
        this._onDestroy = new Subject();
        this._summeryTableKeys = [
            'supplierKey',
            'supplierName',
            'balanceOwing',
            'termsBalanceAmount',
            'termsDiscountTaken',
            'paymentAmount',
        ];
        this._schema = {
            fields: Object.entries(schema.fields).reduce((total, [key, field]) => {
                if (this._summeryTableKeys.includes(key)) {
                    const classes = this.getAlignment(field === null || field === void 0 ? void 0 : field.alignment);
                    return Object.assign(Object.assign({}, total), { [key]: Object.assign(Object.assign({}, field), { classes }) });
                }
                return Object.assign({}, total);
            }, {}),
        };
        this._currency =
            this._schema.fields.paymentAmount.componentProperties.currency;
        this._locale = this._schema.fields.paymentAmount.componentProperties.locale;
        this._mode = this._schema.fields.paymentAmount.componentProperties.mode;
        combineLatest([
            ...editDataSource.forms$.value.map((form) => form.values$),
        ])
            .pipe(map((formValues) => {
            return formValues.reduce((total, { supplierKey, balanceOwing, termsBalanceAmount, termsDiscountTaken, paymentAmount, supplierName, }) => {
                var _a;
                const row = (_a = total[supplierKey]) !== null && _a !== void 0 ? _a : null;
                if (total[supplierKey]) {
                    return Object.assign(Object.assign({}, total), { [supplierKey]: Object.assign(Object.assign({}, row), { balanceOwing: row.balanceOwing + coerceNumberProperty(balanceOwing), termsBalanceAmount: row.termsBalanceAmount +
                                coerceNumberProperty(termsBalanceAmount), termsDiscountTaken: row.termsDiscountTaken +
                                coerceNumberProperty(termsDiscountTaken), paymentAmount: row.paymentAmount + coerceNumberProperty(paymentAmount) }) });
                }
                return Object.assign(Object.assign({}, total), { [supplierKey]: {
                        supplierKey,
                        balanceOwing: coerceNumberProperty(balanceOwing),
                        termsBalanceAmount: coerceNumberProperty(termsBalanceAmount),
                        termsDiscountTaken: coerceNumberProperty(termsDiscountTaken),
                        paymentAmount: coerceNumberProperty(paymentAmount),
                        supplierName,
                    } });
            }, {});
        }), map((values) => {
            return Object.entries(values).map((_a) => {
                var [_, _b] = _a, { balanceOwing, termsBalanceAmount, termsDiscountTaken, paymentAmount } = _b, rest = __rest(_b, ["balanceOwing", "termsBalanceAmount", "termsDiscountTaken", "paymentAmount"]);
                return Object.assign(Object.assign({}, rest), { balanceOwing: new Intl.NumberFormat(this._locale, {
                        style: this._mode,
                        currency: this._currency,
                    }).format(balanceOwing), termsBalanceAmount: new Intl.NumberFormat(this._locale, {
                        style: this._mode,
                        currency: this._currency,
                    }).format(termsBalanceAmount), termsDiscountTaken: new Intl.NumberFormat(this._locale, {
                        style: this._mode,
                        currency: this._currency,
                    }).format(termsDiscountTaken), paymentAmount: new Intl.NumberFormat(this._locale, {
                        style: this._mode,
                        currency: this._currency,
                    }).format(paymentAmount) });
            });
        }), tap((x) => this.summeryData$.next(x)), takeUntil(this._onDestroy))
            .subscribe();
    }
    get schema() {
        return this._schema;
    }
    get columnsToDisplay() {
        return [
            'supplierName',
            'balanceOwing',
            'termsBalanceAmount',
            'termsDiscountTaken',
            'paymentAmount',
        ];
    }
    connect() {
        return this.summeryData$;
    }
    disconnect() {
        this._onDestroy.next(true);
    }
    getAlignment(alignment) {
        switch (alignment) {
            case TableAlignment$1.RIGHT:
                return { 'content-end': true };
            case TableAlignment$1.CENTER:
                return { center: true };
            case TableAlignment$1.LEFT:
            default:
                return {};
        }
    }
}

let PayV2Component = class PayV2Component {
    constructor(http, formGenerator, store, datePipe, payService, router, mp, route, translocoService, toast, localSearchService, confirmationService) {
        var _a, _b, _c, _d, _e;
        this.http = http;
        this.formGenerator = formGenerator;
        this.store = store;
        this.datePipe = datePipe;
        this.payService = payService;
        this.router = router;
        this.mp = mp;
        this.route = route;
        this.translocoService = translocoService;
        this.toast = toast;
        this.localSearchService = localSearchService;
        this.confirmationService = confirmationService;
        this.back = new EventEmitter();
        this.page = new BehaviorSubject(2);
        this.invoiceKeys = [];
        this.paymentReferenceNumber = '';
        this.bankAccountName = '';
        this.isLoading = false;
        this.termsClickedSubject = new Subject();
        this.templateTypes = TemplateTypes$1;
        this._onDestroySubject = new Subject();
        // tslint:disable-next-line:no-unused-expression
        this.payService.ready === false &&
            this.router.navigate([this.payService.redirectUrl]);
        this.http.baseUrl = this.mp.getConfig().receivedInvoice;
        this.invoiceKeys = (_a = this.payService.invoiceKeys) !== null && _a !== void 0 ? _a : [];
        this.bankAccount = (_b = this.payService.bankAccount) !== null && _b !== void 0 ? _b : null;
        this.bankAccountName = (_c = this.payService.bankAccountName) !== null && _c !== void 0 ? _c : '';
        this.paymentReferenceNumber = (_d = this.payService.paymentReferenceNumber) !== null && _d !== void 0 ? _d : '';
        this.paymentDate = (_e = this.payService.paymentDate) !== null && _e !== void 0 ? _e : '';
    }
    get paymentSummery() {
        return this.dataSource
            ? new Intl.NumberFormat(this.dataSource.schema.fields.paymentAmount.componentProperties.locale, {
                style: this.dataSource.schema.fields.paymentAmount.componentProperties
                    .mode,
                currency: this.dataSource.schema.fields.paymentAmount.componentProperties
                    .currency,
            }).format(this.dataSource.aggregation)
            : '0';
    }
    ngAfterViewInit() {
        this.request = this.http
            .fetch({
            endpoint: 'invoice/pay/form/step/final',
            httpMethod: 'POST',
            body: {
                data: this.payService.data,
                search: this.payService.search,
                selectedKeys: this.payService.selectedKeys,
            },
        })
            .pipe(tap(({ fields, data }) => {
            fields.paymentAmount.validations = [
                {
                    message: '',
                    test: ({ paymentAmount, termsDiscountTaken, balanceOwing, }) => {
                        return (coerceNumberProperty(paymentAmount) +
                            coerceNumberProperty(termsDiscountTaken) <=
                            coerceNumberProperty(balanceOwing));
                    },
                },
            ];
            fields.termsDiscountTaken.validations = [
                {
                    message: '',
                    test: ({ paymentAmount, termsDiscountTaken, balanceOwing, }) => coerceNumberProperty(paymentAmount) +
                        coerceNumberProperty(termsDiscountTaken) <=
                        coerceNumberProperty(balanceOwing),
                },
            ];
            fields.shortPayReason.validations = [
                {
                    message: '',
                    test: ({ paymentAmount, termsDiscountTaken, balanceOwing, shortPayReason, }) => {
                        const cTotal = coerceNumberProperty(paymentAmount) +
                            coerceNumberProperty(termsDiscountTaken);
                        const cBalanceOwing = coerceNumberProperty(balanceOwing);
                        if (!!shortPayReason) {
                            return true;
                        }
                        if (!(cTotal < cBalanceOwing)) {
                            return true;
                        }
                        return false;
                    },
                },
            ];
            this.dataSource = new EditTableDataSource({ fields }, this.formGenerator, (total, form) => {
                var _a;
                return total + coerceNumberProperty((_a = form === null || form === void 0 ? void 0 : form.paymentAmount) !== null && _a !== void 0 ? _a : 0);
            }, 0, [...data], {
                shortPayReason: {
                    trigger(form, value) {
                        return true;
                    },
                    action(form, value) {
                        value === 12
                            ? form.setDisabled('shortPayReasonDescription', false)
                            : form.setDisabled('shortPayReasonDescription', true);
                    },
                },
            }, this.localSearchService);
            this.summeryDataSource = new PaySummeryDataSource({ fields }, this.dataSource);
        }));
        this.paginator.changes
            .pipe(startWith(this.paginator), first((paginator) => paginator.length !== 0), filter((paginator) => paginator.length !== 0), tap((paginator) => (this.dataSource.paginator = paginator.toArray()[0])))
            .subscribe();
    }
    ngOnInit() {
        this.store
            .pipe(select(selectors.userProfile), tap((userProfile) => {
            var _a;
            this.dateFormat = (_a = userProfile === null || userProfile === void 0 ? void 0 : userProfile.userInfo) === null || _a === void 0 ? void 0 : _a.DateTypeFormat;
            this.date = this.datePipe.transform(this.paymentDate, this.dateFormat);
        }), takeUntil(this._onDestroySubject))
            .subscribe();
    }
    ngOnDestroy() {
        this._onDestroySubject.next(true);
    }
    onSubmit() {
        this.isLoading = true;
        const payRequest = {
            invoices: this.dataSource.values.map(({ invoiceKey, paymentAmount, termsBalanceAmount, shortPayReason, shortPayReasonDescription, }) => ({
                invoiceKey,
                amount: coerceNumberProperty(paymentAmount),
                termsDiscountAmount: coerceNumberProperty(termsBalanceAmount),
                shortPaymentTypeKey: shortPayReason,
                shortPaymentDescription: shortPayReasonDescription,
            })),
            paymentReferenceNumber: this.payService.paymentReferenceNumber,
            paymentDate: this.payService.paymentDate,
            accountBankingInfoKeys: this.payService.accountBankingInfoKeys,
            paymentMethodType: this.payService.paymentMethodType,
        };
        this.http
            .fetch({
            endpoint: 'invoice/pay',
            httpMethod: 'POST',
            body: payRequest,
        })
            .pipe(tap(() => {
            this.confirmationService.confirm({
                header: this.translocoService.translate('MARKETPLACE.PAY_INVOICES'),
                message: this.translocoService.translate('INVOICE.PAY_CONFIRMATION'),
                accept: () => {
                    this.payService.reset();
                    this.router.navigate([this.payService.redirectUrl]);
                },
                rejectVisible: false,
                acceptLabel: this.translocoService.translate('ACTIONS.OK'),
            });
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('GROUP.FAILURE_TOAST_MESSAGE')))), finalize(() => {
            this.isLoading = false;
        }))
            .subscribe();
    }
    onCancel() {
        this.confirmationService.confirm({
            header: this.translocoService.translate('ACTIONS.CANCEL'),
            message: this.translocoService.translate('COMMON.CONFIRM_LEAVE'),
            acceptLabel: this.translocoService.translate('ACTIONS.YES'),
            rejectLabel: this.translocoService.translate('ACTIONS.NO'),
            accept: () => {
                this.payService.reset();
                this.router.navigate([this.payService.redirectUrl]);
            },
        });
    }
    preserveOrder() {
        return 0;
    }
    setTerms() {
        this.dataSource.forms$.value.forEach((form) => form.patch({
            termsDiscountTaken: coerceNumberProperty(form.values.termsBalanceAmount),
            paymentAmount: coerceNumberProperty(form.values.balanceOwing) -
                coerceNumberProperty(form.values.termsBalanceAmount),
        }));
    }
    onBack() {
        if (this.page.value === 2) {
            this.back.emit();
        }
        if (this.page.value === 3) {
            this.page.next(2);
        }
    }
};
PayV2Component.ctorParameters = () => [
    { type: BaseHttpService },
    { type: GenerateFormService },
    { type: Store },
    { type: DatePipe },
    { type: PayService },
    { type: Router },
    { type: MarketplaceService },
    { type: ActivatedRoute },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: LocalSearchService },
    { type: ConfirmationService }
];
__decorate([
    ViewChildren(DefaultPaginatorComponent)
], PayV2Component.prototype, "paginator", void 0);
__decorate([
    Output()
], PayV2Component.prototype, "back", void 0);
__decorate([
    Output()
], PayV2Component.prototype, "page", void 0);
PayV2Component = __decorate([
    Component({
        selector: 'lib-pay-v2',
        template: "<div class=\"pay-view\">\r\n  <h2 class=\"center\">\r\n    {{ 'MARKETPLACE.PAY_INVOICES' | transloco }}\r\n  </h2>\r\n  <lbmx-widget-wrapper [request]=\"request\" [hidden]=\"isLoading\">\r\n    <ng-template [laTemplate]=\"templateTypes.READY\">\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [laTemplate]=\"templateTypes.LOADING\">\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [laTemplate]=\"templateTypes.DONE\">\r\n      <div class=\"pay-information\">\r\n        <div class=\"pay-info-field\">\r\n          <span class=\"pay-info-field-title\">{{\r\n            'MARKETPLACE.PAYMENT_REFERENCE_NUMBER' | transloco\r\n          }}</span>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            [value]=\"paymentReferenceNumber\"\r\n            [readonly]=\"true\"\r\n          />\r\n        </div>\r\n        <div class=\"pay-info-field\">\r\n          <span class=\"pay-info-field-title\">{{\r\n            'MARKETPLACE.PAYMENT_DATE' | transloco\r\n          }}</span>\r\n          <input pInputText type=\"text\" [value]=\"date\" [readonly]=\"true\" />\r\n        </div>\r\n        <div class=\"pay-info-field\" *ngIf=\"bankAccountName\">\r\n          <span class=\"pay-info-field-title\">{{\r\n            'MARKETPLACE.BANK_ACCOUNT' | transloco\r\n          }}</span>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            [value]=\"bankAccountName\"\r\n            [readonly]=\"true\"\r\n          />\r\n        </div>\r\n        <div class=\"pay-info-field\">\r\n          <span class=\"pay-info-field-title\">{{\r\n            'MARKETPLACE.PAYMENT_SUMMARY' | transloco\r\n          }}</span>\r\n          <input\r\n            pInputText\r\n            type=\"text\"\r\n            style=\"text-align: end\"\r\n            *ngIf=\"dataSource\"\r\n            [value]=\"paymentSummery\"\r\n            [readonly]=\"true\"\r\n          />\r\n        </div>\r\n      </div>\r\n      <div [hidden]=\"page.value !== 2\">\r\n        <!-- <div class=\"nav-secondary toolbar\"> -->\r\n        <!-- <div class=\"horizontal-flow space-between-025\">\r\n            <button pButton class=\"ds tertiary small\" (click)=\"setTerms()\">\r\n              {{ 'INVOICE.TAKE_TERMS' | transloco }}\r\n            </button>\r\n          </div>\r\n        </div> -->\r\n        <lib-edit-table\r\n          [dataSource]=\"dataSource\"\r\n          (termsClick)=\"termsClickedSubject.next($event)\"\r\n        ></lib-edit-table>\r\n        <lui-default-paginator></lui-default-paginator>\r\n      </div>\r\n      <div\r\n        class=\"edit-table\"\r\n        *ngIf=\"summeryDataSource\"\r\n        [hidden]=\"page.value !== 3\"\r\n      >\r\n        <table cdk-table class=\"lui-table\" [dataSource]=\"summeryDataSource\">\r\n          <ng-container\r\n            *ngFor=\"\r\n              let column of summeryDataSource.schema.fields\r\n                | keyvalue : preserveOrder\r\n            \"\r\n            [cdkColumnDef]=\"column.key\"\r\n          >\r\n            <th\r\n              cdk-header-cell\r\n              class=\"lui-header-cell\"\r\n              *cdkHeaderCellDef\r\n              [ngStyle]=\"column.value?.style || {}\"\r\n            >\r\n              {{ column.value.label }}\r\n            </th>\r\n            <td\r\n              cdk-cell\r\n              class=\"lui-cell\"\r\n              *cdkCellDef=\"let row\"\r\n              [ngStyle]=\"column.value?.style || {}\"\r\n              [ngClass]=\"column.value?.classes || {}\"\r\n            >\r\n              {{ row[column.key] }}\r\n            </td>\r\n          </ng-container>\r\n          <tr\r\n            cdk-header-row\r\n            class=\"lui-header-row\"\r\n            *cdkHeaderRowDef=\"summeryDataSource.columnsToDisplay\"\r\n          ></tr>\r\n          <tr\r\n            cdk-row\r\n            class=\"lui-row\"\r\n            *cdkRowDef=\"let row; columns: summeryDataSource.columnsToDisplay\"\r\n          ></tr>\r\n        </table>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [laTemplate]=\"templateTypes.ERROR\">\r\n      <div class=\"center error\" style=\"cursor: default\">\r\n        <div class=\"message\">\r\n          <i class=\"pi pi-times-circle\"></i>\r\n          <span>{{ 'MARKETPLACE.PAY_ERROR' | transloco }}</span>\r\n        </div>\r\n      </div>\r\n    </ng-template>\r\n  </lbmx-widget-wrapper>\r\n  <div\r\n    *ngIf=\"isLoading\"\r\n    class=\"spinner-background\"\r\n    style=\"min-height: 30vh; position: relative\"\r\n  >\r\n    <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n  </div>\r\n  <div class=\"pay-controls\">\r\n    <button pButton class=\"ds secondary\" (click)=\"onCancel()\">\r\n      {{ 'ACTIONS.CANCEL' | transloco }}\r\n    </button>\r\n    <button pButton class=\"ds primary\" (click)=\"onBack()\">\r\n      {{ 'ACTIONS.BACK_TO_SEARCH' | transloco }}\r\n    </button>\r\n    <button\r\n      pButton\r\n      class=\"ds primary\"\r\n      (click)=\"page.next(3)\"\r\n      *ngIf=\"page.value === 2\"\r\n      [disabled]=\"\r\n        dataSource\r\n          ? dataSource.aggregation <= 0 ||\r\n            !dataSource.isValid ||\r\n            isLoading === true\r\n          : true\r\n      \"\r\n    >\r\n      {{ 'ACTIONS.NEXT' | transloco }}\r\n    </button>\r\n    <button\r\n      pButton\r\n      *ngIf=\"page.value === 3\"\r\n      class=\"ds primary\"\r\n      (click)=\"onSubmit()\"\r\n      [disabled]=\"\r\n        dataSource\r\n          ? dataSource.aggregation <= 0 ||\r\n            !dataSource.isValid ||\r\n            isLoading === true\r\n          : true\r\n      \"\r\n    >\r\n      {{ 'ACTIONS.SUBMIT' | transloco }}\r\n    </button>\r\n  </div>\r\n</div>\r\n",
        providers: [BaseHttpService, LocalSearchService],
        encapsulation: ViewEncapsulation.None,
        styles: [""]
    })
], PayV2Component);

let EditFieldsetDirective = class EditFieldsetDirective {
    constructor(useForm) {
        this.useForm = useForm;
        this.initialState = {};
    }
    ngOnInit() {
        this.useForm.form = this.pfEditFieldset;
    }
    save() {
        return this.useForm.form.values;
    }
    reset() {
        return this.useForm.form.patch(this.useForm.form.defaultValues);
    }
};
EditFieldsetDirective.ctorParameters = () => [
    { type: UseFormService }
];
__decorate([
    Input()
], EditFieldsetDirective.prototype, "pfEditFieldset", void 0);
__decorate([
    Input()
], EditFieldsetDirective.prototype, "initialState", void 0);
__decorate([
    Input()
], EditFieldsetDirective.prototype, "form", void 0);
EditFieldsetDirective = __decorate([
    Directive({
        selector: '[pfEditFieldset]',
        providers: [UseFormService],
    })
], EditFieldsetDirective);

let EditTableComponent = class EditTableComponent {
    constructor() { }
    preserveOrder() {
        return 0;
    }
};
__decorate([
    Input()
], EditTableComponent.prototype, "dataSource", void 0);
EditTableComponent = __decorate([
    Component({
        selector: 'lib-edit-table',
        template: "<div class=\"edit-table\" *ngIf=\"dataSource\">\r\n  <table cdk-table class=\"lui-table\" [dataSource]=\"dataSource\">\r\n    <ng-container\r\n      *ngFor=\"let column of dataSource.schema.fields | keyvalue : preserveOrder\"\r\n      [cdkColumnDef]=\"column.key\"\r\n    >\r\n      <th\r\n        cdk-header-cell\r\n        class=\"lui-header-cell\"\r\n        *cdkHeaderCellDef\r\n        [ngStyle]=\"column.value?.style || {}\"\r\n      >\r\n        {{ column.value.label }}\r\n      </th>\r\n      <td\r\n        cdk-cell\r\n        class=\"lui-cell\"\r\n        *cdkCellDef=\"let form\"\r\n        [ngStyle]=\"column.value?.style || {}\"\r\n        [ngClass]=\"column.value?.classes || {}\"\r\n        [pfEditFieldset]=\"form\"\r\n      >\r\n        <ng-container\r\n          *ngIf=\"\r\n            form.schema[column.key].readonly;\r\n            then readOnly;\r\n            else inputField\r\n          \"\r\n        ></ng-container>\r\n        <ng-template #readOnly>{{ form.values[column.key] }}</ng-template>\r\n        <ng-template #inputField>\r\n          <lui-prime-field\r\n            [ngClass]=\"{ 'form-error': form.errors[column.key].length !== 0 }\"\r\n            [field]=\"form.schema[column.key]\"\r\n            [name]=\"column.key\"\r\n          ></lui-prime-field>\r\n        </ng-template>\r\n      </td>\r\n    </ng-container>\r\n    <tr\r\n      cdk-header-row\r\n      class=\"lui-header-row\"\r\n      *cdkHeaderRowDef=\"dataSource.displayedColumns\"\r\n    ></tr>\r\n    <tr\r\n      cdk-row\r\n      class=\"lui-row\"\r\n      *cdkRowDef=\"let row; columns: dataSource.displayedColumns\"\r\n    ></tr>\r\n  </table>\r\n  <!-- <lui-paginator></lui-paginator> -->\r\n</div>\r\n",
        encapsulation: ViewEncapsulation.None,
        styles: [""]
    })
], EditTableComponent);

const DEFAULT_PAGE_SIZE$1 = 2;
let LuiPaginatorComponent = class LuiPaginatorComponent {
    constructor(changeDetector) {
        this.changeDetector = changeDetector;
        this._pageSizeOptions = [
            {
                label: 25,
                value: 25,
            },
            {
                label: 50,
                value: 50,
            },
            {
                label: 75,
                value: 75,
            },
            {
                label: 100,
                value: 100,
            },
        ];
        this._pageIndex = 0;
        this.page = new EventEmitter();
        this.getRangeLabel = (page, pageSize, length) => {
            if (length === 0 ||
                pageSize === 0 ||
                length === undefined ||
                pageSize === undefined) {
                return `0 of 0`;
            }
            length = Math.max(length, 0);
            const startIndex = this.pageIndex * this.pageSize < length
                ? this.pageIndex * this.pageSize
                : length - this.pageSize;
            const endIndex = startIndex < length
                ? Math.min(startIndex + pageSize, length)
                : startIndex + pageSize;
            if (this.pageIndex > 0) {
                const lastPageIndex = Math.ceil(length / pageSize) - 1 || 0;
                const newPageIndex = Math.min(page, lastPageIndex);
                if (newPageIndex !== page) {
                    this.pageIndex = newPageIndex;
                    this._emitPageEvent();
                }
            }
            return `${startIndex + 1} - ${endIndex} of ${length}`;
            // tslint:disable-next-line:semicolon
        };
    }
    get pageIndex() {
        return this._pageIndex;
    }
    set pageIndex(value) {
        this._pageIndex = Math.max(value, 0);
    }
    get length() {
        return this._length;
    }
    set length(n) {
        this._length = n;
    }
    get pageSize() {
        return this._pageSize;
    }
    set pageSize(n) {
        this._pageSize = n;
        this._updateDisplayedPageSizeOptions();
    }
    get pageSizeOptions() {
        return this._pageSizeOptions;
    }
    set pageSizeOptions(options) {
        this._pageSizeOptions = options;
        this._updateDisplayedPageSizeOptions();
    }
    ngOnInit() {
        this._updateDisplayedPageSizeOptions();
        this.initialized = new Observable((s) => {
            s.next();
            s.complete();
        });
    }
    ngAfterContentChecked() {
        this.changeDetector.detectChanges();
    }
    nextPage() {
        if (!this.hasNextPage()) {
            return;
        }
        const previousPageIndex = this.pageIndex;
        this.pageIndex = this.pageIndex + 1;
        this._emitPageEvent(previousPageIndex);
    }
    previousPage() {
        if (!this.hasPreviousPage()) {
            return;
        }
        const previousPageIndex = this.pageIndex;
        this.pageIndex = this.pageIndex - 1;
        this._emitPageEvent(previousPageIndex);
    }
    firstPage() {
        if (!this.hasPreviousPage()) {
            return;
        }
        const previousPageIndex = this.pageIndex;
        this.pageIndex = 0;
        this._emitPageEvent(previousPageIndex);
    }
    lastPage() {
        if (!this.hasNextPage()) {
            return;
        }
        const previousPageIndex = this.pageIndex;
        this.pageIndex = this.getNumberOfPages() - 1;
        this._emitPageEvent(previousPageIndex);
    }
    hasPreviousPage() {
        return this.pageIndex >= 1 && this.pageSize !== 0;
    }
    hasNextPage() {
        const maxPageIndex = this.getNumberOfPages() - 1;
        return this.pageIndex < maxPageIndex && this.pageSize !== 0;
    }
    _changePageSize(event) {
        this._pageSize = event.value.value;
        this._pageIndex = 0;
        if (this.hasNextPage()) {
            this._emitPageEvent();
        }
    }
    _emitPageEvent(previousPageIndex) {
        this.page.emit({
            previousPageIndex,
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            length: this.length,
        });
    }
    _updateDisplayedPageSizeOptions() {
        if (!this._pageSize) {
            this._pageSize =
                this._pageSizeOptions.length !== 0
                    ? this._pageSizeOptions[0].value
                    : DEFAULT_PAGE_SIZE$1;
        }
    }
    getNumberOfPages() {
        if (!this._pageSize || !this.length) {
            return 0;
        }
        return Math.ceil(this.length / this.pageSize);
    }
};
LuiPaginatorComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
__decorate([
    Input()
], LuiPaginatorComponent.prototype, "pageIndex", null);
__decorate([
    Input()
], LuiPaginatorComponent.prototype, "length", null);
__decorate([
    Input()
], LuiPaginatorComponent.prototype, "pageSize", null);
__decorate([
    Input()
], LuiPaginatorComponent.prototype, "pageSizeOptions", null);
__decorate([
    Output()
], LuiPaginatorComponent.prototype, "page", void 0);
LuiPaginatorComponent = __decorate([
    Component({
        // tslint:disable-next-line:component-selector
        selector: 'lui-paginator',
        exportAs: 'luiPaginator',
        template: "<div class=\"lui-paginator\">\r\n  <div>Items per page:</div>\r\n  <p-dropdown\r\n    lui-select\r\n    [options]=\"pageSizeOptions\"\r\n    (onChange)=\"_changePageSize($event)\"\r\n    optionLabel=\"value\"\r\n  >\r\n  </p-dropdown>\r\n  <button\r\n    pButton\r\n    luiPaginatorButton=\"first\"\r\n    class=\"ds seccondary\"\r\n    type=\"button\"\r\n    (click)=\"firstPage()\"\r\n  >\r\n    <svg\r\n      width=\"24\"\r\n      height=\"24\"\r\n      fill=\"none\"\r\n      class=\"mx-auto\"\r\n      viewBox=\"0 0 24 24\"\r\n      xmlns=\"http://www.w3.org/2000/svg\"\r\n    >\r\n      <path d=\"M18 17L10 12L18 7V17Z\" fill=\"currentColor\" />\r\n      <path d=\"M6 7H9V17H6V7Z\" fill=\"currentColor\" />\r\n    </svg>\r\n  </button>\r\n  <button\r\n    pButton\r\n    luiPaginatorButton=\"prev\"\r\n    class=\"ds seccondary\"\r\n    (click)=\"previousPage()\"\r\n    type=\"button\"\r\n  >\r\n    <svg\r\n      width=\"24\"\r\n      height=\"24\"\r\n      fill=\"none\"\r\n      class=\"mx-auto\"\r\n      viewBox=\"0 0 24 24\"\r\n      xmlns=\"http://www.w3.org/2000/svg\"\r\n    >\r\n      <path d=\"M15 17L7 12L15 7V17Z\" fill=\"currentColor\" />\r\n    </svg>\r\n  </button>\r\n\r\n  <div class=\"lui-paginator__label\">\r\n    {{ getRangeLabel(pageIndex, pageSize, length) }}\r\n  </div>\r\n  <button\r\n    pButton\r\n    luiPaginatorButton=\"next\"\r\n    class=\"ds seccondary\"\r\n    type=\"button\"\r\n    (click)=\"nextPage()\"\r\n  >\r\n    <svg\r\n      width=\"24\"\r\n      height=\"24\"\r\n      viewBox=\"0 0 24 24\"\r\n      class=\"mx-auto\"\r\n      fill=\"none\"\r\n      xmlns=\"http://www.w3.org/2000/svg\"\r\n    >\r\n      <path d=\"M9 17L17 12L9 7V17Z\" fill=\"currentColor\" />\r\n    </svg>\r\n  </button>\r\n  <button\r\n    pButton\r\n    luiPaginatorButton=\"last\"\r\n    class=\"ds seccondary\"\r\n    type=\"button\"\r\n    (click)=\"lastPage()\"\r\n  >\r\n    <svg\r\n      width=\"24\"\r\n      height=\"24\"\r\n      viewBox=\"0 0 24 24\"\r\n      class=\"mx-auto\"\r\n      fill=\"none\"\r\n      xmlns=\"http://www.w3.org/2000/svg\"\r\n    >\r\n      <path d=\"M6 17L14 12L6 7V17Z\" fill=\"currentColor\" />\r\n      <path d=\"M18 7H15V12V17H18V7Z\" fill=\"currentColor\" />\r\n    </svg>\r\n  </button>\r\n</div>\r\n",
        encapsulation: ViewEncapsulation.None
    })
], LuiPaginatorComponent);

let LuiPaginatorModule = class LuiPaginatorModule {
};
LuiPaginatorModule = __decorate([
    NgModule({
        declarations: [LuiPaginatorComponent],
        imports: [CommonModule, FormsModule, DropdownModule, ButtonModule$1],
        exports: [LuiPaginatorComponent],
    })
], LuiPaginatorModule);

let EditTableModule = class EditTableModule {
};
EditTableModule = __decorate([
    NgModule({
        declarations: [EditTableComponent, EditFieldsetDirective],
        imports: [
            CommonModule,
            FormsModule,
            CdkTableModule,
            PerFormModule,
            PerFormPrimengModule,
            CheckboxModule$1,
            LuiPaginatorModule,
        ],
        exports: [EditTableComponent],
    })
], EditTableModule);

let DefaultPaginatorModule = class DefaultPaginatorModule {
};
DefaultPaginatorModule = __decorate([
    NgModule({
        declarations: [DefaultPaginatorComponent],
        imports: [CommonModule, FormsModule, DropdownModule, ButtonModule$1],
        exports: [DefaultPaginatorComponent],
    })
], DefaultPaginatorModule);

let ActiveTabService = class ActiveTabService {
    setActiveTab(tab, index) {
        this.activeTab = tab;
        this.activeIndex = index;
    }
};
ActiveTabService.ɵprov = ɵɵdefineInjectable({ factory: function ActiveTabService_Factory() { return new ActiveTabService(); }, token: ActiveTabService, providedIn: "root" });
ActiveTabService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], ActiveTabService);

var ROLES;
(function (ROLES) {
    ROLES["HEADING"] = "heading";
    ROLES["TAB"] = "tab";
    ROLES["TABLIST"] = "tab-list";
    ROLES["TABPANEL"] = "tab-panel";
})(ROLES || (ROLES = {}));
var STATES;
(function (STATES) {
    STATES["ACTIVE"] = "active";
    STATES["INACTIVE"] = "inactive";
})(STATES || (STATES = {}));
const COMPONENT_NAMESPACE = 'tab-group';

let LuiTab = 
// tslint:disable-next-line: component-class-suffix
class LuiTab {
    constructor(activeTabSrv) {
        this.activeTabSrv = activeTabSrv;
        this.panel = ROLES.TABPANEL;
        this.isActive = false;
    }
    get hidden() {
        return this.label !== this.activeTabSrv.activeTab;
    }
};
LuiTab.ctorParameters = () => [
    { type: ActiveTabService }
];
__decorate([
    Input()
], LuiTab.prototype, "label", void 0);
__decorate([
    HostBinding('hidden')
], LuiTab.prototype, "hidden", null);
LuiTab = __decorate([
    Component({
        // tslint:disable-next-line:component-selector
        selector: 'lui-tab',
        template: "<div class=\"{{panel}}\">\r\n  <ng-content></ng-content>\r\n</div>\r\n",
        encapsulation: ViewEncapsulation.None
    })
    // tslint:disable-next-line: component-class-suffix
], LuiTab);

let LuiTabGroup = 
// tslint:disable-next-line: component-class-suffix
class LuiTabGroup {
    constructor(activeTabSrv) {
        this.activeTabSrv = activeTabSrv;
        this.activeIndex = 0;
        this.tabs = [];
        this.namespace = COMPONENT_NAMESPACE;
        this.panel = ROLES.TABPANEL;
    }
    ngAfterContentInit() {
        this.activeTab = this.activeIndex;
        this.children.toArray().map((x) => {
            this.tabs.push(x.label);
        });
        this.activeTabSrv.activeTab =
            this.children.toArray()[this.activeIndex].label;
        this.activeTabSrv.activeIndex = this.activeIndex;
    }
};
LuiTabGroup.ctorParameters = () => [
    { type: ActiveTabService }
];
__decorate([
    Input()
], LuiTabGroup.prototype, "activeIndex", void 0);
__decorate([
    ContentChildren(LuiTab, { descendants: true })
], LuiTabGroup.prototype, "children", void 0);
LuiTabGroup = __decorate([
    Component({
        // tslint:disable-next-line:component-selector
        selector: 'lui-tab-group',
        template: "<div class=\"{{namespace}}\">\r\n    <lui-tab-header [buttonsToDisplay]=\"tabs\"></lui-tab-header>\r\n    <div id=\"{{panel}}-{{activeTabSrv.activeIndex}}\" attr.role=\"{{panel}}\"\r\n        attr.aria-labelledby=\"{{panel}}-{{activeTabSrv.activeIndex}}\">\r\n        <ng-content select=\"lui-tab\"></ng-content>\r\n    </div>\r\n</div>",
        providers: [ActiveTabService]
    })
    // tslint:disable-next-line: component-class-suffix
], LuiTabGroup);

let LuiTabHeader = 
// tslint:disable-next-line: component-class-suffix
class LuiTabHeader {
    constructor(activeTabSrv) {
        this.activeTabSrv = activeTabSrv;
        this.roleList = ROLES.TABLIST;
        this.roleButton = ROLES.TAB;
    }
};
LuiTabHeader.ctorParameters = () => [
    { type: ActiveTabService }
];
__decorate([
    Input()
], LuiTabHeader.prototype, "buttonsToDisplay", void 0);
LuiTabHeader = __decorate([
    Component({
        // tslint:disable-next-line:component-selector
        selector: 'lui-tab-header',
        template: "<div class=\"{{roleList}}\">\r\n  <div *ngFor=\"let button of buttonsToDisplay; let i = index\">\r\n    <div id=\"{{roleButton}}-{{i}}\">\r\n      <button\r\n        (click)=\"activeTabSrv.setActiveTab(button, i)\"\r\n        attr.role=\"{{roleButton}}\"\r\n        type=\"button\"\r\n        attr.aria-controls=\"{{'tab-panel-' + i}}\"\r\n        attr.aria-selected=\"{{button === activeTabSrv.activeTab}}\"\r\n        class=\"tab\"\r\n        [ngClass]=\"{'active': button === activeTabSrv.activeTab}\"\r\n      >\r\n        {{button}}\r\n      </button>\r\n    </div>\r\n  </div>\r\n</div>\r\n"
    })
    // tslint:disable-next-line: component-class-suffix
], LuiTabHeader);

let TabModule = class TabModule {
};
TabModule = __decorate([
    NgModule({
        declarations: [LuiTab, LuiTabGroup, LuiTabHeader],
        imports: [CommonModule],
        exports: [LuiTab, LuiTabGroup, LuiTabHeader],
    })
], TabModule);

let PayWizardModule = class PayWizardModule {
};
PayWizardModule = __decorate([
    NgModule({
        declarations: [PayWizardComponent, PayV2Component],
        imports: [
            AnalyticsModule,
            PerFormPrimengModule,
            ProgressSpinnerModule$1,
            CommonModule,
            TranslocoModule,
            WizardModule,
            EditTableModule,
            InputTextModule$1,
            InputNumberModule$1,
            FormsModule,
            ButtonModule$1,
            WarningsModule,
            InputNumberModule$1,
            DefaultPaginatorModule,
            TabModule,
            CdkTableModule,
            ConfirmDialogModule$1,
            LuiWizardModule,
            LuiWidgetWrapperModule,
        ],
    })
], PayWizardModule);

const schemaDefinition$9 = (fields) => ({
    fields,
});

let OnHoldContainerComponent = class OnHoldContainerComponent {
    constructor(http, translocoService, toast, formGenerator) {
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.formGenerator = formGenerator;
        this.closeDialog = new EventEmitter();
        this.saveDialog = new EventEmitter();
        this.schemaDefinition = schemaDefinition$9;
    }
    ngOnInit() {
        this.http
            .fetchWithFqn({
            endpoint: `${this.baseUrl}/on-hold/form`,
            httpMethod: 'GET',
        })
            .pipe(tap(({ fields }) => {
            this.form = this.formGenerator.init(this.schemaDefinition(fields));
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))))
            .subscribe();
    }
};
OnHoldContainerComponent.ctorParameters = () => [
    { type: BaseHttpService$3 },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: GenerateFormService }
];
__decorate([
    Input()
], OnHoldContainerComponent.prototype, "baseUrl", void 0);
__decorate([
    Output()
], OnHoldContainerComponent.prototype, "closeDialog", void 0);
__decorate([
    Output()
], OnHoldContainerComponent.prototype, "saveDialog", void 0);
OnHoldContainerComponent = __decorate([
    Component({
        selector: 'lib-on-hold-container',
        template: ` <lib-on-hold
    [form]="form"
    (closeDialog)="closeDialog.emit()"
    (saveDialog)="saveDialog.emit($event)"
  ></lib-on-hold>`
    })
], OnHoldContainerComponent);

let OnHoldComponent = class OnHoldComponent {
    constructor() {
        this.closeDialog = new EventEmitter();
        this.saveDialog = new EventEmitter();
    }
    ngOnInit() { }
    save() {
        this.saveDialog.emit(this.form.values);
    }
    close() {
        this.closeDialog.emit();
    }
};
__decorate([
    Input()
], OnHoldComponent.prototype, "form", void 0);
__decorate([
    Output()
], OnHoldComponent.prototype, "closeDialog", void 0);
__decorate([
    Output()
], OnHoldComponent.prototype, "saveDialog", void 0);
OnHoldComponent = __decorate([
    Component({
        selector: 'lib-on-hold',
        template: "<div\r\n  class=\"crossrefrences-dialogue\"\r\n  style=\"display: flex; flex-direction: column\"\r\n>\r\n  <h2 class=\"dialog-title\">\r\n    {{ 'MARKETPLACE_ADVANCED_SEARCH.ON_HOLD' | transloco }}\r\n  </h2>\r\n  <div style=\"flex-grow: 1; position: relative\">\r\n    <lui-form *ngIf=\"form; else formNotAvailable\" [form]=\"form\"></lui-form>\r\n    <ng-template #formNotAvailable>\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <div\r\n    class=\"contols\"\r\n    style=\"display: flex; gap: 0.5em; padding-top: 1em; padding-bottom: 5em\"\r\n  >\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      (click)=\"close()\"\r\n    ></button>\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      class=\"ds\"\r\n      (click)=\"save()\"\r\n      [disabled]=\"!form?.valid\"\r\n      style=\"flex-grow: 1\"\r\n    ></button>\r\n  </div>\r\n</div>\r\n"
    })
], OnHoldComponent);

let OnHoldModule = class OnHoldModule {
};
OnHoldModule = __decorate([
    NgModule({
        declarations: [OnHoldContainerComponent, OnHoldComponent],
        imports: [
            CommonModule,
            TranslocoModule,
            PerFormPrimengModule,
            ProgressSpinnerModule$1,
            ButtonModule$1,
            UtilsModule,
        ],
        exports: [OnHoldContainerComponent],
    })
], OnHoldModule);

let WarningsListComponent = class WarningsListComponent {
    constructor(confirmationService, http, formGenerator) {
        this.confirmationService = confirmationService;
        this.http = http;
        this.formGenerator = formGenerator;
        this.keys = [];
        this.title = '';
        this.description = '';
        this.submitMsg = '';
        this.errorMsg = '';
        this.baseUrl = '';
        this.endUrl = '';
        this.submitEndUrl = '';
        this.cancel = new EventEmitter();
        this.page = new BehaviorSubject(0);
        this.form = new BehaviorSubject(null);
        this._onDestroy = new Subject();
        this.templateTypes = TemplateTypes;
    }
    ngOnDestroy() {
        this._onDestroy.next();
    }
    ngOnInit() {
        this.http.baseUrl = this.baseUrl;
        const page$ = this.page.pipe(tap((page) => (this.request = this.http
            .fetch({
            endpoint: urlJoin(this.keys[page], this.endUrl),
            httpMethod: HttpMethod$2.GET,
        })
            .pipe(tap((formDef) => this.form.next(this.formGenerator.init(formDef)))))));
        merge(page$).pipe(takeUntil(this._onDestroy)).subscribe();
    }
    clear() {
        this.confirmationService.confirm(Object.assign(Object.assign({}, this.confirmation), { accept: () => {
                this.request = this.http
                    .fetch({
                    endpoint: urlJoin(this.keys[this.page.value], this.submitEndUrl),
                    httpMethod: HttpMethod$2.POST,
                    body: { warningKeys: [...this.form.value.values.warnings] },
                })
                    .pipe(finalize(() => this.page.next(this.page.value)));
            } }));
    }
    next() {
        this.page.next(this.page.value + 1);
    }
    prev() {
        this.page.next(this.page.value - 1);
    }
    get isFirstIndex() {
        return this.keys.length === 0 ? true : this.page.value <= 0;
    }
    get isLastIndex() {
        return this.keys.length === 0
            ? true
            : this.keys.length <= this.page.value + 1;
    }
    get clearDisabled() {
        var _a, _b, _c, _d;
        return (((_b = (_a = this.form.value.values) === null || _a === void 0 ? void 0 : _a.warnings) === null || _b === void 0 ? void 0 : _b.length) === 0 ||
            ((_d = (_c = this.form.value.values) === null || _c === void 0 ? void 0 : _c.warnings) === null || _d === void 0 ? void 0 : _d.length) === undefined);
    }
};
WarningsListComponent.ctorParameters = () => [
    { type: ConfirmationService },
    { type: BaseHttpService$2 },
    { type: GenerateFormService }
];
__decorate([
    Input()
], WarningsListComponent.prototype, "keys", void 0);
__decorate([
    Input()
], WarningsListComponent.prototype, "title", void 0);
__decorate([
    Input()
], WarningsListComponent.prototype, "description", void 0);
__decorate([
    Input()
], WarningsListComponent.prototype, "submitMsg", void 0);
__decorate([
    Input()
], WarningsListComponent.prototype, "errorMsg", void 0);
__decorate([
    Input()
], WarningsListComponent.prototype, "baseUrl", void 0);
__decorate([
    Input()
], WarningsListComponent.prototype, "endUrl", void 0);
__decorate([
    Input()
], WarningsListComponent.prototype, "submitEndUrl", void 0);
__decorate([
    Input()
], WarningsListComponent.prototype, "confirmation", void 0);
__decorate([
    Output()
], WarningsListComponent.prototype, "cancel", void 0);
WarningsListComponent = __decorate([
    Component({
        selector: 'lib-warnings-list',
        template: "<div class=\"warnings-list\">\r\n  <div class=\"warnings-title\" *ngIf=\"title\">\r\n    <h2>{{ title }}</h2>\r\n  </div>\r\n  <div class=\"warnings-info\" *ngIf=\"description\">\r\n    <p>\r\n      {{ description }}\r\n    </p>\r\n  </div>\r\n  <lui-widget-wrapper [request]=\"request\">\r\n    <ng-template [luiWidget]=\"templateTypes.DONE\">\r\n      <lui-form *ngIf=\"form.value\" [form]=\"form.value\"></lui-form>\r\n      <div class=\"warnings-buttons\">\r\n        <button pButton class=\"ds secondary\" (click)=\"cancel.emit()\">\r\n          {{ 'ACTIONS.CLOSE' | transloco }}\r\n        </button>\r\n        <button\r\n          pButton\r\n          class=\"ds primary\"\r\n          (click)=\"clear()\"\r\n          [disabled]=\"clearDisabled\"\r\n        >\r\n          {{ submitMsg }}\r\n        </button>\r\n        <button\r\n          pButton\r\n          class=\"ds primary\"\r\n          (click)=\"prev()\"\r\n          [disabled]=\"isFirstIndex\"\r\n        >\r\n          {{ 'ACTIONS.BACK_TO_SEARCH' | transloco }}\r\n        </button>\r\n\r\n        <button\r\n          pButton\r\n          class=\"ds primary\"\r\n          (click)=\"next()\"\r\n          [disabled]=\"isLastIndex\"\r\n        >\r\n          {{ 'ACTIONS.NEXT' | transloco }}\r\n        </button>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.LOADING\">\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"position: relative; min-height: 5em\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.ERROR\">\r\n      <div\r\n        class=\"error\"\r\n        style=\"\r\n          min-height: 30vh;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n        \"\r\n      >\r\n        <div>\r\n          <span>\r\n            <i class=\"pi pi-times-circle\"></i>\r\n            {{ errorMsg }}\r\n          </span>\r\n        </div>\r\n      </div>\r\n      <button pButton (click)=\"cancel.emit()\" class=\"ds secondary\">\r\n        {{ 'ACTIONS.CLOSE' | transloco }}\r\n      </button>\r\n    </ng-template>\r\n    <ng-template [luiWidget]=\"templateTypes.READY\"></ng-template>\r\n  </lui-widget-wrapper>\r\n</div>\r\n",
        providers: [BaseHttpService$2],
        styles: [""]
    })
], WarningsListComponent);

let WarningsListModule = class WarningsListModule {
};
WarningsListModule = __decorate([
    NgModule({
        declarations: [WarningsListComponent],
        imports: [
            CommonModule,
            PerFormModule,
            PerFormPrimengModule,
            LuiWidgetWrapperModule,
            ButtonModule$1,
            TranslocoModule,
            ProgressSpinnerModule$1,
        ],
        exports: [WarningsListComponent],
    })
], WarningsListModule);

let ReceivedInvoiceModule = class ReceivedInvoiceModule {
};
ReceivedInvoiceModule = __decorate([
    NgModule({
        declarations: [ReceivedInvoiceComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            DashboardModule,
            DialogModule$1,
            PerFormPrimengModule,
            ProgressSpinnerModule$1,
            CommonModule,
            EditInvoiceModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            PrintOptionsModule,
            OnHoldModule,
            PdfViewerModule,
            ExportModule,
            WizardModule,
            EditTableModule,
            InputTextModule$1,
            InputNumberModule$1,
            FormsModule,
            ButtonModule$1,
            WarningsModule,
            WarningsListModule,
            InputNumberModule$1,
            DefaultPaginatorModule,
            TabModule,
            CdkTableModule,
            PerFormPrimengModule,
            PerFormModule,
            LoggingModule,
            LuiWizardModule,
            LuiWizardV3Module,
            LuiWidgetWrapperModule,
            ConfirmDialogModule$1,
        ],
        entryComponents: [
            PdfViewerComponent,
            ExportComponent,
            DataGeniusSelectionComponent,
        ],
    })
], ReceivedInvoiceModule);

let MakePaymentsModule = class MakePaymentsModule {
};
MakePaymentsModule = __decorate([
    NgModule({
        declarations: [MakePaymentsComponent],
        imports: [
            CommonModule,
            DialogModule$1,
            ExportModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            UtilsModule,
            PayWizardModule,
            PerFormPrimengModule,
            PrintOptionsModule,
            LoggingModule,
            PdfViewerModule,
            ButtonModule$1,
            OnHoldModule,
            ProgressSpinnerModule$1,
        ],
        entryComponents: [PdfViewerComponent, ExportComponent],
    })
], MakePaymentsModule);

let OpenReceivablesModule = class OpenReceivablesModule {
};
OpenReceivablesModule = __decorate([
    NgModule({
        declarations: [OpenReceivablesComponent],
        imports: [
            CommonModule,
            DialogModule$1,
            ExportModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            UtilsModule,
            PerFormPrimengModule,
            PdfViewerModule,
            LoggingModule,
            ButtonModule$1,
            PrintOptionsModule,
            ProgressSpinnerModule$1,
        ],
        entryComponents: [PdfViewerComponent, ExportComponent],
    })
], OpenReceivablesModule);

let OsReceivedModule = class OsReceivedModule {
};
OsReceivedModule = __decorate([
    NgModule({
        declarations: [OsReceivedComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            DashboardModule,
            DialogModule$1,
            CommonModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            WizardModule,
            PdfViewerModule,
            ExportModule,
            LoggingModule,
            EditInvoiceModule,
            WarningsModule,
            PrintOptionsModule,
            ProgressSpinnerModule$1,
            LuiWizardModule,
            LuiWidgetWrapperModule,
        ],
        entryComponents: [PdfViewerComponent, ExportComponent],
    })
], OsReceivedModule);

let SentOSModule = class SentOSModule {
};
SentOSModule = __decorate([
    NgModule({
        declarations: [SentOSComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            DashboardModule,
            DialogModule$1,
            CommonModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            WizardModule,
            PdfViewerModule,
            ExportModule,
            LoggingModule,
            EditInvoiceModule,
            WarningsModule,
            PrintOptionsModule,
            ProgressSpinnerModule$1,
            LuiWizardModule,
            LuiWidgetWrapperModule,
        ],
        entryComponents: [PdfViewerComponent, ExportComponent],
    })
], SentOSModule);

let PadReceivedModule = class PadReceivedModule {
};
PadReceivedModule = __decorate([
    NgModule({
        declarations: [PadReceivedComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            DashboardModule,
            DialogModule$1,
            CommonModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            WizardModule,
            PdfViewerModule,
            ExportModule,
            LoggingModule,
            EditInvoiceModule,
            WarningsModule,
            PrintOptionsModule,
            ProgressSpinnerModule$1,
            LuiWizardModule,
            LuiWidgetWrapperModule,
        ],
        entryComponents: [PdfViewerComponent, ExportComponent],
    })
], PadReceivedModule);

const schemaDefinition$a = (fields) => ({
    fields,
});

let GenerateFileFormContainerComponent$1 = class GenerateFileFormContainerComponent {
    constructor(http, translocoService, toast, formGenerator) {
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.formGenerator = formGenerator;
        this.closeDialog = new EventEmitter();
        this.saveDialog = new EventEmitter();
        this.schemaDefinition = schemaDefinition$a;
    }
    ngOnInit() {
        this.http
            .fetchWithFqn({
            endpoint: `${this.baseUrl}/generate-file/form`,
            httpMethod: 'POST',
            body: {
                keys: this.selectedKeys,
            },
        })
            .pipe(tap(({ fields }) => {
            const _fields = Object.entries(Object.assign({}, fields)).map(([_, fieldValue]) => {
                var _a, _b;
                return (fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.type) === 'calendar'
                    ? Object.assign(Object.assign({}, fieldValue), { componentProperties: Object.assign(Object.assign({}, fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.componentProperties), { placeholder: (_a = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.componentProperties) === null || _a === void 0 ? void 0 : _a.dateFormat, showIcon: true, minDate: new Date((_b = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.componentProperties) === null || _b === void 0 ? void 0 : _b.minDate) }) }) : fieldValue;
            });
            this.form = this.formGenerator.init(this.schemaDefinition(_fields));
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))))
            .subscribe();
    }
};
GenerateFileFormContainerComponent$1.ctorParameters = () => [
    { type: BaseHttpService$3 },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: GenerateFormService }
];
__decorate([
    Input()
], GenerateFileFormContainerComponent$1.prototype, "baseUrl", void 0);
__decorate([
    Input()
], GenerateFileFormContainerComponent$1.prototype, "selectedKeys", void 0);
__decorate([
    Output()
], GenerateFileFormContainerComponent$1.prototype, "closeDialog", void 0);
__decorate([
    Output()
], GenerateFileFormContainerComponent$1.prototype, "saveDialog", void 0);
GenerateFileFormContainerComponent$1 = __decorate([
    Component({
        selector: 'lib-generate-file-form-container',
        template: ` <lib-generate-file-form
    [form]="form"
    (closeDialog)="closeDialog.emit()"
    (saveDialog)="saveDialog.emit($event)"
  ></lib-generate-file-form>`
    })
], GenerateFileFormContainerComponent$1);

let GenerateFileFormComponent$1 = class GenerateFileFormComponent {
    constructor() {
        this.closeDialog = new EventEmitter();
        this.saveDialog = new EventEmitter();
    }
    set formSetter(form) {
        this.form = form;
        this.checkFormValidity();
    }
    save() {
        this.saveDialog.emit(this.form.values);
    }
    close() {
        this.closeDialog.emit();
    }
    checkFormValidity() {
        var _a;
        Object.keys(Object.assign({}, (_a = this.form) === null || _a === void 0 ? void 0 : _a.schema)).forEach((field) => {
            this.form.setStatus(field, 'touched', true);
        });
    }
};
__decorate([
    Input('form')
], GenerateFileFormComponent$1.prototype, "formSetter", null);
__decorate([
    Output()
], GenerateFileFormComponent$1.prototype, "closeDialog", void 0);
__decorate([
    Output()
], GenerateFileFormComponent$1.prototype, "saveDialog", void 0);
GenerateFileFormComponent$1 = __decorate([
    Component({
        selector: 'lib-generate-file-form',
        template: "<div\r\n  class=\"crossrefrences-dialogue\"\r\n  style=\"display: flex; flex-direction: column\"\r\n>\r\n  <h2 class=\"dialog-title\">\r\n    {{ 'INVOICE.COLLECTION_BATCHES_GENERATE_FILE_HEADER' | transloco }}\r\n  </h2>\r\n  <span>\r\n    {{ 'INVOICE.COLLECTION_BATCHES_GENERATE_FILE_MESSAGE' | transloco }}\r\n  </span>\r\n  <br />\r\n  <div style=\"flex-grow: 1; position: relative\">\r\n    <lui-form *ngIf=\"form; else formNotAvailable\" [form]=\"form\"></lui-form>\r\n    <ng-template #formNotAvailable>\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <div\r\n    class=\"contols\"\r\n    style=\"display: flex; gap: 0.5em; padding-top: 1em; padding-bottom: 5em\"\r\n  >\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      (click)=\"close()\"\r\n    ></button>\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SAVE' | transloco }}\"\r\n      class=\"ds\"\r\n      (click)=\"save()\"\r\n      [disabled]=\"!form?.valid\"\r\n      style=\"flex-grow: 1\"\r\n    ></button>\r\n  </div>\r\n</div>\r\n"
    })
], GenerateFileFormComponent$1);

const schemaDefinition$b = (fields) => ({
    fields,
});

let ViewContainerComponent$1 = class ViewContainerComponent {
    constructor(http, translocoService, toast, formGenerator) {
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.formGenerator = formGenerator;
        this.closeViewDialog = new EventEmitter();
        this.schemaDefinition = schemaDefinition$b;
    }
    ngOnInit() {
        this.http
            .fetchWithFqn({
            endpoint: `${this.baseUrl}/view/${this.paymentBatchKey}`,
            httpMethod: 'GET',
        })
            .pipe(tap(({ fields }) => {
            this.form = this.formGenerator.init(this.schemaDefinition(fields));
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))))
            .subscribe();
    }
};
ViewContainerComponent$1.ctorParameters = () => [
    { type: BaseHttpService$3 },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: GenerateFormService }
];
__decorate([
    Input()
], ViewContainerComponent$1.prototype, "baseUrl", void 0);
__decorate([
    Input()
], ViewContainerComponent$1.prototype, "paymentBatchKey", void 0);
__decorate([
    Output()
], ViewContainerComponent$1.prototype, "closeViewDialog", void 0);
ViewContainerComponent$1 = __decorate([
    Component({
        selector: 'lib-view-container',
        template: ` <lib-view
    [form]="form"
    (closeDialog)="closeViewDialog.emit()"
  ></lib-view>`
    })
], ViewContainerComponent$1);

let ViewComponent$1 = class ViewComponent {
    constructor() {
        this.closeDialog = new EventEmitter();
    }
    close() {
        this.closeDialog.emit();
    }
};
__decorate([
    Output()
], ViewComponent$1.prototype, "closeDialog", void 0);
__decorate([
    Input()
], ViewComponent$1.prototype, "form", void 0);
ViewComponent$1 = __decorate([
    Component({
        selector: 'lib-view',
        template: "<div\r\n  class=\"crossrefrences-dialogue\"\r\n  style=\"display: flex; flex-direction: column\"\r\n>\r\n  <div style=\"justify-content: center\">\r\n    <h2 class=\"dialog-title\">\r\n      {{ 'INVOICE.PAYMENT_BATCHES_VIEW' | transloco }}\r\n    </h2>\r\n    <div style=\"flex-grow: 1; position: relative\">\r\n      <lui-form *ngIf=\"form; else formNotAvailable\" [form]=\"form\"></lui-form>\r\n      <ng-template #formNotAvailable>\r\n        <div\r\n          class=\"spinner-background\"\r\n          style=\"min-height: 30vh; position: relative\"\r\n        >\r\n          <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n        </div>\r\n      </ng-template>\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"contols\" style=\"display: flex; gap: 0.5em; padding-top: 1em\">\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CLOSE' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      (click)=\"close()\"\r\n      style=\"flex-grow: 1\"\r\n    ></button>\r\n  </div>\r\n</div>\r\n"
    })
], ViewComponent$1);

let EFTACHSettingsComponent$1 = class EFTACHSettingsComponent {
    constructor(translocoService, toast, spinner, marketplaceService, http, searchContainerLoaderService) {
        this.translocoService = translocoService;
        this.toast = toast;
        this.spinner = spinner;
        this.marketplaceService = marketplaceService;
        this.http = http;
        this.searchContainerLoaderService = searchContainerLoaderService;
        // search container loader states
        this.searchContainerName = 'paymentsEFTACHSettings';
        this.i18nSearchField = 'COMPANY.SEARCH';
        this.toolbarActionsDispatcher = {
            view: (selection) => { },
            edit: (selection) => { },
            editList: (selection) => { },
        };
        this.baseUrl = `${this.marketplaceService.getConfig()}`;
        this.columnActions = {};
        // `${this.marketplaceService.getConfig()}`;
        // http.baseUrl = marketplaceService.getConfig().getAccountRootURL;
    }
    ngOnInit() { }
};
EFTACHSettingsComponent$1.ctorParameters = () => [
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: SpinnerService },
    { type: MarketplaceService },
    { type: BaseHttpService },
    { type: SearchContainerLoaderService }
];
EFTACHSettingsComponent$1 = __decorate([
    Component({
        selector: 'lib-eft-ach-settings',
        template: "<div style=\"padding-top: 2rem\">\r\n  <lib-search-container-loader\r\n    [searchContainerName]=\"searchContainerName\"\r\n    [i18nSearchField]=\"i18nSearchField\"\r\n    [toolbarActionsDispatcher]=\"toolbarActionsDispatcher\"\r\n    [baseUrl]=\"baseUrl\"\r\n    [columnActions]=\"columnActions\"\r\n    [disableAdvancedSearch]=\"true\"\r\n  ></lib-search-container-loader>\r\n</div>\r\n",
        providers: [SearchContainerLoaderService]
    })
], EFTACHSettingsComponent$1);

let PaymentsComponent = class PaymentsComponent {
    constructor(translocoService) {
        this.translocoService = translocoService;
        this.items = [];
        this.subscriptions = [];
    }
    ngOnInit() {
        this.translateTabNames();
    }
    translateTabNames() {
        this.subscriptions.push(this.translocoService
            .selectTranslate('MARKETPLACE')
            .pipe(map((translate) => translate), tap((translate) => {
            this.items = [
                {
                    label: translate.TAB_PAYMENTS_BATCHES,
                    routerLink: 'batches',
                },
            ];
        }))
            .subscribe());
    }
    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((subscription) => subscription.unsubscribe());
        }
    }
};
PaymentsComponent.ctorParameters = () => [
    { type: TranslocoService }
];
PaymentsComponent = __decorate([
    Component({
        selector: 'lib-payments',
        template: "<h2>{{ 'MARKETPLACE.PAYMENTS' | transloco }}</h2>\r\n<div>\r\n  <p-tabMenu [model]=\"items\"></p-tabMenu>\r\n  <router-outlet></router-outlet>\r\n</div>\r\n"
    })
], PaymentsComponent);

let LoggingComponent$1 = class LoggingComponent {
    constructor(http, translocoService, toast, formGenerator) {
        this.http = http;
        this.translocoService = translocoService;
        this.toast = toast;
        this.formGenerator = formGenerator;
        this.closeLogDialog = new EventEmitter();
        this.saveLogDialog = new EventEmitter();
        this.schemaDefinition = schemaDefinition$5;
    }
    ngOnInit() {
        this.http
            .fetchWithFqn({
            endpoint: `${this.baseUrl}/logging/form/${this.batchKey}`,
            httpMethod: 'GET',
        })
            .pipe(tap((formData) => {
            const _fields = this.schemaDefinition(formData === null || formData === void 0 ? void 0 : formData.fields);
            this.form = this.formGenerator.init(_fields);
        }), catchError(() => of(this.toast.errorNotify(this.translocoService.translate('MESSAGES.GENERIC_ERROR')))))
            .subscribe();
    }
};
LoggingComponent$1.ctorParameters = () => [
    { type: BaseHttpService },
    { type: TranslocoService },
    { type: ToastrNotificationService },
    { type: GenerateFormService }
];
__decorate([
    Input()
], LoggingComponent$1.prototype, "baseUrl", void 0);
__decorate([
    Input()
], LoggingComponent$1.prototype, "batchKey", void 0);
__decorate([
    Output()
], LoggingComponent$1.prototype, "closeLogDialog", void 0);
__decorate([
    Output()
], LoggingComponent$1.prototype, "saveLogDialog", void 0);
LoggingComponent$1 = __decorate([
    Component({
        selector: 'lib-logging',
        template: `<lib-logging-form
    [form]="form"
    (closeForm)="closeLogDialog.emit()"
    (saveForm)="saveLogDialog.emit($event)"
  ></lib-logging-form>`
    })
], LoggingComponent$1);

let LoggingFormComponent$1 = class LoggingFormComponent {
    constructor() {
        this.closeForm = new EventEmitter();
        this.saveForm = new EventEmitter();
    }
    set formSetter(form) {
        this.form = form;
        this.checkFormValidity();
    }
    checkFormValidity() {
        var _a;
        Object.keys(Object.assign({}, (_a = this.form) === null || _a === void 0 ? void 0 : _a.schema)).forEach((field) => {
            this.form.setStatus(field, 'touched', true);
        });
    }
};
__decorate([
    Input('form')
], LoggingFormComponent$1.prototype, "formSetter", null);
__decorate([
    Output()
], LoggingFormComponent$1.prototype, "closeForm", void 0);
__decorate([
    Output()
], LoggingFormComponent$1.prototype, "saveForm", void 0);
LoggingFormComponent$1 = __decorate([
    Component({
        selector: 'lib-logging-form',
        template: "<div\r\n  class=\"crossrefrences-dialogue\"\r\n  style=\"display: flex; flex-direction: column\"\r\n>\r\n  <h2 class=\"dialog-title\">\r\n    {{ 'INVOICE.PAYMENT_BATCHES_DISPLAY_LOGS' | transloco }}\r\n  </h2>\r\n  <div style=\"flex-grow: 1; position: relative\">\r\n    <lui-form *ngIf=\"form; else formNotAvailable\" [form]=\"form\"></lui-form>\r\n    <ng-template #formNotAvailable>\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <div\r\n    class=\"contols\"\r\n    style=\"display: flex; gap: 0.5em; padding-top: 1em; padding-bottom: 5em\"\r\n  >\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      (click)=\"closeForm.emit()\"\r\n    ></button>\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SUBMIT' | transloco }}\"\r\n      class=\"ds\"\r\n      (click)=\"saveForm.emit(form?.values)\"\r\n      [disabled]=\"!form?.valid\"\r\n      style=\"flex-grow: 1\"\r\n    ></button>\r\n  </div>\r\n</div>\r\n"
    })
], LoggingFormComponent$1);

let PaymentsModule = class PaymentsModule {
};
PaymentsModule = __decorate([
    NgModule({
        declarations: [
            PaymentsComponent,
            EFTACHSettingsComponent$1,
            BatchesComponent$1,
            GenerateFileFormContainerComponent$1,
            GenerateFileFormComponent$1,
            ViewComponent$1,
            ViewContainerComponent$1,
            LoggingComponent$1,
            LoggingFormComponent$1,
        ],
        imports: [
            CommonModule,
            RouterModule,
            TabMenuModule,
            RouterModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            UtilsModule,
            ExportModule,
            DialogModule$2,
            PerFormPrimengModule,
            ProgressSpinnerModule$3,
            ButtonModule$2,
            AnalyticsModule,
            DashboardModule,
        ],
        entryComponents: [ExportComponent],
    })
], PaymentsModule);

let POAReceivedModule = class POAReceivedModule {
};
POAReceivedModule = __decorate([
    NgModule({
        declarations: [PoaReceivedComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            DashboardModule,
            CommonModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            DialogModule$1,
            PerFormPrimengModule,
            ProgressSpinnerModule$1,
            PrintOptionsModule,
            ButtonModule$1,
            PdfViewerModule,
            LoggingModule,
            ExportModule,
            WarningsModule,
            LuiWizardModule,
            LuiWizardV3Module,
            LuiWidgetWrapperModule,
        ],
        entryComponents: [
            PdfViewerComponent,
            ExportComponent,
            DataGeniusSelectionComponent,
        ],
    })
], POAReceivedModule);

let PocReceivedModule = class PocReceivedModule {
};
PocReceivedModule = __decorate([
    NgModule({
        declarations: [PocReceivedComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            DashboardModule,
            DialogModule$1,
            CommonModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            WizardModule,
            PdfViewerModule,
            ExportModule,
            LoggingModule,
            EditInvoiceModule,
            WarningsModule,
            PrintOptionsModule,
            ProgressSpinnerModule$1,
            LuiWizardModule,
            LuiWidgetWrapperModule,
        ],
        entryComponents: [PdfViewerComponent, ExportComponent],
    })
], PocReceivedModule);

let SentPOCModule = class SentPOCModule {
};
SentPOCModule = __decorate([
    NgModule({
        declarations: [SentPOCComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            DashboardModule,
            DialogModule$1,
            CommonModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            WizardModule,
            PdfViewerModule,
            ExportModule,
            LoggingModule,
            EditInvoiceModule,
            WarningsModule,
            PrintOptionsModule,
            ProgressSpinnerModule$1,
            LuiWizardModule,
            LuiWidgetWrapperModule,
        ],
        entryComponents: [PdfViewerComponent, ExportComponent],
    })
], SentPOCModule);

let ReceivedAAModule = class ReceivedAAModule {
};
ReceivedAAModule = __decorate([
    NgModule({
        declarations: [ReceivedAAComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            DashboardModule,
            DialogModule$1,
            CommonModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            WizardModule,
            PdfViewerModule,
            ExportModule,
            LoggingModule,
            EditInvoiceModule,
            WarningsModule,
            PrintOptionsModule,
            ProgressSpinnerModule$1,
            LuiWizardModule,
            LuiWidgetWrapperModule,
        ],
        entryComponents: [PdfViewerComponent, ExportComponent],
    })
], ReceivedAAModule);

let ReceivedDSDSIModule = class ReceivedDSDSIModule {
};
ReceivedDSDSIModule = __decorate([
    NgModule({
        declarations: [ReceivedDSDSIComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            DashboardModule,
            DialogModule$1,
            CommonModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            WizardModule,
            PdfViewerModule,
            ExportModule,
            LoggingModule,
            EditInvoiceModule,
            WarningsModule,
            PrintOptionsModule,
            ProgressSpinnerModule$1,
            LuiWizardModule,
            LuiWidgetWrapperModule,
        ],
        entryComponents: [PdfViewerComponent, ExportComponent],
    })
], ReceivedDSDSIModule);

let ReceivedPOModule = class ReceivedPOModule {
};
ReceivedPOModule = __decorate([
    NgModule({
        declarations: [ReceivedPoComponent, FlipDocTypeComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            CommonModule,
            ButtonModule$1,
            DashboardModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            DialogModule$1,
            PerFormPrimengModule,
            ProgressSpinnerModule$1,
            PrintOptionsModule,
            PdfViewerModule,
            ExportModule,
            LoggingModule,
            WarningsModule,
            WarningsListModule,
            LuiWizardV3Module,
            LuiWidgetWrapperModule,
            ConfirmDialogModule$1,
        ],
        providers: [BaseHttpService, CanDeactivateGuard],
        entryComponents: [
            PdfViewerComponent,
            ExportComponent,
            DataGeniusSelectionComponent,
        ],
    })
], ReceivedPOModule);

let ReceivedPSRCModule = class ReceivedPSRCModule {
};
ReceivedPSRCModule = __decorate([
    NgModule({
        declarations: [ReceivedPsrcComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            DashboardModule,
            DialogModule$1,
            CommonModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            WizardModule,
            PdfViewerModule,
            ExportModule,
            LoggingModule,
            EditInvoiceModule,
            WarningsModule,
            PrintOptionsModule,
            ProgressSpinnerModule$1,
            LuiWizardModule,
            LuiWidgetWrapperModule,
        ],
        entryComponents: [PdfViewerComponent, ExportComponent],
    })
], ReceivedPSRCModule);

let ReceivedRebateStatementModule = class ReceivedRebateStatementModule {
};
ReceivedRebateStatementModule = __decorate([
    NgModule({
        declarations: [ReceivedRebateStatementComponent],
        imports: [
            AdvancedSearchLoaderModule,
            CommonModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            DialogModule$1,
            PerFormPrimengModule,
            ProgressSpinnerModule$1,
            PrintOptionsModule,
            PdfViewerModule,
            ExportModule,
        ],
        entryComponents: [PdfViewerComponent, ExportComponent],
    })
], ReceivedRebateStatementModule);

let ReceivedTMModule = class ReceivedTMModule {
};
ReceivedTMModule = __decorate([
    NgModule({
        declarations: [ReceivedTmComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            DashboardModule,
            DialogModule$1,
            CommonModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            WizardModule,
            PdfViewerModule,
            ExportModule,
            LoggingModule,
            EditInvoiceModule,
            WarningsModule,
            PrintOptionsModule,
            ProgressSpinnerModule$1,
            LuiWizardModule,
            LuiWidgetWrapperModule,
        ],
        entryComponents: [PdfViewerComponent, ExportComponent],
    })
], ReceivedTMModule);

let RemittancesReceivedModule = class RemittancesReceivedModule {
};
RemittancesReceivedModule = __decorate([
    NgModule({
        declarations: [RemittancesReceivedComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            DashboardModule,
            DialogModule$1,
            CommonModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            WizardModule,
            PdfViewerModule,
            ExportModule,
            LoggingModule,
            EditInvoiceModule,
            WarningsModule,
            PrintOptionsModule,
            ProgressSpinnerModule$1,
            LuiWizardModule,
            LuiWidgetWrapperModule,
        ],
        entryComponents: [PdfViewerComponent, ExportComponent],
    })
], RemittancesReceivedModule);

let SentAsnModule = class SentAsnModule {
};
SentAsnModule = __decorate([
    NgModule({
        declarations: [SentAsnComponent],
        imports: [
            AdvancedSearchLoaderModule,
            CommonModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            DialogModule$1,
            PerFormPrimengModule,
            ProgressSpinnerModule$1,
            PdfViewerModule,
            ExportModule,
            PrintOptionsModule,
            WarningsModule,
            AnalyticsModule,
            LoggingModule,
            DashboardModule,
            ButtonModule$1,
            LuiWizardModule,
            LuiWizardV3Module,
            LuiWidgetWrapperModule,
        ],
        providers: [CanDeactivateGuard],
        entryComponents: [
            PdfViewerComponent,
            ExportComponent,
            DataGeniusSelectionComponent,
        ],
    })
], SentAsnModule);

let SentDSDSIModule = class SentDSDSIModule {
};
SentDSDSIModule = __decorate([
    NgModule({
        declarations: [SentDSDSIComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            DashboardModule,
            DialogModule$1,
            CommonModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            WizardModule,
            PdfViewerModule,
            ExportModule,
            LoggingModule,
            EditInvoiceModule,
            WarningsModule,
            PrintOptionsModule,
            ProgressSpinnerModule$1,
            LuiWizardModule,
            LuiWidgetWrapperModule,
        ],
        entryComponents: [PdfViewerComponent, ExportComponent],
    })
], SentDSDSIModule);

let DataGeniusFormComponent = class DataGeniusFormComponent {
    constructor() {
        this.closeForm = new EventEmitter();
        this.save = new EventEmitter();
    }
};
__decorate([
    Input()
], DataGeniusFormComponent.prototype, "form", void 0);
__decorate([
    Output()
], DataGeniusFormComponent.prototype, "closeForm", void 0);
__decorate([
    Output()
], DataGeniusFormComponent.prototype, "save", void 0);
DataGeniusFormComponent = __decorate([
    Component({
        selector: 'lib-data-genius-form',
        template: "<div class=\"export-dialogue\" style=\"display: flex; flex-direction: column\">\r\n  <h2 class=\"dialog-title\">\r\n    {{ 'ACTIONS.DATA_GENIUS_PROMPT_HEADER' | transloco }}\r\n  </h2>\r\n  <div style=\"flex-grow: 1; position: relative\">\r\n    <lui-form *ngIf=\"form; else formNotAvailable\" [form]=\"form\"></lui-form>\r\n    <ng-template #formNotAvailable>\r\n      <div\r\n        class=\"spinner-background\"\r\n        style=\"min-height: 30vh; position: relative\"\r\n      >\r\n        <p-progressSpinner styleClass=\"custom-spinner\"></p-progressSpinner>\r\n      </div>\r\n    </ng-template>\r\n  </div>\r\n\r\n  <div\r\n    class=\"contols\"\r\n    style=\"display: flex; gap: 0.5em; padding-top: 1em; padding-bottom: 5em\"\r\n  >\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.CANCEL' | transloco }}\"\r\n      class=\"ds secondary\"\r\n      (click)=\"closeForm.emit()\"\r\n    ></button>\r\n    <button\r\n      pButton\r\n      type=\"button\"\r\n      label=\"{{ 'ACTIONS.SUBMIT' | transloco }}\"\r\n      class=\"ds\"\r\n      (click)=\"save.emit(form.values)\"\r\n      [disabled]=\"!form?.valid\"\r\n      style=\"flex-grow: 1\"\r\n    ></button>\r\n  </div>\r\n</div>\r\n"
    })
], DataGeniusFormComponent);

let DataGeniusSelectionModule = class DataGeniusSelectionModule {
};
DataGeniusSelectionModule = __decorate([
    NgModule({
        declarations: [DataGeniusSelectionComponent, DataGeniusFormComponent],
        imports: [
            CommonModule,
            TranslocoModule,
            PerFormPrimengModule,
            ProgressSpinnerModule$1,
            ButtonModule$1,
            UtilsModule,
            DialogModule,
        ],
        exports: [DataGeniusSelectionComponent],
    })
], DataGeniusSelectionModule);

let FullInvoiceEntryModule = class FullInvoiceEntryModule {
};
FullInvoiceEntryModule = __decorate([
    NgModule({
        declarations: [FullInvoiceEntryComponent],
        imports: [
            ButtonModule$2,
            CommonSharedModuleModule,
            CommonModule,
            DialogModule,
            FormsModule,
            RouterModule,
            ConfirmDialogModule$1,
            LuiWizardModule,
            LuiWidgetWrapperModule,
            LuiWizardV3Module,
            TranslocoModule,
            TableModule$1,
            PerFormModule,
            ProgressSpinnerModule$1,
            PerFormPrimengModule,
        ],
        exports: [FullInvoiceEntryComponent],
    })
], FullInvoiceEntryModule);

let NewInvoiceModule = class NewInvoiceModule {
};
NewInvoiceModule = __decorate([
    NgModule({
        declarations: [NewInvoiceComponent],
        imports: [
            ButtonModule$2,
            CommonSharedModuleModule,
            CommonModule,
            DialogModule,
            FormsModule,
            RouterModule,
            ConfirmDialogModule$1,
            LuiWizardModule,
            LuiWizardV3Module,
            LuiWidgetWrapperModule,
            TranslocoModule,
            TableModule$1,
            PerFormModule,
            ProgressSpinnerModule$1,
            PerFormPrimengModule,
        ],
        exports: [NewInvoiceComponent],
    })
], NewInvoiceModule);

let SentInvoiceModule = class SentInvoiceModule {
};
SentInvoiceModule = __decorate([
    NgModule({
        declarations: [SentInvoiceComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            DashboardModule,
            ButtonModule$1,
            DialogModule$1,
            CommonModule,
            DataGeniusSelectionModule,
            FormsModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            RadioButtonModule,
            WizardModule,
            PdfViewerModule,
            ExportModule,
            LoggingModule,
            EditInvoiceModule,
            WarningsModule,
            PerFormPrimengModule,
            NewInvoiceModule,
            FullInvoiceEntryModule,
            WarningsListModule,
            ProgressSpinnerModule$1,
            PrintOptionsModule,
            LuiWizardModule,
            LuiWizardV3Module,
            LuiWidgetWrapperModule,
        ],
        providers: [CanDeactivateGuard],
        entryComponents: [
            PdfViewerComponent,
            ExportComponent,
            DataGeniusSelectionComponent,
        ],
    })
], SentInvoiceModule);

let SentPADModule = class SentPADModule {
};
SentPADModule = __decorate([
    NgModule({
        declarations: [SentPADComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            DashboardModule,
            DialogModule$1,
            CommonModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            WizardModule,
            PdfViewerModule,
            ExportModule,
            LoggingModule,
            EditInvoiceModule,
            WarningsModule,
            PrintOptionsModule,
            ProgressSpinnerModule$1,
            LuiWizardModule,
            LuiWidgetWrapperModule,
        ],
        entryComponents: [PdfViewerComponent, ExportComponent],
    })
], SentPADModule);

let SentPIModule = class SentPIModule {
};
SentPIModule = __decorate([
    NgModule({
        declarations: [SentPIComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            DashboardModule,
            DialogModule$1,
            CommonModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            WizardModule,
            PdfViewerModule,
            ExportModule,
            LoggingModule,
            EditInvoiceModule,
            WarningsModule,
            PrintOptionsModule,
            ProgressSpinnerModule$1,
            LuiWizardModule,
            LuiWidgetWrapperModule,
        ],
        entryComponents: [PdfViewerComponent, ExportComponent],
    })
], SentPIModule);

let SentPOModule = class SentPOModule {
};
SentPOModule = __decorate([
    NgModule({
        declarations: [SentPoComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            ButtonModule$2,
            CommonModule,
            DashboardModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            DialogModule$1,
            PerFormPrimengModule,
            ProgressSpinnerModule$1,
            PrintOptionsModule,
            PdfViewerModule,
            ExportModule,
            LoggingModule,
            WarningsListModule,
            WarningsModule,
            WizardModule,
            LuiWizardV3Module,
            LuiWidgetWrapperModule,
        ],
        entryComponents: [
            PdfViewerComponent,
            ExportComponent,
            DataGeniusSelectionComponent,
        ],
    })
], SentPOModule);

let SentPoaModule = class SentPoaModule {
};
SentPoaModule = __decorate([
    NgModule({
        declarations: [SentPoaComponent],
        imports: [
            AnalyticsModule,
            DashboardModule,
            AdvancedSearchLoaderModule,
            CommonModule,
            SearchContainerLoaderModule,
            ButtonModule$1,
            TranslocoModule,
            DialogModule$1,
            PrintOptionsModule,
            PerFormPrimengModule,
            ProgressSpinnerModule$1,
            PdfViewerModule,
            LoggingModule,
            ExportModule,
            WarningsModule,
            LuiWizardModule,
            LuiWizardV3Module,
            LuiWidgetWrapperModule,
        ],
        entryComponents: [
            PdfViewerComponent,
            ExportComponent,
            DataGeniusSelectionComponent,
        ],
    })
], SentPoaModule);

let SentPSRCModule = class SentPSRCModule {
};
SentPSRCModule = __decorate([
    NgModule({
        declarations: [SentPsrcComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            DashboardModule,
            DialogModule$1,
            CommonModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            WizardModule,
            PdfViewerModule,
            ExportModule,
            LoggingModule,
            EditInvoiceModule,
            WarningsModule,
            PrintOptionsModule,
            ProgressSpinnerModule$1,
            LuiWizardModule,
            LuiWidgetWrapperModule,
        ],
        entryComponents: [PdfViewerComponent, ExportComponent],
    })
], SentPSRCModule);

let RemittancesSentModule = class RemittancesSentModule {
};
RemittancesSentModule = __decorate([
    NgModule({
        declarations: [RemittancesSentComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            DashboardModule,
            DialogModule$1,
            CommonModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            WizardModule,
            PdfViewerModule,
            ExportModule,
            LoggingModule,
            EditInvoiceModule,
            WarningsModule,
            PrintOptionsModule,
            ProgressSpinnerModule$1,
            LuiWizardModule,
            LuiWidgetWrapperModule,
        ],
        entryComponents: [PdfViewerComponent, ExportComponent],
    })
], RemittancesSentModule);

let AsnEntryModule = class AsnEntryModule {
};
AsnEntryModule = __decorate([
    NgModule({
        declarations: [AsnEntryComponent],
        imports: [
            ButtonModule$2,
            CommonSharedModuleModule,
            CommonModule,
            DialogModule,
            FormsModule,
            RouterModule,
            ConfirmDialogModule$1,
            LuiWizardModule,
            LuiWidgetWrapperModule,
            LuiWizardV3Module,
            TranslocoModule,
            TableModule$1,
            PerFormModule,
            ProgressSpinnerModule$1,
            PerFormPrimengModule,
        ],
        exports: [AsnEntryComponent],
    })
], AsnEntryModule);

let CdaWizardModule = class CdaWizardModule {
};
CdaWizardModule = __decorate([
    NgModule({
        declarations: [CdaWizardComponent],
        imports: [
            ButtonModule$2,
            CommonSharedModuleModule,
            CommonModule,
            DialogModule,
            FormsModule,
            RouterModule,
            ConfirmDialogModule$1,
            LuiWizardModule,
            LuiWidgetWrapperModule,
            LuiWizardV3Module,
            TranslocoModule,
            TableModule$1,
            PerFormModule,
            ProgressSpinnerModule$1,
            PerFormPrimengModule,
        ],
        exports: [CdaWizardComponent],
    })
], CdaWizardModule);

let StatementReceivedModule = class StatementReceivedModule {
};
StatementReceivedModule = __decorate([
    NgModule({
        declarations: [StatementReceivedComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            DashboardModule,
            DialogModule$1,
            CommonModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            WizardModule,
            PdfViewerModule,
            ExportModule,
            LoggingModule,
            EditInvoiceModule,
            WarningsModule,
            PrintOptionsModule,
            ProgressSpinnerModule$1,
            LuiWizardModule,
            LuiWidgetWrapperModule,
        ],
        entryComponents: [PdfViewerComponent, ExportComponent],
    })
], StatementReceivedModule);

let ReceivedPIModule = class ReceivedPIModule {
};
ReceivedPIModule = __decorate([
    NgModule({
        declarations: [ReceivedPIComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            DashboardModule,
            DialogModule$1,
            CommonModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            WizardModule,
            PdfViewerModule,
            ExportModule,
            LoggingModule,
            EditInvoiceModule,
            WarningsModule,
            PrintOptionsModule,
            ProgressSpinnerModule$1,
            LuiWizardModule,
            LuiWidgetWrapperModule,
        ],
        entryComponents: [PdfViewerComponent, ExportComponent],
    })
], ReceivedPIModule);

let SentWarehouseModule = class SentWarehouseModule {
};
SentWarehouseModule = __decorate([
    NgModule({
        declarations: [SentWarehouseComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            DashboardModule,
            DialogModule$1,
            CommonModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            WizardModule,
            PdfViewerModule,
            ExportModule,
            LoggingModule,
            EditInvoiceModule,
            WarningsModule,
            PrintOptionsModule,
            ProgressSpinnerModule$1,
            LuiWizardModule,
            LuiWidgetWrapperModule,
        ],
        entryComponents: [PdfViewerComponent, ExportComponent],
    })
], SentWarehouseModule);

let ReceivedWarehouseModule = class ReceivedWarehouseModule {
};
ReceivedWarehouseModule = __decorate([
    NgModule({
        declarations: [ReceivedWarehouseComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            DashboardModule,
            DialogModule$1,
            CommonModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            WizardModule,
            PdfViewerModule,
            ExportModule,
            LoggingModule,
            EditInvoiceModule,
            WarningsModule,
            PrintOptionsModule,
            ProgressSpinnerModule$1,
            LuiWizardModule,
            LuiWidgetWrapperModule,
        ],
        entryComponents: [PdfViewerComponent, ExportComponent],
    })
], ReceivedWarehouseModule);

let ComplianceStatementMatchingModule = class ComplianceStatementMatchingModule {
};
ComplianceStatementMatchingModule = __decorate([
    NgModule({
        declarations: [ComplianceStatementMatchingComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            DashboardModule,
            DialogModule$1,
            PerFormPrimengModule,
            ProgressSpinnerModule$1,
            CommonModule,
            SearchContainerLoaderModule,
            TranslocoModule,
            PrintOptionsModule,
            PdfViewerModule,
            ExportModule,
            LoggingModule,
            WarningsModule,
            LuiWizardModule,
            LuiWizardV3Module,
            LuiWidgetWrapperModule,
        ],
        entryComponents: [PdfViewerComponent, ExportComponent],
    })
], ComplianceStatementMatchingModule);

let EditInvoiceEntryModule = class EditInvoiceEntryModule {
};
EditInvoiceEntryModule = __decorate([
    NgModule({
        declarations: [EditInvoiceEntryComponent],
        imports: [
            ButtonModule$2,
            CommonSharedModuleModule,
            CommonModule,
            DialogModule,
            FormsModule,
            RouterModule,
            ConfirmDialogModule$1,
            LuiWizardModule,
            LuiWidgetWrapperModule,
            LuiWizardV3Module,
            TranslocoModule,
            TableModule$1,
            PerFormModule,
            ProgressSpinnerModule$1,
            PerFormPrimengModule,
        ],
        exports: [EditInvoiceEntryComponent],
    })
], EditInvoiceEntryModule);

let ComplianceInvoiceMatchingModule = class ComplianceInvoiceMatchingModule {
};
ComplianceInvoiceMatchingModule = __decorate([
    NgModule({
        declarations: [ComplianceInvoiceMatchingComponent],
        imports: [
            AdvancedSearchLoaderModule,
            AnalyticsModule,
            DashboardModule,
            DialogModule$1,
            PerFormPrimengModule,
            ProgressSpinnerModule$1,
            CommonModule,
            SearchContainerLoaderModule,
            EditInvoiceEntryModule,
            TranslocoModule,
            PrintOptionsModule,
            PdfViewerModule,
            ExportModule,
            LoggingModule,
            WarningsModule,
            LuiWizardModule,
            LuiWizardV3Module,
            LuiWidgetWrapperModule,
        ],
        entryComponents: [PdfViewerComponent, ExportComponent],
    })
], ComplianceInvoiceMatchingModule);

// import { ComplianceInvoiceMatchingComponent } from './features/compliance-invoice-matching/compliance-invoice-matching.component';
// import { ComplianceStatementMatchingComponent } from './features/compliance-statement-matching/compliance-statement-matching.component';
let MarketplaceModule = class MarketplaceModule {
};
MarketplaceModule = __decorate([
    NgModule({
        declarations: [MarketplaceComponent],
        imports: [
            AsnEntryModule,
            ComplianceStatementMatchingModule,
            ComplianceInvoiceMatchingModule,
            SentPOModule,
            SentPoaModule,
            ReceivedAAModule,
            SentPADModule,
            SentCDAModule,
            SentPOCModule,
            SentPSRCModule,
            SentPIModule,
            SentAsnModule,
            SentWarehouseModule,
            POAReceivedModule,
            SentOSModule,
            SentDSDSIModule,
            AsnReceivedModule,
            ClaimsReceivedModule,
            RemittancesReceivedModule,
            RemittancesSentModule,
            StatementReceivedModule,
            UtilsModule,
            RouterModule.forChild(routes$A),
            UtilsModule,
            SentInvoiceModule,
            ReceivedTMModule,
            ReceivedPOModule,
            ReceivedPSRCModule,
            ReceivedDSDSIModule,
            ReceivedPIModule,
            ReceivedWarehouseModule,
            CdaReceivedModule,
            OsReceivedModule,
            PocReceivedModule,
            MakePaymentsModule,
            PadReceivedModule,
            OpenReceivablesModule,
            ReceivedInvoiceModule,
            PaymentsModule,
            CollectionsModule,
            CdaWizardModule,
            ReceivedRebateStatementModule,
            PayWizardModule,
        ],
        exports: [MarketplaceComponent],
        providers: [ConfirmationService$2],
    })
], MarketplaceModule);

/*
 * Public API Surface of marketplace
 */

/**
 * Generated bundle index. Do not edit.
 */

export { KpiService, MarketplaceComponent, MarketplaceModule, MarketplaceService, AsnEntryModule as ɵa, AsnEntryComponent as ɵb, LoggingComponent as ɵba, LoggingFormComponent as ɵbb, WarningsModule as ɵbc, WarningsContainerComponent as ɵbd, WarningsFormComponent as ɵbe, ComplianceInvoiceMatchingModule as ɵbf, ComplianceInvoiceMatchingComponent as ɵbg, EditInvoiceService as ɵbh, EditInvoiceEntryModule as ɵbi, EditInvoiceEntryComponent as ɵbj, SentPOModule as ɵbk, SentPoComponent as ɵbl, WarningsListModule as ɵbm, WarningsListComponent as ɵbn, WizardModule as ɵbo, WizardComponent as ɵbp, ScreenComponent as ɵbr, DataGeniusSelectionComponent as ɵbs, SentPoaModule as ɵbt, SentPoaComponent as ɵbu, ReceivedAAModule as ɵbv, ReceivedAAComponent as ɵbw, EditInvoiceModule as ɵbx, EditInvoiceComponent as ɵby, SentPADModule as ɵbz, ComponentCanDeactivate as ɵc, SentPADComponent as ɵca, SentCDAModule as ɵcb, SentCDAComponent as ɵcc, CdaWizardService as ɵcd, MarketplaceAnalyticsModule as ɵce, DashboardLoaderComponent as ɵcf, DashboardTemplateComponent as ɵch, WidgetSelectionComponent as ɵci, SentPOCModule as ɵcj, SentPOCComponent as ɵck, SentPSRCModule as ɵcl, SentPsrcComponent as ɵcm, SentPIModule as ɵcn, SentPIComponent as ɵco, SentAsnModule as ɵcp, SentAsnComponent as ɵcq, CanDeactivateGuard as ɵcr, SentWarehouseModule as ɵcs, SentWarehouseComponent as ɵct, POAReceivedModule as ɵcu, PoaReceivedComponent as ɵcv, SentOSModule as ɵcw, SentOSComponent as ɵcx, SentDSDSIModule as ɵcy, SentDSDSIComponent as ɵcz, NewInvoiceService as ɵd, AsnReceivedModule as ɵda, AsnReceivedComponent as ɵdb, ClaimsReceivedModule as ɵdc, ClaimsReceivedComponent as ɵdd, ViewClaimsReceivedComponent as ɵde, ClaimsReceivedService as ɵdf, PurchaseOrderService as ɵdg, DocumentServerService as ɵdh, AdvancedSearchComponent as ɵdi, RemittancesReceivedModule as ɵdj, RemittancesReceivedComponent as ɵdk, RemittancesSentModule as ɵdl, RemittancesSentComponent as ɵdm, StatementReceivedModule as ɵdn, StatementReceivedComponent as ɵdo, routes$A as ɵdp, AuthGuardService as ɵdq, routes$p as ɵdr, routes$2 as ɵds, routes as ɵdt, routes$o as ɵdu, routes$i as ɵdv, routes$d as ɵdw, OsReceivedComponent as ɵdx, routes$1 as ɵdy, ReceivedInvoiceComponent as ɵdz, AsnWizardService as ɵe, PayService as ɵea, CdaWizardComponent as ɵeb, routes$t as ɵec, routes$s as ɵed, routes$g as ɵee, BatchesComponent$1 as ɵef, routes$7 as ɵeg, routes$9 as ɵeh, routes$a as ɵei, routes$n as ɵej, SentInvoiceComponent as ɵek, NewInvoiceComponent as ɵel, FullInvoiceEntryComponent as ɵem, routes$m as ɵen, routes$8 as ɵeo, BatchesComponent as ɵep, routes$6 as ɵeq, CdaReceivedComponent as ɵer, routes$3 as ɵes, ReceivedPoComponent as ɵet, ReceivedPOService as ɵeu, FlipDocTypeComponent as ɵev, routes$h as ɵew, PocReceivedComponent as ɵex, routes$4 as ɵey, routes$5 as ɵez, CommonSharedModuleModule as ɵf, routes$f as ɵfa, PadReceivedComponent as ɵfb, routes$e as ɵfc, routes$l as ɵfd, ReceivedTmComponent as ɵfe, routes$j as ɵff, routes$q as ɵfg, routes$r as ɵfh, ReceivedPsrcComponent as ɵfi, routes$k as ɵfj, ReceivedRebateStatementComponent as ɵfk, routes$b as ɵfl, MakePaymentsComponent as ɵfm, routes$c as ɵfn, OpenReceivablesComponent as ɵfo, routes$u as ɵfp, routes$v as ɵfq, ReceivedDSDSIComponent as ɵfr, routes$w as ɵfs, routes$x as ɵft, ReceivedPIComponent as ɵfu, routes$y as ɵfv, routes$z as ɵfw, ReceivedWarehouseComponent as ɵfx, SentInvoiceModule as ɵfy, DataGeniusSelectionModule as ɵfz, ViewLogTemplateComponent as ɵg, DataGeniusFormComponent as ɵga, NewInvoiceModule as ɵgb, FullInvoiceEntryModule as ɵgc, ReceivedTMModule as ɵgd, ReceivedPOModule as ɵge, ReceivedPSRCModule as ɵgf, ReceivedDSDSIModule as ɵgg, ReceivedPIModule as ɵgh, ReceivedWarehouseModule as ɵgi, CdaReceivedModule as ɵgj, OsReceivedModule as ɵgk, PocReceivedModule as ɵgl, MakePaymentsModule as ɵgm, PayWizardModule as ɵgn, PayWizardComponent as ɵgo, PayV2Component as ɵgq, LocalSearchService as ɵgr, DefaultPaginatorComponent as ɵgs, EditTableModule as ɵgt, EditTableComponent as ɵgu, EditFieldsetDirective as ɵgv, LuiPaginatorModule as ɵgw, LuiPaginatorComponent as ɵgx, DefaultPaginatorModule as ɵgy, TabModule as ɵgz, ComplianceStatementMatchingModule as ɵh, LuiTab as ɵha, ActiveTabService as ɵhb, LuiTabGroup as ɵhc, LuiTabHeader as ɵhd, OnHoldModule as ɵhe, OnHoldContainerComponent as ɵhf, OnHoldComponent as ɵhg, PadReceivedModule as ɵhh, OpenReceivablesModule as ɵhi, ReceivedInvoiceModule as ɵhj, PaymentsModule as ɵhk, PaymentsComponent as ɵhl, EFTACHSettingsComponent$1 as ɵhm, GenerateFileFormContainerComponent$1 as ɵhn, GenerateFileFormComponent$1 as ɵho, ViewComponent$1 as ɵhp, ViewContainerComponent$1 as ɵhq, LoggingComponent$1 as ɵhr, LoggingFormComponent$1 as ɵhs, CollectionsModule as ɵht, CollectionsComponent as ɵhu, EFTACHSettingsComponent as ɵhv, ViewComponent as ɵhw, FlipFormContainerComponent as ɵhx, FlipFormComponent as ɵhy, GenerateFileFormContainerComponent as ɵhz, ComplianceStatementMatchingComponent as ɵi, GenerateFileFormComponent as ɵia, ViewContainerComponent as ɵib, RejectComponent as ɵic, RejectFormComponent as ɵid, CdaWizardModule as ɵie, ReceivedRebateStatementModule as ɵif, PrintOptionsService as ɵj, DashboardModule as ɵk, DashboardComponent as ɵl, DashboardContainerComponent as ɵm, KpiSelectionModalComponent as ɵo, PrintOptionsModule as ɵq, PrintOptionsComponent as ɵr, PrintOptionsContainerComponent as ɵs, BaseHttpService as ɵt, PdfViewerModule as ɵu, PdfViewerComponent as ɵv, ExportModule as ɵw, ExportComponent as ɵx, ExportFormComponent as ɵy, LoggingModule as ɵz };
//# sourceMappingURL=lbmx-marketplace.js.map
